
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("d8WYQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "StatusField", () => $e9e7f56f9c545619$export$28769ce7cf4b59f9);
$parcel$export(module.exports, "default", () => $e9e7f56f9c545619$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $dllpM = parcelRequire("dllpM");

var $5vQ2T = parcelRequire("5vQ2T");

var $4cTDP = parcelRequire("4cTDP");

var $3bSs8 = parcelRequire("3bSs8");

var $d2AGn = parcelRequire("d2AGn");

var $eDOqM = parcelRequire("eDOqM");

var $2ghht = parcelRequire("2ghht");

var $3mZMJ = parcelRequire("3mZMJ");

var $ftN6c = parcelRequire("ftN6c");

var $bNexr = parcelRequire("bNexr");

var $koAZ4 = parcelRequire("koAZ4");

var $bmoS1 = parcelRequire("bmoS1");

var $jaf8h = parcelRequire("jaf8h");

var $dxgbR = parcelRequire("dxgbR");

var $178sl = parcelRequire("178sl");

var $e1mtn = parcelRequire("e1mtn");

var $dYkoV = parcelRequire("dYkoV");
const $e9e7f56f9c545619$export$28769ce7cf4b59f9 = ({ isOptimistic: isOptimistic = true, ViewWorkflowContextService: ViewWorkflowContextService = (0, $178sl.default), preFetchTransitions: preFetchTransitions = false, projectType: projectType = null, onEditStart: onEditStart = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onEditCancel: onEditCancel = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onModalClose: onModalClose = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), issueKey: issueKey, issueId: issueId, isEditable: isEditable, initialValue: initialValue, appearance: appearance, value: value, statusButtonRef: statusButtonRefExternal, popperProps: popperProps, registerInCommandPalette: registerInCommandPalette, onUpdateStatusMutation: onUpdateStatusMutation, isStatusOnLHS: isStatusOnLHS, onEditedStatusDetails: onEditedStatusDetails, shouldCaptureEscape: shouldCaptureEscape })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const canConfigureStatus = (0, $2ghht.useCanConfigureStatus)(projectKey);
    const showConfigureStatusButtons = canConfigureStatus && (0, $2ghht.shouldShowConfigureStatusOption)(projectType);
    const statusButtonRef = (0, $eJOHy.useRef)(null);
    const tenantContext = (0, $koAZ4.useTenantContext)();
    const viewMode = (0, $bmoS1.useViewMode)();
    const onCloseModal = (0, $eJOHy.useCallback)(()=>{
        statusButtonRef?.current?.focus();
        onModalClose();
    }, [
        onModalClose
    ]);
    const shouldNotRender = (0, $eJOHy.useMemo)(()=>{
        return !tenantContext || !(value || initialValue);
    }, [
        tenantContext,
        value,
        initialValue
    ]);
    const restoreFocus = (0, $eJOHy.useCallback)(()=>{
        setTimeout(()=>{
            const element = globalThis.document?.getElementById('issue.fields.status-view.status-button');
            if (element instanceof HTMLElement) element.focus();
        }, 500);
    }, []);
    const successCallback = (0, $eJOHy.useCallback)((...params)=>{
        onSuccess(...params);
        // restore focus back to status button after successfully changing the status
        restoreFocus();
    }, [
        onSuccess,
        restoreFocus
    ]);
    const failureCallback = (0, $eJOHy.useCallback)((err)=>{
        onFailure(err);
        // restore focus back to status button after changing the status fails
        restoreFocus();
    }, [
        onFailure,
        restoreFocus
    ]);
    const pressTrace = (0, $dllpM.default)('issue.field.status');
    return shouldNotRender ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jaf8h.StatusService), {
        appearance: appearance,
        value: value,
        projectType: projectType,
        initialValue: initialValue,
        issueKey: issueKey,
        issueId: issueId,
        onSubmit: onSubmit,
        onSuccess: (0, $4cTDP.fg)('fix_jac_96071') ? successCallback : onSuccess,
        onFailure: (0, $4cTDP.fg)('fix_jac_96071') ? failureCallback : onFailure,
        onEditStart: onEditStart,
        onEditCancel: onEditCancel,
        checkRefreshedData: true,
        ...(0, $4cTDP.fg)('relay-migration-issue-fields-status') ? {
            onUpdateStatusMutation: onUpdateStatusMutation
        } : {}
    }, ({ value: statusServiceValue, loading: saving, transitionStatus: transitionStatus, error: error, resetError: resetError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxgbR.TransitionsQuery), {
            issueKey: issueKey,
            // this will force an empty list of transitions when the status changes
            status: statusServiceValue,
            isSaving: saving,
            preFetch: preFetchTransitions,
            projectType: projectType
        }, ({ data: transitions, loading: loading, fetch: fetch, ui: ui })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ViewWorkflowContextService, {
                issueKey: issueKey
            }, (workflowServiceApi)=>{
                const isSaving = saving || Boolean(ui?.transitionInProgress);
                const viewWorkflowFooter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
                    id: "issue-field-view-workflow"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dYkoV.default), {
                    issueKey: issueKey,
                    workflowServiceApi: workflowServiceApi,
                    onCloseModal: onCloseModal
                }));
                const workflowFooter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, viewWorkflowFooter);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e1mtn.default), {
                    statusButtonRef: statusButtonRefExternal || statusButtonRef,
                    value: statusServiceValue,
                    isEditable: isEditable,
                    isLoading: loading || saving || Boolean(ui?.transitionInProgress),
                    isSaving: isOptimistic === true ? false : isSaving,
                    appearance: appearance,
                    transitions: transitions,
                    onOpen: (analyticsEvent)=>{
                        onEditStart();
                        if ((0, $4cTDP.fg)('fix_blindspots_for_board_and_backlog')) pressTrace();
                        const startEvent = createAnalyticsEvent({});
                        (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart((0, $3mZMJ.STATUS_TYPE), {
                            analytics: startEvent,
                            attributes: {
                                fieldType: (0, $3bSs8.FIELD_TYPE_MAP)[0, $3mZMJ.STATUS_TYPE],
                                isInlineEditing: !(0, $eDOqM.getIsEditFromIssueView)(startEvent)
                            }
                        });
                        fetch(analyticsEvent);
                        const hasFetchedWorkflowService = workflowServiceApi.data && workflowServiceApi.data.hasPermission !== undefined;
                        if (hasFetchedWorkflowService !== true) workflowServiceApi.fetch();
                        resetError();
                    },
                    onClose: onEditCancel,
                    onChange: transitionStatus,
                    shouldCaptureEscape: shouldCaptureEscape,
                    error: error,
                    footer: workflowFooter,
                    popperProps: popperProps,
                    registerInCommandPalette: registerInCommandPalette,
                    onSuccess: onSuccess,
                    onFetch: fetch,
                    ...(0, $4cTDP.fg)('relay-migration-issue-fields-status') ? {
                        onUpdateStatusMutation: onUpdateStatusMutation
                    } : {},
                    showConfigureStatusButtons: showConfigureStatusButtons,
                    configureStatusDialogType: viewMode === 'SIDEBAR' ? 'modal' : 'popup',
                    configureStatusPopupPlacement: isStatusOnLHS ? 'bottom-start' : 'bottom-end',
                    projectId: workflowServiceApi.data?.projectId,
                    issueTypeId: workflowServiceApi.data?.issueTypeId,
                    projectKey: projectKey,
                    projectType: projectType,
                    onStatusCreatedOrUpdated: async (options)=>{
                        const { shouldRefreshCurrentStatus: shouldRefreshCurrentStatus } = options || {};
                        // Refetch transitions
                        fetch(createAnalyticsEvent({}));
                        // Refetch current status if details have been updated
                        if (shouldRefreshCurrentStatus) onEditedStatusDetails?.({});
                    }
                }));
            })));
};
var $e9e7f56f9c545619$export$2e2bcd8739ae039 = $e9e7f56f9c545619$export$28769ce7cf4b59f9;

});
parcelRegister("dllpM", function(module, exports) {
$parcel$export(module.exports, "default", () => $4adf76c7a26850b8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $d0Gew = parcelRequire("d0Gew");
function $4adf76c7a26850b8$export$2e2bcd8739ae039(name) {
    const context = (0, $eJOHy.useContext)((0, $d0Gew.default));
    const handleClick = (0, $eJOHy.useCallback)((timeStamp)=>{
        if (context) {
            const time = timeStamp || performance.now();
            context.tracePress(name, time);
        }
    }, [
        context,
        name
    ]);
    return handleClick;
}

});

parcelRegister("eDOqM", function(module, exports) {
$parcel$export(module.exports, "getIsEditFromIssueView", () => $2cf48d43ab1e3da4$export$8846558eb0b5fa3);

var $9gq2c = parcelRequire("9gq2c");

var $2xVsC = parcelRequire("2xVsC");
const $2cf48d43ab1e3da4$export$8846558eb0b5fa3 = (event)=>{
    const ISSUE_VIEW_SOURCES = [
        'fullIssueScreen',
        'boardIssueViewScreen',
        'agility-backlogScreen',
        'issueNavigatorEmbeddedIssueViewScreen',
        'globalIssueNavigatorIssueScreen',
        'mobileIssueScreen',
        'classicRoadmapScreen',
        'roadmapScreen',
        'versionDetailsIssueScreen',
        'bitbucketIssueScreen',
        'jsmQueueAgentViewSidebarScreen',
        'viewQueueIssueScreen',
        'jswModalIssueAppScreen',
        'jwmModalIssueAppScreen',
        'jswSidebarIssueAppScreen',
        'jwmSidebarIssueAppScreen'
    ];
    const { payload: { source: source } } = (0, $2xVsC.getEvent)(event);
    if (!source) return false;
    if (ISSUE_VIEW_SOURCES.includes(source)) // event originated from issue view location
    return true;
    if (source.startsWith((0, $9gq2c.PACKAGE_NAME_GASV3))) // event originated from forge app, which can only be mounted in issue view for field editing
    return true;
    return false;
};

});

parcelRegister("2ghht", function(module, exports) {
$parcel$export(module.exports, "useCanConfigureStatus", () => $f8c9ffd6e8d05c61$export$c330622bbe9077c2);
$parcel$export(module.exports, "shouldShowConfigureStatusOption", () => $f8c9ffd6e8d05c61$export$33aa2c7a0150a75c);
$parcel$export(module.exports, "canConfigureStatusForProject", () => $f8c9ffd6e8d05c61$export$bbae6b0cfa2349b8);

var $5PQOA = parcelRequire("5PQOA");

var $FhXEJ = parcelRequire("FhXEJ");

var $bNexr = parcelRequire("bNexr");

var $f5OzW = parcelRequire("f5OzW");
const $f8c9ffd6e8d05c61$export$c330622bbe9077c2 = (projectKey)=>{
    const isTeamManaged = (0, $bNexr.useIsSimplifiedProject)(projectKey);
    const hasAdminPermissions = (0, $f5OzW.useCanConfigureIssue)(projectKey);
    return isTeamManaged && hasAdminPermissions;
};
const $f8c9ffd6e8d05c61$export$33aa2c7a0150a75c = (projectType)=>{
    return projectType === (0, $FhXEJ.CORE_PROJECT) || projectType === (0, $FhXEJ.SOFTWARE_PROJECT);
};
const $f8c9ffd6e8d05c61$export$bbae6b0cfa2349b8 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))(({ project: project, isProjectAdmin: isProjectAdmin })=>{
    return isProjectAdmin && (project?.isSimplified ?? false) && $f8c9ffd6e8d05c61$export$33aa2c7a0150a75c(project?.projectType ?? null);
});

});
parcelRegister("f5OzW", function(module, exports) {
$parcel$export(module.exports, "useProjectPermissions", () => $9392c16d11e1d8d6$export$c6c6b35628cf47a8);
$parcel$export(module.exports, "useCanAdministerProject", () => $9392c16d11e1d8d6$export$f39ed5a161efa614);
$parcel$export(module.exports, "useCanAdministerJira", () => $9392c16d11e1d8d6$export$ec12ddafd19b95ac);
$parcel$export(module.exports, "useCanConfigureIssue", () => $9392c16d11e1d8d6$export$e7267b8a084eadb3);
$parcel$export(module.exports, "useCanUseServiceDeskAgentFeatures", () => $9392c16d11e1d8d6$export$756d7c97077a2f76);
$parcel$export(module.exports, "useCanUseCustomerServiceAgentFeatures", () => $9392c16d11e1d8d6$export$a9aa002e3fe96518);
$parcel$export(module.exports, "useCanDownloadAttachments", () => $9392c16d11e1d8d6$export$d47dad3a7e3265ea);
$parcel$export(module.exports, "useProjectPermissionsActions", () => $9392c16d11e1d8d6$export$86c656cdb87052cd);

var $eJOHy = parcelRequire("eJOHy");

var $koAZ4 = parcelRequire("koAZ4");

var $6PAED = parcelRequire("6PAED");

var $cmy2V = parcelRequire("cmy2V");
const $9392c16d11e1d8d6$export$c6c6b35628cf47a8 = (projectKey)=>{
    const [permissions, { setProjectPermissions: setProjectPermissions }] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const actions = (0, $eJOHy.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        permissions,
        actions
    ];
};
const $9392c16d11e1d8d6$export$f39ed5a161efa614 = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerProject;
};
const $9392c16d11e1d8d6$export$ec12ddafd19b95ac = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerJira;
};
const $9392c16d11e1d8d6$export$e7267b8a084eadb3 = (projectKey)=>{
    const canConfigureAdministerProject = $9392c16d11e1d8d6$export$f39ed5a161efa614(projectKey);
    const canAdministerJira = $9392c16d11e1d8d6$export$ec12ddafd19b95ac(projectKey);
    return canConfigureAdministerProject || canAdministerJira;
};
const $9392c16d11e1d8d6$export$756d7c97077a2f76 = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const { appPermissions: appPermissions } = (0, $koAZ4.useTenantContext)();
    return permissions.canUseServiceDeskAgentFeatures && appPermissions?.hasServiceDeskAccess;
};
const $9392c16d11e1d8d6$export$a9aa002e3fe96518 = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const { hasCustomerServiceAccess: hasCustomerServiceAccess } = (0, $6PAED.useApplicationPermissions)();
    return permissions.canUseServiceDeskAgentFeatures && hasCustomerServiceAccess;
};
const $9392c16d11e1d8d6$export$d47dad3a7e3265ea = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canExportIssue;
};
const $9392c16d11e1d8d6$export$86c656cdb87052cd = ()=>{
    const [, { setProjectPermissions: setProjectPermissions }] = (0, $cmy2V.useProjectPermissionsStoreActions)();
    const actions = (0, $eJOHy.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("cmy2V", function(module, exports) {
$parcel$export(module.exports, "defaultPermissions", () => $872d4887d895f20d$export$ccfee65526b322ca);
$parcel$export(module.exports, "useProjectPermissionsStore", () => $872d4887d895f20d$export$4919fa09a3d81224);
$parcel$export(module.exports, "useProjectPermissionsStoreActions", () => $872d4887d895f20d$export$e8436ef485b33bdb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $g2Hwr = parcelRequire("g2Hwr");
const $872d4887d895f20d$export$ccfee65526b322ca = {
    canAddComments: false,
    canAdministerJira: false,
    canAdministerProject: false,
    canAssignIssues: false,
    canBeAssignedToIssues: false,
    canCloneIssue: false,
    canCreateAttachments: false,
    canCreateChildren: false,
    canCreateSubtask: false,
    canDeleteAllAttachments: false,
    canDeleteAllComments: false,
    canDeleteAllWorklogs: false,
    canDeleteIssue: false,
    canDeleteOwnAttachments: false,
    canDeleteOwnComments: false,
    canDeleteOwnWorklogs: false,
    canEditAllComments: false,
    canEditAllWorklogs: false,
    canEditIssues: false,
    canEditOwnComments: false,
    canEditOwnWorklogs: false,
    canLinkIssues: false,
    canLogWork: false,
    canManageWatchers: false,
    canMoveIssue: false,
    canModifyReporter: false,
    canScheduleIssues: false,
    canUseServiceDeskAgentFeatures: false,
    canBrowseUsers: false,
    canViewDevTools: false,
    canViewWatchers: false,
    canViewVoters: false,
    canCreateIssuesInClassicProjectEpic: false,
    canResolveIssues: false,
    canExportIssue: false,
    canArchiveIssue: false,
    canUnarchiveIssue: false
};
const $872d4887d895f20d$var$store = (0, $GtRbT.createStore)({
    name: 'project-permissions',
    initialState: {},
    actions: $g2Hwr
});
const $872d4887d895f20d$var$getProjectPermissionSelector = (state, { projectKey: projectKey })=>state[projectKey] || $872d4887d895f20d$export$ccfee65526b322ca;
const $872d4887d895f20d$export$4919fa09a3d81224 = (0, $iJq0l.createHook)($872d4887d895f20d$var$store, {
    selector: $872d4887d895f20d$var$getProjectPermissionSelector
});
const $872d4887d895f20d$export$e8436ef485b33bdb = (0, $iJq0l.createHook)($872d4887d895f20d$var$store, {
    selector: null
});

});
parcelRegister("g2Hwr", function(module, exports) {
$parcel$export(module.exports, "setProjectPermissions", () => $d904843c11c916e5$export$53f5cc27627e5fe3);
const $d904843c11c916e5$export$53f5cc27627e5fe3 = (projectKey, permissions)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [projectKey]: permissions
        });
    };

});




parcelRegister("jaf8h", function(module, exports) {
$parcel$export(module.exports, "StatusService", () => $8f154ebe664dc956$export$3e14b51c9a9c5a1a);

var $eJOHy = parcelRequire("eJOHy");

var $jchga = parcelRequire("jchga");

var $eaTQ3 = parcelRequire("eaTQ3");

var $f9jBk = parcelRequire("f9jBk");

var $7ty7w = parcelRequire("7ty7w");

var $8oKDI = parcelRequire("8oKDI");

var $3mZMJ = parcelRequire("3mZMJ");

var $cHtIB = parcelRequire("cHtIB");

var $bmoS1 = parcelRequire("bmoS1");

var $9Z4bX = parcelRequire("9Z4bX");
const $8f154ebe664dc956$export$7a6a15706decd0f9 = '#issue-workflow-transition-submit';
const $8f154ebe664dc956$export$582c70653d60fda9 = (selector, event, handler)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const el = document.querySelector(selector);
    if (el) el.removeEventListener(event, handler);
};
const $8f154ebe664dc956$export$8e05e1932c4b20b0 = (selector, event, handler)=>{
    $8f154ebe664dc956$export$582c70653d60fda9(selector, event, handler);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const el = document.querySelector(selector);
    if (el) el.addEventListener(event, handler);
};
const $8f154ebe664dc956$var$StatusServiceWithoutAriId = (props)=>{
    const { issueId: issueId } = props;
    const cloudId = (0, $cHtIB.useCloudId)();
    const ariIssueId = issueId ? (0, $8oKDI.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId
    }) : undefined;
    const renderIssueTransitionModal = (0, $f9jBk.useOpenIssueTransitionModal)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Z4bX.default), {
        ...props,
        renderIssueTransitionModal: renderIssueTransitionModal,
        issueId: ariIssueId
    });
};
const $8f154ebe664dc956$var$StatusServiceForMigrateIssueTransitionEnabled = (props)=>{
    const source = (0, $bmoS1.useAnalyticsSource)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8f154ebe664dc956$var$StatusServiceWithoutAriId, {
        ...props,
        source: source
    });
};
const $8f154ebe664dc956$var$StatusWithValueService = (props)=>{
    const [, workflowTransitionsActions] = (0, $7ty7w.useWorkflowTransitionsActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eaTQ3.FieldValueSubscriber), {
        issueKey: props.issueKey,
        fieldKey: (0, $3mZMJ.STATUS_TYPE)
    }, (value, fieldValueActions)=>{
        const statusServiceProps = {
            value: // Overrides the value in the store if the consumer really wants to do it
            value,
            ...props,
            fieldValueActions: fieldValueActions,
            workflowTransitionsActions: workflowTransitionsActions
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8f154ebe664dc956$var$StatusServiceForMigrateIssueTransitionEnabled, statusServiceProps);
    });
};
const $8f154ebe664dc956$export$3e14b51c9a9c5a1a = (0, $jchga.default)($8f154ebe664dc956$var$StatusWithValueService);

});
parcelRegister("jchga", function(module, exports) {
$parcel$export(module.exports, "default", () => $252247aaa31f729e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cSXp8 = parcelRequire("cSXp8");
const $252247aaa31f729e$var$withFlagService = (WrappedComponent)=>{
    return (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
            ...props,
            flagService: (0, $cSXp8.flagService)
        });
};
var $252247aaa31f729e$export$2e2bcd8739ae039 = $252247aaa31f729e$var$withFlagService;

});

parcelRegister("eaTQ3", function(module, exports) {
$parcel$export(module.exports, "useFieldValue", () => $626f51b4fb1f2379$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $626f51b4fb1f2379$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $626f51b4fb1f2379$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $626f51b4fb1f2379$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $626f51b4fb1f2379$export$612d9bcb0c9d8976);

var $eJOHy = parcelRequire("eJOHy");

var $1O6Yz = parcelRequire("1O6Yz");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
const $626f51b4fb1f2379$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $626f51b4fb1f2379$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $626f51b4fb1f2379$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $626f51b4fb1f2379$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $626f51b4fb1f2379$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, getState()[issueKey], fields)
        });
    };
const $626f51b4fb1f2379$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, getState(), newIssues));
    };
const $626f51b4fb1f2379$var$actions = {
    setFieldValue: $626f51b4fb1f2379$var$setFieldValue,
    getFieldValue: $626f51b4fb1f2379$var$getFieldValue,
    setIssue: $626f51b4fb1f2379$var$setIssue,
    mergeIssue: $626f51b4fb1f2379$var$mergeIssue,
    setIssues: $626f51b4fb1f2379$var$setIssues,
    mergeIssues: $626f51b4fb1f2379$export$11aa02e14fdf7753
};
// this is a global store
const $626f51b4fb1f2379$var$store = (0, $GtRbT.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $626f51b4fb1f2379$var$actions
});
const $626f51b4fb1f2379$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $626f51b4fb1f2379$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$626f51b4fb1f2379$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $626f51b4fb1f2379$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $626f51b4fb1f2379$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $626f51b4fb1f2379$var$getAllFields = (state, issueKey)=>state[issueKey];
const $626f51b4fb1f2379$export$b79fae7fbe3ac392 = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getFieldValueSelector
});
const $626f51b4fb1f2379$export$25b73e671fe7a8fa = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getAllFields
});
const $626f51b4fb1f2379$export$ac289b84121829df = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getFieldValuesForIssuesSelector
});
const $626f51b4fb1f2379$export$915cdeec521b54f7 = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getMultiFieldValuesForIssuesSelector
});
const $626f51b4fb1f2379$export$4e5f1f4ed08d155e = (0, $ht3nQ.createSubscriber)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getFieldValueSelector
});
const $626f51b4fb1f2379$var$useFieldValueStoreActions = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: null
});
const $626f51b4fb1f2379$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $626f51b4fb1f2379$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $eJOHy.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});

parcelRegister("f9jBk", function(module, exports) {
$parcel$export(module.exports, "useOpenIssueTransitionModal", () => $203e3d1400c85c11$export$736bd10472c63b49);
$parcel$export(module.exports, "useCloseIssueTransitionModal", () => $203e3d1400c85c11$export$4629f18d511ad32e);
$parcel$export(module.exports, "useTriggerIssueTransitionModal", () => $203e3d1400c85c11$export$95a1e9702d78f223);
$parcel$export(module.exports, "default", () => $203e3d1400c85c11$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2EgxC = parcelRequire("2EgxC");

var $4cTDP = parcelRequire("4cTDP");

var $6hw9S = parcelRequire("6hw9S");

var $bmoS1 = parcelRequire("bmoS1");

var $2Z9P0 = parcelRequire("2Z9P0");

var $l4UT4 = parcelRequire("l4UT4");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $5yVUD = parcelRequire("5yVUD");

var $aYBjl = parcelRequire("aYBjl");

var $4xxMe = parcelRequire("4xxMe");

var $3FNro = parcelRequire("3FNro");

var $7SyqX = parcelRequire("7SyqX");

var $axEN1 = parcelRequire("axEN1");
const $203e3d1400c85c11$export$736bd10472c63b49 = ()=>{
    const { openIssueTransitionModal: openIssueTransitionModalAction, openIssueTransitionModalNew: openIssueTransitionModalNew } = (0, $3FNro.useTriggerIssueTransitionModalActions)();
    const { stateGet: { state: { isEnabled: isEnabled = true } = {} } = {} } = (0, $aYBjl.useIssueTransitionLabsOptIn)();
    const publish = (0, $4xxMe.usePublishOpenIssueTransitionModalPubSub)();
    const source = (0, $bmoS1.useAnalyticsSource)();
    const { fireUIEvent: fireUIEvent } = (0, $l4UT4.useIssueTransitionUIAnalyticsEvent)();
    const { stateGet: { state: state } } = (0, $5yVUD.useIssueTransitionChangeboardingPreferences)();
    const { fireOperationalAnalyticsTransitionScreenOpened: fireOperationalAnalyticsTransitionScreenOpened } = (0, $2Z9P0.useIssueTransitionsOperationalAnalyticsEvent)();
    const benefitsModal = typeof state !== 'number' ? state?.benefitsModal : undefined;
    const { isDisabled: isDisabled, nextDateToShowBenefitsModal: nextDateToShowBenefitsModal } = benefitsModal || {};
    return (0, $eJOHy.useCallback)((nextState)=>{
        try {
            const { triggerPointKey: triggerPointKey } = nextState || {};
            const isNewITSEnabled = (0, $axEN1.isNewTransitionScreenEnabled)(isEnabled, triggerPointKey);
            if ((0, $4cTDP.fg)('modern_issue_transition_enable_benefits_modal')) {
                fireOperationalAnalyticsTransitionScreenOpened({
                    actionSubject: 'issueTransition triggered',
                    isBenefitsModalFGEneabled: (0, $4cTDP.fg)('modern_issue_transition_enable_benefits_modal'),
                    preferNewIssueTransitionScreen: isEnabled,
                    issueViewAnalyticsSource: source,
                    isBenefitsModalDisabled: isDisabled,
                    dateToShowBenefitsModal: nextDateToShowBenefitsModal || undefined
                });
                openIssueTransitionModalNew({
                    nextState: nextState,
                    preferNewIssueTransitionScreen: isEnabled,
                    issueViewAnalyticsSource: source,
                    publishTriggerToOpenTransitions: publish,
                    isBenefitsModalDisabled: isDisabled,
                    dateToShowBenefitsModal: nextDateToShowBenefitsModal || undefined,
                    fireUIEvent: fireUIEvent
                });
                return;
            }
            if ((0, $4cTDP.fg)('fix-connect-app-not-loading')) {
                if (isNewITSEnabled && source === 'connect-issue') {
                    // fire UI event when issue transition is opened via connect API
                    fireUIEvent({
                        actionSubject: 'issueTransition',
                        actionSubjectId: 'connectIssue',
                        action: 'opened'
                    });
                    publish(nextState, isEnabled);
                } else openIssueTransitionModalAction(nextState, isEnabled);
            } else if (source === 'connect-issue') {
                // fire UI event when issue transition is opened via connect API
                fireUIEvent({
                    actionSubject: 'issueTransition',
                    actionSubjectId: 'connectIssue',
                    action: 'opened'
                });
                publish(nextState, isEnabled);
            } else openIssueTransitionModalAction(nextState, isEnabled);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $2EgxC.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                attributes: {
                    transitionModalVersion: 'NEW'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }, [
        fireOperationalAnalyticsTransitionScreenOpened,
        isEnabled,
        source,
        isDisabled,
        nextDateToShowBenefitsModal,
        openIssueTransitionModalNew,
        publish,
        fireUIEvent,
        openIssueTransitionModalAction
    ]);
};
const $203e3d1400c85c11$export$4629f18d511ad32e = ()=>{
    const [, { resetState: resetState }] = (0, $6hw9S.useInlineFieldsActions)();
    const { closeIssueTransitionModal: closeIssueTransitionModalAction } = (0, $3FNro.useTriggerIssueTransitionModalActions)();
    const { payload: { issueKey: issueKey, transitionId: transitionId }, onDialogCancel: onDialogCancel, onDialogError: onDialogError, onDialogSuccess: onDialogSuccess } = (0, $3FNro.useTriggerIssueTransitionModalState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)((shouldOpenLegacyModal = false)=>{
        closeIssueTransitionModalAction();
        resetState();
        if (shouldOpenLegacyModal) {
            const onOpenDialog = ()=>{
                (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'legacyTransitionsScreen Switched');
            };
            (0, $7SyqX.openLegacyIssueTransitionModal)({
                issueKey: issueKey,
                isReopenScenario: true,
                transitionId: transitionId,
                onDialogCancel: onDialogCancel,
                onDialogError: onDialogError,
                onDialogSuccess: onDialogSuccess,
                onOpenDialog: onOpenDialog
            });
        }
    }, [
        closeIssueTransitionModalAction,
        createAnalyticsEvent,
        issueKey,
        onDialogCancel,
        onDialogError,
        onDialogSuccess,
        transitionId,
        resetState
    ]);
};
const $203e3d1400c85c11$export$95a1e9702d78f223 = ()=>{
    const state = (0, $3FNro.useTriggerIssueTransitionModalState)();
    const actions = (0, $3FNro.useTriggerIssueTransitionModalActions)();
    const { openIssueTransitionModalNew: openIssueTransitionModalNew, ...restActions } = actions;
    const openIssueTransitionModal = $203e3d1400c85c11$export$736bd10472c63b49();
    return [
        state,
        {
            ...restActions,
            openIssueTransitionModal: openIssueTransitionModal
        }
    ];
};
var $203e3d1400c85c11$export$2e2bcd8739ae039 = $203e3d1400c85c11$export$95a1e9702d78f223;

});
parcelRegister("2EgxC", function(module, exports) {
$parcel$export(module.exports, "fireIssueTransitionErrorAnalytics", () => $afba0e2c09012241$export$3839c9497170b08f);

var $bguQO = parcelRequire("bguQO");
const $afba0e2c09012241$export$3839c9497170b08f = (payload)=>{
    const { attributes: attributes = {}, error: error, ...otherPayload } = payload;
    (0, $bguQO.fireErrorAnalyticsCommon)({
        ...otherPayload,
        attributes: {
            ...attributes
        },
        error: error
    });
};

});
parcelRegister("bguQO", function(module, exports) {
$parcel$export(module.exports, "fireErrorAnalyticsCommon", () => $ae9ed2f07255b016$export$51f199f6846377f7);

var $9pTd3 = parcelRequire("9pTd3");

var $k2nOs = parcelRequire("k2nOs");
const $ae9ed2f07255b016$export$51f199f6846377f7 = (payload)=>{
    const { skipSentry: skipSentry = true, attributes: attributes, ...otherPayload } = payload;
    (0, $9pTd3.fireErrorAnalytics)({
        ...otherPayload,
        attributes: {
            ...attributes,
            ...(0, $k2nOs.getTenantAttributes)()
        },
        skipSentry: // skiping sentry as true for fireErrorAnalytics
        skipSentry
    });
};

});
parcelRegister("k2nOs", function(module, exports) {
$parcel$export(module.exports, "getTenantAttributes", () => $6d869a890ae8f6bb$export$bc31ff13a0bbe592);

var $hWeHP = parcelRequire("hWeHP");

var $lopBx = parcelRequire("lopBx");
const $6d869a890ae8f6bb$export$bc31ff13a0bbe592 = ()=>{
    const shard = (0, $hWeHP.default)('ajs-shard');
    const region = (0, $hWeHP.default)('ajs-region');
    return {
        shard: shard,
        region: region,
        isFedRamp: (0, $lopBx.isFedRamp)()
    };
};

});



parcelRegister("6hw9S", function(module, exports) {
$parcel$export(module.exports, "useInlineFields", () => $36772de20b38f9e3$export$71d5b5acb7d7f5ce);
$parcel$export(module.exports, "useInlineField", () => $36772de20b38f9e3$export$14c9655e9d9e873c);
$parcel$export(module.exports, "useInlineFieldsActions", () => $36772de20b38f9e3$export$cdb4b503c6154b35);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $9pP3F = parcelRequire("9pP3F");
// Inline fields state tracks field states in create issue view as the user interacts with them
// this is particularly needed as we want to save the field's value when the user
// unfocuses the field
const $36772de20b38f9e3$var$store = (0, $GtRbT.createStore)({
    name: 'forge.inline-fields-state',
    initialState: {},
    actions: $9pP3F.default
});
const $36772de20b38f9e3$export$71d5b5acb7d7f5ce = (0, $iJq0l.createHook)($36772de20b38f9e3$var$store);
const $36772de20b38f9e3$export$14c9655e9d9e873c = (0, $iJq0l.createHook)($36772de20b38f9e3$var$store, {
    selector: (state, fieldId)=>state[fieldId]
});
const $36772de20b38f9e3$export$cdb4b503c6154b35 = (0, $iJq0l.createHook)($36772de20b38f9e3$var$store, {
    selector: null
});

});
parcelRegister("9pP3F", function(module, exports) {
$parcel$export(module.exports, "default", () => $29c5e55e7c9295c3$export$2e2bcd8739ae039);

var $daw73 = parcelRequire("daw73");
const $29c5e55e7c9295c3$var$actions = {
    setFieldState: $daw73.setFieldState,
    resetState: $daw73.resetState,
    dispatchRetryFunction: $daw73.dispatchRetryFunction,
    dispatchFormSubmits: $daw73.dispatchFormSubmits
};
var $29c5e55e7c9295c3$export$2e2bcd8739ae039 = $29c5e55e7c9295c3$var$actions;

});
parcelRegister("daw73", function(module, exports) {
$parcel$export(module.exports, "setFieldState", () => $21c19e4f95046684$export$80fd62d9217dd703);
$parcel$export(module.exports, "resetState", () => $21c19e4f95046684$export$8e84bad0b35de9e8);
$parcel$export(module.exports, "dispatchRetryFunction", () => $21c19e4f95046684$export$27c59f06a7c1fe26);
$parcel$export(module.exports, "dispatchFormSubmits", () => $21c19e4f95046684$export$42fd5e650971333b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4cTDP = parcelRequire("4cTDP");


var $21Y41 = parcelRequire("21Y41");
const $21c19e4f95046684$export$80fd62d9217dd703 = (data)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const stateObject = {
            status: data.status !== undefined ? data.status : currentState[data.fieldId]?.status,
            formRef: data.formRef !== undefined ? data.formRef : currentState[data.fieldId]?.formRef,
            retryFunction: data.retryFunction !== undefined ? data.retryFunction : currentState[data.fieldId]?.retryFunction,
            ...(0, $4cTDP.fg)('fcf-new-submit-on-gic-and-tv') ? {
                onFormSubmit: data.onFormSubmit !== undefined ? data.onFormSubmit : currentState[data.fieldId]?.onFormSubmit
            } : {}
        };
        setState({
            ...getState(),
            [data.fieldId]: stateObject
        });
    };
const $21c19e4f95046684$export$8e84bad0b35de9e8 = ()=>({ getState: getState, setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const stateToOverride = {};
        Object.getOwnPropertyNames(getState()).forEach((fieldId)=>{
            stateToOverride[fieldId] = {
                status: (0, $dfc00c8d0d7fbcf9$export$bbf78c43fa5268c8)
            };
        });
        setState(stateToOverride);
    };
const $21c19e4f95046684$export$27c59f06a7c1fe26 = (fieldId)=>async ({ getState: getState })=>{
        const currentState = getState();
        const fieldData = currentState[fieldId];
        const retryFunction = fieldData?.retryFunction;
        retryFunction && retryFunction();
    };
const $21c19e4f95046684$export$42fd5e650971333b = ()=>async ({ getState: getState })=>{
        const currentState = getState();
        Object.keys(currentState).forEach((fieldId)=>{
            if (currentState[fieldId]?.status === (0, $dfc00c8d0d7fbcf9$export$32bbcfb76243a487)) {
                if ((0, $4cTDP.fg)('fcf-new-submit-on-gic-and-tv')) currentState[fieldId]?.onFormSubmit?.();
                else {
                    const formRef = currentState[fieldId]?.formRef;
                    (0, $21Y41.dispatchFormSubmitAndBlurElements)(formRef);
                }
            }
        });
    };

});
const $dfc00c8d0d7fbcf9$export$32bbcfb76243a487 = 'FOCUSED';
const $dfc00c8d0d7fbcf9$export$f81c1d6b9217380c = 'PENDING';
const $dfc00c8d0d7fbcf9$export$2ace7d3737836262 = 'RESOLVED';
const $dfc00c8d0d7fbcf9$export$9956c6a700e724c4 = 'STORED';
const $dfc00c8d0d7fbcf9$export$742c877aeb0f3dbd = 'FAILED';
const $dfc00c8d0d7fbcf9$export$bbf78c43fa5268c8 = 'IDLE';
const $dfc00c8d0d7fbcf9$export$ae7c16bdba5e2e15 = 10000;
const $dfc00c8d0d7fbcf9$export$30daef8830f2505d = 'WAIT';
const $dfc00c8d0d7fbcf9$export$f86e250f1a7b07c8 = 'PROCEED';
const $dfc00c8d0d7fbcf9$export$e784a07a62e2e0e5 = 'TIMEOUT';

parcelRegister("21Y41", function(module, exports) {
$parcel$export(module.exports, "submitForgeFormField", () => $52b8ad5d67eac13b$export$7e50fee868362aa2);
$parcel$export(module.exports, "dispatchFormSubmitAndBlurElements", () => $52b8ad5d67eac13b$export$4d639a8e0790daf2);
$parcel$export(module.exports, "isBlurEventTriggeredOutsideTheField", () => $52b8ad5d67eac13b$export$ee23412a8bea9333);

const $52b8ad5d67eac13b$export$7e50fee868362aa2 = (formRef)=>{
    formRef?.current?.requestSubmit();
};
const $52b8ad5d67eac13b$export$4d639a8e0790daf2 = (formRef)=>{
    $52b8ad5d67eac13b$export$7e50fee868362aa2(formRef);
    if (formRef?.current?.elements) Array.from(formRef.current.elements).forEach((element)=>{
        if ('blur' in element && typeof element.blur === 'function') element?.blur();
    });
};
const $52b8ad5d67eac13b$export$ee23412a8bea9333 = (fieldState, event, divRef)=>fieldState?.status === (0, $dfc00c8d0d7fbcf9$export$32bbcfb76243a487) && !divRef.current?.contains(event.relatedTarget);

});




parcelRegister("2Z9P0", function(module, exports) {
$parcel$export(module.exports, "useIssueTransitionsOperationalAnalyticsEvent", () => $61f1a0bd70160d80$export$4d10663856b750d0);

var $eJOHy = parcelRequire("eJOHy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
const $61f1a0bd70160d80$export$4d10663856b750d0 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireOperationalEventIssueTransitionFieldsCount = (0, $eJOHy.useCallback)(({ actionSubject: actionSubject, fieldCount: fieldCount })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $kRgKj.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject, {
            fieldCount: fieldCount
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireOperationalAnalyticsPermissionsUnAvailable = (0, $eJOHy.useCallback)(({ actionSubject: actionSubject })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $kRgKj.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject);
    }, [
        createAnalyticsEvent
    ]);
    const fireOperationalAnalyticsTransitionScreenOpened = (0, $eJOHy.useCallback)(({ actionSubject: actionSubject, isBenefitsModalFGEneabled: isBenefitsModalFGEneabled, preferNewIssueTransitionScreen: preferNewIssueTransitionScreen, issueViewAnalyticsSource: issueViewAnalyticsSource, isBenefitsModalDisabled: isBenefitsModalDisabled, dateToShowBenefitsModal: dateToShowBenefitsModal })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $kRgKj.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject, {
            isBenefitsModalFGEneabled: isBenefitsModalFGEneabled,
            preferNewIssueTransitionScreen: preferNewIssueTransitionScreen,
            issueViewAnalyticsSource: issueViewAnalyticsSource,
            isBenefitsModalDisabled: isBenefitsModalDisabled,
            dateToShowBenefitsModal: dateToShowBenefitsModal
        });
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireOperationalEventIssueTransitionFieldsCount: fireOperationalEventIssueTransitionFieldsCount,
        fireOperationalAnalyticsPermissionsUnAvailable: fireOperationalAnalyticsPermissionsUnAvailable,
        fireOperationalAnalyticsTransitionScreenOpened: fireOperationalAnalyticsTransitionScreenOpened
    };
};

});

parcelRegister("l4UT4", function(module, exports) {
$parcel$export(module.exports, "useIssueTransitionUIAnalyticsEvent", () => $8ffdc81ff1362a6d$export$d0823e3d2e087672);

var $eJOHy = parcelRequire("eJOHy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
const $8ffdc81ff1362a6d$export$d0823e3d2e087672 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireUIEvent = (0, $eJOHy.useCallback)(({ analyticsEvent: analyticsEvent, actionSubjectId: actionSubjectId, action: action = 'clicked', actionSubject: actionSubject, attributes: attributes = {} })=>{
        if (analyticsEvent !== undefined) (0, $kRgKj.fireUIAnalytics)(analyticsEvent, actionSubjectId, attributes);
        else {
            const createdAnalyticsEvent = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            });
            (0, $kRgKj.fireUIAnalytics)(createdAnalyticsEvent, actionSubjectId, attributes);
        }
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireUIEvent: fireUIEvent
    };
};

});

parcelRegister("4xxMe", function(module, exports) {
$parcel$export(module.exports, "usePublishOpenIssueTransitionModalPubSub", () => $4322ecec3e9446dc$export$76b6328962c9935f);

var $eJOHy = parcelRequire("eJOHy");


var $bZa4R = parcelRequire("bZa4R");
const $4322ecec3e9446dc$export$76b6328962c9935f = ()=>(0, $eJOHy.useCallback)((payload, isEnabled)=>{
        (0, $bZa4R.ITSPubSub).publish((0, $3c718c856dd4cbdb$export$283bfc4a4b25707a), {
            payload: payload,
            isEnabled: isEnabled
        });
    }, []);

});
const $3c718c856dd4cbdb$export$283bfc4a4b25707a = 'open-issue-transition-modal';

parcelRegister("bZa4R", function(module, exports) {
$parcel$export(module.exports, "ITSPubSub", () => $d8182c339189cae2$export$a3877931259d622e);

var $eyAys = parcelRequire("eyAys");
const $d8182c339189cae2$export$a3877931259d622e = new (0, $eyAys.PubSubHub)();
const $d8182c339189cae2$export$58b86c4766378620 = ()=>({
        ...$d8182c339189cae2$export$a3877931259d622e
    });

});
parcelRegister("eyAys", function(module, exports) {
$parcel$export(module.exports, "PubSubHub", () => $3f91a97de5262c97$export$e3607828f8f2c01e);
class $3f91a97de5262c97$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});



parcelRegister("3FNro", function(module, exports) {
$parcel$export(module.exports, "TriggerIssueTransitionModalContainer", () => $02ead0d1b558cb0d$export$8ad65e459a406a8a);
$parcel$export(module.exports, "useTriggerIssueTransitionModalActions", () => $02ead0d1b558cb0d$export$68de001c738e4145);
$parcel$export(module.exports, "useTriggerIssueTransitionModalState", () => $02ead0d1b558cb0d$export$d3aceeec551eaab5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $2ZWxz = parcelRequire("2ZWxz");

var $3kNiX = parcelRequire("3kNiX");
const $02ead0d1b558cb0d$var$store = (0, $GtRbT.createStore)({
    name: 'issue-transition.issue-transition-form.use-trigger-issue-transition-modal',
    initialState: $2ZWxz.initialState,
    actions: $3kNiX
});
const $02ead0d1b558cb0d$export$8ad65e459a406a8a = (0, $6E16M.createContainer)($02ead0d1b558cb0d$var$store);
const $02ead0d1b558cb0d$export$68de001c738e4145 = (0, $iJq0l.createActionsHook)($02ead0d1b558cb0d$var$store);
const $02ead0d1b558cb0d$export$d3aceeec551eaab5 = (0, $iJq0l.createStateHook)($02ead0d1b558cb0d$var$store);

});
parcelRegister("2ZWxz", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $93d963d2149f1f5f$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "OPEN_MODERN_TRANSITION_MODAL", () => $93d963d2149f1f5f$export$7320afd6d2c7276d);
$parcel$export(module.exports, "OPEN_LEGACY_TRANSITION_MODAL", () => $93d963d2149f1f5f$export$8ed7400ca8e89de2);

const $93d963d2149f1f5f$export$d4c72bab9d6cc13a = {
    isModalOpen: false,
    isBenefitsModalOpen: false,
    isSubsequentLoad: false,
    payload: {
        issueId: '',
        issueKey: '',
        transitionId: ''
    },
    id: 'issue-transition-dialog',
    title: null,
    fetchedIssueId: '',
    triggerPointKey: (0, $862d7962fb804c73$export$8d987f6e80b74000),
    openLegacyTransitionsDialog: null,
    onDialogSuccess: null,
    onDialogCancel: null,
    onDialogError: null
};
const $93d963d2149f1f5f$export$7320afd6d2c7276d = 'OPEN_MODERN_TRANSITION_MODAL';
const $93d963d2149f1f5f$export$8ed7400ca8e89de2 = 'OPEN_LEGACY_TRANSITION_MODAL';

});
const $862d7962fb804c73$export$ef94a84e2990361c = 'issue-transition-issue-view';
const $862d7962fb804c73$export$de11f84a7d32933b = 'issue-transition-board-card-transition';
const $862d7962fb804c73$export$6c46e4003e7b7e9c = 'issue-transition-advanced-roadmaps-jira-transition';
const $862d7962fb804c73$export$e77cd508fbc3b5ba = 'issue-transition-backlog-inline-transition';
const $862d7962fb804c73$export$4edf4c3eee5081f6 = 'issue-transition-issue-view-shortcut-dialog';
const $862d7962fb804c73$export$27b74e685c26e665 = 'issue-transition-command-palette-status-field-transition';
const $862d7962fb804c73$export$290710ac08f770c0 = 'issue-transition-issue-results-shortcut-transition';
const $862d7962fb804c73$export$ddade13ad1b89bf0 = 'issue-transition-status-field-trigger';
const $862d7962fb804c73$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $862d7962fb804c73$export$2bf0e335b815a90b = 'comment';
const $862d7962fb804c73$export$1b8cc53b37a62399 = 'worklog';
const $862d7962fb804c73$export$d624b8367eb730df = 'issuelinks';


parcelRegister("3kNiX", function(module, exports) {
$parcel$export(module.exports, "closeIssueTransitionModal", () => (parcelRequire("bfHFG")).default);
$parcel$export(module.exports, "openIssueTransitionModal", () => (parcelRequire("6bdxh")).default);
$parcel$export(module.exports, "restoreState", () => (parcelRequire("76GoG")).default);
$parcel$export(module.exports, "setFetchedIssueId", () => (parcelRequire("edFG8")).default);
$parcel$export(module.exports, "hideBenefitsModal", () => (parcelRequire("6EG2b")).default);
$parcel$export(module.exports, "openIssueTransitionModalNew", () => (parcelRequire("bgUfW")).default);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $bfHFG = parcelRequire("bfHFG");

var $6bdxh = parcelRequire("6bdxh");

var $76GoG = parcelRequire("76GoG");

var $edFG8 = parcelRequire("edFG8");

var $6EG2b = parcelRequire("6EG2b");

var $bgUfW = parcelRequire("bgUfW");

});
parcelRegister("bfHFG", function(module, exports) {
$parcel$export(module.exports, "default", () => $621b2e1d5352d14e$export$2e2bcd8739ae039);

var $2ZWxz = parcelRequire("2ZWxz");
const $621b2e1d5352d14e$var$closeIssueTransitionModal = ()=>({ setState: setState })=>{
        setState({
            ...(0, $2ZWxz.initialState),
            isModalOpen: false,
            isSubsequentLoad: true
        });
    };
var $621b2e1d5352d14e$export$2e2bcd8739ae039 = $621b2e1d5352d14e$var$closeIssueTransitionModal;

});

parcelRegister("6bdxh", function(module, exports) {
$parcel$export(module.exports, "default", () => $2769a08690472f10$export$2e2bcd8739ae039);

var $12DRg = parcelRequire("12DRg");

var $23DdZ = parcelRequire("23DdZ");

var $9UaKE = parcelRequire("9UaKE");

var $2EgxC = parcelRequire("2EgxC");

var $lXLoB = parcelRequire("lXLoB");

var $axEN1 = parcelRequire("axEN1");
const $2769a08690472f10$var$openIssueTransitionModal = (nextState, preferNewIssueTransitionScreen = true)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
            payload: {}
        };
        let transitionModalVersion = '';
        const isNewITSEnabled = (0, $axEN1.isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
        try {
            if (isNewITSEnabled) {
                transitionModalVersion = 'NEW';
                (0, $lXLoB.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState
                });
            } else {
                transitionModalVersion = 'OLD';
                (0, $9UaKE.timeToRenderTransitionModal).start();
                new (0, $23DdZ.default)({
                    issueKey: issueKey,
                    transitionId: transitionId
                }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).show();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $2EgxC.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: transitionModalVersion
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
var $2769a08690472f10$export$2e2bcd8739ae039 = $2769a08690472f10$var$openIssueTransitionModal;

});
parcelRegister("23DdZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $48cd41f2280862c0$export$2e2bcd8739ae039);

var $12DRg = parcelRequire("12DRg");

var $gjeS9 = parcelRequire("gjeS9");
var $agkbU = parcelRequire("agkbU");
var $97BGz = parcelRequire("97BGz");
var $iyT45 = parcelRequire("iyT45");
var $4T9yL = parcelRequire("4T9yL");
var $ligZL = parcelRequire("ligZL");

var $kIz4h = parcelRequire("kIz4h");

var $4cTDP = parcelRequire("4cTDP");

var $9UaKE = parcelRequire("9UaKE");
class $48cd41f2280862c0$export$2e2bcd8739ae039 {
    constructor({ issueId: issueId, transitionId: transitionId, issueKey: issueKey, issueKeys: issueKeys }){
        this.onDialogSuccessCallback = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
        this.onDialogErrorCallback = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
        this.onDialogCancelCallback = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
        this.issueId = issueId;
        this.transitionId = transitionId;
        this.issueKey = issueKey;
        this.issueKeys = issueKeys;
    }
    static{
        this.onDialogContentReady = ()=>{
            // This event fired by a dialog before the dialog itself is rendered and visible to the user
            // That's why we need to postpone sending the response to the next moment after it became visible
            setTimeout(()=>{
                (0, $9UaKE.timeToRenderTransitionModal).stop();
            });
        };
    }
    onDialogSuccess(onDialogSuccessCallback) {
        this.onDialogSuccessCallback = onDialogSuccessCallback;
        return this;
    }
    onDialogError(onDialogErrorCallback) {
        this.onDialogErrorCallback = onDialogErrorCallback;
        return this;
    }
    onDialogCancel(onDialogCancelCallback) {
        this.onDialogCancelCallback = onDialogCancelCallback;
        return this;
    }
    getIssueParam() {
        if (this.issueId != null) return `id=${this.issueId}`;
        if (this.issueKey != null) return `key=${this.issueKey}`;
        return '';
    }
    getUrl() {
        const { issueKeys: issueKeys } = this;
        if (issueKeys != null) // key= is needed to be sent together with keys= because of legacy API
        return `/secure/BulkTransitionIssue!default.jspa?keys=${issueKeys.join(',')}&key=${issueKeys[0]}&action=${this.transitionId}&atl_token=${(0, $kIz4h.default)() || ''}&decorator=dialog&inline=true&returnUrl=`;
        return `/secure/WorkflowUIDispatcher.jspa?${this.getIssueParam()}&action=${this.transitionId}&atl_token=${(0, $kIz4h.default)() || ''}&returnUrl=`;
    }
    async show() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogContentReady', $48cd41f2280862c0$export$2e2bcd8739ae039.onDialogContentReady);
        let FormDialog;
        /**
		 * Trying out different ways of load the AMD bundle for legacy issue transition dialog
		 */ /* eslint-disable jira/wrm/no-load-bridge */ if ((0, $4cTDP.fg)('legacy-its-modal-load-with-load-bridge-weak')) FormDialog = await (0, $iyT45.loadBridgeWeak)({
            name: 'jira/dialog/form-dialog'
        });
        else if ((0, $4cTDP.fg)('legacy-its-modal-load-with-load-bridge-strict')) {
            await (0, $4T9yL.waitForHeritage)();
            FormDialog = await (0, $97BGz.loadBridgeStrict)({
                name: 'jira/dialog/form-dialog',
                wrmKeys: [
                    'wrc!jira.webresources:dialogs'
                ]
            });
        } else if ((0, $4cTDP.fg)('legacy-issue-transition-load-bridge')) {
            await (0, $ligZL.wrmRequire)([
                'wrc!jira.webresources:dialogs'
            ]);
            FormDialog = await (0, $agkbU.loadBridgeRace)({
                name: 'jira/dialog/form-dialog',
                timeout: 2000
            });
        } else FormDialog = await (0, $gjeS9.loadBridge)({
            name: 'jira/dialog/form-dialog',
            wrmKeys: 'wrc!jira.webresources:dialogs'
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const dialog = new FormDialog({
            id: 'edit-issue-dialog',
            ajaxOptions: {
                url: this.getUrl(),
                dataType: 'json'
            },
            autoClose: true,
            widthClass: 'large',
            onDialogFinished: this.onDialogSuccessCallback,
            onUnSuccessfulSubmit: this.onDialogErrorCallback,
            shouldLoadHeritageFormDialogContext: true
        });
        const cancelNativeHandler = (event)=>{
            if (!(event instanceof CustomEvent)) return;
            const dialogElement = event.detail.popup;
            const { reason: reason } = event.detail;
            if (dialogElement.is(dialog.get$popup())) {
                if (reason === 'cancel' || reason === 'esc') this.onDialogCancelCallback(event, dialogElement, reason);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.removeEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.removeEventListener('legacyJiraDialogContentReady', $48cd41f2280862c0$export$2e2bcd8739ae039.onDialogContentReady);
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
        dialog.show();
    }
}

});
parcelRegister("9UaKE", function(module, exports) {
$parcel$export(module.exports, "timeToRenderTransitionModal", () => $005484b577e7eb91$export$9d20a86383e90d09);

var $hqYEY = parcelRequire("hqYEY");
const $005484b577e7eb91$export$9d20a86383e90d09 = (0, $hqYEY.metrics).interaction({
    key: 'issue.time-to.render-issue-transition-screen',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_2500_4000_7000_10000'
    }
});

});


parcelRegister("lXLoB", function(module, exports) {
$parcel$export(module.exports, "startIssueTransitionMetrics", () => $a25f9b403dcc7733$export$3fc439100e136a52);

var $h6i8k = parcelRequire("h6i8k");

var $54FlQ = parcelRequire("54FlQ");

var $lwx4S = parcelRequire("lwx4S");

var $55aXL = parcelRequire("55aXL");
const $a25f9b403dcc7733$export$3fc439100e136a52 = (isSubsequentLoad)=>{
    (0, $54FlQ.IssueTransitionLoadUFOExperience).start();
    (0, $54FlQ.IssueTransitionUFOExperience).start();
    const issueTransitionModalLoadMetric = isSubsequentLoad ? (0, $lwx4S.issueTransittionModalLoadSubsequent) : (0, $lwx4S.issueTransitionModalLoad);
    if (isSubsequentLoad) (0, $h6i8k.default)('issue-transition.transition-modal-subsequent');
    else (0, $h6i8k.default)('issue-transition.transition-modal');
    issueTransitionModalLoadMetric.start();
    (0, $55aXL.startUimTTI)();
};

});
parcelRegister("54FlQ", function(module, exports) {
$parcel$export(module.exports, "IssueTransitionLoadUFOExperience", () => $d3b5fdfe001070e2$export$8fb308d8abecd81a);
$parcel$export(module.exports, "IssueTransitionSubmitUFOExpereince", () => $d3b5fdfe001070e2$export$bd3bf8b90a131c50);
$parcel$export(module.exports, "IssueTransitionUFOExperience", () => $d3b5fdfe001070e2$export$2f3b26e8acf79182);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");
const $d3b5fdfe001070e2$export$8fb308d8abecd81a = new (0, $f39LL.UFOExperience)('issue-transition-screen.transition-load', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-load'
});
const $d3b5fdfe001070e2$export$bd3bf8b90a131c50 = new (0, $f39LL.UFOExperience)('issue-transition-screen.transition-submit', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad,
    category: 'issue-transition-screen.transition-sumbit'
});
const $d3b5fdfe001070e2$export$2f3b26e8acf79182 = new (0, $f39LL.UFOExperience)('issue-transition-screen.transition-issue', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad,
    category: 'issue-transition-screen.transition-issue'
});

});

parcelRegister("lwx4S", function(module, exports) {
$parcel$export(module.exports, "issueTransitionModalLoad", () => $df727c28db2e450a$export$772fb4a8bd181fd6);
$parcel$export(module.exports, "issueTransittionModalLoadSubsequent", () => $df727c28db2e450a$export$afa89f024c56a00a);

var $hqYEY = parcelRequire("hqYEY");
const $df727c28db2e450a$export$772fb4a8bd181fd6 = (0, $hqYEY.metrics).interaction({
    key: 'issue-transition-modal'
});
const $df727c28db2e450a$export$afa89f024c56a00a = (0, $hqYEY.metrics).interaction({
    key: 'issue-transition-modal-subsequent'
});

});

parcelRegister("55aXL", function(module, exports) {
$parcel$export(module.exports, "startUimTTI", () => $a7c7a4f87935497a$export$ae34c17d9cd2c876);
$parcel$export(module.exports, "markIssueTransitionLoaded", () => $a7c7a4f87935497a$export$7cc1bb35860c7c25);
$parcel$export(module.exports, "stopTTI", () => $a7c7a4f87935497a$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $a7c7a4f87935497a$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $a7c7a4f87935497a$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $a7c7a4f87935497a$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $a7c7a4f87935497a$export$d86f4868694f2aa7);
/**
 * For issue view, we moved similar constants to view-specific packages.
 * However, for issue-transition, such a move causes a circular dependency with @atlassian/jira-issue-transition-trigger package,
 * since view-specific/issue-transition imports trigger points related functionality from @atlassian/jira-issue-transition-trigger.
 * Therefore, for now, let's keep it here.
 */ 
var $hqYEY = parcelRequire("hqYEY");
const $a7c7a4f87935497a$var$uimInIssueTransitionTTI = (0, $hqYEY.metrics).interaction({
    key: 'ui-modifications-in-issue-transition',
    timings: [
        {
            key: 'issue-transition-tti-delta',
            startMark: 'issue-transition-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ]
});
const $a7c7a4f87935497a$export$ae34c17d9cd2c876 = ()=>{
    $a7c7a4f87935497a$var$uimInIssueTransitionTTI.start();
};
const $a7c7a4f87935497a$export$7cc1bb35860c7c25 = ()=>$a7c7a4f87935497a$var$uimInIssueTransitionTTI.mark('issue-transition-tti');
const $a7c7a4f87935497a$export$30ca4c461fab486c = (customData)=>{
    $a7c7a4f87935497a$var$uimInIssueTransitionTTI.stop({
        customData: customData
    });
};
const $a7c7a4f87935497a$export$27f2445288b528c = ()=>{
    $a7c7a4f87935497a$var$uimInIssueTransitionTTI.cancel();
};
const $a7c7a4f87935497a$export$7a2709fc1e33401a = ()=>{
    $a7c7a4f87935497a$var$uimInIssueTransitionTTI.mark('iframe-load');
};
const $a7c7a4f87935497a$export$cf3893335c93e33b = ()=>{
    $a7c7a4f87935497a$var$uimInIssueTransitionTTI.mark('fields-registered');
};
const $a7c7a4f87935497a$export$d86f4868694f2aa7 = ()=>{
    $a7c7a4f87935497a$var$uimInIssueTransitionTTI.mark('oninit-resolved');
};

});


parcelRegister("axEN1", function(module, exports) {
$parcel$export(module.exports, "isNewTransitionScreenEnabled", () => $7c4eced4d65dd32f$export$1f5b72e7dbe0548d);

var $lopBx = parcelRequire("lopBx");

var $4cTDP = parcelRequire("4cTDP");
const $7c4eced4d65dd32f$export$1f5b72e7dbe0548d = (preferNewIssueTransitionScreen, triggerPointKey)=>{
    if ((0, $lopBx.isFedRamp)()) return true;
    if (!(0, $4cTDP.fg)('render-modern-issue-transition')) return false;
    if (!triggerPointKey) return false;
    return preferNewIssueTransitionScreen || (0, $4cTDP.fg)('issue-transition-customisation-for-srb');
};

});


parcelRegister("76GoG", function(module, exports) {
$parcel$export(module.exports, "default", () => $7592117783ba8d3f$export$2e2bcd8739ae039);
const $7592117783ba8d3f$var$restoreState = (stateToRestore)=>({ setState: setState })=>{
        setState(stateToRestore);
    };
var $7592117783ba8d3f$export$2e2bcd8739ae039 = $7592117783ba8d3f$var$restoreState;

});

parcelRegister("edFG8", function(module, exports) {
$parcel$export(module.exports, "default", () => $b03af3d18e6b8f33$export$2e2bcd8739ae039);
/**
 *
 * @deprecated since we should not be using this in the log run
 * we should not call this method any where and should clean this up as soon as GIC-JIS migration is done
 * @param issueId
 * @returns
 */ const $b03af3d18e6b8f33$var$setFetchedIssueId = (issueId)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { fetchedIssueId: fetchedIssueId } = currentState;
        if (issueId !== fetchedIssueId) setState({
            ...currentState,
            fetchedIssueId: issueId
        });
    };
var $b03af3d18e6b8f33$export$2e2bcd8739ae039 = $b03af3d18e6b8f33$var$setFetchedIssueId;

});

parcelRegister("6EG2b", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc4da86e1baaf3f5$export$2e2bcd8739ae039);

var $2ZWxz = parcelRequire("2ZWxz");

var $lXLoB = parcelRequire("lXLoB");
const $cc4da86e1baaf3f5$var$hideBenefitsModal = (nextAction)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (nextAction === (0, $2ZWxz.OPEN_MODERN_TRANSITION_MODAL)) {
            (0, $lXLoB.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
            setState({
                ...currentState,
                isBenefitsModalOpen: false,
                isModalOpen: true
            });
        } else if (nextAction === (0, $2ZWxz.OPEN_LEGACY_TRANSITION_MODAL)) {
            const { openLegacyTransitionsDialog: openLegacyTransitionsDialog } = getState();
            setState({
                ...currentState,
                isBenefitsModalOpen: false,
                isModalOpen: false
            });
            openLegacyTransitionsDialog?.();
        }
    };
var $cc4da86e1baaf3f5$export$2e2bcd8739ae039 = $cc4da86e1baaf3f5$var$hideBenefitsModal;

});

parcelRegister("bgUfW", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1cb7f5be815b3c4$export$2e2bcd8739ae039);

var $12DRg = parcelRequire("12DRg");

var $23DdZ = parcelRequire("23DdZ");

var $9UaKE = parcelRequire("9UaKE");

var $2EgxC = parcelRequire("2EgxC");

var $4cTDP = parcelRequire("4cTDP");

var $lXLoB = parcelRequire("lXLoB");

var $axEN1 = parcelRequire("axEN1");
const $d1cb7f5be815b3c4$var$openIssueTransitionModalNew = ({ nextState: nextState, preferNewIssueTransitionScreen: preferNewIssueTransitionScreen = true, issueViewAnalyticsSource: issueViewAnalyticsSource, publishTriggerToOpenTransitions: publishTriggerToOpenTransitions, isBenefitsModalDisabled: isBenefitsModalDisabled, dateToShowBenefitsModal: dateToShowBenefitsModal, fireUIEvent: fireUIEvent })=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
            payload: {}
        };
        let transitionModalVersion = '';
        const isNewITSEnabled = (0, $axEN1.isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
        try {
            if (isNewITSEnabled) {
                if (issueViewAnalyticsSource === 'connect-issue') {
                    publishTriggerToOpenTransitions?.(nextState, preferNewIssueTransitionScreen);
                    fireUIEvent?.({
                        actionSubject: 'issueTransition',
                        actionSubjectId: 'connectIssue',
                        action: 'opened'
                    });
                    return;
                }
                transitionModalVersion = 'NEW';
                (0, $lXLoB.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState
                });
                return;
            }
            const currentDate = new Date();
            const showBenefitsModalOnDate = dateToShowBenefitsModal && dateToShowBenefitsModal !== 'null' ? new Date(dateToShowBenefitsModal) : new Date(-1);
            const isDateToShowBenefitsModalLessThanCurrentDate = currentDate >= showBenefitsModalOnDate;
            if (!isBenefitsModalDisabled && issueViewAnalyticsSource !== 'connect-issue' && isDateToShowBenefitsModalLessThanCurrentDate && (0, $4cTDP.fg)('render-modern-issue-transition')) {
                // add condition to show BenefitsModal
                transitionModalVersion = 'NEW';
                const callback = ()=>{
                    (0, $9UaKE.timeToRenderTransitionModal).start();
                    new (0, $23DdZ.default)({
                        issueKey: issueKey,
                        transitionId: transitionId
                    }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).show();
                };
                setState({
                    ...currentState,
                    isBenefitsModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState,
                    openLegacyTransitionsDialog: callback
                });
            } else {
                transitionModalVersion = 'OLD';
                (0, $9UaKE.timeToRenderTransitionModal).start();
                new (0, $23DdZ.default)({
                    issueKey: issueKey,
                    transitionId: transitionId
                }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).show();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $2EgxC.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: transitionModalVersion
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
var $d1cb7f5be815b3c4$export$2e2bcd8739ae039 = $d1cb7f5be815b3c4$var$openIssueTransitionModalNew;

});



parcelRegister("7SyqX", function(module, exports) {
$parcel$export(module.exports, "openLegacyIssueTransitionModal", () => $c99c1512d35cb397$export$6bfef2005bd55204);

var $12DRg = parcelRequire("12DRg");

var $23DdZ = parcelRequire("23DdZ");

var $9UaKE = parcelRequire("9UaKE");

var $2EgxC = parcelRequire("2EgxC");
const $c99c1512d35cb397$export$6bfef2005bd55204 = ({ issueKey: issueKey, transitionId: transitionId, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, isReopenScenario: isReopenScenario = false, onOpenDialog: onOpenDialog })=>{
    try {
        (0, $9UaKE.timeToRenderTransitionModal).start();
        new (0, $23DdZ.default)({
            issueKey: issueKey,
            transitionId: transitionId
        }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))).show();
        onOpenDialog?.();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2EgxC.fireIssueTransitionErrorAnalytics)({
            meta: {
                id: 'transitionIssueTrigger',
                packageName: 'jiraIssueTransitionTrigger',
                teamName: 'gryffindor'
            },
            error: error,
            attributes: {
                transitionModalVersion: 'OLD',
                isReopenScenario: isReopenScenario
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});


parcelRegister("7ty7w", function(module, exports) {
$parcel$export(module.exports, "useWorkflowTransitionsValue", () => $8d9b0e0123c5c6bc$export$435cba24c8d1ddf6);
$parcel$export(module.exports, "useWorkflowTransitionsTransitionInProgress", () => $8d9b0e0123c5c6bc$export$9b35656991b0ecda);
$parcel$export(module.exports, "useWorkflowTransitionsActions", () => $8d9b0e0123c5c6bc$export$d5245ade1619037b);

var $eJOHy = parcelRequire("eJOHy");

var $6JG72 = parcelRequire("6JG72");
const $8d9b0e0123c5c6bc$export$435cba24c8d1ddf6 = ()=>{
    const [value, { setState: setState }] = (0, $6JG72.useWorkflowTransitionsStoreValue)();
    return [
        value,
        setState
    ];
};
const $8d9b0e0123c5c6bc$export$9b35656991b0ecda = ()=>{
    const [value] = (0, $6JG72.useWorkflowTransitionsStoreTransitionInProgress)();
    return value;
};
const $8d9b0e0123c5c6bc$export$d5245ade1619037b = ()=>{
    const [, actions] = (0, $6JG72.useWorkflowTransitionsStoreActions)();
    const workflowActions = (0, $eJOHy.useMemo)(()=>{
        // @ts-expect-error - TS7006 - Parameter 'partialState' implicitly has an 'any' type.
        const setState = (partialState)=>{
            actions.setState(partialState);
        };
        const setTransitionInProgress = (isLoading)=>{
            actions.setTransitionInProgress(isLoading);
        };
        return {
            setState: setState,
            setTransitionInProgress: setTransitionInProgress
        };
    }, [
        actions
    ]);
    return [
        null,
        workflowActions
    ];
};

});
parcelRegister("6JG72", function(module, exports) {
$parcel$export(module.exports, "useWorkflowTransitionsStoreValue", () => $03a286594d43c837$export$435e780321f76edc);
$parcel$export(module.exports, "useWorkflowTransitionsStoreTransitionInProgress", () => $03a286594d43c837$export$35c153667c57d035);
$parcel$export(module.exports, "useWorkflowTransitionsStoreActions", () => $03a286594d43c837$export$370707f36c1f66df);
$parcel$export(module.exports, "WorkflowTransitionsStoreContainer", () => $03a286594d43c837$export$1e23e2bdfc599859);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $bxfNP = parcelRequire("bxfNP");
const $03a286594d43c837$var$store = (0, $GtRbT.createStore)({
    name: 'workflow-transitions',
    initialState: {
        data: null,
        loading: false,
        error: null,
        ui: {
            transitionInProgress: false
        }
    },
    actions: $bxfNP.actions
});
const $03a286594d43c837$export$435e780321f76edc = (0, $iJq0l.createHook)($03a286594d43c837$var$store, {
    selector: (state)=>state
});
const $03a286594d43c837$export$35c153667c57d035 = (0, $iJq0l.createHook)($03a286594d43c837$var$store, {
    selector: (state)=>state.ui.transitionInProgress
});
const $03a286594d43c837$export$370707f36c1f66df = (0, $iJq0l.createHook)($03a286594d43c837$var$store, {
    selector: null
});
const $03a286594d43c837$export$1e23e2bdfc599859 = (0, $6E16M.createContainer)($03a286594d43c837$var$store);

});
parcelRegister("bxfNP", function(module, exports) {
$parcel$export(module.exports, "actions", () => $df970d8be97cf267$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $df970d8be97cf267$var$setState = (state = {})=>({ setState: setSweetState, getState: getState })=>{
        const newState = {
            ...getState(),
            ...state
        };
        setSweetState(newState);
    };
const $df970d8be97cf267$var$setTransitionInProgress = (transitionInProgress)=>({ setState: setSweetState, getState: getState })=>{
        setSweetState({
            ui: {
                ...getState().ui,
                transitionInProgress: transitionInProgress
            }
        });
    };
const $df970d8be97cf267$export$e324594224ef24da = {
    setState: $df970d8be97cf267$var$setState,
    setTransitionInProgress: $df970d8be97cf267$var$setTransitionInProgress
};

});



parcelRegister("9Z4bX", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0a4e1084abe7954$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $eSnSE = parcelRequire("eSnSE");

var $hrKgE = parcelRequire("hrKgE");

var $4cTDP = parcelRequire("4cTDP");

var $14RSn = parcelRequire("14RSn");

var $7wFII = parcelRequire("7wFII");

var $dMM78 = parcelRequire("dMM78");

var $keOPi = parcelRequire("keOPi");

var $d2AGn = parcelRequire("d2AGn");

var $eDOqM = parcelRequire("eDOqM");

var $3ibpe = parcelRequire("3ibpe");

var $8oKDI = parcelRequire("8oKDI");

var $3mZMJ = parcelRequire("3mZMJ");

var $kRgKj = parcelRequire("kRgKj");



var $FMOPx = parcelRequire("FMOPx");

var $6gASS = parcelRequire("6gASS");

var $kVuBT = parcelRequire("kVuBT");
const $c0a4e1084abe7954$var$DIALOG_SUBMIT_BTN = '#issue-workflow-transition-submit';
const $c0a4e1084abe7954$var$safeUnbindDomEvent = (selector, event, handler)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const el = document.querySelector(selector);
    if (el) el.removeEventListener(event, handler);
};
const $c0a4e1084abe7954$var$safeBindDomEvent = (selector, event, handler)=>{
    $c0a4e1084abe7954$var$safeUnbindDomEvent(selector, event, handler);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const el = document.querySelector(selector);
    if (el) el.addEventListener(event, handler);
};
const $c0a4e1084abe7954$var$StatusService = ({ value: propValue, initialValue: initialValue, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onEditCancel: onEditCancel = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), children: children, ...unstableProps })=>{
    const props = (0, $hrKgE.useShallowStableReference)(unstableProps);
    const [stateValue, setStateValue] = (0, $eJOHy.useState)(()=>{
        const value = propValue || initialValue;
        if (!value) throw new Error('Either value or initialValue prop is required.');
        return value;
    });
    const [lastSavedValue, setLastSavedValue] = (0, $eJOHy.useState)(stateValue);
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    const [stateError, setError] = (0, $eJOHy.useState)(null);
    // These are unused but we are keeping parity with the class component
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [isDialogOpened, setIsDialogOpened] = (0, $eJOHy.useState)(false);
    // These are unused but we are keeping parity with the class component
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [isDialogConfirmPressed, setIsDialogConfirmPressed] = (0, $eJOHy.useState)(false);
    /**
	 * Equivalent to getDerivedStateFromProps in class component version.
	 *
	 * Lets the consumer control the value of this component. If the consumer passes a `value` prop
	 * it will override the value in state, as long as the component is not in loading state. That's because the component
	 * will only let the consumer know about the new status value once the transition is complete (i.e. loading=false).
	 *
	 * This lifecycle method gets called before every invocation of render().
	 */ const value = (0, $eJOHy.useMemo)(()=>{
        if (loading || !propValue) return stateValue;
        return propValue;
    }, [
        loading,
        propValue,
        stateValue
    ]);
    // componentDidUpdate
    const prevInitialValueRef = (0, $eJOHy.useRef)(initialValue);
    (0, $eJOHy.useLayoutEffect)(()=>{
        const prevInitialValue = prevInitialValueRef.current;
        const newInitialValue = initialValue;
        const isNewStatus = newInitialValue && prevInitialValue && prevInitialValue.id !== newInitialValue.id && newInitialValue.id !== value.id;
        const hasNameChanged = newInitialValue && prevInitialValue && prevInitialValue.name !== newInitialValue.name;
        const hasCategoryChanged = newInitialValue && prevInitialValue && prevInitialValue.statusCategory.id !== newInitialValue.statusCategory.id;
        if (isNewStatus || props.checkRefreshedData && (hasNameChanged || hasCategoryChanged)) {
            setLoading(false);
            setStateValue(newInitialValue);
        }
        prevInitialValueRef.current = newInitialValue;
    }, [
        initialValue,
        props.checkRefreshedData,
        value.id
    ]);
    const onClickDialogConfirm = (0, $eJOHy.useCallback)(()=>{
        setIsDialogConfirmPressed(true);
    }, []);
    const bindDialogFormHandlers = (0, $eJOHy.useCallback)(()=>{
        $c0a4e1084abe7954$var$safeBindDomEvent($c0a4e1084abe7954$var$DIALOG_SUBMIT_BTN, 'click', onClickDialogConfirm);
    }, [
        onClickDialogConfirm
    ]);
    const unbindDialogFormHandlers = (0, $eJOHy.useCallback)(()=>{
        $c0a4e1084abe7954$var$safeUnbindDomEvent($c0a4e1084abe7954$var$DIALOG_SUBMIT_BTN, 'click', onClickDialogConfirm);
    }, [
        onClickDialogConfirm
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // componentDidMount
        const onDialogContentReady = ()=>{
            // Using setTimeout as that was the class component version - this may need to be changed for concurrent
            // This event fired by a dialog before the dialog itself is rendered and visible to the user
            // That's why we need to postpone sending the response to the next moment after it became visible
            setTimeout(()=>{
                bindDialogFormHandlers();
                setIsDialogOpened(true);
                setIsDialogConfirmPressed(false);
            });
        };
        const handleBeforeDialogHide = ()=>{
            unbindDialogFormHandlers();
            setIsDialogOpened(false);
            setIsDialogConfirmPressed(false);
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogContentReady', onDialogContentReady);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogBeforeHide', handleBeforeDialogHide);
        return ()=>{
            // componentWillUnmount
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('legacyJiraDialogContentReady', onDialogContentReady);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('legacyJiraDialogBeforeHide', handleBeforeDialogHide);
            unbindDialogFormHandlers();
        // this.isDialogOpened = false; // we dont need to change the state since we are unmounting
        };
    }, [
        bindDialogFormHandlers,
        unbindDialogFormHandlers
    ]);
    const resetError = (0, $eJOHy.useCallback)(()=>{
        setError(null);
    }, []);
    const submit = (0, $eJOHy.useCallback)((transition, event)=>{
        const oldValue = value;
        const newValue = transition.to;
        const isEditFromIssueView = (0, $eDOqM.getIsEditFromIssueView)(event);
        const issueAri = props.issueId;
        const issueId = issueAri && (0, $8oKDI.isAri)(issueAri) ? (0, $8oKDI.getAriConfig)(issueAri).resourceId : issueAri;
        (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $3mZMJ.STATUS_TYPE), {
            analytics: event,
            attributes: {
                fieldType: (0, $3mZMJ.STATUS_TYPE),
                // Disabling typechange to keep parity
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                oldValId: oldValue.statusId ?? oldValue.id,
                newValId: newValue.id,
                oldStatusCategoryId: oldValue.statusCategory.id,
                newStatusCategoryId: newValue.statusCategory.id,
                isInlineEditing: !isEditFromIssueView,
                issueId: issueId
            }
        });
        setLoading(true);
        setStateValue(newValue);
        onSubmit(oldValue, newValue, {
            transition: transition
        }, event);
    }, [
        value,
        onSubmit,
        props.issueId
    ]);
    const success = (0, $eJOHy.useCallback)(({ status: status, event: event, viaDialog: viaDialog = false })=>{
        setLoading(false);
        setLastSavedValue(status);
        props.fieldValueActions.setFieldValue(props.issueKey, (0, $3mZMJ.STATUS_TYPE), status);
        onSuccess(status, viaDialog, event);
        if ((0, $4cTDP.fg)('fix-status-field-loading-issue')) props.workflowTransitionsActions.setTransitionInProgress(false);
        (0, $kRgKj.fireTrackAnalytics)(event, 'statusField transitioned', 'statusField');
        (0, $3ibpe.sendExperienceAnalytics)((0, $FMOPx.transitionIssueExperienceDescription)(true, 'POST', props.source ?? '', props.projectType));
    }, [
        onSuccess,
        props.fieldValueActions,
        props.issueKey,
        props.projectType,
        props.source,
        props.workflowTransitionsActions
    ]);
    const failure = (0, $eJOHy.useCallback)((error, event)=>{
        setError(error);
        setLoading(false);
        setStateValue(lastSavedValue || propValue || initialValue);
        onFailure(error);
        if ((0, $4cTDP.fg)('fix-status-field-loading-issue')) props.workflowTransitionsActions.setTransitionInProgress(false);
        const isValidationError = error instanceof (0, $14RSn.ValidationError);
        if (isValidationError) props.flagService.showFlag((0, $kVuBT.default)(error.message));
        else props.flagService.showFlag((0, $6gASS.default)({
            error: error,
            traceId: error.traceId
        }));
        (0, $kRgKj.fireOperationalAnalytics)(event, 'statusField postTransitionFailed', {
            validationError: isValidationError,
            isClientFetchError: (0, $dMM78.isClientFetchError)(error)
        });
        (0, $3ibpe.sendExperienceAnalytics)((0, $FMOPx.transitionIssueExperienceDescription)(false, 'POST', props.source ?? '', props.projectType, error.message, error.traceId, error.statusCode, (0, $7wFII.isAbortableError)(error) && (0, $4cTDP.fg)('thor_add_taskabort_events_for_core_experiences') ? 'taskAbort' : 'taskFail'));
    }, [
        initialValue,
        lastSavedValue,
        onFailure,
        propValue,
        props.flagService,
        props.projectType,
        props.source,
        props.workflowTransitionsActions
    ]);
    const cancel = (0, $eJOHy.useCallback)(()=>{
        setLoading(false);
        // @ts-expect-error - TS2322 - Type 'Status | undefined' is not assignable to type 'Status'.
        setStateValue(propValue || initialValue);
        onEditCancel();
        props.workflowTransitionsActions.setTransitionInProgress(false);
    }, [
        initialValue,
        onEditCancel,
        propValue,
        props.workflowTransitionsActions
    ]);
    const transitionStatus = (0, $eJOHy.useCallback)(async (transition, event)=>{
        const { appearance: appearance, issueKey: issueKey, renderIssueTransitionModal: renderIssueTransitionModal } = props;
        const newStatus = transition.to;
        submit(transition, event);
        try {
            if (transition.hasScreen) {
                const handleDialogSuccess = ()=>{
                    (0, $kRgKj.fireTrackAnalytics)(event, 'issueTransition success', {
                        triggerPointKey: (0, $69adb038ef37db8c$export$a6eb4c39beb71474),
                        isModalOpen: true
                    });
                    return success({
                        status: newStatus,
                        event: event,
                        viaDialog: true
                    });
                };
                const handleDialogCancel = ()=>{
                    (0, $kRgKj.fireTrackAnalytics)(event, 'issueTransition cancel', {
                        triggerPointKey: (0, $69adb038ef37db8c$export$a6eb4c39beb71474),
                        isModalOpen: true
                    });
                    return cancel();
                };
                const handleDialogError = ()=>{
                    (0, $kRgKj.fireTrackAnalytics)(event, 'issueTransition failed', {
                        triggerPointKey: (0, $69adb038ef37db8c$export$a6eb4c39beb71474),
                        isModalOpen: true
                    });
                };
                if (renderIssueTransitionModal) {
                    const { issueId: issueId } = props;
                    renderIssueTransitionModal({
                        payload: {
                            issueId: issueId,
                            issueKey: issueKey,
                            transitionId: transition.id
                        },
                        triggerPointKey: appearance === 'lozenge' ? 'issue-transition-status-field-trigger' : 'issue-transition-issue-view',
                        onDialogSuccess: handleDialogSuccess,
                        onDialogCancel: handleDialogCancel,
                        onDialogError: handleDialogError,
                        analyticsEvent: event
                    });
                }
            } else {
                if (props.onUpdateStatusMutation && (0, $4cTDP.fg)('relay-migration-issue-fields-status')) await props.onUpdateStatusMutation?.({
                    transitionId: transition.id,
                    newStatus: newStatus
                });
                else await (0, $keOPi.performIssuePostRequest)(`/rest/api/2/issue/${issueKey}/transitions`, {
                    body: JSON.stringify({
                        transition: transition
                    })
                }, 'fields/status/src/services/status-service/status-service-new');
                (0, $kRgKj.fireTrackAnalytics)(event, 'issueTransition success', {
                    triggerPointKey: (0, $69adb038ef37db8c$export$a6eb4c39beb71474),
                    isModalOpen: false
                });
                success({
                    status: newStatus,
                    event: event
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData((0, $4ecf649628197b0c$export$25529a3376b831fd), error);
            (0, $kRgKj.fireTrackAnalytics)(event, 'issueTransition failed', {
                triggerPointKey: (0, $69adb038ef37db8c$export$a6eb4c39beb71474),
                isModalOpen: false
            });
            failure(error, event);
        }
    }, [
        cancel,
        failure,
        props,
        submit,
        success
    ]);
    const state = (0, $eJOHy.useMemo)(()=>({
            value: value,
            lastSavedValue: lastSavedValue,
            loading: loading,
            error: stateError
        }), [
        value,
        lastSavedValue,
        loading,
        stateError
    ]);
    const api = (0, $eJOHy.useMemo)(()=>({
            transitionStatus: transitionStatus,
            resetError: resetError
        }), [
        resetError,
        transitionStatus
    ]);
    return children({
        ...state,
        ...api
    });
};
var $c0a4e1084abe7954$export$2e2bcd8739ae039 = $c0a4e1084abe7954$var$StatusService;

});
parcelRegister("7wFII", function(module, exports) {
$parcel$export(module.exports, "isAbortableError", () => $a93b392b7e4fefa9$export$e05e0fb17c2ab75a);

var $6NFx3 = parcelRequire("6NFx3");

var $9Dhvc = parcelRequire("9Dhvc");

var $14RSn = parcelRequire("14RSn");

var $dMM78 = parcelRequire("dMM78");

var $4cTDP = parcelRequire("4cTDP");
const $a93b392b7e4fefa9$export$e05e0fb17c2ab75a = (error)=>{
    const statusCode = $a93b392b7e4fefa9$var$extractStatusCode(error);
    if ((0, $dMM78.isHttpClientErrorStatusCode)(statusCode) || !statusCode && (0, $dMM78.isClientFetchError)(error) || error?.name === (0, $14RSn.VALIDATION_ERROR_NAME)) return true;
    return false;
};
const $a93b392b7e4fefa9$var$getStatusCodeFromGraphQLErrors = (graphQLErrors)=>{
    const statusCodes = graphQLErrors.map((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(e, [
            'extensions',
            'statusCode'
        ])).filter((statusCode)=>!!statusCode);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($6NFx3)))(statusCodes);
    return statusCode || null;
};
const $a93b392b7e4fefa9$var$extractStatusCode = (error)=>{
    const errorStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'statusCode'
    ], null);
    const graphQLErrors = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'graphQLErrors'
    ], null);
    const networkError = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'networkError'
    ], null);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(networkError, [
        'statusCode'
    ], null);
    const relayErrors = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
        'source',
        'errors'
    ], null);
    if (typeof errorStatusCode === 'number') return errorStatusCode;
    if (typeof statusCode === 'number') return statusCode;
    if (Array.isArray(graphQLErrors) && graphQLErrors.length > 0) return $a93b392b7e4fefa9$var$getStatusCodeFromGraphQLErrors(graphQLErrors);
    if (Array.isArray(relayErrors) && relayErrors.length > 0 && (0, $4cTDP.fg)('improve_abortable_errors_experience_tracker')) return $a93b392b7e4fefa9$var$getStatusCodeFromGraphQLErrors(relayErrors);
    return null;
};

});
parcelRegister("6NFx3", function(module, exports) {

var $dbOsL = parcelRequire("dbOsL");

var $9wRNl = parcelRequire("9wRNl");

var $d7YnM = parcelRequire("d7YnM");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $4f3789168d11a4da$var$max(array) {
    return array && array.length ? $dbOsL(array, $d7YnM, $9wRNl) : undefined;
}
module.exports = $4f3789168d11a4da$var$max;

});
parcelRegister("dbOsL", function(module, exports) {

var $9D78T = parcelRequire("9D78T");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $99a3725aea015bd0$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$9D78T(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = $99a3725aea015bd0$var$baseExtremum;

});

parcelRegister("9wRNl", function(module, exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $6f00d4c0b88cefe1$var$baseGt(value, other) {
    return value > other;
}
module.exports = $6f00d4c0b88cefe1$var$baseGt;

});



const $4ecf649628197b0c$export$71a8e2ae8cfade56 = 'issue-field.status.fetch-transitions';
const $4ecf649628197b0c$export$25529a3376b831fd = 'issue-field.status.post-transition';
const $4ecf649628197b0c$export$4bf6353caa97e8e7 = 'issue-field.status.fetch-view-workflow';
const $4ecf649628197b0c$export$136fc24ec1bfcefd = 'VIEW_READONLY_WORKFLOW';
const $4ecf649628197b0c$export$624e7abc8d9cada5 = 'ADMINISTER';

const $69adb038ef37db8c$export$a6eb4c39beb71474 = 'issue-transition-status-field';

parcelRegister("FMOPx", function(module, exports) {
$parcel$export(module.exports, "transitionIssueExperienceDescription", () => $febcdf73cff08cfb$export$1afc7ca514c2b5b9);

var $aYncF = parcelRequire("aYncF");

var $lBYgs = parcelRequire("lBYgs");

var $cblKs = parcelRequire("cblKs");
const $febcdf73cff08cfb$export$1afc7ca514c2b5b9 = (wasSuccessful, method, analyticsSource, projectType, errorMessage, traceId, statusCode, action)=>{
    let application = null;
    let edition = null;
    if (projectType !== null) try {
        const { appEditions: appEditions } = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
        application = (0, $lBYgs.getApplicationForProject)(projectType);
        edition = (0, $cblKs.getEdition)(application, appEditions);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // application and edition already default to null.
    }
    // Flow sadly cannot do multiple spreads in one object, and additionalAttributes
    // cannot potentially contain fields as undefined.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const additionalAttributes = {};
    if (errorMessage != null) additionalAttributes.errorMessage = errorMessage;
    if (traceId != null) additionalAttributes.traceId = traceId;
    if (statusCode) additionalAttributes.statusCode = statusCode;
    const experience = method === 'POST' ? 'transitionIssue' : 'getTransitions';
    return {
        experience: experience,
        action: action,
        wasExperienceSuccesful: wasSuccessful,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        additionalAttributes: {
            ...additionalAttributes,
            method: method
        }
    };
};

});

parcelRegister("6gASS", function(module, exports) {
$parcel$export(module.exports, "default", () => $622673ba3c3979db$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $622673ba3c3979db$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "issue-field-status.services.flags.transition-failed-error.main.title",
        "defaultMessage": "We couldn't update the status"
    },
    description: {
        "id": "issue-field-status.services.flags.transition-failed-error.main.description",
        "defaultMessage": "Check your network connection, then try reloading the issue."
    }
});
const $622673ba3c3979db$var$statusTransitionErrorFlag = (flagConfig)=>({
        messageId: `issue.fields.status.services.flags.transition-failed-error.flag.error.${flagConfig?.error?.name}`,
        messageType: 'transactional',
        type: 'error',
        title: $622673ba3c3979db$var$messages.title,
        description: $622673ba3c3979db$var$messages.description,
        isAutoDismiss: true,
        ...flagConfig || {}
    });
var $622673ba3c3979db$export$2e2bcd8739ae039 = $622673ba3c3979db$var$statusTransitionErrorFlag;

});

parcelRegister("kVuBT", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee8205860cbe92a0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ee8205860cbe92a0$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "issue-field-status.services.flags.validation-error.main.title",
        "defaultMessage": "Transition failed"
    }
});
const $ee8205860cbe92a0$var$statusTransitionValidationErrorFlag = (description)=>({
        messageId: 'issue-field-status.services.flags.validation-error.flag.warning.error',
        messageType: 'transactional',
        type: 'warning',
        title: $ee8205860cbe92a0$var$messages.title,
        description: {
            id: 'issue-field.status.services.flags.validation-error.main.description',
            defaultMessage: description
        },
        isAutoDismiss: true
    });
var $ee8205860cbe92a0$export$2e2bcd8739ae039 = $ee8205860cbe92a0$var$statusTransitionValidationErrorFlag;

});



parcelRegister("dxgbR", function(module, exports) {
$parcel$export(module.exports, "TransitionsQuery", () => $fcebea1e3daa5ecd$export$e166c7039d71);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $3So8J = parcelRequire("3So8J");

var $cD8Vg = parcelRequire("cD8Vg");
const $fcebea1e3daa5ecd$export$e166c7039d71 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "issue.fields.status.transitions-query"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3So8J.default), {
        id: "fields.status.transitions-query",
        packageName: "jiraIssueFieldStatus",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cD8Vg.TransitionsQuery), props)));

});
parcelRegister("cD8Vg", function(module, exports) {
$parcel$export(module.exports, "getStatusTransitionsUrl", () => $39cd6476d8b36e07$export$661439a50b90a96f);
$parcel$export(module.exports, "TransitionsQuery", () => $39cd6476d8b36e07$export$e166c7039d71);

var $eJOHy = parcelRequire("eJOHy");

var $4J0ad = parcelRequire("4J0ad");

var $4cTDP = parcelRequire("4cTDP");

var $4mEPL = parcelRequire("4mEPL");

var $eaTQ3 = parcelRequire("eaTQ3");

var $3ibpe = parcelRequire("3ibpe");

var $gPQL9 = parcelRequire("gPQL9");

var $7wFII = parcelRequire("7wFII");

var $6JG72 = parcelRequire("6JG72");

var $7ty7w = parcelRequire("7ty7w");

var $kRgKj = parcelRequire("kRgKj");

var $bmoS1 = parcelRequire("bmoS1");

var $cxKOj = parcelRequire("cxKOj");

var $d4GL0 = parcelRequire("d4GL0");


var $FMOPx = parcelRequire("FMOPx");

var $e3GKX = parcelRequire("e3GKX");

var $bk4nH = parcelRequire("bk4nH");
const $39cd6476d8b36e07$export$661439a50b90a96f = (issueKey)=>`/rest/api/2/issue/${issueKey}/transitions?sortByOpsBarAndStatus=true`;
const $39cd6476d8b36e07$var$enhancedSendExperienceAnalytics = (successful, projectType, errorMessage, traceId, statusCode, source, action)=>{
    const description = (0, $FMOPx.transitionIssueExperienceDescription)(successful, 'GET', source ?? '', projectType || null, errorMessage, traceId, statusCode, action);
    (0, $3ibpe.sendExperienceAnalytics)(description);
};
const $39cd6476d8b36e07$var$BaseTransitionsQuery = (props)=>{
    const { status: status, issueKey: issueKey, projectType: projectType, preFetch: preFetch, createAnalyticsEvent: createAnalyticsEvent, isSaving: isSaving, source: source } = props;
    const [transitionsState, setTransitionsState] = (0, $7ty7w.useWorkflowTransitionsValue)();
    const isSingletonRequestRef = (0, $eJOHy.useRef)(false);
    // This is a workaround to ensure that the loading state is up to date in useEffect
    // without it leading to an infinite loop.
    const isTransitionStateLoading = (0, $eJOHy.useRef)(transitionsState.loading);
    isTransitionStateLoading.current = transitionsState.loading;
    const isBusinessIssue = (0, $d4GL0.useIsBusinessIssue)();
    const isSoftwareIssue = (0, $d4GL0.useIsSoftwareIssue)();
    const isStatusMoveExperimentEnabled = (0, $eJOHy.useMemo)(()=>{
        return (isBusinessIssue || isSoftwareIssue) && (0, $cxKOj.expVal)('move_status_to_summary_ga', 'isEnabled', false);
    }, [
        isBusinessIssue,
        isSoftwareIssue
    ]);
    const [fieldValues] = (0, $eaTQ3.useFieldsValues)(issueKey);
    const { fetchTransitions: fetchTransitions } = (0, $4cTDP.fg)('relay-migration-issue-fields-status') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $e3GKX.useFetchTransitionsForStatusField)({
        issueKey: issueKey
    }) : {
        fetchTransitions: ()=>[]
    };
    const fetch = (0, $eJOHy.useCallback)(async (event)=>{
        if (!isStatusMoveExperimentEnabled && transitionsState.loading) return;
        if (isStatusMoveExperimentEnabled && isTransitionStateLoading?.current) return;
        if (isSingletonRequestRef.current) return;
        isSingletonRequestRef.current = true;
        setTransitionsState({
            loading: true,
            error: null
        });
        try {
            let transitions;
            if ((0, $4cTDP.fg)('relay-migration-issue-fields-status')) transitions = await fetchTransitions();
            else {
                const result = await (0, $4mEPL.default)($39cd6476d8b36e07$export$661439a50b90a96f(issueKey), {}, 'fields/status/src/services/transitions-query/main');
                transitions = (0, $bk4nH.filterTransitionsWithDestinationAndCategory)(result.transitions).map((0, $bk4nH.transformTransitionToStore));
            }
            (0, $kRgKj.fireTrackAnalyticsDeferred)(event, 'statusField transitionsFetched', 'statusField', {
                count: transitions.length
            });
            // Issue Transition SLA
            $39cd6476d8b36e07$var$enhancedSendExperienceAnalytics(true, projectType, undefined, undefined, undefined, source);
            setTransitionsState({
                data: transitions,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gPQL9.trackOrLogClientError)((0, $4ecf649628197b0c$export$71a8e2ae8cfade56), e.toString(), e);
            // Issue Transition SLA
            $39cd6476d8b36e07$var$enhancedSendExperienceAnalytics(false, projectType, `${e.name || ''} ${e.message}`.trim(), e.traceId, e.statusCode, source, (0, $7wFII.isAbortableError)(e) && (0, $4cTDP.fg)('thor_add_taskabort_events_for_core_experiences') ? 'taskAbort' : 'taskFail');
            setTransitionsState({
                data: null,
                loading: false,
                error: e
            });
        }
        isSingletonRequestRef.current = false;
    }, // we want to fetch the transitions whenever any field values change
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        issueKey,
        projectType,
        setTransitionsState,
        fieldValues,
        isStatusMoveExperimentEnabled
    ]);
    let useProperEffect = (0, $4cTDP.fg)('relay-migration-issue-fields-status') ? (0, $eJOHy.useLayoutEffect) : (0, $eJOHy.useMemo);
    if ((0, $4cTDP.fg)('hot-122017--fetch-transitions-in-use-effect')) useProperEffect = (0, $eJOHy.useEffect);
    if ((0, $4cTDP.fg)('hot-122017--fetch-transitions-in-use-layout-effect')) useProperEffect = (0, $eJOHy.useLayoutEffect);
    // re-evaluates fetching data again whenever issueKey changes
    // we have to use useLayoutEffect instead of useEffect here because useMemo will be invoked before render
    // we cannot use useMemo in concurrent - if setState within a useMemo concurrent breaks
    // eg, when you have a parent issue and navigate to a child issue - the child issue loads the parent data instead
    // when you use useMemo
    useProperEffect(()=>{
        if (preFetch === true && createAnalyticsEvent) fetch(createAnalyticsEvent({}));
    }, [
        issueKey,
        preFetch,
        createAnalyticsEvent,
        setTransitionsState,
        fetch
    ]);
    // We need to clear the "data" list whenever the status object changes, because
    // each status has a different list of transitions associated with it.
    // We could achieve a similar behaviour by using a "key" prop when rendering
    // TransitionQuery, but that causes problems with keeping the focus on the component
    // when the status changes. We are using the full status object as "self-transitions"
    // from one status to itself need to exhibit the same behaviour, and it also fixes a bug
    // with PopupSelect downstream
    (0, $eJOHy.useEffect)(()=>{
        if (isSaving) setTransitionsState({
            data: null
        });
        else if (!isSaving && preFetch === true && createAnalyticsEvent) fetch(createAnalyticsEvent({}));
    }, [
        isSaving,
        status,
        preFetch,
        createAnalyticsEvent,
        setTransitionsState,
        fetch
    ]);
    const transitions = (0, $eJOHy.useMemo)(()=>transitionsState.data ? transitionsState.data.map((0, $bk4nH.transformTransitionFromStore)) : null, [
        transitionsState.data
    ]);
    return props.children({
        ...transitionsState,
        data: transitions,
        fetch: fetch
    });
};
const $39cd6476d8b36e07$var$ScopedTransitionsQueryBase = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6JG72.WorkflowTransitionsStoreContainer), {
        scope: props.issueKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($39cd6476d8b36e07$var$BaseTransitionsQuery, props));
const $39cd6476d8b36e07$export$833bdce708ba82a6 = (props)=>{
    const source = (0, $bmoS1.useAnalyticsSource)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($39cd6476d8b36e07$var$ScopedTransitionsQueryBase, {
        ...props,
        source: source
    });
};
const $39cd6476d8b36e07$export$e166c7039d71 = (0, $4J0ad.default)()($39cd6476d8b36e07$export$833bdce708ba82a6);

});
parcelRegister("4mEPL", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d563314f1a32c40$export$2e2bcd8739ae039);
// Stryker disable all

var $3ibpe = parcelRequire("3ibpe");

var $hgi0g = parcelRequire("hgi0g");

var $14RSn = parcelRequire("14RSn");

var $4cTDP = parcelRequire("4cTDP");

var $dxLpE = parcelRequire("dxLpE");
async function $4d563314f1a32c40$export$2e2bcd8739ae039(url, options = {}, path) {
    if (!(0, $4cTDP.fg)('issue-view-enable-reliability-wrapper-utils')) return (0, $hgi0g.default)(url, options);
    const defaultExperienceDescription = {
        experience: (0, $dxLpE.isGiraUrl)(url) ? 'issueGira' : 'issueRest',
        analyticsSource: (0, $dxLpE.isGiraUrl)(url) ? 'issueGira' : 'issueRest',
        application: null,
        edition: null
    };
    try {
        const response = await (0, $hgi0g.default)(url, {
            ...options
        });
        return response;
    } catch (error) {
        if ((0, $14RSn.isFetchError)(error)) {
            const additionalAttributes = {
                statusCode: error.statusCode || 0,
                errorMessage: error.message || 'unknown',
                traceId: error.traceId || 'unknown',
                path: path
            };
            const statusCode = additionalAttributes.statusCode;
            let action = 'taskFail';
            if (statusCode && statusCode >= 400 && statusCode < 500) action = 'taskAbort';
            (0, $3ibpe.sendExperienceAnalytics)({
                ...defaultExperienceDescription,
                action: action,
                additionalAttributes: additionalAttributes
            });
        }
        throw error;
    }
}

});
parcelRegister("dxLpE", function(module, exports) {
$parcel$export(module.exports, "isGiraUrl", () => $f1c40d25f35e4f9e$export$ea636743f241905c);
const $f1c40d25f35e4f9e$export$ea636743f241905c = (url)=>url.startsWith('/rest/gira/');

});


parcelRegister("gPQL9", function(module, exports) {
$parcel$export(module.exports, "trackOrLogClientError", () => $10ba3674ae190436$export$2fc29872103bf255);

var $eSnSE = parcelRequire("eSnSE");

var $9pTd3 = parcelRequire("9pTd3");

var $dMM78 = parcelRequire("dMM78");
const $10ba3674ae190436$export$c392d6295c0a29c7 = (location, message, error)=>{
    (0, $9pTd3.fireErrorAnalytics)({
        error: error,
        attributes: {
            message: message
        },
        meta: {
            id: location,
            packageName: 'jiraIssueViewCommonUtils'
        }
    });
};
const $10ba3674ae190436$export$2fc29872103bf255 = (location, message, error)=>{
    if (error instanceof TypeError && (0, $dMM78.isClientFetchError)(error)) $10ba3674ae190436$export$c392d6295c0a29c7(location, message, error);
    else (0, $eSnSE.default).safeErrorWithoutCustomerData(location, message, error);
};

});

parcelRegister("d4GL0", function(module, exports) {
$parcel$export(module.exports, "useIsJsmIssue", () => $c232e8d882e0b631$export$5f53c98aa7c9de5);
$parcel$export(module.exports, "useIsSoftwareIssue", () => $c232e8d882e0b631$export$ed33ecaf885020f8);
$parcel$export(module.exports, "useIsBusinessIssue", () => $c232e8d882e0b631$export$c4a50ee3a409d3b);

var $FhXEJ = parcelRequire("FhXEJ");

var $bmoS1 = parcelRequire("bmoS1");

var $bNexr = parcelRequire("bNexr");
const $c232e8d882e0b631$export$6362f1ad6af51d2e = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    return (0, $bNexr.useProjectType)(projectKey);
};
const $c232e8d882e0b631$export$5f53c98aa7c9de5 = ()=>{
    const projectType = $c232e8d882e0b631$export$6362f1ad6af51d2e();
    return projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT);
};
const $c232e8d882e0b631$export$ed33ecaf885020f8 = ()=>{
    const projectType = $c232e8d882e0b631$export$6362f1ad6af51d2e();
    return projectType === (0, $FhXEJ.SOFTWARE_PROJECT);
};
const $c232e8d882e0b631$export$c4a50ee3a409d3b = ()=>{
    const projectType = $c232e8d882e0b631$export$6362f1ad6af51d2e();
    return projectType === (0, $FhXEJ.CORE_PROJECT);
};

});

parcelRegister("e3GKX", function(module, exports) {
$parcel$export(module.exports, "useFetchTransitionsForStatusField", () => $d1a1abb60393fd2b$export$bff299af05778444);

var $ajG1S = parcelRequire("ajG1S");

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");

var $7zZ4w = parcelRequire("7zZ4w");

var $cHtIB = parcelRequire("cHtIB");

var $jHI6h = parcelRequire("jHI6h");

var $14RSn = parcelRequire("14RSn");
const $d1a1abb60393fd2b$var$OPERATION_NAME = 'transitionsRelayQueryForStatusFieldQuery';
const $d1a1abb60393fd2b$var$fetchTransitionsQuery = (issueKey, cloudId)=>(0, $37Ewn.fetchQuery)((0, $7zZ4w.default)(), (0, $ajG1S.default), {
        issueKey: issueKey,
        cloudId: cloudId
    });
const $d1a1abb60393fd2b$var$formatResponse = (data)=>data?.jira?.issueByKey?.statusField?.transitions?.edges?.map((edge)=>({
            id: edge?.node?.transitionId ?? 0,
            name: edge?.node?.name ?? '',
            hasScreen: edge?.node?.hasScreen ?? false,
            isGlobal: edge?.node?.isGlobal ?? false,
            isInitial: edge?.node?.isInitial ?? false,
            isConditional: edge?.node?.hasPreConditions ?? false,
            isLooped: edge?.node?.isLooped ?? false,
            to: {
                id: parseInt(edge?.node?.to?.statusId ?? '', 10),
                name: edge?.node?.to?.name ?? '',
                description: '',
                statusCategory: {
                    id: parseInt(edge?.node?.to?.statusCategory?.statusCategoryId ?? '', 10)
                }
            },
            from: null
        })) ?? [];
const $d1a1abb60393fd2b$export$bff299af05778444 = ({ issueKey: issueKey })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const fetchTransitions = (0, $eJOHy.useCallback)(async ()=>{
        (0, $jHI6h.startCapturingTraceIds)($d1a1abb60393fd2b$var$OPERATION_NAME);
        try {
            const data = await $d1a1abb60393fd2b$var$fetchTransitionsQuery(issueKey, cloudId).toPromise();
            return $d1a1abb60393fd2b$var$formatResponse(data);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const firstError = error?.source?.errors?.[0] || {};
            const statusCode = firstError?.extensions?.statusCode ?? error.statusCode ?? error.status;
            const errorMessage = firstError.message ?? error.message;
            throw new (0, $14RSn.default)(statusCode, errorMessage || `Relay Fetch call failed with status code: ${statusCode}`, (0, $jHI6h.getTraceIds)($d1a1abb60393fd2b$var$OPERATION_NAME)?.[0] ?? error.traceId);
        } finally{
            (0, $jHI6h.stopCapturingTraceIds)($d1a1abb60393fd2b$var$OPERATION_NAME);
        }
    }, [
        cloudId,
        issueKey
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            fetchTransitions: fetchTransitions
        }), [
        fetchTransitions
    ]);
};

});
parcelRegister("ajG1S", function(module, exports) {
$parcel$export(module.exports, "default", () => $2087f56812ebf44f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ad848ef2c030384b9c0dbb654e369a1c>>
 * @relayHash 796dc965641af207a0b9419914846a68
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 20d04eb1eb34d95f608eed19bd7178ed5e44deabd2a8e0e10666e1f6ff5f998b
const $2087f56812ebf44f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "sortingOption",
            "value": "OPS_BAR_THEN_STATUS_CATEGORY"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "transitionId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "hasScreen"
    }, v6 = {
        "kind": "ScalarField",
        "name": "isGlobal"
    }, v7 = {
        "kind": "ScalarField",
        "name": "isInitial"
    }, v8 = {
        "kind": "ScalarField",
        "name": "isLooped"
    }, v9 = {
        "kind": "ScalarField",
        "name": "hasPreConditions"
    }, v10 = {
        "kind": "ScalarField",
        "name": "statusId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "transitionsRelayQueryForStatusFieldQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraStatusField",
                                    "kind": "LinkedField",
                                    "name": "statusField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v2 /*: any*/ ,
                                            "concreteType": "JiraTransitionConnection",
                                            "kind": "LinkedField",
                                            "name": "transitions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraTransitionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraTransition",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "to",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "transitions(sortingOption:\"OPS_BAR_THEN_STATUS_CATEGORY\")"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "transitionsRelayQueryForStatusFieldQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraStatusField",
                                    "kind": "LinkedField",
                                    "name": "statusField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v2 /*: any*/ ,
                                            "concreteType": "JiraTransitionConnection",
                                            "kind": "LinkedField",
                                            "name": "transitions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraTransitionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraTransition",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "to",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v12 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v12 /*: any*/ 
                                                                    ]
                                                                },
                                                                v12 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "transitions(sortingOption:\"OPS_BAR_THEN_STATUS_CATEGORY\")"
                                        },
                                        v12 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "20d04eb1eb34d95f608eed19bd7178ed5e44deabd2a8e0e10666e1f6ff5f998b",
            "metadata": {},
            "name": "transitionsRelayQueryForStatusFieldQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2087f56812ebf44f$var$node.hash = "ef8a89687e1190fb71a38a47f8fc039c";
var $2087f56812ebf44f$export$2e2bcd8739ae039 = $2087f56812ebf44f$var$node;

});


parcelRegister("bk4nH", function(module, exports) {
$parcel$export(module.exports, "filterTransitionsWithDestinationAndCategory", () => $3c1b20bf1f475143$export$f27913d8073a7e1);
$parcel$export(module.exports, "transformTransitionToStore", () => $3c1b20bf1f475143$export$3482bcbbb2a2b63a);
$parcel$export(module.exports, "transformTransitionFromStore", () => $3c1b20bf1f475143$export$1eab4bccf39ab44d);
const $3c1b20bf1f475143$export$f27913d8073a7e1 = (transitions = [])=>transitions.filter((transition)=>!!transition.to && !!transition.to.statusCategory);
const $3c1b20bf1f475143$export$3482bcbbb2a2b63a = (transition)=>({
        id: parseInt(transition.id, 10),
        name: transition.name,
        hasScreen: transition.hasScreen,
        isGlobal: transition.isGlobal,
        isInitial: transition.isInitial,
        isConditional: transition.isConditional,
        ...typeof transition.isLooped === 'boolean' && {
            isLooped: transition.isLooped
        },
        to: {
            id: parseInt(transition.to.id, 10),
            name: transition.to.name,
            description: '',
            statusCategory: {
                id: transition.to.statusCategory.id
            }
        },
        from: null
    });
const $3c1b20bf1f475143$export$1eab4bccf39ab44d = (transition)=>({
        id: String(transition.id),
        name: transition.name,
        hasScreen: transition.hasScreen,
        isGlobal: transition.isGlobal,
        isInitial: transition.isInitial,
        isConditional: transition.isConditional,
        ...typeof transition.isLooped === 'boolean' && {
            isLooped: transition.isLooped
        },
        to: {
            id: String(transition.to.id),
            name: transition.to.name,
            statusCategory: {
                id: transition.to.statusCategory.id
            }
        }
    });

});



parcelRegister("178sl", function(module, exports) {
$parcel$export(module.exports, "default", () => $128e68ff799cc10b$export$2e2bcd8739ae039);

var $hxjKC = parcelRequire("hxjKC");
const $128e68ff799cc10b$export$d1183e28fea9e49c = {
    data: undefined,
    loading: false,
    error: undefined,
    fetch: ()=>Promise.resolve()
};
/**
 * Gets projectData from ContainerContextSubscriber or from service
 */ const $128e68ff799cc10b$var$ViewWorkflowContextService = (props)=>{
    const { issueKey: issueKey, children: children } = props;
    return children((0, $hxjKC.useProjectViewWorkflowService)(issueKey));
};
var $128e68ff799cc10b$export$2e2bcd8739ae039 = $128e68ff799cc10b$var$ViewWorkflowContextService;

});
parcelRegister("hxjKC", function(module, exports) {
$parcel$export(module.exports, "useProjectViewWorkflowService", () => $73177ef1611689d5$export$aa23574b54bd5f5e);

var $FhXEJ = parcelRequire("FhXEJ");

var $dNyY6 = parcelRequire("dNyY6");

var $eWzpp = parcelRequire("eWzpp");

var $2QZBX = parcelRequire("2QZBX");

var $cHtIB = parcelRequire("cHtIB");

var $d2he3 = parcelRequire("d2he3");
const $73177ef1611689d5$export$d1183e28fea9e49c = {
    data: undefined,
    loading: false,
    error: undefined,
    fetch: ()=>Promise.resolve()
};
const $73177ef1611689d5$var$getIssueProjectDataFromContext = (useProjectData, issueProjectKey)=>{
    if (!useProjectData || !useProjectData.data) return undefined;
    const hasIssueProjectDataInContext = useProjectData.data.key === issueProjectKey;
    if (!hasIssueProjectDataInContext) return undefined;
    return {
        projectId: (0, $2QZBX.toProjectId)(useProjectData.data.id.toString()),
        projectType: (0, $FhXEJ.toProjectType)(useProjectData.data.type),
        isSimplified: useProjectData.data.isSimplified
    };
};
const $73177ef1611689d5$export$aa23574b54bd5f5e = (issueKey)=>{
    const issueProjectKey = issueKey ? (0, $dNyY6.extractProjectKey)(issueKey) : null;
    const useProjectData = (0, $eWzpp.useProject)();
    const projectContextData = $73177ef1611689d5$var$getIssueProjectDataFromContext(useProjectData, issueProjectKey);
    const cloudId = (0, $cHtIB.useCloudId)();
    const issueContextData = (0, $d2he3.useViewWorkflowData)({
        projectKey: projectContextData ? undefined : issueProjectKey || undefined,
        issueKey: issueKey,
        isSimplified: projectContextData && projectContextData.isSimplified,
        cloudId: cloudId
    });
    if (!issueKey || !issueProjectKey) return {
        ...$73177ef1611689d5$export$d1183e28fea9e49c
    };
    const combinedData = projectContextData || issueContextData.data ? {
        ...projectContextData,
        ...issueContextData.data
    } : undefined;
    return {
        ...issueContextData,
        data: combinedData
    };
};

});
parcelRegister("d2he3", function(module, exports) {
$parcel$export(module.exports, "useViewWorkflowData", () => $0575e92f804fa4c2$export$d60b63dd0a193e30);

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $4cTDP = parcelRequire("4cTDP");

var $4mEPL = parcelRequire("4mEPL");


var $jGEO3 = parcelRequire("jGEO3");

var $7eI4v = parcelRequire("7eI4v");
const $0575e92f804fa4c2$export$7a2d7e5adacde085 = ()=>'/rest/gira/latest/?operation=nextGenViewWorkflowQuery';
const $0575e92f804fa4c2$var$optionsGraphQlQuery = (issueKey, cloudId, projectKey)=>`
    query nextGenViewWorkflowQuery {
        permissions(issueKey:"${issueKey}", keys:["${0, $4ecf649628197b0c$export$136fc24ec1bfcefd}", "${0, $4ecf649628197b0c$export$624e7abc8d9cada5}"]) {
            key
            havePermission
        }
        ${projectKey ? `project(projectKey: "${projectKey}") {
            projectId
            simplified
            type
        }` : ''}
        jira {
            issueByKey(key: "${issueKey}", cloudId: "${cloudId}") {
                fieldsById(ids: ["issuetype"]) {
                    edges {
                        node {
                            ... on JiraIssueTypeField {
                                fieldId
                                issueType {
                                issueTypeId
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
const $0575e92f804fa4c2$export$7fe04353ef301d96 = (issueKey, cloudId, projectKey, isSimplified)=>(0, $4mEPL.default)($0575e92f804fa4c2$export$7a2d7e5adacde085(), {
        method: 'POST',
        body: JSON.stringify({
            query: $0575e92f804fa4c2$var$optionsGraphQlQuery(issueKey, cloudId, projectKey)
        })
    }, 'fields/status/src/services/view-workflow-service/use-view-workflow-data/main').then((data)=>(0, $7eI4v.transform)(data, isSimplified));
const $0575e92f804fa4c2$export$d60b63dd0a193e30 = ({ projectKey: projectKey, issueKey: issueKey, isSimplified: isSimplified, cloudId: cloudId })=>{
    const [dataState, setDataState] = (0, $eJOHy.useState)(undefined);
    const [errorState, setErrorState] = (0, $eJOHy.useState)(undefined);
    const [loadingState, setLoadingState] = (0, $eJOHy.useState)(false);
    const { fetchWorkflowServiceData: fetchWorkflowServiceData } = (0, $4cTDP.fg)('relay-migration-issue-fields-status') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jGEO3.useFetchWorkflowServiceData)({
        issueKey: issueKey
    }) : {
        fetchWorkflowServiceData: ()=>undefined
    };
    const fetch = async ()=>{
        request();
        try {
            let dataRes;
            if ((0, $4cTDP.fg)('relay-migration-issue-fields-status')) dataRes = await fetchWorkflowServiceData();
            else dataRes = await $0575e92f804fa4c2$export$7fe04353ef301d96(issueKey, cloudId, projectKey, isSimplified);
            success(dataRes);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (ex) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData((0, $4ecf649628197b0c$export$4bf6353caa97e8e7), ex);
            failure(ex);
        }
    };
    const request = ()=>{
        setDataState(undefined);
        setErrorState(undefined);
        setLoadingState(true);
    };
    const success = (data)=>{
        setDataState(data);
        setErrorState(undefined);
        setLoadingState(false);
    };
    const failure = (error)=>{
        setDataState(undefined);
        setErrorState(error);
        setLoadingState(false);
    };
    return {
        data: dataState,
        error: errorState,
        loading: loadingState,
        fetch: fetch
    };
};

});
parcelRegister("jGEO3", function(module, exports) {
$parcel$export(module.exports, "useFetchWorkflowServiceData", () => $1fdd02676deaa0f3$export$5625d50611791f51);

var $lDUEG = parcelRequire("lDUEG");

var $eJOHy = parcelRequire("eJOHy");

var $37Ewn = parcelRequire("37Ewn");

var $FhXEJ = parcelRequire("FhXEJ");

var $7zZ4w = parcelRequire("7zZ4w");

var $2QZBX = parcelRequire("2QZBX");

var $cHtIB = parcelRequire("cHtIB");
const $1fdd02676deaa0f3$export$5625d50611791f51 = ({ issueKey: issueKey })=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const fetchWorkflowServiceData = (0, $eJOHy.useCallback)(async ()=>{
        const data = await (0, $37Ewn.fetchQuery)((0, $7zZ4w.default)(), (0, $lDUEG.default), {
            issueKey: issueKey,
            cloudId: cloudId
        }).toPromise();
        return {
            hasPermission: (data?.jira?.issueByKey?.projectField?.project?.projectStyle === 'TEAM_MANAGED_PROJECT' ? data?.jira?.issueByKey?.canReadWorkflow || data?.jira?.issueByKey?.canEditWorkflow : data?.jira?.issueByKey?.canReadWorkflow) ?? false,
            projectId: (0, $2QZBX.toProjectId)(data?.jira?.issueByKey?.projectField?.project?.projectId ?? ''),
            projectType: (0, $FhXEJ.toProjectType)(data?.jira?.issueByKey?.projectField?.project?.projectType ?? ''),
            isSimplified: data?.jira?.issueByKey?.projectField?.project?.projectStyle === 'TEAM_MANAGED_PROJECT',
            issueTypeId: (0, $2QZBX.toIssueTypeId)(data?.jira?.issueByKey?.issueTypeField?.issueType?.issueTypeId ?? '')
        };
    }, [
        cloudId,
        issueKey
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            fetchWorkflowServiceData: fetchWorkflowServiceData
        }), [
        fetchWorkflowServiceData
    ]);
};

});
parcelRegister("lDUEG", function(module, exports) {
$parcel$export(module.exports, "default", () => $917a867343b86888$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b37a15a2646cf2b254e93c51233c770a>>
 * @relayHash 52ec9f41292374b8b42a659792cc636f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 04a89f473a7a99d1e53af734bfdc49e7266fc4803ed427ccf54421609fb93a8a
const $917a867343b86888$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v2 = {
        "alias": "canReadWorkflow",
        "args": [
            {
                "kind": "Literal",
                "name": "permission",
                "value": "VIEW_READONLY_WORKFLOW"
            }
        ],
        "kind": "ScalarField",
        "name": "hasProjectPermission",
        "storageKey": "hasProjectPermission(permission:\"VIEW_READONLY_WORKFLOW\")"
    }, v3 = {
        "alias": "canEditWorkflow",
        "args": [
            {
                "kind": "Literal",
                "name": "permission",
                "value": "EDIT_WORKFLOW"
            }
        ],
        "kind": "ScalarField",
        "name": "hasProjectPermission",
        "storageKey": "hasProjectPermission(permission:\"EDIT_WORKFLOW\")"
    }, v4 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v7 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useWorkflowRelayQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useWorkflowRelayQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "04a89f473a7a99d1e53af734bfdc49e7266fc4803ed427ccf54421609fb93a8a",
            "metadata": {},
            "name": "useWorkflowRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$917a867343b86888$var$node.hash = "ebdee6e1f1db415100c81dcb27198ff2";
var $917a867343b86888$export$2e2bcd8739ae039 = $917a867343b86888$var$node;

});


parcelRegister("7eI4v", function(module, exports) {
$parcel$export(module.exports, "transform", () => $ba4d302c52fb8dca$export$51186ad6e864892a);

var $FhXEJ = parcelRequire("FhXEJ");

var $2QZBX = parcelRequire("2QZBX");

// @ts-expect-error - TS7031 - Binding element 'key' implicitly has an 'any' type. | TS7031 - Binding element 'havePermission' implicitly has an 'any' type.
const $ba4d302c52fb8dca$var$simplifiedPermissionPredicate = ({ key: key, havePermission: havePermission })=>key === (0, $4ecf649628197b0c$export$136fc24ec1bfcefd) && havePermission || key === (0, $4ecf649628197b0c$export$624e7abc8d9cada5) && havePermission;
// @ts-expect-error - TS7031 - Binding element 'key' implicitly has an 'any' type. | TS7031 - Binding element 'havePermission' implicitly has an 'any' type.
const $ba4d302c52fb8dca$var$classicPermissionPredicate = ({ key: key, havePermission: havePermission })=>key === (0, $4ecf649628197b0c$export$136fc24ec1bfcefd) && havePermission;
const $ba4d302c52fb8dca$export$51186ad6e864892a = ({ data: data }, isSimplifiedCached)=>{
    if (!data || !data.permissions || !data.jira) return undefined;
    const { permissions: permissions, project: project, jira: jira } = data;
    const isSimplified = project && project.simplified || isSimplifiedCached;
    const permissionPredicate = isSimplified === true ? $ba4d302c52fb8dca$var$simplifiedPermissionPredicate : $ba4d302c52fb8dca$var$classicPermissionPredicate;
    const issueTypeField = jira.issueByKey?.fieldsById?.edges?.find((edge)=>edge.node?.fieldId === 'issuetype');
    const result = {
        hasPermission: permissions.some(permissionPredicate),
        issueTypeId: (0, $2QZBX.toIssueTypeId)(issueTypeField?.node?.issueType?.issueTypeId ? issueTypeField.node.issueType.issueTypeId : '')
    };
    if (project) {
        result.projectId = (0, $2QZBX.toProjectId)(String(project.projectId));
        result.projectType = (0, $FhXEJ.toProjectType)(project.type);
        result.isSimplified = project.simplified;
    }
    return result;
};

});




parcelRegister("e1mtn", function(module, exports) {
$parcel$export(module.exports, "StatusView", () => $cd5a236a0b8ca92f$export$a11134e1462e763);
$parcel$export(module.exports, "default", () => $cd5a236a0b8ca92f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $1O6Yz = parcelRequire("1O6Yz");

var $12DRg = parcelRequire("12DRg");

var $h6i8k = parcelRequire("h6i8k");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $c4OV1 = parcelRequire("c4OV1");
var $sl8jM = parcelRequire("sl8jM");

var $lLL16 = parcelRequire("lLL16");

var $f5dwt = parcelRequire("f5dwt");

var $hrKgE = parcelRequire("hrKgE");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $6d9QY = parcelRequire("6d9QY");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $9ZjBG = parcelRequire("9ZjBG");

var $6rZHS = parcelRequire("6rZHS");

var $5S4to = parcelRequire("5S4to");

var $bzbsd = parcelRequire("bzbsd");

var $bskNA = parcelRequire("bskNA");


var $6UBwj = parcelRequire("6UBwj");

var $90zjX = parcelRequire("90zjX");

var $6ReHL = parcelRequire("6ReHL");

var $aKmI9 = parcelRequire("aKmI9");

var $aY0vM = parcelRequire("aY0vM");

var $ke54d = parcelRequire("ke54d");

var $2gPiL = parcelRequire("2gPiL");

var $dYFa5 = parcelRequire("dYFa5");

var $dSpUw = parcelRequire("dSpUw");

var $kTIpG = parcelRequire("kTIpG");

var $7Pc1n = parcelRequire("7Pc1n");

var $8X6rE = parcelRequire("8X6rE");

var $fkCrf = parcelRequire("fkCrf");

var $eCUrP = parcelRequire("eCUrP");

var $buB1R = parcelRequire("buB1R");
const $cd5a236a0b8ca92f$var$defaultPopperProps = {
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        },
        {
            name: 'preventOverflow',
            options: {
                padding: 5,
                rootBoundary: 'document'
            }
        }
    ],
    // makes it work inside modal-dialog
    strategy: 'fixed'
};
const $cd5a236a0b8ca92f$var$isOptionDisabled = (option)=>('transition' in option && option.transition.isDisabled) ?? false;
const $cd5a236a0b8ca92f$var$isTransitionOption = (option)=>'transition' in option;
const $cd5a236a0b8ca92f$var$FormatTransitionOptionLabel = ({ option: option })=>{
    const { forceNoLabels: forceNoLabels = false, filteredAndOrderedTransitions: filteredAndOrderedTransitions } = $cd5a236a0b8ca92f$var$useStatusViewContext();
    const isGlobalOnly = (0, $90zjX.isOnlyGlobalTransitions)(filteredAndOrderedTransitions || []);
    const showLabel = !(forceNoLabels || isGlobalOnly);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $cd5a236a0b8ca92f$var$transitionOptionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dYFa5.Transition), {
        transition: option.transition,
        hasLabel: showLabel,
        testId: "issue-field-status.ui.status-view.transition"
    }));
};
const $cd5a236a0b8ca92f$var$FormatTransitionOptionLabelForCommandPalette = ({ option: option, transitionProps: transitionProps })=>{
    const { forceNoLabels: forceNoLabels = false, filteredAndOrderedTransitions: filteredAndOrderedTransitions } = $cd5a236a0b8ca92f$var$useStatusViewContext();
    const isGlobalOnly = (0, $90zjX.isOnlyGlobalTransitions)(filteredAndOrderedTransitions || []);
    const showLabel = !(forceNoLabels || isGlobalOnly);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dYFa5.Transition), {
        transition: option.transition,
        hasLabel: showLabel,
        addTransitionArrowSpacing: transitionProps?.addTransitionArrowSpacing,
        testId: "issue-field-status.ui.status-view.transition"
    });
};
const $cd5a236a0b8ca92f$var$FormatTransitionOptionLabelWithCreateStatus = ({ option: option })=>{
    const { value: value, transitions: transitions, showConfigureStatusButtons: showConfigureStatusButtons, projectId: projectId, projectKey: projectKey, projectType: projectType, issueTypeId: issueTypeId, onClickConfigureStatus: onClickConfigureStatus, onCloseConfigureStatus: onCloseConfigureStatus, onStatusCreatedOrUpdated: onStatusCreatedOrUpdated, configureStatusSource: configureStatusSource, createStatusButtonRef: createStatusButtonRef, editStatusButtonRef: editStatusButtonRef, shouldStatusConfigTriggerModal: shouldStatusConfigTriggerModal } = $cd5a236a0b8ca92f$var$useStatusViewContext();
    const isConfigureStatusAvailable = showConfigureStatusButtons && projectType && projectKey;
    if (isConfigureStatusAvailable && projectKey && projectType && projectId && issueTypeId && 'value' in option) switch(option.value){
        case 0, $559e2d0f325c757f$export$bbd08ee543ba8cc3:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kTIpG.CreateStatusOption), {
                projectId: projectId,
                projectKey: projectKey,
                projectType: projectType,
                issueTypeId: issueTypeId,
                statusNames: transitions?.map((transition)=>transition?.to?.name),
                onClick: onClickConfigureStatus,
                onClose: onCloseConfigureStatus,
                onStatusCreated: onStatusCreatedOrUpdated,
                buttonRef: createStatusButtonRef,
                source: configureStatusSource,
                shouldTriggerModal: shouldStatusConfigTriggerModal
            });
        case 0, $559e2d0f325c757f$export$bc1622166baa0162:
            return transitions && value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Pc1n.EditStatusOption), {
                status: (0, $6rZHS.transformServerRestStatusToStatus)(value),
                statuses: transitions.map((transition)=>(0, $6rZHS.transformServerRestStatusToStatus)(transition?.to)).filter((status, index, self)=>index === self.findIndex((t)=>t.statusName === status.statusName)),
                projectId: projectId,
                projectKey: projectKey,
                issueTypeId: issueTypeId,
                statusNames: transitions?.map((transition)=>transition?.to?.name),
                onClick: onClickConfigureStatus,
                onClose: onCloseConfigureStatus,
                onStatusUpdated: onStatusCreatedOrUpdated,
                source: configureStatusSource,
                buttonRef: editStatusButtonRef,
                shouldTriggerModal: shouldStatusConfigTriggerModal
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
        case 0, $559e2d0f325c757f$export$4f9299d0cd8b6a8b:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $cd5a236a0b8ca92f$var$manageWorkflowStyles
            }, option.label);
        default:
            break;
    }
    if ($cd5a236a0b8ca92f$var$isTransitionOption(option)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$FormatTransitionOptionLabel, {
        option: option
    });
};
const $cd5a236a0b8ca92f$var$CommandPaletteStatusViewComponent = ()=>{
    const { isLoading: isLoading, value: value, transitions: transitions, onSuccess: onSuccess, onFetch: onFetch, onUpdateStatusMutation: onUpdateStatusMutation, filteredAndOrderedTransitions: filteredAndOrderedTransitions } = $cd5a236a0b8ca92f$var$useStatusViewContext();
    const wasFetchSuccessful = transitions != null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6ReHL.CommandPaletteStatusView), {
        transitions: filteredAndOrderedTransitions,
        currentStatus: value,
        onSuccess: onSuccess,
        wasFetchSuccessful: wasFetchSuccessful,
        renderTransition: (0, $eJOHy.useCallback)((option, transitionProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$FormatTransitionOptionLabelForCommandPalette, {
                option: option,
                transitionProps: transitionProps
            }), []),
        onFetch: onFetch,
        isLoading: isLoading,
        onUpdateStatusMutation: onUpdateStatusMutation
    });
};
const $cd5a236a0b8ca92f$var$Lozenge = ({ targetRef: targetRef, triggerProps: triggerProps })=>{
    const { isEditable: isEditable = true, isSaving: isSaving = false, error: error, value: value, statusButtonRef: statusButtonRef, isOpen: isOpen } = $cd5a236a0b8ca92f$var$useStatusViewContext();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (isSaving) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lLL16.default), {
        border: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UBwj.WrappedStatusLozenge), {
        targetRef: targetRef,
        status: value,
        error: error,
        contentRef: statusButtonRef,
        triggerProps: triggerProps
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UBwj.WrappedStatusLozenge), {
        ariaLabel: `${value.name} - ${formatMessage((0, $aY0vM.default).changeStatus)}`,
        error: error,
        hasHoverState: true,
        isEditable: isEditable,
        isOpen: isOpen,
        status: value,
        targetRef: targetRef,
        contentRef: statusButtonRef,
        triggerProps: triggerProps
    });
};
const $cd5a236a0b8ca92f$var$StatusButtonComponent = ({ targetRef: targetRef, triggerProps: triggerProps, helperTextId: helperTextId })=>{
    const { isEditable: isEditable = true, isSaving: isSaving = false, value: value, statusButtonRef: statusButtonRef, shouldFitContainer: shouldFitContainer = true, isOpen: isOpen } = $cd5a236a0b8ca92f$var$useStatusViewContext();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const statusButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2gPiL.StatusButton), {
        ariaLabel: `${value.name} - ${formatMessage((0, $aY0vM.default).changeStatus)}`,
        isEditable: isEditable,
        isOpen: isOpen,
        status: value,
        targetRef: targetRef,
        statusButtonRef: statusButtonRef,
        shouldFitContainer: shouldFitContainer,
        triggerProps: triggerProps,
        helperTextId: helperTextId
    });
    return isSaving ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lLL16.default), null, statusButton) : statusButton;
};
const $cd5a236a0b8ca92f$var$FocusWrapper = ({ children: children })=>{
    const { isSaving: isSaving = false } = $cd5a236a0b8ca92f$var$useStatusViewContext();
    const childWrapperRef = (0, $eJOHy.useRef)(null);
    const previousIsSaving = (0, $6d9QY.usePrevious)(isSaving);
    (0, $eJOHy.useEffect)(()=>{
        if (previousIsSaving === true && isSaving === false) childWrapperRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        childWrapperRef.current.children.length > 0 && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        childWrapperRef.current.children[0].focus();
    }, [
        isSaving,
        previousIsSaving
    ]); // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<HTMLDivElement> | undefined'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: childWrapperRef
    }, children);
};
const $cd5a236a0b8ca92f$var$Target = ({ targetRef: targetRef, triggerProps: triggerProps, helperTextId: helperTextId })=>{
    const { value: value, appearance: appearance, registerInCommandPalette: registerInCommandPalette } = $cd5a236a0b8ca92f$var$useStatusViewContext();
    if (value) {
        if (appearance === 'lozenge') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$FocusWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$Lozenge, {
            targetRef: targetRef,
            triggerProps: triggerProps
        }));
        if (appearance === 'button') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$FocusWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$StatusButtonComponent, {
            targetRef: targetRef,
            triggerProps: triggerProps,
            helperTextId: helperTextId
        })), registerInCommandPalette && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$CommandPaletteStatusViewComponent, null));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null);
};
const $cd5a236a0b8ca92f$var$Footer = ()=>{
    const { footer: footer, showConfigureStatusButtons: showConfigureStatusButtons, value: value, transitions: transitions, onClickConfigureStatus: onClickConfigureStatus, onCloseConfigureStatus: onCloseConfigureStatus, onStatusCreatedOrUpdated: onStatusCreatedOrUpdated, onClickExplainWorkflow: onClickExplainWorkflow, createStatusButtonRef: createStatusButtonRef, editStatusButtonRef: editStatusButtonRef, configureStatusSource: configureStatusSource, shouldStatusConfigTriggerModal: shouldStatusConfigTriggerModal, projectKey: projectKey, projectId: projectId, projectType: projectType, issueTypeId: issueTypeId } = $cd5a236a0b8ca92f$var$useStatusViewContext();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const showCreateStatusButton = showConfigureStatusButtons && projectKey && projectType && projectId;
    const showEditStatusButton = showCreateStatusButton && value && transitions;
    if (!footer && !showCreateStatusButton) return null;
    const footerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showCreateStatusButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aKmI9.CreateStatusButton), {
        projectId: projectId,
        projectKey: projectKey,
        projectType: projectType,
        // temporary empty string will trigger a loading state within the create status modal
        issueTypeId: issueTypeId ?? '',
        statusNames: transitions?.map((transition)=>transition?.to?.name),
        onClick: onClickConfigureStatus,
        onClose: onCloseConfigureStatus,
        onStatusCreated: onStatusCreatedOrUpdated,
        buttonRef: createStatusButtonRef,
        source: configureStatusSource,
        shouldTriggerModal: shouldStatusConfigTriggerModal
    }), showEditStatusButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8X6rE.EditStatusButton), {
        status: (0, $6rZHS.transformServerRestStatusToStatus)(value),
        statuses: transitions.map((transition)=>(0, $6rZHS.transformServerRestStatusToStatus)(transition?.to)).filter((status, index, self)=>index === self.findIndex((t)=>t.statusName === status.statusName)),
        projectId: projectId,
        projectKey: projectKey,
        // temporary empty string will trigger a loading state within the edit status modal
        issueTypeId: issueTypeId ?? '',
        statusNames: transitions?.map((transition)=>transition?.to?.name),
        onClick: onClickConfigureStatus,
        onClose: onCloseConfigureStatus,
        onStatusUpdated: onStatusCreatedOrUpdated,
        source: configureStatusSource,
        buttonRef: editStatusButtonRef,
        shouldTriggerModal: shouldStatusConfigTriggerModal
    }), footer, (0, $4cTDP.fg)('jira-pandora-ai-explain-workflow') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $buB1R.ExplainWorkflowButton), {
        onClick: onClickExplainWorkflow
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        direction: "column",
        xcss: $cd5a236a0b8ca92f$var$statusViewFooterStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("fieldset", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("legend", {
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _ogto7mnp _4t3it94y _1bsbt94y _kqswstnw"
        ])
    }, formatMessage((0, $aY0vM.default).status)), footerContent));
};
const $cd5a236a0b8ca92f$var$StatusViewContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isLoading: false,
    value: {
        id: '',
        name: '',
        statusCategory: {
            id: 0
        }
    },
    transitions: [],
    appearance: 'button',
    shouldStatusConfigTriggerModal: true,
    isOpen: false,
    setIsConfigureStatusModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onClickConfigureStatus: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onCloseConfigureStatus: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onClickExplainWorkflow: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    createStatusButtonRef: null,
    editStatusButtonRef: null,
    filteredAndOrderedTransitions: []
});
const $cd5a236a0b8ca92f$var$useStatusViewContext = ()=>{
    const context = (0, $eJOHy.useContext)($cd5a236a0b8ca92f$var$StatusViewContext);
    if (!context) throw new Error('useStatusViewContext must be used within a StatusViewProvider');
    return context;
};
const $cd5a236a0b8ca92f$export$a11134e1462e763 = (props)=>{
    const { isEditable: isEditable = true, isSaving: isSaving = false, isLoading: isLoading, value: value, transitions: transitions, isDefaultSelect: isDefaultSelect = false, selectedTransition: selectedTransition, onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onOpen: onOpen = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onClose: onClose = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), shouldCaptureEscape: shouldCaptureEscape = true, customNoOptionsMessage: customNoOptionsMessage, statusButtonRef: statusButtonRef, popperProps: popperProps, fieldId: fieldId, showConfigureStatusButtons: showConfigureStatusButtons, configureStatusDialogType: configureStatusDialogType = 'modal', configureStatusPopupPlacement: configureStatusPopupPlacement = 'bottom-end', projectKey: projectKey, projectType: projectType, defaultOpen: // for testing
    defaultOpen = false, onOpenManageWorkflow: onOpenManageWorkflow, autofocus: autofocus = false, helperTextId: helperTextId } = props;
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const selectRef = (0, $eJOHy.useRef)(null);
    const wasChanged = (0, $eJOHy.useRef)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const wasFetchSuccessful = transitions != null;
    const filteredAndOrderedTransitions = (0, $eJOHy.useMemo)(()=>(0, $90zjX.getFilteredOrderedTransitions)(transitions, value.id), [
        transitions,
        value.id
    ]);
    const isConfigureStatusAvailable = showConfigureStatusButtons && projectType && projectKey;
    const createStatusButtonRef = (0, $eJOHy.useRef)(null);
    const editStatusButtonRef = (0, $eJOHy.useRef)(null);
    const [isConfigureStatusModalOpen, setIsConfigureStatusModalOpen] = (0, $eJOHy.useState)(false);
    const [isConfigureStatusPopupOpen, setIsConfigureStatusPopupOpen] = (0, $eJOHy.useState)(false);
    const [shouldRefocus, setShouldRefocus] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
        if (shouldRefocus) {
            statusButtonRef?.current?.focus();
            setShouldRefocus(false);
        }
    }, [
        shouldRefocus,
        statusButtonRef
    ]);
    const { Panel: ConfigureStatusPopupContent, Provider: ConfigureStatusPopupTriggerContextProvider } = (0, $5S4to.usePanelContext)((0, $eCUrP.ConfigureStatusPanel));
    const shouldRenderSelectComponent = isDefaultSelect && !!selectedTransition;
    const shouldStatusConfigTriggerModal = configureStatusDialogType === 'modal' || shouldRenderSelectComponent;
    const onCloseConfigureStatus = (0, $eJOHy.useCallback)(()=>{
        if (shouldStatusConfigTriggerModal) setIsConfigureStatusModalOpen(false);
        else setIsConfigureStatusPopupOpen(false);
        setShouldRefocus(true);
    }, [
        shouldStatusConfigTriggerModal
    ]);
    const onClickConfigureStatus = (0, $eJOHy.useCallback)(()=>{
        if (shouldStatusConfigTriggerModal) setIsConfigureStatusModalOpen(true);
        else setIsConfigureStatusPopupOpen(true);
    }, [
        shouldStatusConfigTriggerModal
    ]);
    const onClickExplainWorkflow = (0, $eJOHy.useCallback)(()=>{
        statusButtonRef?.current?.click();
        setShouldRefocus(true);
    }, [
        statusButtonRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (autofocus) selectRef.current?.focus?.();
    }, [
        autofocus
    ]); // specifically for screen readers
    const getTransitionOptionLabel = (option)=>{
        if ($cd5a236a0b8ca92f$var$isTransitionOption(option)) return option.transition.isGlobal ? formatMessage((0, $aY0vM.default).transitionTo, {
            statusName: option.label
        }) : `${option.transition.name} \u{2192} ${option.transition.to.name}`;
        return option.label;
    };
    const mergedPopperProps = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))($cd5a236a0b8ca92f$var$defaultPopperProps, popperProps), [
        popperProps
    ]);
    const handleChangeStatus = (0, $eJOHy.useCallback)((transition)=>{
        const { hasScreen: hasScreen } = transition;
        wasChanged.current = true;
        const analyticsEvent = createAnalyticsEvent({
            action: 'transitionSelected',
            actionSubject: 'statusField'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'transitionSelectedStatusField', {
            hasScreen: hasScreen
        });
        (0, $h6i8k.default)('issue.fields.status.popup.submit');
        onChange?.(transition, analyticsEvent);
    }, [
        onChange,
        createAnalyticsEvent
    ]);
    const handleChange = (0, $eJOHy.useCallback)((option)=>{
        if (isConfigureStatusAvailable && option?.value && [
            (0, $559e2d0f325c757f$export$bbd08ee543ba8cc3),
            (0, $559e2d0f325c757f$export$4f9299d0cd8b6a8b),
            (0, $559e2d0f325c757f$export$bc1622166baa0162)
        ].includes(option.value)) {
            switch(option?.value){
                case 0, $559e2d0f325c757f$export$bbd08ee543ba8cc3:
                    createStatusButtonRef?.current?.click();
                    setIsConfigureStatusModalOpen(true);
                    break;
                case 0, $559e2d0f325c757f$export$bc1622166baa0162:
                    editStatusButtonRef?.current?.click();
                    setIsConfigureStatusModalOpen(true);
                    break;
                case 0, $559e2d0f325c757f$export$4f9299d0cd8b6a8b:
                    onOpenManageWorkflow && onOpenManageWorkflow();
                    break;
                default:
                    break;
            }
            return;
        }
        if (option && $cd5a236a0b8ca92f$var$isTransitionOption(option)) handleChangeStatus(option.transition);
    }, [
        handleChangeStatus,
        isConfigureStatusAvailable,
        onOpenManageWorkflow
    ]);
    const handleOpen = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'openDropdown',
            actionSubject: 'statusField'
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'openDropdownStatusField');
        onOpen?.(analyticsEvent);
        setIsOpen(true);
    }, [
        onOpen,
        createAnalyticsEvent
    ]);
    const handleClose = (0, $eJOHy.useCallback)(()=>{
        wasChanged.current = false;
        onClose?.();
        setIsOpen(false);
        setShouldRefocus(true);
    }, [
        onClose
    ]);
    const isStatusInlineFooterEnabled = (0, $eJOHy.useMemo)(()=>showConfigureStatusButtons, [
        showConfigureStatusButtons
    ]);
    const transformedOptions = (0, $eJOHy.useMemo)(()=>(0, $90zjX.transformOptions)(filteredAndOrderedTransitions || []), [
        filteredAndOrderedTransitions
    ]);
    const selectOptions = (0, $dSpUw.useSelectOptions)(transformedOptions, isStatusInlineFooterEnabled);
    const getNoOptionsMessage = ()=>{
        if (customNoOptionsMessage) return customNoOptionsMessage;
        const noPermissionMessage = (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $aY0vM.default).noPermissionIssueTermRefresh : (0, $aY0vM.default).noPermission;
        return formatMessage(wasFetchSuccessful ? noPermissionMessage : (0, $aY0vM.default).cannotLoadTransitions);
    };
    const statusPopup = shouldRenderSelectComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        label: formatMessage((0, $aY0vM.default).selectStatus),
        inputId: fieldId,
        noOptionsMessage: getNoOptionsMessage,
        formatOptionLabel: (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$FormatTransitionOptionLabelWithCreateStatus, {
                option: option
            }),
        getOptionLabel: getTransitionOptionLabel,
        options: selectOptions,
        isLoading: isLoading,
        isDisabled: !isEditable,
        isOptionDisabled: $cd5a236a0b8ca92f$var$isOptionDisabled,
        onChange: handleChange,
        value: (0, $90zjX.transformOptions)([
            selectedTransition
        ])[0],
        isSearchable: false,
        onMenuOpen: handleOpen,
        closeMenuOnSelect: true,
        components: {
            LoadingMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ke54d.LoadingSpinner), null),
            ...isStatusInlineFooterEnabled && {
                Group: (0, $9ZjBG.GroupComponentWithStickyFooter),
                Option: (0, $dSpUw.OptionComponent)
            }
        },
        menuIsOpen: isConfigureStatusModalOpen ? false : undefined,
        popperProps: mergedPopperProps,
        ref: selectRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sl8jM.default), {
        inputId: fieldId,
        noOptionsMessage: getNoOptionsMessage,
        formatOptionLabel: (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$FormatTransitionOptionLabel, {
                option: option
            }),
        getOptionLabel: getTransitionOptionLabel,
        options: transformedOptions,
        target: ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$Target, {
                targetRef: statusButtonRef ? (0, $bzbsd.mergeRefs)(ref, statusButtonRef) : ref,
                helperTextId: helperTextId
            }),
        isLoading: isLoading,
        isDisabled: !isEditable,
        isOptionDisabled: $cd5a236a0b8ca92f$var$isOptionDisabled,
        searchThreshold: 99999,
        onChange: handleChange,
        onOpen: handleOpen,
        handleClick: handleOpen,
        onClose: handleClose,
        closeMenuOnSelect: true,
        components: {
            LoadingMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ke54d.LoadingSpinner), null)
        },
        isOpen: isConfigureStatusModalOpen ? false : undefined,
        popperProps: mergedPopperProps,
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$Footer, null),
        defaultIsOpen: defaultOpen,
        label: formatMessage((0, $aY0vM.default).selectStatus),
        shouldCloseMenuOnTab: false
    });
    const stableProps = (0, $hrKgE.useShallowStableReference)(props);
    const contextValues = (0, $eJOHy.useMemo)(()=>({
            ...stableProps,
            shouldStatusConfigTriggerModal: shouldStatusConfigTriggerModal,
            isOpen: isOpen,
            setIsConfigureStatusModalOpen: setIsConfigureStatusModalOpen,
            onClickConfigureStatus: onClickConfigureStatus,
            onCloseConfigureStatus: onCloseConfigureStatus,
            onClickExplainWorkflow: (0, $4cTDP.fg)('jira-pandora-ai-explain-workflow') ? onClickExplainWorkflow : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            createStatusButtonRef: createStatusButtonRef,
            editStatusButtonRef: editStatusButtonRef,
            filteredAndOrderedTransitions: filteredAndOrderedTransitions
        }), [
        stableProps,
        shouldStatusConfigTriggerModal,
        isOpen,
        setIsConfigureStatusModalOpen,
        onClickConfigureStatus,
        onCloseConfigureStatus,
        onClickExplainWorkflow,
        filteredAndOrderedTransitions
    ]); /* This prevents the dropdown from being accessible while saving/not editable,
                                                                                                                                                                                                     * because for the underlying PopupSelect, the `isDisabled` prop only prevents
                                                                                                                                                                                                     * the actual dropdown items from being selectable - the dropdown itself still
                                                                                                                                                                                                     * pops up/down.
                                                                                                                                                                                                     */ 
    if (isSaving || !isEditable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$StatusViewContext.Provider, {
        value: contextValues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$Target, null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$StatusViewContext.Provider, {
        value: contextValues
    }, isConfigureStatusPopupOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fkCrf.ConfigureStatusPopup), {
        placement: configureStatusPopupPlacement,
        renderTarget: $cd5a236a0b8ca92f$var$Target,
        renderPopupContent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ConfigureStatusPopupContent, null),
        isTargetEditable: isEditable,
        onClose: ()=>setIsConfigureStatusPopupOpen(false)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ConfigureStatusPopupTriggerContextProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bskNA.ModalContextProvider), null, !shouldCaptureEscape && ((0, $4cTDP.fg)('treegrid_keyboard_navigation') || (0, $4cTDP.fg)('nin-grid-keyboard-navigation')) ? statusPopup : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f5dwt.default), {
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }, statusPopup))));
};
const $cd5a236a0b8ca92f$var$statusViewFooterStyles = (0, $1DXK0.xcss)({
    borderTop: `2px solid ${"var(--ds-border, #091E4224)"}`
});
const $cd5a236a0b8ca92f$var$manageWorkflowStyles = (0, $1DXK0.xcss)({
    height: '100%',
    width: '100%',
    backgroundColor: 'color.background.neutral.subtle',
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: 'font.weight.medium'
});
const $cd5a236a0b8ca92f$var$visuallyHiddenLegendStyles = null;
const $cd5a236a0b8ca92f$var$transitionOptionStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.025',
    paddingBottom: 'space.025'
});
var $cd5a236a0b8ca92f$export$2e2bcd8739ae039 = $cd5a236a0b8ca92f$export$a11134e1462e763;

});
parcelRegister("sl8jM", function(module, exports) {
$parcel$export(module.exports, "default", () => $f040ddaa0ef5501e$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $aQK2r = parcelRequire("aQK2r");

var $1Q3jn = parcelRequire("1Q3jn");

var $7QJq6 = parcelRequire("7QJq6");
var $i0xNm = parcelRequire("i0xNm");
var $lEbH4 = parcelRequire("lEbH4");

var $5yteI = parcelRequire("5yteI");

var $gl2vi = parcelRequire("gl2vi");

var $eGOwo = parcelRequire("eGOwo");

var $e9zKl = parcelRequire("e9zKl");


var $c4OV1 = parcelRequire("c4OV1");

var $5nAXq = parcelRequire("5nAXq");

var $ctyCN = parcelRequire("ctyCN");
/**
 * Are we rendering on the client or server?
 */ const $f040ddaa0ef5501e$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $f040ddaa0ef5501e$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
/**
 * The new defaults match the default modifiers of `@atlaskit/popper`.
 *
 * In the future we should investigate using `@atlaskit/popper` instead of
 * consuming `react-popper` directly.
 *
 * Previously the select popup would slide over the trigger to try to stay visible.
 * This behavior could actually cause it to go offscreen.
 *
 * Now it will stay anchored above / below the trigger and cause the
 * clipping parent to scroll if necessary. This aligns with other popups.
 */ const $f040ddaa0ef5501e$var$newDefaultModifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            rootBoundary: 'document'
        }
    },
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: 5,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
const $f040ddaa0ef5501e$var$defaultPopperProps = {
    modifiers: $f040ddaa0ef5501e$var$modifiers,
    placement: 'bottom-start'
};
const $f040ddaa0ef5501e$var$newDefaultPopperProps = {
    modifiers: $f040ddaa0ef5501e$var$newDefaultModifiers,
    placement: 'bottom-start'
};
const $f040ddaa0ef5501e$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $f040ddaa0ef5501e$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            shouldCloseMenuOnTab: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...(0, $eGOwo.fg)('platform_dst_nav4_layering_in_main_slot_fixes') ? $f040ddaa0ef5501e$var$newDefaultPopperProps : $f040ddaa0ef5501e$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $5yteI.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $5nAXq.defaultComponents),
            ...props.components
        };
        if (!(0, $5yteI.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$f040ddaa0ef5501e$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $4eDgu.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $7QJq6.Manager), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gl2vi.IdProvider), {
                    postfix: "-popup-select",
                    children: ({ id: id })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lEbH4.Reference), {
                                    children: ({ ref: ref })=>target && target({
                                            isOpen: isOpen,
                                            onKeyDown: this.handleTargetKeyDown,
                                            ref: this.resolveTargetRef(ref),
                                            // Should technically be 'dialog' by default instead of 'true' via AriaAttributes, but will require further changes.
                                            // See go/DSP-22283
                                            'aria-haspopup': 'true',
                                            'aria-expanded': isOpen,
                                            'aria-controls': isOpen ? id : undefined
                                        })
                                }),
                                this.renderSelect(id)
                            ]
                        })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ctyCN.NotifyOpenLayerObserver), {
                    isOpen: this.state.isOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.menuRef = null, this.selectRef = null, this.targetRef = null, this.unbindWindowClick = null, this.unbindWindowKeydown = null, this.defaultStyles = {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $7bb4c1736002a04a$export$eaa8c8a70ac22806})`
                })
        }, this.isOpenControlled = this.props.isOpen !== undefined, this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen, this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $5nAXq.defaultComponents),
            mergedPopperProps: (0, $eGOwo.fg)('platform_dst_nav4_layering_in_main_slot_fixes') ? $f040ddaa0ef5501e$var$newDefaultPopperProps : $f040ddaa0ef5501e$var$defaultPopperProps
        }, // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        }, this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
            if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        }, this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        }, this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        }, this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        }, // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $4eDgu.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        }, /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            //@ts-ignore react-select unsupported props
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }, // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            }, this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            }, this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        }, // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        }, this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        }, // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        }, // Renderers
        // ==============================
        this.renderSelect = (id)=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $f040ddaa0ef5501e$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $5nAXq.DummyControl)
            };
            // @ts-ignore - TS7030: Not all code paths return a value - causing issues for help-center local consumption with TS 5.9.2
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
                return undefined;
            };
            const popper = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i0xNm.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                },
                children: ({ placement: placement, ref: ref, style: style })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $5nAXq.MenuDialog), {
                        // There is not a limited amount of values for the widths, so they need to remain dynamic.
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            ...style,
                            maxWidth: maxMenuWidth,
                            minWidth: minMenuWidth
                        },
                        "data-placement": placement,
                        id: id,
                        testId: testId,
                        ref: this.resolveMenuRef(ref),
                        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $1Q3jn.default), {
                            disabled: !focusLockEnabled,
                            returnFocus: true,
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
                                    label: getLabel(),
                                    backspaceRemovesValue: false,
                                    controlShouldRenderValue: false,
                                    isClearable: false,
                                    tabSelectsValue: false,
                                    menuIsOpen: true,
                                    placeholder: placeholder,
                                    ref: this.getSelectRef,
                                    ...props,
                                    isSearchable: showSearchControl,
                                    styles: (0, $e9zKl.mergeStyles)(this.defaultStyles, props.styles || {}),
                                    maxMenuHeight: this.getMaxHeight(),
                                    components: selectComponents,
                                    onChange: this.handleSelectChange,
                                    testId: testId
                                }),
                                footer
                            ]
                        })
                    })
            });
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $aQK2r.createPortal)(popper, portalDestination);
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            this.close();
        };
    }
}

});
parcelRegister("7QJq6", function(module, exports) {
$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $5b709f3958b336e6$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $5b709f3958b336e6$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $5b709f3958b336e6$export$d0d38e7dec7a1a61);

var $eJOHy = parcelRequire("eJOHy");
var $5b709f3958b336e6$export$3dbd3405086fec7b = $eJOHy.createContext();
var $5b709f3958b336e6$export$cbabb21c2529b130 = $eJOHy.createContext();
function $5b709f3958b336e6$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $eJOHy.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $eJOHy.useRef(false);
    $eJOHy.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $eJOHy.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $eJOHy.createElement($5b709f3958b336e6$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $eJOHy.createElement($5b709f3958b336e6$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("i0xNm", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $d1c2711317bcdd69$export$badac9ada3a0bdf9);

var $eJOHy = parcelRequire("eJOHy");

var $7QJq6 = parcelRequire("7QJq6");

var $65sWw = parcelRequire("65sWw");

var $8E4Pq = parcelRequire("8E4Pq");
var $d1c2711317bcdd69$var$NOOP = function NOOP() {
    return void 0;
};
var $d1c2711317bcdd69$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $d1c2711317bcdd69$var$EMPTY_MODIFIERS = [];
function $d1c2711317bcdd69$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $d1c2711317bcdd69$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $eJOHy.useContext((0, $7QJq6.ManagerReferenceNodeContext));
    var _React$useState = $eJOHy.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $eJOHy.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $eJOHy.useEffect(function() {
        (0, $65sWw.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $eJOHy.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $8E4Pq.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $eJOHy.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $d1c2711317bcdd69$var$NOOP,
            update: update || $d1c2711317bcdd69$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $65sWw.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("65sWw", function(module, exports) {
$parcel$export(module.exports, "unwrapArray", () => $46e9a926da059f7f$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $46e9a926da059f7f$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $46e9a926da059f7f$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $46e9a926da059f7f$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $46e9a926da059f7f$export$700979bc83e7db82);

var $eJOHy = parcelRequire("eJOHy");
var $46e9a926da059f7f$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $46e9a926da059f7f$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $46e9a926da059f7f$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $46e9a926da059f7f$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $46e9a926da059f7f$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $46e9a926da059f7f$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $eJOHy.useLayoutEffect : $eJOHy.useEffect;

});

parcelRegister("8E4Pq", function(module, exports) {
$parcel$export(module.exports, "usePopper", () => $64b5cdf5dd511d2b$export$f4d5bf230a36dd6e);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $gnxAv = parcelRequire("gnxAv");

var $aVrYR = parcelRequire("aVrYR");

var $65sWw = parcelRequire("65sWw");
var $64b5cdf5dd511d2b$var$EMPTY_MODIFIERS = [];
var $64b5cdf5dd511d2b$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $eJOHy.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $64b5cdf5dd511d2b$var$EMPTY_MODIFIERS
    };
    var _React$useState = $eJOHy.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $eJOHy.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $aQK2r.flushSync(function() {
                    setState({
                        styles: (0, $65sWw.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $65sWw.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $eJOHy.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($aVrYR)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $eJOHy.useRef();
    (0, $65sWw.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $65sWw.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $gnxAv.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("gnxAv", function(module, exports) {
$parcel$export(module.exports, "createPopper", () => $bec8d928f7873785$export$8f7491d57c8f97a9);

var $heIbG = parcelRequire("heIbG");

var $bMX9T = parcelRequire("bMX9T");

var $3lXAT = parcelRequire("3lXAT");

var $9rdGq = parcelRequire("9rdGq");

var $9HkoV = parcelRequire("9HkoV");

var $f7Vnd = parcelRequire("f7Vnd");

var $6DBHs = parcelRequire("6DBHs");

var $31C6T = parcelRequire("31C6T");

var $a6oPx = parcelRequire("a6oPx");

var $c2Bzy = parcelRequire("c2Bzy");


var $bec8d928f7873785$export$d34966752335dd47 = [
    (0, $bMX9T.default),
    (0, $3lXAT.default),
    (0, $9rdGq.default),
    (0, $9HkoV.default),
    (0, $f7Vnd.default),
    (0, $6DBHs.default),
    (0, $31C6T.default),
    (0, $a6oPx.default),
    (0, $c2Bzy.default)
];
var $bec8d928f7873785$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $heIbG.popperGenerator)({
    defaultModifiers: $bec8d928f7873785$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("heIbG", function(module, exports) {
$parcel$export(module.exports, "popperGenerator", () => $c8c60531711653f3$export$ed5e13716264f202);

var $elLvv = parcelRequire("elLvv");

var $9J30E = parcelRequire("9J30E");

var $kXPOQ = parcelRequire("kXPOQ");

var $5hADZ = parcelRequire("5hADZ");

var $467x6 = parcelRequire("467x6");

var $bQzW7 = parcelRequire("bQzW7");

var $287ko = parcelRequire("287ko");


var $gg6Qu = parcelRequire("gg6Qu");
var $c8c60531711653f3$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $c8c60531711653f3$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $c8c60531711653f3$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $c8c60531711653f3$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $c8c60531711653f3$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $gg6Qu.isElement)(reference) ? (0, $kXPOQ.default)(reference) : reference.contextElement ? (0, $kXPOQ.default)(reference.contextElement) : [],
                    popper: (0, $kXPOQ.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $467x6.default)((0, $287ko.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$c8c60531711653f3$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $elLvv.default)(reference, (0, $5hADZ.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $9J30E.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $bQzW7.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$c8c60531711653f3$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $c8c60531711653f3$export$8f7491d57c8f97a9 = /*#__PURE__*/ $c8c60531711653f3$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("elLvv", function(module, exports) {
$parcel$export(module.exports, "default", () => $a727e0cb46add6f0$export$2e2bcd8739ae039);

var $k65dW = parcelRequire("k65dW");

var $g4m1c = parcelRequire("g4m1c");

var $4baem = parcelRequire("4baem");

var $gg6Qu = parcelRequire("gg6Qu");

var $2uwXd = parcelRequire("2uwXd");

var $7gyBU = parcelRequire("7gyBU");

var $9Uhst = parcelRequire("9Uhst");

var $8amqe = parcelRequire("8amqe");
function $a727e0cb46add6f0$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $8amqe.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $8amqe.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $a727e0cb46add6f0$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $gg6Qu.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $gg6Qu.isHTMLElement)(offsetParent) && $a727e0cb46add6f0$var$isElementScaled(offsetParent);
    var documentElement = (0, $7gyBU.default)(offsetParent);
    var rect = (0, $k65dW.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4baem.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $9Uhst.default)(documentElement)) scroll = (0, $g4m1c.default)(offsetParent);
        if ((0, $gg6Qu.isHTMLElement)(offsetParent)) {
            offsets = (0, $k65dW.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $2uwXd.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("k65dW", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea186b851f3316f0$export$2e2bcd8739ae039);

var $gg6Qu = parcelRequire("gg6Qu");

var $8amqe = parcelRequire("8amqe");

var $fWmj3 = parcelRequire("fWmj3");

var $2aPrh = parcelRequire("2aPrh");
function $ea186b851f3316f0$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $gg6Qu.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $8amqe.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $8amqe.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $gg6Qu.isElement)(element) ? (0, $fWmj3.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $2aPrh.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("gg6Qu", function(module, exports) {
$parcel$export(module.exports, "isElement", () => $bd63735f7342e30f$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $bd63735f7342e30f$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $bd63735f7342e30f$export$af51f0f06c0f328a);

var $fWmj3 = parcelRequire("fWmj3");
function $bd63735f7342e30f$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $fWmj3.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $bd63735f7342e30f$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $fWmj3.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $bd63735f7342e30f$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $fWmj3.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("fWmj3", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9ad935b388d902f$export$2e2bcd8739ae039);
function $b9ad935b388d902f$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("8amqe", function(module, exports) {
$parcel$export(module.exports, "max", () => $5f20a67c3007211c$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $5f20a67c3007211c$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $5f20a67c3007211c$export$2077e0241d6afd3c);
var $5f20a67c3007211c$export$8960430cfd85939f = Math.max;
var $5f20a67c3007211c$export$96ec731ed4dcb222 = Math.min;
var $5f20a67c3007211c$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("2aPrh", function(module, exports) {
$parcel$export(module.exports, "default", () => $19546aaa985cfe85$export$2e2bcd8739ae039);

var $jfbGV = parcelRequire("jfbGV");
function $19546aaa985cfe85$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $jfbGV.default)());
}

});
parcelRegister("jfbGV", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0287cade039ed57$export$2e2bcd8739ae039);
function $e0287cade039ed57$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("g4m1c", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb2e196d14a21ebf$export$2e2bcd8739ae039);

var $cOno9 = parcelRequire("cOno9");

var $fWmj3 = parcelRequire("fWmj3");

var $gg6Qu = parcelRequire("gg6Qu");

var $cjw1I = parcelRequire("cjw1I");
function $bb2e196d14a21ebf$export$2e2bcd8739ae039(node) {
    if (node === (0, $fWmj3.default)(node) || !(0, $gg6Qu.isHTMLElement)(node)) return (0, $cOno9.default)(node);
    else return (0, $cjw1I.default)(node);
}

});
parcelRegister("cOno9", function(module, exports) {
$parcel$export(module.exports, "default", () => $953c4c05b181c08e$export$2e2bcd8739ae039);

var $fWmj3 = parcelRequire("fWmj3");
function $953c4c05b181c08e$export$2e2bcd8739ae039(node) {
    var win = (0, $fWmj3.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("cjw1I", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f701a3aded86182$export$2e2bcd8739ae039);
function $8f701a3aded86182$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("4baem", function(module, exports) {
$parcel$export(module.exports, "default", () => $30b0201497441060$export$2e2bcd8739ae039);
function $30b0201497441060$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("2uwXd", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d07f21abc9989f4$export$2e2bcd8739ae039);

var $k65dW = parcelRequire("k65dW");

var $7gyBU = parcelRequire("7gyBU");

var $cOno9 = parcelRequire("cOno9");
function $1d07f21abc9989f4$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $k65dW.default)((0, $7gyBU.default)(element)).left + (0, $cOno9.default)(element).scrollLeft;
}

});
parcelRegister("7gyBU", function(module, exports) {
$parcel$export(module.exports, "default", () => $54a4dfebec89ee7e$export$2e2bcd8739ae039);

var $gg6Qu = parcelRequire("gg6Qu");
function $54a4dfebec89ee7e$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $gg6Qu.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("9Uhst", function(module, exports) {
$parcel$export(module.exports, "default", () => $7366e2de4224a174$export$2e2bcd8739ae039);

var $gJ1QC = parcelRequire("gJ1QC");
function $7366e2de4224a174$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $gJ1QC.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("gJ1QC", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2d24838526c2191$export$2e2bcd8739ae039);

var $fWmj3 = parcelRequire("fWmj3");
function $c2d24838526c2191$export$2e2bcd8739ae039(element) {
    return (0, $fWmj3.default)(element).getComputedStyle(element);
}

});



parcelRegister("9J30E", function(module, exports) {
$parcel$export(module.exports, "default", () => $714aa6a5cb9954a0$export$2e2bcd8739ae039);

var $k65dW = parcelRequire("k65dW");
function $714aa6a5cb9954a0$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $k65dW.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("kXPOQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f431837fa9e8ca57$export$2e2bcd8739ae039);

var $2CQVf = parcelRequire("2CQVf");

var $5ewz1 = parcelRequire("5ewz1");

var $fWmj3 = parcelRequire("fWmj3");

var $9Uhst = parcelRequire("9Uhst");
function $f431837fa9e8ca57$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2CQVf.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $fWmj3.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $9Uhst.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($f431837fa9e8ca57$export$2e2bcd8739ae039((0, $5ewz1.default)(target)));
}

});
parcelRegister("2CQVf", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e982ea2e37d1ae0$export$2e2bcd8739ae039);

var $5ewz1 = parcelRequire("5ewz1");

var $9Uhst = parcelRequire("9Uhst");

var $4baem = parcelRequire("4baem");

var $gg6Qu = parcelRequire("gg6Qu");
function $1e982ea2e37d1ae0$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $4baem.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $gg6Qu.isHTMLElement)(node) && (0, $9Uhst.default)(node)) return node;
    return $1e982ea2e37d1ae0$export$2e2bcd8739ae039((0, $5ewz1.default)(node));
}

});
parcelRegister("5ewz1", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cf7850ed94ba01d$export$2e2bcd8739ae039);

var $4baem = parcelRequire("4baem");

var $7gyBU = parcelRequire("7gyBU");

var $gg6Qu = parcelRequire("gg6Qu");
function $3cf7850ed94ba01d$export$2e2bcd8739ae039(element) {
    if ((0, $4baem.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $gg6Qu.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $7gyBU.default)(element) // fallback
    );
}

});



parcelRegister("5hADZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d8af70a4a661074$export$2e2bcd8739ae039);

var $fWmj3 = parcelRequire("fWmj3");

var $4baem = parcelRequire("4baem");

var $gJ1QC = parcelRequire("gJ1QC");

var $gg6Qu = parcelRequire("gg6Qu");

var $fJU2S = parcelRequire("fJU2S");

var $5ewz1 = parcelRequire("5ewz1");

var $jfbGV = parcelRequire("jfbGV");
function $3d8af70a4a661074$var$getTrueOffsetParent(element) {
    if (!(0, $gg6Qu.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $gJ1QC.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $3d8af70a4a661074$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $jfbGV.default)());
    var isIE = /Trident/i.test((0, $jfbGV.default)());
    if (isIE && (0, $gg6Qu.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $gJ1QC.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $5ewz1.default)(element);
    if ((0, $gg6Qu.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $gg6Qu.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $4baem.default)(currentNode)) < 0){
        var css = (0, $gJ1QC.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $3d8af70a4a661074$export$2e2bcd8739ae039(element) {
    var window = (0, $fWmj3.default)(element);
    var offsetParent = $3d8af70a4a661074$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fJU2S.default)(offsetParent) && (0, $gJ1QC.default)(offsetParent).position === 'static')offsetParent = $3d8af70a4a661074$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $4baem.default)(offsetParent) === 'html' || (0, $4baem.default)(offsetParent) === 'body' && (0, $gJ1QC.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $3d8af70a4a661074$var$getContainingBlock(element) || window;
}

});
parcelRegister("fJU2S", function(module, exports) {
$parcel$export(module.exports, "default", () => $b756886c0c925609$export$2e2bcd8739ae039);

var $4baem = parcelRequire("4baem");
function $b756886c0c925609$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $4baem.default)(element)) >= 0;
}

});


parcelRegister("467x6", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fbd90d3076093ac$export$2e2bcd8739ae039);

var $1LHyG = parcelRequire("1LHyG");
function $2fbd90d3076093ac$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $2fbd90d3076093ac$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $2fbd90d3076093ac$var$order(modifiers); // order based on phase
    return (0, $1LHyG.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("1LHyG", function(module, exports) {
$parcel$export(module.exports, "top", () => $149bf80282ae6f0a$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $149bf80282ae6f0a$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $149bf80282ae6f0a$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $149bf80282ae6f0a$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $149bf80282ae6f0a$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $149bf80282ae6f0a$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $149bf80282ae6f0a$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $149bf80282ae6f0a$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $149bf80282ae6f0a$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $149bf80282ae6f0a$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $149bf80282ae6f0a$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $149bf80282ae6f0a$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $149bf80282ae6f0a$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $149bf80282ae6f0a$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $149bf80282ae6f0a$export$d087d3878fdf71d5);
var $149bf80282ae6f0a$export$1e95b668f3b82d = 'top';
var $149bf80282ae6f0a$export$40e543e69a8b3fbb = 'bottom';
var $149bf80282ae6f0a$export$79ffe56a765070d2 = 'right';
var $149bf80282ae6f0a$export$eabcd2c8791e7bf4 = 'left';
var $149bf80282ae6f0a$export$dfb5619354ba860 = 'auto';
var $149bf80282ae6f0a$export$aec2ce47c367b8c3 = [
    $149bf80282ae6f0a$export$1e95b668f3b82d,
    $149bf80282ae6f0a$export$40e543e69a8b3fbb,
    $149bf80282ae6f0a$export$79ffe56a765070d2,
    $149bf80282ae6f0a$export$eabcd2c8791e7bf4
];
var $149bf80282ae6f0a$export$b3571188c770cc5a = 'start';
var $149bf80282ae6f0a$export$bd5df0f255a350f8 = 'end';
var $149bf80282ae6f0a$export$390fd549c5303b4d = 'clippingParents';
var $149bf80282ae6f0a$export$d7b7311ec04a3e8f = 'viewport';
var $149bf80282ae6f0a$export$ae5ab1c730825774 = 'popper';
var $149bf80282ae6f0a$export$ca50aac9f3ba507f = 'reference';
var $149bf80282ae6f0a$export$368f9a87e87fa4e1 = /*#__PURE__*/ $149bf80282ae6f0a$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $149bf80282ae6f0a$export$b3571188c770cc5a,
        placement + "-" + $149bf80282ae6f0a$export$bd5df0f255a350f8
    ]);
}, []);
var $149bf80282ae6f0a$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($149bf80282ae6f0a$export$aec2ce47c367b8c3, [
    $149bf80282ae6f0a$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $149bf80282ae6f0a$export$b3571188c770cc5a,
        placement + "-" + $149bf80282ae6f0a$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $149bf80282ae6f0a$export$421679a7c3d56e = 'beforeRead';
var $149bf80282ae6f0a$export$aafa59e2e03f2942 = 'read';
var $149bf80282ae6f0a$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $149bf80282ae6f0a$export$c65e99957a05207c = 'beforeMain';
var $149bf80282ae6f0a$export$f22da7240b7add18 = 'main';
var $149bf80282ae6f0a$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $149bf80282ae6f0a$export$8d4d2d70e7d46032 = 'beforeWrite';
var $149bf80282ae6f0a$export$68d8715fc104d294 = 'write';
var $149bf80282ae6f0a$export$70a6e5159acce2e6 = 'afterWrite';
var $149bf80282ae6f0a$export$d087d3878fdf71d5 = [
    $149bf80282ae6f0a$export$421679a7c3d56e,
    $149bf80282ae6f0a$export$aafa59e2e03f2942,
    $149bf80282ae6f0a$export$6964f6c886723980,
    $149bf80282ae6f0a$export$c65e99957a05207c,
    $149bf80282ae6f0a$export$f22da7240b7add18,
    $149bf80282ae6f0a$export$bab79516f2d662fe,
    $149bf80282ae6f0a$export$8d4d2d70e7d46032,
    $149bf80282ae6f0a$export$68d8715fc104d294,
    $149bf80282ae6f0a$export$70a6e5159acce2e6
];

});


parcelRegister("bQzW7", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a006d460a409cf5$export$2e2bcd8739ae039);
function $8a006d460a409cf5$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("287ko", function(module, exports) {
$parcel$export(module.exports, "default", () => $18d203526ff3d300$export$2e2bcd8739ae039);
function $18d203526ff3d300$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("bMX9T", function(module, exports) {
$parcel$export(module.exports, "default", () => $89521114592bb4c0$export$2e2bcd8739ae039);

var $fWmj3 = parcelRequire("fWmj3");
var $89521114592bb4c0$var$passive = {
    passive: true
};
function $89521114592bb4c0$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $fWmj3.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $89521114592bb4c0$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $89521114592bb4c0$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $89521114592bb4c0$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $89521114592bb4c0$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $89521114592bb4c0$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $89521114592bb4c0$var$effect,
    data: {}
};

});

parcelRegister("3lXAT", function(module, exports) {
$parcel$export(module.exports, "default", () => $27118f602f9fb7ed$export$2e2bcd8739ae039);

var $fl9ah = parcelRequire("fl9ah");
function $27118f602f9fb7ed$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $fl9ah.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $27118f602f9fb7ed$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $27118f602f9fb7ed$var$popperOffsets,
    data: {}
};

});
parcelRegister("fl9ah", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2afed1d882b4807$export$2e2bcd8739ae039);

var $ix6Fe = parcelRequire("ix6Fe");

var $3nitp = parcelRequire("3nitp");

var $aRMwh = parcelRequire("aRMwh");

var $1LHyG = parcelRequire("1LHyG");
function $b2afed1d882b4807$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $ix6Fe.default)(placement) : null;
    var variation = placement ? (0, $3nitp.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1LHyG.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1LHyG.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1LHyG.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1LHyG.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $aRMwh.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1LHyG.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1LHyG.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("ix6Fe", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7e07a637cd667c6$export$2e2bcd8739ae039);

function $d7e07a637cd667c6$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("3nitp", function(module, exports) {
$parcel$export(module.exports, "default", () => $2751d9819e47949e$export$2e2bcd8739ae039);
function $2751d9819e47949e$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("aRMwh", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e947d96e10112da$export$2e2bcd8739ae039);
function $7e947d96e10112da$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("9rdGq", function(module, exports) {
$parcel$export(module.exports, "default", () => $6df13fe20ccb3860$export$2e2bcd8739ae039);

var $1LHyG = parcelRequire("1LHyG");

var $5hADZ = parcelRequire("5hADZ");

var $fWmj3 = parcelRequire("fWmj3");

var $7gyBU = parcelRequire("7gyBU");

var $gJ1QC = parcelRequire("gJ1QC");

var $ix6Fe = parcelRequire("ix6Fe");

var $3nitp = parcelRequire("3nitp");

var $8amqe = parcelRequire("8amqe");
var $6df13fe20ccb3860$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $6df13fe20ccb3860$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $8amqe.round)(x * dpr) / dpr || 0,
        y: (0, $8amqe.round)(y * dpr) / dpr || 0
    };
}
function $6df13fe20ccb3860$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1LHyG.left);
    var sideY = (0, $1LHyG.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5hADZ.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $fWmj3.default)(popper)) {
            offsetParent = (0, $7gyBU.default)(popper);
            if ((0, $gJ1QC.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1LHyG.top) || (placement === (0, $1LHyG.left) || placement === (0, $1LHyG.right)) && variation === (0, $1LHyG.end)) {
            sideY = (0, $1LHyG.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1LHyG.left) || (placement === (0, $1LHyG.top) || placement === (0, $1LHyG.bottom)) && variation === (0, $1LHyG.end)) {
            sideX = (0, $1LHyG.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $6df13fe20ccb3860$var$unsetSides);
    var _ref4 = roundOffsets === true ? $6df13fe20ccb3860$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $fWmj3.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $6df13fe20ccb3860$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $ix6Fe.default)(state.placement),
        variation: (0, $3nitp.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $6df13fe20ccb3860$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $6df13fe20ccb3860$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $6df13fe20ccb3860$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $6df13fe20ccb3860$var$computeStyles,
    data: {}
};

});

parcelRegister("9HkoV", function(module, exports) {
$parcel$export(module.exports, "default", () => $70f7f4679a787bbc$export$2e2bcd8739ae039);

var $4baem = parcelRequire("4baem");

var $gg6Qu = parcelRequire("gg6Qu");
// and applies them to the HTMLElements such as popper and arrow
function $70f7f4679a787bbc$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $gg6Qu.isHTMLElement)(element) || !(0, $4baem.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $70f7f4679a787bbc$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $gg6Qu.isHTMLElement)(element) || !(0, $4baem.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $70f7f4679a787bbc$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $70f7f4679a787bbc$var$applyStyles,
    effect: $70f7f4679a787bbc$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("f7Vnd", function(module, exports) {
$parcel$export(module.exports, "default", () => $b034039cedbbe126$export$2e2bcd8739ae039);

var $ix6Fe = parcelRequire("ix6Fe");

var $1LHyG = parcelRequire("1LHyG");
function $b034039cedbbe126$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $ix6Fe.default)(placement);
    var invertDistance = [
        (0, $1LHyG.left),
        (0, $1LHyG.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1LHyG.left),
        (0, $1LHyG.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $b034039cedbbe126$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1LHyG.placements).reduce(function(acc, placement) {
        acc[placement] = $b034039cedbbe126$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $b034039cedbbe126$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $b034039cedbbe126$var$offset
};

});

parcelRegister("6DBHs", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d53a105c719d71f$export$2e2bcd8739ae039);

var $jEhSs = parcelRequire("jEhSs");

var $ix6Fe = parcelRequire("ix6Fe");

var $3nM6l = parcelRequire("3nM6l");

var $2L52j = parcelRequire("2L52j");

var $zvQQI = parcelRequire("zvQQI");

var $1LHyG = parcelRequire("1LHyG");

var $3nitp = parcelRequire("3nitp");
function $4d53a105c719d71f$var$getExpandedFallbackPlacements(placement) {
    if ((0, $ix6Fe.default)(placement) === (0, $1LHyG.auto)) return [];
    var oppositePlacement = (0, $jEhSs.default)(placement);
    return [
        (0, $3nM6l.default)(placement),
        oppositePlacement,
        (0, $3nM6l.default)(oppositePlacement)
    ];
}
function $4d53a105c719d71f$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $ix6Fe.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $jEhSs.default)(preferredPlacement)
    ] : $4d53a105c719d71f$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $ix6Fe.default)(placement) === (0, $1LHyG.auto) ? (0, $zvQQI.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $ix6Fe.default)(placement);
        var isStartVariation = (0, $3nitp.default)(placement) === (0, $1LHyG.start);
        var isVertical = [
            (0, $1LHyG.top),
            (0, $1LHyG.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $2L52j.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1LHyG.right) : (0, $1LHyG.left) : isStartVariation ? (0, $1LHyG.bottom) : (0, $1LHyG.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $jEhSs.default)(mainVariationSide);
        var altVariationSide = (0, $jEhSs.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $4d53a105c719d71f$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $4d53a105c719d71f$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("jEhSs", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4df9ecf09fd7b98$export$2e2bcd8739ae039);
var $e4df9ecf09fd7b98$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $e4df9ecf09fd7b98$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $e4df9ecf09fd7b98$var$hash[matched];
    });
}

});

parcelRegister("3nM6l", function(module, exports) {
$parcel$export(module.exports, "default", () => $2768d4fade00acc0$export$2e2bcd8739ae039);
var $2768d4fade00acc0$var$hash = {
    start: 'end',
    end: 'start'
};
function $2768d4fade00acc0$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $2768d4fade00acc0$var$hash[matched];
    });
}

});

parcelRegister("2L52j", function(module, exports) {
$parcel$export(module.exports, "default", () => $2023e0a84dae9603$export$2e2bcd8739ae039);

var $9x9tN = parcelRequire("9x9tN");

var $7gyBU = parcelRequire("7gyBU");

var $k65dW = parcelRequire("k65dW");

var $fl9ah = parcelRequire("fl9ah");

var $in7or = parcelRequire("in7or");

var $1LHyG = parcelRequire("1LHyG");

var $gg6Qu = parcelRequire("gg6Qu");

var $LmsI1 = parcelRequire("LmsI1");

var $dOabu = parcelRequire("dOabu");
function $2023e0a84dae9603$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1LHyG.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1LHyG.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1LHyG.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $LmsI1.default)(typeof padding !== 'number' ? padding : (0, $dOabu.default)(padding, (0, $1LHyG.basePlacements)));
    var altContext = elementContext === (0, $1LHyG.popper) ? (0, $1LHyG.reference) : (0, $1LHyG.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $9x9tN.default)((0, $gg6Qu.isElement)(element) ? element : element.contextElement || (0, $7gyBU.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $k65dW.default)(state.elements.reference);
    var popperOffsets = (0, $fl9ah.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $in7or.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1LHyG.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1LHyG.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1LHyG.right),
                (0, $1LHyG.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1LHyG.top),
                (0, $1LHyG.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("9x9tN", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f0e8c9530387084$export$2e2bcd8739ae039);

var $1LHyG = parcelRequire("1LHyG");

var $3xt5L = parcelRequire("3xt5L");

var $9oWt3 = parcelRequire("9oWt3");

var $kXPOQ = parcelRequire("kXPOQ");

var $5hADZ = parcelRequire("5hADZ");

var $7gyBU = parcelRequire("7gyBU");

var $gJ1QC = parcelRequire("gJ1QC");

var $gg6Qu = parcelRequire("gg6Qu");

var $k65dW = parcelRequire("k65dW");

var $5ewz1 = parcelRequire("5ewz1");

var $96vJk = parcelRequire("96vJk");

var $4baem = parcelRequire("4baem");

var $in7or = parcelRequire("in7or");

var $8amqe = parcelRequire("8amqe");
function $6f0e8c9530387084$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $k65dW.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $6f0e8c9530387084$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1LHyG.viewport) ? (0, $in7or.default)((0, $3xt5L.default)(element, strategy)) : (0, $gg6Qu.isElement)(clippingParent) ? $6f0e8c9530387084$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $in7or.default)((0, $9oWt3.default)((0, $7gyBU.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $6f0e8c9530387084$var$getClippingParents(element) {
    var clippingParents = (0, $kXPOQ.default)((0, $5ewz1.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $gJ1QC.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $gg6Qu.isHTMLElement)(element) ? (0, $5hADZ.default)(element) : element;
    if (!(0, $gg6Qu.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $gg6Qu.isElement)(clippingParent) && (0, $96vJk.default)(clippingParent, clipperElement) && (0, $4baem.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $6f0e8c9530387084$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $6f0e8c9530387084$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $6f0e8c9530387084$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $8amqe.max)(rect.top, accRect.top);
        accRect.right = (0, $8amqe.min)(rect.right, accRect.right);
        accRect.bottom = (0, $8amqe.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $8amqe.max)(rect.left, accRect.left);
        return accRect;
    }, $6f0e8c9530387084$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("3xt5L", function(module, exports) {
$parcel$export(module.exports, "default", () => $293b0537fae813b9$export$2e2bcd8739ae039);

var $fWmj3 = parcelRequire("fWmj3");

var $7gyBU = parcelRequire("7gyBU");

var $2uwXd = parcelRequire("2uwXd");

var $2aPrh = parcelRequire("2aPrh");
function $293b0537fae813b9$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $fWmj3.default)(element);
    var html = (0, $7gyBU.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $2aPrh.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $2uwXd.default)(element),
        y: y
    };
}

});

parcelRegister("9oWt3", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d83b5603b3586ee$export$2e2bcd8739ae039);

var $7gyBU = parcelRequire("7gyBU");

var $gJ1QC = parcelRequire("gJ1QC");

var $2uwXd = parcelRequire("2uwXd");

var $cOno9 = parcelRequire("cOno9");

var $8amqe = parcelRequire("8amqe");
function $6d83b5603b3586ee$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $7gyBU.default)(element);
    var winScroll = (0, $cOno9.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $8amqe.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $8amqe.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $2uwXd.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $gJ1QC.default)(body || html).direction === 'rtl') x += (0, $8amqe.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("96vJk", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a0d498ab041b2ae$export$2e2bcd8739ae039);

var $gg6Qu = parcelRequire("gg6Qu");
function $6a0d498ab041b2ae$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $gg6Qu.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("in7or", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6001c20f097600c$export$2e2bcd8739ae039);
function $d6001c20f097600c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("LmsI1", function(module, exports) {
$parcel$export(module.exports, "default", () => $08e5d065659557f4$export$2e2bcd8739ae039);

var $hiKju = parcelRequire("hiKju");
function $08e5d065659557f4$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $hiKju.default)(), paddingObject);
}

});
parcelRegister("hiKju", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9880af3f66b6790$export$2e2bcd8739ae039);
function $c9880af3f66b6790$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("dOabu", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0d7d8467385dc15$export$2e2bcd8739ae039);
function $a0d7d8467385dc15$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("zvQQI", function(module, exports) {
$parcel$export(module.exports, "default", () => $06abfa066cc434b3$export$2e2bcd8739ae039);

var $3nitp = parcelRequire("3nitp");

var $1LHyG = parcelRequire("1LHyG");

var $2L52j = parcelRequire("2L52j");

var $ix6Fe = parcelRequire("ix6Fe");
function $06abfa066cc434b3$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1LHyG.placements) : _options$allowedAutoP;
    var variation = (0, $3nitp.default)(placement);
    var placements = variation ? flipVariations ? (0, $1LHyG.variationPlacements) : (0, $1LHyG.variationPlacements).filter(function(placement) {
        return (0, $3nitp.default)(placement) === variation;
    }) : (0, $1LHyG.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $2L52j.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $ix6Fe.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("31C6T", function(module, exports) {
$parcel$export(module.exports, "default", () => $233f06fcebd46aab$export$2e2bcd8739ae039);

var $1LHyG = parcelRequire("1LHyG");

var $ix6Fe = parcelRequire("ix6Fe");

var $aRMwh = parcelRequire("aRMwh");

var $52Fp0 = parcelRequire("52Fp0");

var $hPHoq = parcelRequire("hPHoq");

var $9J30E = parcelRequire("9J30E");

var $5hADZ = parcelRequire("5hADZ");

var $2L52j = parcelRequire("2L52j");

var $3nitp = parcelRequire("3nitp");

var $hiKju = parcelRequire("hiKju");

var $8amqe = parcelRequire("8amqe");
function $233f06fcebd46aab$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $2L52j.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $ix6Fe.default)(state.placement);
    var variation = (0, $3nitp.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $aRMwh.default)(basePlacement);
    var altAxis = (0, $52Fp0.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1LHyG.top) : (0, $1LHyG.left);
        var altSide = mainAxis === 'y' ? (0, $1LHyG.bottom) : (0, $1LHyG.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1LHyG.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1LHyG.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9J30E.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $hiKju.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $hPHoq.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5hADZ.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $hPHoq.within)(tether ? (0, $8amqe.min)(min, tetherMin) : min, offset, tether ? (0, $8amqe.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1LHyG.top) : (0, $1LHyG.left);
        var _altSide = mainAxis === 'x' ? (0, $1LHyG.bottom) : (0, $1LHyG.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1LHyG.top),
            (0, $1LHyG.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $hPHoq.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $hPHoq.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $233f06fcebd46aab$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $233f06fcebd46aab$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("52Fp0", function(module, exports) {
$parcel$export(module.exports, "default", () => $3abd4144d8cebe00$export$2e2bcd8739ae039);
function $3abd4144d8cebe00$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("hPHoq", function(module, exports) {
$parcel$export(module.exports, "within", () => $cfb8dc0327546b5f$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $cfb8dc0327546b5f$export$86c8af6d3ef0b4a);

var $8amqe = parcelRequire("8amqe");
function $cfb8dc0327546b5f$export$f28d906d67a997f3(min, value, max) {
    return (0, $8amqe.max)(min, (0, $8amqe.min)(value, max));
}
function $cfb8dc0327546b5f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $cfb8dc0327546b5f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("a6oPx", function(module, exports) {
$parcel$export(module.exports, "default", () => $75adb9ab5729b460$export$2e2bcd8739ae039);

var $ix6Fe = parcelRequire("ix6Fe");

var $9J30E = parcelRequire("9J30E");

var $96vJk = parcelRequire("96vJk");

var $5hADZ = parcelRequire("5hADZ");

var $aRMwh = parcelRequire("aRMwh");

var $hPHoq = parcelRequire("hPHoq");

var $LmsI1 = parcelRequire("LmsI1");

var $dOabu = parcelRequire("dOabu");

var $1LHyG = parcelRequire("1LHyG");
var $75adb9ab5729b460$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $LmsI1.default)(typeof padding !== 'number' ? padding : (0, $dOabu.default)(padding, (0, $1LHyG.basePlacements)));
};
function $75adb9ab5729b460$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $ix6Fe.default)(state.placement);
    var axis = (0, $aRMwh.default)(basePlacement);
    var isVertical = [
        (0, $1LHyG.left),
        (0, $1LHyG.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $75adb9ab5729b460$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9J30E.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $1LHyG.top) : (0, $1LHyG.left);
    var maxProp = axis === 'y' ? (0, $1LHyG.bottom) : (0, $1LHyG.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5hADZ.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $hPHoq.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $75adb9ab5729b460$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $96vJk.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $75adb9ab5729b460$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $75adb9ab5729b460$var$arrow,
    effect: $75adb9ab5729b460$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("c2Bzy", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c42d10fef006a34$export$2e2bcd8739ae039);

var $1LHyG = parcelRequire("1LHyG");

var $2L52j = parcelRequire("2L52j");
function $8c42d10fef006a34$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $8c42d10fef006a34$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1LHyG.top),
        (0, $1LHyG.right),
        (0, $1LHyG.bottom),
        (0, $1LHyG.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $8c42d10fef006a34$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $2L52j.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $2L52j.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $8c42d10fef006a34$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $8c42d10fef006a34$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $8c42d10fef006a34$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $8c42d10fef006a34$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $8c42d10fef006a34$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $8c42d10fef006a34$var$hide
};

});




parcelRegister("lEbH4", function(module, exports) {
$parcel$export(module.exports, "Reference", () => $fc26678a4f3d738c$export$e0be378c32fb70a7);

var $eJOHy = parcelRequire("eJOHy");

var $9Hk5t = parcelRequire("9Hk5t");

var $7QJq6 = parcelRequire("7QJq6");

var $65sWw = parcelRequire("65sWw");
function $fc26678a4f3d738c$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $eJOHy.useContext((0, $7QJq6.ManagerReferenceNodeSetterContext));
    var refHandler = $eJOHy.useCallback(function(node) {
        (0, $65sWw.setRef)(innerRef, node);
        (0, $65sWw.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $eJOHy.useEffect(function() {
        return function() {
            return (0, $65sWw.setRef)(innerRef, null);
        };
    }, []);
    $eJOHy.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9Hk5t)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $65sWw.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("5yteI", function(module, exports) {
$parcel$export(module.exports, "shallowEqualObjects", () => $40b6ce70abc0b2ca$export$3e67810a3f0e9f1c);
function $40b6ce70abc0b2ca$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $40b6ce70abc0b2ca$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $40b6ce70abc0b2ca$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $40b6ce70abc0b2ca$export$967a6b9924a689f7(a, b);
    return $40b6ce70abc0b2ca$export$3e67810a3f0e9f1c(a, b);
}

});

var $7bb4c1736002a04a$exports = {};
$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';

parcelRegister("5nAXq", function(module, exports) {
$parcel$export(module.exports, "MenuDialog", () => $962253e5722485a0$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $962253e5722485a0$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $962253e5722485a0$export$71abc632aa29e6fe);
/* components.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dqx2X = parcelRequire("dqx2X");

var $6XEne = parcelRequire("6XEne");

var $6fs4r = parcelRequire("6fs4r");
const $962253e5722485a0$var$menuDialogStyles = null;
const $962253e5722485a0$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, id: id, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`,
        className: (0, $hcewu.default)([
            "_2rko12b0 _1pby16oo _bfhk1bhr _16qseva7"
        ]),
        children: children
    });
});
// ==============================
// Custom Components
// ==============================
const $962253e5722485a0$var$dropdownStyles = null;
const $962253e5722485a0$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_1bsbzwfg _12l2v77o _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqx2X))), {
            color: "currentColor",
            label: ""
        })
    });
const $962253e5722485a0$var$controlStyles = null;
const $962253e5722485a0$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: innerRef,
        className: (0, $hcewu.default)([
            "_85i51b66 _1q51u2gc _y4tiu2gc _bozgu2gc"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).Control, {
            ...props,
            innerProps: innerProps
        })
    });
const $962253e5722485a0$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).Control, {
            ...props
        })
    });
// NOTE `props` intentionally omitted from `Fragment`
const $962253e5722485a0$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...innerProps,
        children: children
    });
// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
const $962253e5722485a0$var$ClearIndicator = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).ClearIndicator, {
        ...props
    });
const $962253e5722485a0$var$MultiValueRemove = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).MultiValueRemove, {
        ...props
    });
const $962253e5722485a0$export$71abc632aa29e6fe = {
    Control: $962253e5722485a0$var$Control,
    DropdownIndicator: $962253e5722485a0$var$DropdownIndicator,
    Menu: $962253e5722485a0$var$Menu,
    ClearIndicator: $962253e5722485a0$var$ClearIndicator,
    MultiValueRemove: $962253e5722485a0$var$MultiValueRemove
};

});

parcelRegister("ctyCN", function(module, exports) {
$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $5efc0b15e3dedaed$export$17baa7c95b6ba1b8);

var $5NYi5 = parcelRequire("5NYi5");
function $5efc0b15e3dedaed$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore error TS2353: Object literal may only specify known properties, and &#39;onClose&#39; does not exist in type &#39;{ isOpen?: boolean | undefined; }&#39;.
    (0, $5NYi5.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});


parcelRegister("lLL16", function(module, exports) {
$parcel$export(module.exports, "default", () => $da1f6c4838dfb0b0$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $4cTDP = parcelRequire("4cTDP");
function $da1f6c4838dfb0b0$export$2e2bcd8739ae039(props) {
    const { border: border, children: children } = props;
    return (0, $4cTDP.fg)('corcap-4455-increase-ads-adoption') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $da1f6c4838dfb0b0$var$styles.blanketContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da1f6c4838dfb0b0$var$BackgroundContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da1f6c4838dfb0b0$var$Background, {
        border: border
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $da1f6c4838dfb0b0$var$styles.componentContainer
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da1f6c4838dfb0b0$var$SpinnerContainer, {
        role: "status",
        "aria-label": "Loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da1f6c4838dfb0b0$var$StyledBlanketContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da1f6c4838dfb0b0$var$BackgroundContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da1f6c4838dfb0b0$var$Background, {
        border: border
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da1f6c4838dfb0b0$var$StyledComponentContainer, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da1f6c4838dfb0b0$var$SpinnerContainer, {
        role: "status",
        "aria-label": "Loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), null)));
}
$da1f6c4838dfb0b0$export$2e2bcd8739ae039.defaultProps = {
    border: true
};
const $da1f6c4838dfb0b0$var$styles = {
    blanketContainer: (0, $1DXK0.xcss)({
        position: 'relative',
        height: 'auto',
        display: 'inline-flex',
        flexDirection: 'row'
    }),
    componentContainer: (0, $1DXK0.xcss)({
        opacity: "var(--ds-opacity-loading, 0.2)",
        flex: '1 1 auto'
    })
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da1f6c4838dfb0b0$var$StyledBlanketContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _1e0c116y _2lx2vrvc _4t3i1wug",
            __cmplp.className
        ])
    });
});
const $da1f6c4838dfb0b0$var$SpinnerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154iidpf _1ltvidpf _4t3i1osq _1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _u5f3u2gc _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $da1f6c4838dfb0b0$var$BackgroundContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo1wug _18m91wug _kqswstnw _4t3i1osq _1bsb1osq _vchhusvi _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            __cmplp.className
        ])
    });
});
const $da1f6c4838dfb0b0$var$Background = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { border: border, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _kqswh2mm _4t3i1osq _1bsb1osq _vchhusvi _bfhk11bn",
            __cmplp.border ? "_19it1x87" : "_19itglyw",
            __cmplp.className
        ])
    });
});
const $da1f6c4838dfb0b0$var$StyledComponentContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _tzy4sxj9",
            __cmplp.className
        ])
    });
});

});

parcelRegister("f5dwt", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ac00be16f50b3ce$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6S4l2 = parcelRequire("6S4l2");
class $4ac00be16f50b3ce$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            onEscape: null,
            onEnter: null,
            onBlur: null,
            className: undefined
        };
    }
    componentDidMount() {
        // AK Modal uses document.addEventListener() so we also have to use addEventListener.
        // We can't rely on React Synthetic events as stopPropagation won't work
        // This is due to the way React handles events
        // https://github.com/facebook/react/issues/7094
        if (this.ref) this.ref.addEventListener('keydown', this.handleKeyDown);
    }
    componentWillUnmount() {
        if (this.ref) this.ref.removeEventListener('keydown', this.handleKeyDown);
    }
    render() {
        return(// @ts-expect-error - TS2322 - Type '(() => void) | null' is not assignable to type 'FocusEventHandler<HTMLDivElement> | undefined'.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            onBlur: this.props.onBlur,
            ref: this.setRef,
            className: this.props.className
        }, this.props.children));
    }
    constructor(...args){
        super(...args), this.setRef = (ref)=>{
            this.ref = ref;
        }, this.handleKeyDown = (event)=>{
            switch(event.keyCode){
                case (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('escape'):
                    if (this.props.onEscape) {
                        this.props.onEscape(event);
                        event.stopPropagation();
                    }
                    break;
                case (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('enter'):
                    if (this.props.onEnter) {
                        this.props.onEnter(event);
                        event.stopPropagation();
                    }
                    break;
                default:
                    break;
            }
        };
    }
}

});

parcelRegister("9ZjBG", function(module, exports) {
$parcel$export(module.exports, "GroupComponentWithStickyFooter", () => $f299752236250846$export$a4fcc8b2698425e6);
/* GroupComponentWithStickyFooter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6XEne = parcelRequire("6XEne");

const $f299752236250846$var$groupStyles = {
    root: "_ca0qze3t"
};
const $f299752236250846$export$a4fcc8b2698425e6 = ({ children: children, ...groupProps })=>{
    const containStickyFooterGroup = (0, $eJOHy.useMemo)(()=>{
        return groupProps.data.options.find((option)=>option.groupType === (0, $2a68cf016118f389$export$e13d614fc55c6ce9));
    }, [
        groupProps.data.options
    ]);
    if (containStickyFooterGroup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f299752236250846$var$stickyFooterGroupWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Group, {
        ...groupProps,
        innerProps: {
            ...groupProps.innerProps ?? {},
            style: {
                ...groupProps.innerProps?.style ?? {},
                paddingTop: 0
            },
            className: (0, $2a68cf016118f389$export$1ae91d219a8713ac)
        },
        xcss: $f299752236250846$var$groupStyles.root
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Group, groupProps, children);
};
const $f299752236250846$var$stickyFooterGroupWrapper = (0, $1DXK0.xcss)({
    borderTop: `2px solid ${"var(--ds-border, #091E4224)"}`,
    backgroundColor: 'elevation.surface.overlay',
    borderBottomLeftRadius: 'radius.large',
    borderBottomRightRadius: 'radius.large',
    position: 'sticky',
    bottom: 'space.negative.100',
    marginBottom: 'space.negative.100',
    paddingTop: 'space.050'
});

});
const $2a68cf016118f389$export$e13d614fc55c6ce9 = 'STICKY_FOOTER_GROUP_TYPE';
const $2a68cf016118f389$export$1ae91d219a8713ac = 'select-sticky-footer';


parcelRegister("6rZHS", function(module, exports) {
$parcel$export(module.exports, "transformServerRestStatusToStatus", () => $5dae50f5253963ae$export$f8064e1f9ab3c1e0);

var $jx0Vw = parcelRequire("jx0Vw");
const $5dae50f5253963ae$export$f8064e1f9ab3c1e0 = (serverResStatus)=>{
    return {
        id: serverResStatus?.id ?? '',
        statusName: serverResStatus?.name ?? '',
        statusCategory: (0, $jx0Vw.statusCategoryForId)(serverResStatus?.statusCategory?.id)
    };
};

});

parcelRegister("5S4to", function(module, exports) {
$parcel$export(module.exports, "usePanelContext", () => $1a028287cf9587ef$export$2fe6b5e489926495);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $1a028287cf9587ef$export$2fe6b5e489926495({ Context: Context }, preloadedPanel) {
    const [panel, setPanel] = (0, $eJOHy.useState)(preloadedPanel);
    const Panel = (0, $eJOHy.useMemo)(()=>{
        const PanelComponent = ()=>panel ?? null;
        return PanelComponent;
    }, [
        panel
    ]);
    const handleSetPanel = (0, $eJOHy.useCallback)((panel)=>{
        setPanel(panel);
    }, []);
    const value = (0, $eJOHy.useMemo)(()=>({
            setPanel: handleSetPanel
        }), [
        handleSetPanel
    ]);
    const Provider = (0, $eJOHy.useMemo)(()=>({ children: children })=>{
            return /*#__PURE__*/ (0, $gt9Am.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }, [
        Context,
        value
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            Panel: Panel,
            Provider: Provider
        }), [
        Panel,
        Provider
    ]);
}

});

const $559e2d0f325c757f$export$bbd08ee543ba8cc3 = 'createStatus';
const $559e2d0f325c757f$export$bc1622166baa0162 = 'editStatus';
const $559e2d0f325c757f$export$4f9299d0cd8b6a8b = 'manageWorkflow';

parcelRegister("90zjX", function(module, exports) {
$parcel$export(module.exports, "isOnlyGlobalTransitions", () => $552161697b4d85d8$export$10992041bf7e444a);
$parcel$export(module.exports, "getFilteredOrderedTransitions", () => $552161697b4d85d8$export$707115549202b9e4);
$parcel$export(module.exports, "getLoopedTransitionsForStatus", () => $552161697b4d85d8$export$38146914a8d06579);
$parcel$export(module.exports, "transformOptions", () => $552161697b4d85d8$export$8f4ed8ef83bcbf04);
$parcel$export(module.exports, "getStatusShape", () => $552161697b4d85d8$export$e2dafe47b17b2cfc);

var $LFmXM = parcelRequire("LFmXM");

var $jx0Vw = parcelRequire("jx0Vw");
const $552161697b4d85d8$var$isGlobalSelfTransition = (transition, currentStatusId)=>transition.isGlobal && transition.to.id === currentStatusId;
const $552161697b4d85d8$var$isInitialSelfTransition = (transition, currentStatusId)=>transition.isInitial && transition.to.id === currentStatusId;
const $552161697b4d85d8$var$isLoopedTransitionToSelf = (transition, currentStatusId)=>transition.to.id === currentStatusId && transition.isLooped === true;
const $552161697b4d85d8$var$filterLoopedTransitionsToSelf = (0, $LFmXM.default)((transitions, currentStatusId)=>transitions.filter((transition)=>!$552161697b4d85d8$var$isLoopedTransitionToSelf(transition, currentStatusId) && !$552161697b4d85d8$var$isGlobalSelfTransition(transition, currentStatusId) && !$552161697b4d85d8$var$isInitialSelfTransition(transition, currentStatusId)));
const $552161697b4d85d8$export$10992041bf7e444a = (transitions)=>transitions.every((t)=>t.isGlobal);
const $552161697b4d85d8$export$707115549202b9e4 = (transitions, currentStatusId)=>$552161697b4d85d8$var$filterLoopedTransitionsToSelf(transitions || [], currentStatusId);
const $552161697b4d85d8$export$38146914a8d06579 = (0, $LFmXM.default)((transitions, currentStatusId)=>(transitions || []).filter((transition)=>$552161697b4d85d8$var$isLoopedTransitionToSelf(transition, currentStatusId)));
const $552161697b4d85d8$var$formatOptions = (options)=>options.map((t)=>({
            label: t.to.name,
            value: t.id,
            transition: t
        }));
const $552161697b4d85d8$var$memoizedTranformOptions = (0, $LFmXM.default)($552161697b4d85d8$var$formatOptions);
const $552161697b4d85d8$export$8f4ed8ef83bcbf04 = (options)=>$552161697b4d85d8$var$memoizedTranformOptions(options);
const $552161697b4d85d8$export$e2dafe47b17b2cfc = (id, name, category)=>{
    const statusCategoryId = (0, $jx0Vw.StatusCategoryIds)[category] || (0, $jx0Vw.StatusCategoryIds)[(0, $jx0Vw.StatusCategoryTypes).UNDEFINED];
    return {
        id: id,
        name: name,
        statusCategory: {
            id: statusCategoryId,
            name: name
        }
    };
};

});

parcelRegister("6ReHL", function(module, exports) {
$parcel$export(module.exports, "CommandPaletteStatusView", () => $682d49bec9a2c7ba$export$d907a4132fe8618c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $5W05x = parcelRequire("5W05x");

var $ftN6c = parcelRequire("ftN6c");

var $bwM92 = parcelRequire("bwM92");

var $jdqdp = parcelRequire("jdqdp");

var $4cTDP = parcelRequire("4cTDP");

var $1Zcfy = parcelRequire("1Zcfy");

var $30ysG = parcelRequire("30ysG");

var $khCvX = parcelRequire("khCvX");

var $itdlt = parcelRequire("itdlt");

var $9wM6G = parcelRequire("9wM6G");

var $fWwfy = parcelRequire("fWwfy");

var $efhOD = parcelRequire("efhOD");

var $hf4h9 = parcelRequire("hf4h9");

var $g51Bg = parcelRequire("g51Bg");

var $lRq8t = parcelRequire("lRq8t");

var $3bSs8 = parcelRequire("3bSs8");

var $d2AGn = parcelRequire("d2AGn");

var $bmoS1 = parcelRequire("bmoS1");

var $3mZMJ = parcelRequire("3mZMJ");

var $kRgKj = parcelRequire("kRgKj");

var $8oKDI = parcelRequire("8oKDI");


var $dnUkW = parcelRequire("dnUkW");

var $jXut7 = parcelRequire("jXut7");

var $ku7AV = parcelRequire("ku7AV");
const $682d49bec9a2c7ba$export$d907a4132fe8618c = ({ onFetch: onFetch, wasFetchSuccessful: wasFetchSuccessful, currentStatus: currentStatus, transitions: transitions, renderTransition: renderTransition, onSuccess: onSuccess, onUpdateStatusMutation: onUpdateStatusMutation })=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { getKeywords: getKeywords } = (0, $itdlt.useCommandKeywords)();
    const subscribeCommands = (0, $efhOD.useSubscribeCommands)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ expandedCommand: expandedCommand, isOpen: isOpen }, { setChildCommands: setChildCommands }] = (0, $g51Bg.useCommandPaletteExpandedCommand)();
    const renderHeader = (0, $eJOHy.useCallback)((base)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wM6G.CommandFieldHeader), {
            ...base,
            issueKey: issueKey
        }), [
        issueKey
    ]);
    const issueAri = (0, $5W05x.useIssueAri)();
    const { saveStatusField: saveStatusField } = (0, $jXut7.useSaveStatusField)(issueKey, issueAri, onUpdateStatusMutation);
    const expandedCommandId = expandedCommand?.id;
    const issueId = issueAri && (0, $8oKDI.isAri)(issueAri) ? (0, $8oKDI.getAriConfig)(issueAri).resourceId : undefined;
    const loadTransitions = (0, $eJOHy.useCallback)(()=>{
        if (!wasFetchSuccessful) return {
            commands: []
        };
        const transitionCommands = transitions.map((transition)=>({
                id: `${0, $57e4b742849c62a3$export$5252a6a6e4e4a774}-${transition.id}`,
                name: transition.name,
                components: {
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($682d49bec9a2c7ba$var$TransitionWrapper, null, renderTransition({
                            transition: transition
                        }, {
                            addTransitionArrowSpacing: true
                        })),
                    LeftIcon: !expandedCommandId ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bwM92))), {
                            spacing: "spacious",
                            label: "",
                            "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                        }) : undefined
                },
                keywords: (0, $ku7AV.getTransitionKeywords)(transition),
                primaryAction: {
                    type: (0, $hf4h9.CommandActionType).PERFORM,
                    perform: ()=>{
                        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueStatus updated', {
                            oldValId: currentStatus.id,
                            oldStatusCategoryId: currentStatus.statusCategory.id,
                            newValId: transition.to.id,
                            newStatusCategoryId: transition.to.statusCategory.id,
                            hasScreen: transition.hasScreen,
                            isConditional: transition.isConditional
                        });
                        (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $3mZMJ.STATUS_TYPE), {
                            analytics: createAnalyticsEvent({}),
                            attributes: {
                                isCommandPaletteEditing: true,
                                fieldType: (0, $3bSs8.FIELD_TYPE_MAP)[0, $3mZMJ.STATUS_TYPE],
                                oldValId: currentStatus.id,
                                oldStatusCategoryId: currentStatus.statusCategory.id,
                                newValId: transition.to.id,
                                newStatusCategoryId: transition.to.statusCategory.id,
                                issueId: issueId
                            }
                        });
                        saveStatusField(transition, ()=>{
                            onSuccess?.(transition.to, false, createAnalyticsEvent({}));
                        });
                    }
                },
                analytics: {
                    action: 'changeStatus',
                    actionCategory: (0, $1Zcfy.COMMAND_PALETTE_ISSUE_ACTIONS)
                }
            }));
        const currentCommand = expandedCommandId ? [
            {
                id: `${(0, $57e4b742849c62a3$export$5252a6a6e4e4a774)}-${currentStatus.id}-current`,
                name: currentStatus.name,
                components: {
                    LeftIcon: !expandedCommandId ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bwM92))), {
                            spacing: "spacious",
                            label: (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $dnUkW.messages).editStatus),
                            "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                        }) : undefined,
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($682d49bec9a2c7ba$var$TransitionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($682d49bec9a2c7ba$var$SelectedStatusContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
                            isBold: true
                        }, currentStatus.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($682d49bec9a2c7ba$var$CurrentStatusContainer, null, formatMessage((0, $dnUkW.messages).current)))
                },
                primaryAction: {
                    type: (0, $hf4h9.CommandActionType).PERFORM,
                    perform: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
                }
            }
        ] : [];
        const commands = [
            ...currentCommand,
            ...transitionCommands
        ];
        return {
            commands: commands
        };
    }, [
        wasFetchSuccessful,
        transitions,
        expandedCommandId,
        currentStatus.id,
        currentStatus.name,
        currentStatus.statusCategory.id,
        renderTransition,
        createAnalyticsEvent,
        saveStatusField,
        issueId,
        onSuccess,
        formatMessage
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const { commands: commands } = loadTransitions();
        const statusCommand = {
            id: (0, $57e4b742849c62a3$export$5252a6a6e4e4a774),
            name: formatMessage((0, $dnUkW.messages).editStatus),
            shortcut: 'd',
            placeholder: formatMessage((0, $dnUkW.messages).searchTransition),
            keywords: getKeywords('changeStatusSynonyms'),
            section: (0, $khCvX.getCommandPaletteIssueActionsHeader)(issueKey),
            priority: (0, $30ysG.getCommandPaletteIssueActionsPriority)('STATUS'),
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bwM92))), {
                        spacing: "spacious",
                        label: "",
                        "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                    })
            },
            primaryAction: {
                type: (0, $hf4h9.CommandActionType).COMMAND_LIST,
                fallback: {
                    onNoResults: {
                        label: formatMessage((0, $dnUkW.messages).fallbackNoResults)
                    }
                },
                components: {
                    Header: renderHeader
                },
                commands: commands,
                onClick: ()=>{
                    (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart((0, $3mZMJ.STATUS_TYPE), {
                        analytics: createAnalyticsEvent({}),
                        attributes: {
                            fieldType: (0, $3bSs8.FIELD_TYPE_MAP)[0, $3mZMJ.STATUS_TYPE],
                            isCommandPaletteEditing: true
                        }
                    });
                }
            },
            analytics: {
                action: 'changeStatusMenu'
            }
        };
        const unsubscribe = subscribeCommands((0, $fWwfy.COMMAND_PALETTE_REGISTRY_IDS).STATUS, [
            statusCommand
        ]);
        return ()=>unsubscribe();
    }, [
        formatMessage,
        getKeywords,
        issueKey,
        loadTransitions,
        renderHeader,
        subscribeCommands,
        expandedCommand?.id,
        createAnalyticsEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isOpen && onFetch) // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
        onFetch(createAnalyticsEvent({}));
    }, [
        isOpen,
        onFetch,
        createAnalyticsEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isOpen && expandedCommandId === (0, $57e4b742849c62a3$export$5252a6a6e4e4a774)) setChildCommands(loadTransitions());
    }, [
        expandedCommandId,
        isOpen,
        loadTransitions,
        setChildCommands
    ]);
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $682d49bec9a2c7ba$var$TransitionWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1yb4 _18u01b66 _4t3i1tcg _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $682d49bec9a2c7ba$var$SelectedStatusContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $682d49bec9a2c7ba$var$CurrentStatusContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1gjq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5W05x", function(module, exports) {
$parcel$export(module.exports, "useIssueAri", () => $fabcf1a9fe62ebaf$export$f56776f1b409b56d);

var $bmoS1 = parcelRequire("bmoS1");

var $8oKDI = parcelRequire("8oKDI");

var $cHtIB = parcelRequire("cHtIB");
const $fabcf1a9fe62ebaf$export$f56776f1b409b56d = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const issueId = (0, $bmoS1.useIssueId)();
    return (0, $8oKDI.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId ?? ''
    });
};

});

parcelRegister("bwM92", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::511501585faa18257c05d7a2687e12c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8648076de2cded56$var$_react = $8648076de2cded56$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8648076de2cded56$var$_baseNew = $8648076de2cded56$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8648076de2cded56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8648076de2cded56$var$TaskIcon = (props)=>/*#__PURE__*/ $8648076de2cded56$var$_react.default.createElement($8648076de2cded56$var$_baseNew.default, Object.assign({
        name: "TaskIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$8648076de2cded56$var$TaskIcon.displayName = 'TaskIcon';
var $8648076de2cded56$var$_default = module.exports.default = $8648076de2cded56$var$TaskIcon;

});

parcelRegister("30ysG", function(module, exports) {
$parcel$export(module.exports, "getCommandPaletteIssueActionsPriority", () => $bd309fb06918c099$export$5164bb42fa883371);
const $bd309fb06918c099$var$COMMAND_PALETTE_ISSUE_ACTIONS_PRIORITY = {
    STATUS: 10,
    SUMMARY: 20,
    PARENT: 30,
    LINK_ISSUE: 40,
    CONTENT_FIRST_TAB: 50,
    PINNED_FIELDS: 60,
    DETAILS: 70,
    CONTENT_OTHER_TABS: 80,
    MORE_FIELDS: 90,
    OLD_ISSUE_FIELDS: 95,
    ADD_COMMENT: 100,
    GQL_FIELDS: 105,
    SUB_HEADER_ITEMS: 110,
    ISSUE_HEADER_ITEMS: 120
};
const $bd309fb06918c099$export$5164bb42fa883371 = (key)=>$bd309fb06918c099$var$COMMAND_PALETTE_ISSUE_ACTIONS_PRIORITY[key];

});

parcelRegister("khCvX", function(module, exports) {
$parcel$export(module.exports, "getCommandPaletteIssueActionsHeader", () => $97b35cc81a92c1a8$export$cd9931655a8cfb04);

var $1Zcfy = parcelRequire("1Zcfy");
const $97b35cc81a92c1a8$export$cd9931655a8cfb04 = (issueKey)=>`${0, $1Zcfy.COMMAND_PALETTE_ISSUE_ACTIONS}-${issueKey || ''}`;

});

parcelRegister("9wM6G", function(module, exports) {
$parcel$export(module.exports, "CommandFieldHeader", () => $242246011ddb435e$export$c6444eb1c6f44b2d);

var $eJOHy = parcelRequire("eJOHy");

var $78OnL = parcelRequire("78OnL");

var $jmeeg = parcelRequire("jmeeg");

var $d9bSz = parcelRequire("d9bSz");
const $242246011ddb435e$export$c6444eb1c6f44b2d = ({ children: children, issueKey: issueKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jmeeg.components).Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9bSz.IssueTag), {
        issueKey: issueKey
    }), children));

});
parcelRegister("jmeeg", function(module, exports) {
$parcel$export(module.exports, "components", () => $0452758bc49e816e$export$9b5ac10f59f76296);

var $eJOHy = parcelRequire("eJOHy");

var $dUOwK = parcelRequire("dUOwK");

var $2Nn1q = parcelRequire("2Nn1q");

var $lKFw0 = parcelRequire("lKFw0");

var $b4bRO = parcelRequire("b4bRO");
const $0452758bc49e816e$var$NameComponent = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $0452758bc49e816e$export$9b5ac10f59f76296 = {
    CommandRow: // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
    $2Nn1q.CommandRow,
    Name: $0452758bc49e816e$var$NameComponent,
    LeftIcon: (0, $eJOHy.Fragment),
    Wrapper: (0, $eJOHy.Fragment),
    Footer: $lKFw0.Footer,
    Body: (0, $dUOwK.CommandPaletteBody),
    Header: $b4bRO.Header
};

});
parcelRegister("dUOwK", function(module, exports) {
$parcel$export(module.exports, "NoResultsContainer", () => $3a17c57ac1b263a3$export$2ab569a6937cb4e4);
$parcel$export(module.exports, "CommandPaletteBody", () => $3a17c57ac1b263a3$export$b1023de69a8756e6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $58ssj = parcelRequire("58ssj");

var $ftN6c = parcelRequire("ftN6c");

var $fceQU = parcelRequire("fceQU");

var $4cTDP = parcelRequire("4cTDP");

var $g51Bg = parcelRequire("g51Bg");

var $2OtIa = parcelRequire("2OtIa");

var $5Ywg0 = parcelRequire("5Ywg0");

var $g8Pqh = parcelRequire("g8Pqh");

var $iG2Hi = parcelRequire("iG2Hi");


var $aNkQT = parcelRequire("aNkQT");

var $OZurT = parcelRequire("OZurT");

var $6b4EO = parcelRequire("6b4EO");

var $5IbG4 = parcelRequire("5IbG4");
const $3a17c57ac1b263a3$var$CommandPaletteChildren = ({ results: results, noResultsFallback: noResultsFallback, renderAfterCommands: renderAfterCommands, resultsRefs: resultsRefs })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ isSearchFieldFocused: isSearchFieldFocused, loadingList: loadingList, registry: registry, activeRegistry: activeRegistry }, { setActiveIndex: setActiveIndex, removeCommandsById: removeCommandsById, executeCommand: executeCommand }] = (0, $g51Bg.useCommandPalette)();
    const onHoverCommand = (0, $eJOHy.useCallback)((index)=>{
        if (index === undefined) return;
        setActiveIndex(index);
    }, [
        setActiveIndex
    ]);
    const onMouseDownCommand = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const onClickCommand = (0, $eJOHy.useCallback)((event, result)=>{
        executeCommand(result.command, {
            method: 'mouse',
            createAnalyticsEvent: createAnalyticsEvent,
            attributes: {
                ...(0, $2OtIa.getAnalyticsAttributesFromResult)(result),
                ...(0, $2OtIa.getRegistryData)(registry, activeRegistry, result?.command.id)
            }
        }, (0, $2OtIa.isSecondaryTrigger)(event));
    }, [
        activeRegistry,
        createAnalyticsEvent,
        executeCommand,
        registry
    ]);
    const onClickKeyboardCommand = (0, $eJOHy.useCallback)((event, result)=>{
        executeCommand(result.command, {
            method: 'keyboard',
            createAnalyticsEvent: createAnalyticsEvent,
            attributes: {
                ...(0, $2OtIa.getAnalyticsAttributesFromResult)(result),
                ...(0, $2OtIa.getRegistryData)(registry, activeRegistry, result.command.id)
            }
        }, (0, $58ssj.isMacOs)() ? event.metaKey : event.ctrlKey);
    }, [
        activeRegistry,
        createAnalyticsEvent,
        executeCommand,
        registry
    ]);
    if ((0, $4cTDP.fg)('dee-8683-compal-a11y-button-keyboard-accessibility')) // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $eJOHy.useEffect)(()=>{
        const handleEnterKey = (event)=>{
            if (event.key === 'Enter') {
                const focusedElement = typeof document !== 'undefined' ? document.activeElement : null;
                let targetElement = focusedElement;
                while(targetElement && targetElement !== (0, $fceQU.getDocument)()?.body){
                    if (targetElement.getAttribute('data-testid') === (0, $6b4EO.COMMAND_CONTAINER_ROW_TEST_ID)) {
                        event.preventDefault();
                        const focusedId = targetElement.id?.replace(`${(0, $19c39496d342d719$export$b28d6b416aaf953a)}-`, '');
                        if (focusedId) {
                            const selectedCommand = results.find((result)=>!result.isGroup && 'command' in result && result.command.id === focusedId);
                            if (selectedCommand) onClickKeyboardCommand(event, selectedCommand);
                        }
                        break;
                    }
                    targetElement = targetElement.parentElement;
                }
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('keydown', handleEnterKey);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('keydown', handleEnterKey);
        };
    }, [
        onClickKeyboardCommand,
        results
    ]);
    const localResultRefs = resultsRefs.current;
    const commandItem = (0, $eJOHy.useCallback)((result, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aNkQT.CommandRowErrorBoundary), {
            key: index,
            teamName: typeof registry?.teamName === 'string' ? registry.teamName : 'deliveroo',
            onError: ()=>removeCommandsById([
                    result.command.id
                ]),
            attributes: (0, $2OtIa.getRegistryData)(registry, activeRegistry, result?.command.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g8Pqh.CommandPaletteSearchResultListItem), {
            ref: (commandRef)=>{
                if (commandRef) localResultRefs[index] = commandRef;
            },
            id: result.command.id,
            active: result.active,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $OZurT.CommandRow), {
            index: index,
            isSearchFieldFocused: isSearchFieldFocused,
            result: result,
            onHoverCommand: (ev)=>{
                // Safari is weird and likes to fire mouseover events when the mouse is not moving
                if (ev.movementX === 0 && ev.movementY === 0) return;
                onHoverCommand(result.index);
            },
            onClickCommand: (event)=>onClickCommand(event, result),
            onMouseDownCommand: onMouseDownCommand
        }))), [
        activeRegistry,
        isSearchFieldFocused,
        localResultRefs,
        onClickCommand,
        onHoverCommand,
        onMouseDownCommand,
        registry,
        removeCommandsById
    ]);
    const renderGroupedResults = (0, $eJOHy.useCallback)(()=>{
        const resultList = [];
        let groupList = [];
        const wrappedGroup = (group, groupIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                role: "group",
                "aria-labelledby": `group-heading-${groupIndex}`,
                key: `group-${groupIndex}`
            }, group);
        results.forEach((result, i)=>{
            if (result.isGroup) {
                if (groupList.length !== 0) {
                    resultList.push(wrappedGroup(groupList, resultList.length));
                    groupList = [];
                }
                groupList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Ywg0.CommandPaletteSearchResultGroupItem), {
                    ref: (commandRef)=>{
                        if (commandRef) localResultRefs[i] = commandRef;
                    },
                    group: result.group,
                    key: i
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a17c57ac1b263a3$var$GroupContainerComponent, {
                    as: "h2",
                    role: "presentation",
                    "data-testid": (0, $6b4EO.GROUP_TEST_ID),
                    isFirstResult: i === 0,
                    id: `group-heading-${resultList.length}`
                }, result.renderGroup ? result.renderGroup() : result.group)));
            } else groupList.push(commandItem(result, i));
        });
        if (groupList.length !== 0) resultList.push(wrappedGroup(groupList, resultList.length));
        return resultList;
    }, [
        commandItem,
        localResultRefs,
        results
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !loadingList && noResultsFallback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a17c57ac1b263a3$export$2ab569a6937cb4e4, {
        "data-testid": (0, $6b4EO.NO_RESULTS_TEST_ID)
    }, noResultsFallback), (0, $4cTDP.fg)('dee-8682-cmd-palette-search-items-listbox-fix') && renderGroupedResults(), !(0, $4cTDP.fg)('dee-8682-cmd-palette-search-items-listbox-fix') && results.map((result, index)=>{
        if (result.isGroup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Ywg0.CommandPaletteSearchResultGroupItem), {
            ref: (commandRef)=>{
                if (commandRef) localResultRefs[index] = commandRef;
            },
            group: result.group,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a17c57ac1b263a3$var$GroupContainerComponent, {
            as: "h2",
            role: "presentation",
            "data-testid": (0, $6b4EO.GROUP_TEST_ID),
            isFirstResult: index === 0
        }, result.renderGroup ? result.renderGroup() : result.group));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aNkQT.CommandRowErrorBoundary), {
            key: index,
            teamName: typeof registry?.teamName === 'string' ? registry.teamName : 'deliveroo',
            onError: ()=>removeCommandsById([
                    result.command.id
                ]),
            attributes: (0, $2OtIa.getRegistryData)(registry, activeRegistry, result?.command.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g8Pqh.CommandPaletteSearchResultListItem), {
            ref: (commandRef)=>{
                if (commandRef) localResultRefs[index] = commandRef;
            },
            id: result.command.id,
            active: result.active,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $OZurT.CommandRow), {
            index: index,
            isSearchFieldFocused: isSearchFieldFocused,
            result: result,
            onHoverCommand: (ev)=>{
                // Safari is weird and likes to fire mouseover events when the mouse is not moving
                if (ev.movementX === 0 && ev.movementY === 0) return;
                onHoverCommand(result.index);
            },
            onClickCommand: (event)=>onClickCommand(event, result),
            onMouseDownCommand: onMouseDownCommand
        })));
    }), renderAfterCommands?.({}));
};
const $3a17c57ac1b263a3$export$b1023de69a8756e6 = ({ results: results, total: total, fallback: fallback, renderAfterCommands: renderAfterCommands })=>{
    const [{ activeIndex: activeIndex, isSearchFieldFocused: isSearchFieldFocused, expandedCommand: expandedCommand, search: search }, { setActiveIndex: setActiveIndex }] = (0, $g51Bg.useCommandPalette)();
    const [prevActiveIndex, setPrevActiveIndex] = (0, $eJOHy.useState)(activeIndex);
    const resultsRefs = (0, $eJOHy.useRef)([]);
    const modalBodyRef = (0, $eJOHy.useRef)(null);
    const onArrowScroll = (0, $eJOHy.useCallback)((newActiveIndex)=>{
        setActiveIndex(newActiveIndex);
    }, [
        setActiveIndex
    ]);
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-reset-all-state-on-prop-change
    (0, $eJOHy.useEffect)(()=>{
        if (!modalBodyRef.current || prevActiveIndex === activeIndex) return;
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state
        setPrevActiveIndex(activeIndex);
        const scrollTo = activeIndex > prevActiveIndex ? (0, $6b4EO.SCROLL_DIRECTION).END : (0, $6b4EO.SCROLL_DIRECTION).START;
        const scrollToIndex = (0, $5IbG4.getScrollToIndex)(results, activeIndex, scrollTo);
        const scrolledToResult = resultsRefs.current[scrollToIndex];
        if (scrolledToResult && !(0, $5IbG4.isElementVisibleInContainer)(scrolledToResult, modalBodyRef.current)) {
            const lastIndex = results.length - 1;
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            const firstIndex = results.findIndex((result)=>!result.isGroup);
            if (lastIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, modalBodyRef.current.scrollHeight);
            else if (firstIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, 0);
            else (0, $5IbG4.scrollResultIntoView)({
                target: scrolledToResult,
                direction: scrollTo,
                scrollContainer: modalBodyRef.current
            });
        }
    }, [
        activeIndex,
        prevActiveIndex,
        results
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!modalBodyRef.current?.scrollTo) return;
        modalBodyRef.current.scrollTo(0, 0);
    }, [
        expandedCommand,
        search
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!isSearchFieldFocused) return ()=>{};
        const handleArrowScroll = (ev)=>{
            if (ev.key === 'ArrowUp') {
                ev.preventDefault();
                activeIndex > 0 && onArrowScroll(activeIndex - 1);
            }
            if (ev.key === 'ArrowDown') {
                ev.preventDefault();
                activeIndex < total - 1 && onArrowScroll(activeIndex + 1);
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('keydown', handleArrowScroll);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('keydown', handleArrowScroll);
        };
    }, [
        isSearchFieldFocused,
        total,
        activeIndex,
        setActiveIndex,
        onArrowScroll
    ]);
    const noResultsFallback = (0, $eJOHy.useMemo)(()=>fallback?.onNoResults?.renderLabel?.() || fallback?.onNoResults?.label, [
        fallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iG2Hi.CommandPaletteSearchResultListWrapper), {
        ref: modalBodyRef,
        noResultsFallback: noResultsFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a17c57ac1b263a3$var$CommandPaletteChildren, {
        results: results,
        noResultsFallback: noResultsFallback,
        renderAfterCommands: renderAfterCommands,
        resultsRefs: resultsRefs
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a17c57ac1b263a3$var$GroupContainerComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_h2xaw7": (0, $awdRS.default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _1yt41f6d _syaz131l",
            __cmplp.className
        ])
    });
});
const $3a17c57ac1b263a3$export$2ab569a6937cb4e4 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_y3gn1h6o _syaz131l _ca0qxy5q _u5f3pxbi _n3tdxy5q _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5Ywg0", function(module, exports) {
$parcel$export(module.exports, "CommandPaletteSearchResultGroupItem", () => $2dc004120872e887$export$591c26128e5fd757);

var $eJOHy = parcelRequire("eJOHy");

const $2dc004120872e887$export$591c26128e5fd757 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ group: group, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: ref,
        "data-testid": (0, $19c39496d342d719$export$617744f059bfc3ba),
        id: group ? `${0, $19c39496d342d719$export$9ed1834ff36a8f29}-${group}` : undefined,
        ...rest
    }));

});
const $19c39496d342d719$export$9ffb4923f81813d9 = 'compal-menu';
const $19c39496d342d719$export$b28d6b416aaf953a = `${$19c39496d342d719$export$9ffb4923f81813d9}-item`;
const $19c39496d342d719$export$9ed1834ff36a8f29 = `${$19c39496d342d719$export$9ffb4923f81813d9}-group`;
const $19c39496d342d719$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $19c39496d342d719$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $19c39496d342d719$export$d3cd230e107fbce = 'command-palette.ui.modal.header.search-input';
const $19c39496d342d719$export$9e40a0642460a944 = 'compal-menu-screen-reader';


parcelRegister("g8Pqh", function(module, exports) {
$parcel$export(module.exports, "CommandPaletteSearchResultListItem", () => $1fa300fadfc2263f$export$1f8fa9d1eef77b32);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");


var $bZFaG = parcelRequire("bZFaG");
const $1fa300fadfc2263f$var$styles = {
    root: "_bozg1b66 _y4ti1b66"
};
const $1fa300fadfc2263f$export$1f8fa9d1eef77b32 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ id: id, active: active, selected: selected, ...rest }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: ref,
        "data-testid": (0, $19c39496d342d719$export$617744f059bfc3ba),
        "aria-current": active,
        role: (0, $4cTDP.fg)('dee-8682-cmd-palette-search-items-listbox-fix') ? 'option' : 'menuitem',
        "aria-selected": selected,
        id: `${(0, $19c39496d342d719$export$b28d6b416aaf953a)}-${id}`,
        "aria-label": formatMessage((0, $bZFaG.messages).resultListItemAriaLabel),
        ...(0, $4cTDP.fg)('dee-8683-compal-a11y-button-keyboard-accessibility') && {
            css: $1fa300fadfc2263f$var$styles.root
        },
        ...rest
    });
});

});
parcelRegister("bZFaG", function(module, exports) {
$parcel$export(module.exports, "messages", () => $1a66dcc5b190c609$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1a66dcc5b190c609$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    resultListItemAriaLabel: {
        "id": "command-palette.common.command-palette-search-result-list-item",
        "defaultMessage": "Command palette action item"
    }
});

});


parcelRegister("iG2Hi", function(module, exports) {
$parcel$export(module.exports, "CommandPaletteSearchResultListWrapper", () => $6725cef9016fe1d5$export$95554f6fb39a83c2);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");


var $1XCAD = parcelRequire("1XCAD");

var $2pUb3 = parcelRequire("2pUb3");
const $6725cef9016fe1d5$export$95554f6fb39a83c2 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ noResultsFallback: noResultsFallback, children: children, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const resizerRef = (0, $eJOHy.useRef)(null);
    const height = (0, $2pUb3.useSmoothExpand)(resizerRef);
    (0, $eJOHy.useEffect)(()=>{
        if (ref && 'current' in ref && ref.current) {
            const currentRef = ref.current;
            currentRef.style.height = `${height}px`;
        }
    }, [
        height,
        ref
    ]);
    const resultsRole = (0, $4cTDP.fg)('dee-8682-cmd-palette-search-items-listbox-fix') ? 'listbox' : 'menu';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6725cef9016fe1d5$var$wrapperStyles,
        testId: (0, $19c39496d342d719$export$85eefac753ab5bdb),
        id: (0, $19c39496d342d719$export$9ffb4923f81813d9),
        role: noResultsFallback ? 'group' : resultsRole,
        ref: ref,
        "aria-label": formatMessage((0, $1XCAD.messages).commandPaletteSearchResultListBoxLabel),
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        ref: resizerRef,
        direction: "column",
        gap: "space.050"
    }, children));
});
const $6725cef9016fe1d5$var$wrapperStyles = (0, $1DXK0.xcss)({
    padding: '0',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    transition: 'height 0.15s ease-out',
    overflowY: 'auto',
    maxHeight: '376px'
});

});
parcelRegister("1XCAD", function(module, exports) {
$parcel$export(module.exports, "messages", () => $5f9181ddee7f41b1$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $5f9181ddee7f41b1$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    commandPaletteSearchResultListBoxLabel: {
        "id": "command-palette.common.command-palette-search-dropdown.command-palette-search-result-list-wrapper.command-palette-search-result-list-box-label",
        "defaultMessage": "List of commands"
    }
});

});

parcelRegister("2pUb3", function(module, exports) {
$parcel$export(module.exports, "useSmoothExpand", () => $535f9e4bd6cd6e9a$export$674ba8b02d2bfe86);

var $eJOHy = parcelRequire("eJOHy");
const $535f9e4bd6cd6e9a$var$MAX_HEIGHT = 376;
const $535f9e4bd6cd6e9a$var$STARTING_HEIGHT = 56;
const $535f9e4bd6cd6e9a$var$ADDITIONAL_HEIGHT = 16;
const $535f9e4bd6cd6e9a$export$674ba8b02d2bfe86 = (content)=>{
    const [height, setHeight] = (0, $eJOHy.useState)($535f9e4bd6cd6e9a$var$STARTING_HEIGHT);
    const callback = (0, $eJOHy.useCallback)(()=>{
        const contentClientHeight = content.current?.clientHeight;
        if (!contentClientHeight) return;
        if (contentClientHeight > $535f9e4bd6cd6e9a$var$MAX_HEIGHT) setHeight($535f9e4bd6cd6e9a$var$MAX_HEIGHT);
        else setHeight(contentClientHeight + $535f9e4bd6cd6e9a$var$ADDITIONAL_HEIGHT);
    }, [
        content
    ]);
    (0, $eJOHy.useEffect)(()=>{
        let resizeObserver;
        if (content.current && typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(callback);
            resizeObserver.observe(content.current);
        }
        return ()=>{
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        callback,
        content
    ]);
    return height;
};

});


parcelRegister("aNkQT", function(module, exports) {
$parcel$export(module.exports, "CommandRowErrorBoundary", () => $396c9e18c0709720$export$223f3c3c93a14a83);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");
const $396c9e18c0709720$export$223f3c3c93a14a83 = ({ children: children, teamName: teamName, onError: onError, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "command-palette-row",
        packageName: "jiraCommandPalette",
        fallback: "unmount",
        teamName: teamName,
        onError: onError,
        attributes: attributes
    }, children);

});

parcelRegister("OZurT", function(module, exports) {
$parcel$export(module.exports, "CommandRow", () => $7150d313297e5fc3$export$3ef5d254c3c573e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $2OtIa = parcelRequire("2OtIa");

var $2Nn1q = parcelRequire("2Nn1q");
const $7150d313297e5fc3$var$styles = {
    rowWrapper: "_bozg1b66 _y4ti1b66"
};
const $7150d313297e5fc3$export$3ef5d254c3c573e3 = ({ index: index, result: result, isSearchFieldFocused: isSearchFieldFocused, onHoverCommand: onHoverCommand, onClickCommand: onClickCommand, onMouseDownCommand: onMouseDownCommand })=>{
    const { command: command } = result;
    const isActive = !!(result.active && isSearchFieldFocused);
    const isFirstCommand = result.index === 0;
    const rowProps = {
        index: index,
        isActive: isActive,
        command: command,
        isFirstCommand: isFirstCommand,
        ...(0, $4cTDP.fg)('dee-8683-compal-a11y-button-keyboard-accessibility') && {
            isLinkFocused: !!command.components?.CommandRow
        },
        onMouseMove: onHoverCommand,
        onClick: onClickCommand,
        onMouseDown: onMouseDownCommand,
        analyticsAttributes: (0, $2OtIa.getAnalyticsAttributesFromResult)(result)
    };
    if ((0, $4cTDP.fg)('dee-8683-compal-a11y-button-keyboard-accessibility')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $7150d313297e5fc3$var$styles.rowWrapper
        ])
    }, command.components?.CommandRow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.CommandRow, rowProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Nn1q.CommandRow), rowProps));
    if (command.components?.CommandRow) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.CommandRow, rowProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Nn1q.CommandRow), rowProps);
};

});
parcelRegister("2Nn1q", function(module, exports) {
$parcel$export(module.exports, "CommandRow", () => $23485c420ee6846d$export$3ef5d254c3c573e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $46R8N = parcelRequire("46R8N");

var $6XJko = parcelRequire("6XJko");

var $4cTDP = parcelRequire("4cTDP");

var $1k1Uh = parcelRequire("1k1Uh");


var $cSwEo = parcelRequire("cSwEo");

var $gXsfJ = parcelRequire("gXsfJ");
const $23485c420ee6846d$var$activeStyles = null;
const $23485c420ee6846d$var$leftIconAndNameContainerStyles = null;
const $23485c420ee6846d$var$outlinedLozengeStyles = null;
const $23485c420ee6846d$var$styles = {
    root: "_1bsb1osq",
    commandContainer: "_11c82smr _syaz1gjq _1q511b66 _85i51b66 _bozg1b66 _y4ti1b66 _ahbqr5cr _12l2r5cr",
    innerContainer: "_1q511b66 _85i51b66 _bozgpxbi _y4tipxbi _1e0c1txw _4cvr1h6o _80omtlke _lcxv1wug",
    iconsContainer: "_zulp1b66 _2hwx1b66 _1e0c1txw _4cvr1h6o",
    buttonWrapper: "_bozg1b66 _y4ti1b66",
    button: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _bfhk18uv _y3gn1e5h"
};
const $23485c420ee6846d$export$3ef5d254c3c573e3 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ index: index, command: command, isActive: isActive, isFirstCommand: isFirstCommand, ...rest }, ref)=>{
    const InnerContainer = $23485c420ee6846d$var$CommandContainerInner;
    if (!(0, $4cTDP.fg)('dee-8683-compal-a11y-button-keyboard-accessibility')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandContainerWrapper, {
        "data-testid": command.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandContainer, {
        index: index,
        active: isActive,
        "data-active": isActive,
        "data-testid": (0, $f844ecf9ba7020db$export$b0017db5728101cc)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(InnerContainer, {
        "data-testid": (0, $f844ecf9ba7020db$export$47c379a40b00a339),
        ref: ref,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandLeftIconAndNameContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandIconsContainer, {
        "data-testid": (0, $f844ecf9ba7020db$export$d6dd1cf63aae711c)
    }, command.components?.LeftIcon && ((0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        testId: (0, $f844ecf9ba7020db$export$7b41978523c7dd4a),
        alignItems: "center",
        justifyContent: "center",
        xcss: [
            $23485c420ee6846d$var$iconStyles,
            isActive && $23485c420ee6846d$var$iconActiveStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.LeftIcon, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandLeftIconContainer, {
        "data-testid": (0, $f844ecf9ba7020db$export$7b41978523c7dd4a),
        active: isActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.LeftIcon, null))), command.mode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1k1Uh.OutlinedLozenge), {
        "data-testid": (0, $f844ecf9ba7020db$export$72c5368f559dd523)
    }, command.mode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cSwEo.RenderCommandName), {
        command: command,
        isActive: isActive
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gXsfJ.RightContent), {
        command: command,
        isFirstCommand: isFirstCommand,
        isActive: isActive
    }))));
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": command.id,
        className: (0, $hcewu.default)([
            $23485c420ee6846d$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-active": isActive,
        "data-testid": (0, $f844ecf9ba7020db$export$b0017db5728101cc),
        className: (0, $hcewu.default)([
            $23485c420ee6846d$var$styles.commandContainer,
            isActive && "_syaz1fxt _bfhkfg4m _kqswh2mm _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _19woidpf _1mp4v77o _1rus1p6i"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": (0, $f844ecf9ba7020db$export$47c379a40b00a339),
        ref: ref,
        ...rest,
        className: (0, $hcewu.default)([
            $23485c420ee6846d$var$styles.innerContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": (0, $f844ecf9ba7020db$export$d6dd1cf63aae711c),
        className: (0, $hcewu.default)([
            $23485c420ee6846d$var$styles.iconsContainer
        ])
    }, command.components?.LeftIcon && ((0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        testId: (0, $f844ecf9ba7020db$export$7b41978523c7dd4a),
        alignItems: "center",
        justifyContent: "center",
        xcss: [
            $23485c420ee6846d$var$iconStyles,
            isActive && $23485c420ee6846d$var$iconActiveStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.LeftIcon, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandLeftIconContainer, {
        "data-testid": (0, $f844ecf9ba7020db$export$7b41978523c7dd4a),
        active: isActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.LeftIcon, null))), command.mode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": (0, $f844ecf9ba7020db$export$72c5368f559dd523),
        className: (0, $hcewu.default)([
            "_2rko12b0 _11c81u0j _19it3ju0 _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _4t3igktf _1bsbgktf _k48p1pd9 _bfhk1j9a _syaz131l _vchhusvi"
        ])
    }, command.mode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cSwEo.RenderCommandName), {
        command: command,
        isActive: isActive
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gXsfJ.RightContent), {
        command: command,
        isFirstCommand: isFirstCommand,
        isActive: isActive
    }))));
    if (command.components?.CommandRow) return content;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $46R8N.default), {
        xcss: $23485c420ee6846d$var$styles.button,
        "aria-label": command.name
    }, content);
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $23485c420ee6846d$var$CommandContainerWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $23485c420ee6846d$var$CommandContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _syaz1gjq _ca0q1b66 _u5f3idpf _n3td1b66 _19bvidpf",
            !!__cmplp.active && "_syaz1fxt _bfhkfg4m _kqswh2mm _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _19woidpf _1mp4v77o _1rus1p6i",
            __cmplp.className
        ])
    });
});
const $23485c420ee6846d$var$CommandContainerInner = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q1b66 _u5f3v47k _n3td1b66 _19bvv47k _1e0c1txw _4cvr1h6o _80omtlke _lcxv1wug",
            __cmplp.className
        ])
    });
});
const $23485c420ee6846d$var$CommandIconsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp1b66 _2hwx1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $23485c420ee6846d$var$iconStyles = (0, $1DXK0.xcss)({
    width: '24px',
    height: '24px',
    // @ts-expect-error ts(2322) - this color should be set directly within icon after migration, but requires bigger change in types.
    color: 'color.icon.subtle'
});
const $23485c420ee6846d$var$iconActiveStyles = (0, $1DXK0.xcss)({
    // @ts-expect-error ts(2322) - this color should be set directly within icon after migration.
    color: 'color.icon'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $23485c420ee6846d$var$CommandLeftIconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1tcg _4t3i1tcg _vwz41tcg _1bah1h6o _1wpz1y6m _1f027vkz _nbgx7vkz",
            __cmplp.active ? "_syazwdcn" : "_syaz1oju",
            __cmplp.className
        ])
    });
});
const $23485c420ee6846d$var$CommandLeftIconAndNameContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _vwz41tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1k1Uh", function(module, exports) {
$parcel$export(module.exports, "OutlinedLozenge", () => $34fe5e771f897e84$export$224f9ad7f31e0de6);
$parcel$export(module.exports, "FilledLozenge", () => $34fe5e771f897e84$export$586a428fe10f5ae0);
$parcel$export(module.exports, "SearchLozenge", () => $34fe5e771f897e84$export$2ccc7861eeb7b337);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $34fe5e771f897e84$var$Lozenge = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _11c8dcr7 _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _4t3igktf _1bsbgktf _vwz41crf _syaz1gjq",
            __cmplp.className
        ])
    });
});
const $34fe5e771f897e84$export$224f9ad7f31e0de6 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $34fe5e771f897e84$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81u0j _19it3ju0 _k48p1pd9 _1p1dangw _bfhk1j9a _syaz131l _vchhusvi",
            __cmplp.className
        ])
    });
});
const $34fe5e771f897e84$export$586a428fe10f5ae0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $34fe5e771f897e84$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81u0j _kqswh2mm _1p1dangw _1pbykb7n _1s6krwve _rfx3fajl _1cs8stnw _1kt9b3bt _154psxj9 _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
            __cmplp.className
        ])
    });
});
const $34fe5e771f897e84$export$2ccc7861eeb7b337 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $34fe5e771f897e84$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1bsb1ris _bfhkm7j4",
            __cmplp.className
        ])
    });
});

});

const $f844ecf9ba7020db$export$b0017db5728101cc = 'command-palette.ui.modal.body.command-container';
const $f844ecf9ba7020db$export$47c379a40b00a339 = 'command-palette.common.ui.command-palette-row-view.inner-container';
const $f844ecf9ba7020db$export$7b41978523c7dd4a = 'command-palette.ui.modal.body.command-left-icon-container';
const $f844ecf9ba7020db$export$72c5368f559dd523 = 'command-palette.ui.modal.body.command-mode';
const $f844ecf9ba7020db$export$d6dd1cf63aae711c = 'command-palette.ui.modal.body.command-icon-container';

parcelRegister("cSwEo", function(module, exports) {
$parcel$export(module.exports, "RenderCommandName", () => $d68023b12b2300be$export$931d3f1d35f6c058);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $cQxBL = parcelRequire("cQxBL");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $6XJko = parcelRequire("6XJko");

var $eZyz9 = parcelRequire("eZyz9");

const $d68023b12b2300be$export$931d3f1d35f6c058 = ({ command: command, isActive: isActive })=>{
    const renderCommandName = (0, $eJOHy.useCallback)(()=>{
        if (command.components?.Name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.Name, {
            isActive: isActive
        }, command.name);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eZyz9.TruncateWithTooltipOnActive), {
            isActive: isActive
        }, command.name);
    }, [
        command,
        isActive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d68023b12b2300be$var$CommandNameContainer, {
        "data-testid": (0, $726ded7d34812919$export$1858c2a91b8b53ba),
        active: isActive
    }, command.breadcrumb?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d68023b12b2300be$var$CommandBreadcrumbContainer, {
        "data-testid": (0, $726ded7d34812919$export$5e3a644e2bbe06f3)
    }, command.breadcrumb.map((BreadCrumb, index, arr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d68023b12b2300be$var$CommandBreadcrumbItem, {
            isParent: index !== arr.length - 1,
            "data-testid": (0, $726ded7d34812919$export$fb5462105b23e3e5),
            active: isActive
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BreadCrumb, {
            isActive: isActive
        })), index !== arr.length - 1 && ((0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
            justifyContent: "center",
            xcss: $d68023b12b2300be$var$iconWrapperStyles,
            alignItems: "center",
            testId: (0, $726ded7d34812919$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
            color: "currentColor",
            label: "separator",
            size: "small"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d68023b12b2300be$var$CommandChevronContainer, {
            "data-testid": (0, $726ded7d34812919$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
            color: "currentColor",
            label: "separator",
            size: "small"
        })))))) : renderCommandName());
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d68023b12b2300be$var$CommandNameContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
            __cmplp.active ? "_syaz1fxt" : "_syaz1gjq",
            __cmplp.className
        ])
    });
});
const $d68023b12b2300be$var$CommandBreadcrumbContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $d68023b12b2300be$var$CommandBreadcrumbItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isParent: isParent, active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_dm2rwo": (0, $awdRS.default)(__cmplp.active ? "var(--ds-text-subtle, #44546F)" : "var(--ds-text-subtlest, #626F86)")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !!__cmplp.isParent && "_syazalb7",
            __cmplp.className
        ])
    });
});
const $d68023b12b2300be$var$CommandChevronContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_vwz4kb7n _syaz1oju",
            __cmplp.className
        ])
    });
});
const $d68023b12b2300be$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    height: '24px',
    width: '24px'
});

});
parcelRegister("eZyz9", function(module, exports) {
$parcel$export(module.exports, "TruncateWithTooltipOnActive", () => $0485cf2ed2b26536$export$4495aca3d261add0);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $IW7jS = parcelRequire("IW7jS");

var $8nMzv = parcelRequire("8nMzv");

var $i92Id = parcelRequire("i92Id");


var $fu9LY = parcelRequire("fu9LY");
const $0485cf2ed2b26536$var$TooltipRenderer = ({ children: children, shouldShowTooltip: shouldShowTooltip })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        isOpen: !!shouldShowTooltip,
        autoFocus: false,
        placement: "bottom-end",
        messageId: "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.popup",
        messageType: "transactional",
        popupComponent: (0, $i92Id.PopupComponent),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i92Id.TooltipContent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.tooltip-content"
            }, children),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i92Id.TriggerComponent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.trigger-component",
                ...triggerProps
            }),
        zIndex: (0, $IW7jS.layers).tooltip()
    });
const $0485cf2ed2b26536$export$70f47de153e915ed = ()=>(0, $eJOHy.useRef)(null);
const $0485cf2ed2b26536$export$4495aca3d261add0 = ({ children: children, isActive: isActive, customTooltip: customTooltip, showTooltip: showTooltip, preventTruncate: preventTruncate })=>{
    const containerRef = $0485cf2ed2b26536$export$70f47de153e915ed();
    const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $fu9LY.useTruncatedTooltip)({
        containerRef: containerRef,
        tooltipDelay: (0, $4c1f11f798b8ffde$export$f9e3e7ede9ba929d)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ref: containerRef,
        xcss: [
            $0485cf2ed2b26536$var$tooltipContainerStyles,
            !preventTruncate && $0485cf2ed2b26536$var$truncateTooltipStyles
        ]
    }, children), isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0485cf2ed2b26536$var$TooltipRenderer, {
        shouldShowTooltip: showTooltip || shouldShowTruncatedTooltip
    }, showTooltip && customTooltip ? customTooltip : children));
};
const $0485cf2ed2b26536$var$tooltipContainerStyles = (0, $1DXK0.xcss)({
    position: 'relative',
    flexGrow: 1,
    textTransform: 'none'
});
const $0485cf2ed2b26536$var$truncateTooltipStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("i92Id", function(module, exports) {
$parcel$export(module.exports, "TooltipComponent", () => $849f6edf3f22b0d2$export$e18e2f8e82cdc428);
$parcel$export(module.exports, "TriggerComponent", () => $849f6edf3f22b0d2$export$534fc570264a52a4);
$parcel$export(module.exports, "TooltipTrigger", () => $849f6edf3f22b0d2$export$8c610744efcf8a1d);
$parcel$export(module.exports, "PopupComponent", () => $849f6edf3f22b0d2$export$9fac2d040f3ed438);
$parcel$export(module.exports, "TruncateWithTooltipContainer", () => $849f6edf3f22b0d2$export$8cae238d61c8405a);
$parcel$export(module.exports, "TooltipContent", () => $849f6edf3f22b0d2$export$e9003e2be37ec060);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $7AseU = parcelRequire("7AseU");

var $lRq8t = parcelRequire("lRq8t");

var $ccaPK = parcelRequire("ccaPK");
const $849f6edf3f22b0d2$export$e18e2f8e82cdc428 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($849f6edf3f22b0d2$var$StyledTooltipPrimitive, {
        ...props,
        ref: ref
    }));
const $849f6edf3f22b0d2$export$534fc570264a52a4 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($849f6edf3f22b0d2$export$8c610744efcf8a1d, {
        ...props,
        role: "button",
        ref: ref,
        "aria-label": formatMessage((0, $ccaPK.messages).tooltipTriggerAriaLabel)
    });
});
const $849f6edf3f22b0d2$export$9fac2d040f3ed438 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($849f6edf3f22b0d2$var$StyledPopupPrimitive, {
        ...props,
        ref: ref
    }, children)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $849f6edf3f22b0d2$var$StyledTooltipPrimitive = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $7AseU.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1pbydx66 _1bsbp3fh _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7 _bfhk1j9a _16qs1cd0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $849f6edf3f22b0d2$var$StyledPopupPrimitive = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1pbydx66 _1bsbp3fh _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7 _bfhk1j9a _16qs1cd0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $849f6edf3f22b0d2$export$8cae238d61c8405a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _kqswh2mm _o5721q9c _1bto1l2s _1p1dglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $849f6edf3f22b0d2$export$e9003e2be37ec060 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _syaz1fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $849f6edf3f22b0d2$export$8c610744efcf8a1d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ccaPK", function(module, exports) {
$parcel$export(module.exports, "messages", () => $c726bd5d325f45ec$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $c726bd5d325f45ec$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    tooltipTriggerAriaLabel: {
        "id": "command-palette.common.truncate-with-tooltip.components.tooltip-trigger-aria-label",
        "defaultMessage": "Command palette tool tip"
    }
});

});


const $4c1f11f798b8ffde$export$f9e3e7ede9ba929d = 400;

parcelRegister("fu9LY", function(module, exports) {
$parcel$export(module.exports, "useTruncatedTooltip", () => $696d52b07491914e$export$94b118b3187f12c);

var $eJOHy = parcelRequire("eJOHy");

var $2OtIa = parcelRequire("2OtIa");
const $696d52b07491914e$export$22c0312879c61300 = ()=>(0, $eJOHy.useState)(false);
const $696d52b07491914e$export$1ac6e474a0163418 = ()=>(0, $eJOHy.useState)(false);
const $696d52b07491914e$export$94b118b3187f12c = ({ containerRef: containerRef, tooltipDelay: tooltipDelay })=>{
    const [shouldShowTruncatedTooltip, setShouldShowTruncatedTooltip] = $696d52b07491914e$export$22c0312879c61300();
    const [isTruncated, setIsTruncated] = $696d52b07491914e$export$1ac6e474a0163418();
    const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, $2OtIa.useSetTimeoutAutoClear)();
    const setTimeoutFunc = setTimeoutAutoClear;
    (0, $eJOHy.useEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        if (container.offsetWidth < container.scrollWidth) setIsTruncated(true);
        else setIsTruncated(false);
    }, [
        setIsTruncated,
        containerRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isTruncated && tooltipDelay === 0) {
            setShouldShowTruncatedTooltip(true);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        if (isTruncated && tooltipDelay > 0) {
            setTimeoutFunc(()=>setShouldShowTruncatedTooltip(true), tooltipDelay);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        setShouldShowTruncatedTooltip(false);
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
    }, [
        isTruncated,
        setShouldShowTruncatedTooltip,
        tooltipDelay,
        setTimeoutFunc
    ]);
    return {
        shouldShowTruncatedTooltip: shouldShowTruncatedTooltip
    };
};

});


const $726ded7d34812919$export$1858c2a91b8b53ba = 'command-palette.ui.modal.body.command-name-container';
const $726ded7d34812919$export$5e3a644e2bbe06f3 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-container';
const $726ded7d34812919$export$fb5462105b23e3e5 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-item';
const $726ded7d34812919$export$4675b4d60d9881d4 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.separator';


parcelRegister("gXsfJ", function(module, exports) {
$parcel$export(module.exports, "RightContent", () => $36c01c052dc4602a$export$11dbab4b39f15d6b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cQxBL = parcelRequire("cQxBL");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $2OtIa = parcelRequire("2OtIa");


var $xZyb9 = parcelRequire("xZyb9");

var $ivvUQ = parcelRequire("ivvUQ");

var $d6dCH = parcelRequire("d6dCH");

var $i7euV = parcelRequire("i7euV");
const $36c01c052dc4602a$export$11dbab4b39f15d6b = ({ command: command, isActive: isActive, isFirstCommand: isFirstCommand = false })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const transitionStep = (0, $i7euV.useHoverTransitionStep)(command, isActive, isFirstCommand);
    const commandHasChildren = (0, $eJOHy.useMemo)(()=>(0, $2OtIa.hasChildren)(command), [
        command
    ]);
    const shouldRenderRightContent = commandHasChildren || !!command.shortcut;
    if (!shouldRenderRightContent) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($36c01c052dc4602a$var$RightContentWrapper, null, commandHasChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($36c01c052dc4602a$var$CommandRightChevronContainer, {
        "data-testid": (0, $f29cb9aaec65a024$export$e3e144c17be58a44),
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
        spacing: "spacious",
        label: (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $xZyb9.messages).rightChevronLabel),
        size: "small",
        "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
    })), !!command.shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($36c01c052dc4602a$var$ShortcutContainer, {
        "data-testid": (0, $f29cb9aaec65a024$export$f3036e9d26f81cd9),
        shouldHaveTransition: commandHasChildren,
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivvUQ.Shortcuts), {
        shortcut: command.shortcut
    })));
};
const $36c01c052dc4602a$var$animationFadeIn = null;
const $36c01c052dc4602a$var$animationFadeOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $36c01c052dc4602a$var$RightContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _1e0c11p5 _18u01b66 _syaz1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $36c01c052dc4602a$var$CommandRightChevronContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ii7kb7n _yyhykb7n _4cvr1h6o _1e0c1txw _1bsb1tcg _4t3i1tcg _5sag1ttt _1pgl1ytf _1o51q7pw _tzy4idpf _syaz1oju",
            __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING && "_j7hq1wwu",
            __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $36c01c052dc4602a$var$ShortcutContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldHaveTransition: shouldHaveTransition, transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ii7kb7n _yyhykb7n _5sag1ttt _1pgl1ytf _1o51q7pw _1e0c1txw _1bahesu3",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1wwu",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});
const $f29cb9aaec65a024$export$f3036e9d26f81cd9 = 'command-palette.ui.modal.body.command-shortcut-container';
const $f29cb9aaec65a024$export$e3e144c17be58a44 = 'command-palette.ui.modal.body.command-chevron-container';

parcelRegister("xZyb9", function(module, exports) {
$parcel$export(module.exports, "messages", () => $8f4e2b0de24497ce$export$defe85febe8b728c);
// Delete file when cleaning up deliveroo_compal_a11y_fixes

var $7qGN1 = parcelRequire("7qGN1");
const $8f4e2b0de24497ce$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rightChevronLabel: {
        "id": "command-palette.common.components.command-row.right-content.right-chevron-label",
        "defaultMessage": "Command with children icon"
    }
});

});

parcelRegister("ivvUQ", function(module, exports) {
$parcel$export(module.exports, "Shortcuts", () => $2bdae852387b780f$export$b326d77e4b8b7664);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $cMTOh = parcelRequire("cMTOh");

var $2OtIa = parcelRequire("2OtIa");


var $ey2FZ = parcelRequire("ey2FZ");
const $2bdae852387b780f$var$KeyElement = ({ shortcut: shortcut })=>{
    const isLongText = shortcut && shortcut.length > 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $2bdae852387b780f$var$styles.shortcutKeyWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": (0, $09f953b7673081a6$export$cd62afa4691c297),
        className: (0, $hcewu.default)([
            $2bdae852387b780f$var$styles.lozenge,
            isLongText && $2bdae852387b780f$var$styles.longLozenge
        ])
    }, shortcut));
};
const $2bdae852387b780f$var$DivisorElement = ({ divisor: divisor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$ShortcutDivider, {
        "data-testid": (0, $09f953b7673081a6$export$e06ad7c09a29974b)
    }, divisor);
const $2bdae852387b780f$var$SHIFT_CHAR_MAP = {
    '?': 'shift /',
    '!': 'shift 1',
    '@': 'shift 2',
    '#': 'shift 3',
    $: 'shift 4',
    '%': 'shift 5',
    '^': 'shift 6',
    '&': 'shift 7',
    '*': 'shift 8',
    '(': 'shift 9',
    ')': 'shift 0',
    _: 'shift -',
    '+': 'shift =',
    '{': 'shift [',
    '}': 'shift ]',
    ':': 'shift ;',
    '"': "shift '",
    '<': 'shift ,',
    '>': 'shift .',
    '|': 'shift \\',
    '~': 'shift `'
};
const $2bdae852387b780f$var$shiftModifierCheck = (shortcut)=>{
    if (shortcut.length === 1) {
        if (/[A-Z]/.test(shortcut)) return `shift ${shortcut.toLowerCase()}`;
        return $2bdae852387b780f$var$SHIFT_CHAR_MAP[shortcut] || shortcut;
    }
    return shortcut;
};
const $2bdae852387b780f$var$parseShortcut = (shortcut, replacers, acc = [], types = [])=>{
    const replacer = replacers.shift();
    if (!replacer) {
        $2bdae852387b780f$var$shiftModifierCheck(shortcut).split(' ').forEach((key, index, array)=>{
            acc.push({
                type: (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).KEY,
                key: key
            });
            types.push((0, $cMTOh.SHORTCUT_ELEMENT_TYPES).KEY);
            if (index < array.length - 1) {
                const separatorType = (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).PLUS;
                acc.push({
                    type: separatorType
                });
                types.push(separatorType);
            }
        });
        return [
            acc,
            types
        ];
    }
    shortcut.split(replacer.char).forEach((str, index, self)=>{
        $2bdae852387b780f$var$parseShortcut(str, replacers.slice(0), acc, types);
        if (index < self.length - 1) {
            acc.push({
                type: replacer.replacement
            });
            types.push(replacer.replacement);
        }
    });
    return [
        acc,
        types
    ];
};
const $2bdae852387b780f$export$cfaeb054b183bb20 = ()=>(0, $lRq8t.default)();
const $2bdae852387b780f$export$b326d77e4b8b7664 = ({ shortcut: shortcut })=>{
    const { formatMessage: formatMessage } = $2bdae852387b780f$export$cfaeb054b183bb20();
    const [shortcuts, types] = (0, $eJOHy.useMemo)(()=>$2bdae852387b780f$var$parseShortcut(shortcut, (0, $2OtIa.getShortcutSpecialCharacters)()), [
        shortcut
    ]);
    const basicShortcutMessage = (0, $eJOHy.useMemo)(()=>{
        if (types.length === 3) {
            if (types[0] === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).KEY && types[2] === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).KEY) {
                if (types[1] === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).THEN) return (0, $ey2FZ.messages).shortcutThen;
                if (types[1] === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).OR) return (0, $ey2FZ.messages).shortcutOr;
                if (types[1] === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).PLUS) return (0, $ey2FZ.messages).shortcutPlus;
            }
        }
        return null;
    }, [
        types
    ]);
    const formatTypeToMessage = (0, $eJOHy.useCallback)((type)=>{
        switch(type){
            case (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).THEN:
                return formatMessage((0, $ey2FZ.messages).divisorThen);
            case (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).OR:
                return formatMessage((0, $ey2FZ.messages).divisorOr);
            default:
                return formatMessage((0, $ey2FZ.messages).divisorPlus);
        }
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$ShortcutContainer, {
        "data-testid": (0, $09f953b7673081a6$export$ec8260df4f23714c),
        "aria-hidden": true
    }, basicShortcutMessage ? formatMessage(basicShortcutMessage, {
        shortcutA: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$KeyElement, {
            shortcut: shortcuts[0].key
        }),
        shortcutB: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$KeyElement, {
            shortcut: shortcuts[2].key
        }),
        divisor: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$DivisorElement, {
                divisor: chunk
            })
    }) : shortcuts.map((obj, index)=>{
        if (obj.type === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).KEY) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$KeyElement, {
            key: index,
            shortcut: obj.key
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$DivisorElement, {
            key: index,
            divisor: formatTypeToMessage(obj.type)
        });
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2bdae852387b780f$var$ShortcutDivider = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1b66 _otyridpf _18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2bdae852387b780f$var$ShortcutContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _16jlidpf _1o9zkb7n _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $2bdae852387b780f$var$styles = {
    lozenge: "_2rko12b0 _11c81u0j _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _4t3i1tcg _syaz1fxt _1ul91tcg _1bsb1ris _kqswh2mm _1p1d1dk0 _1pbykb7n _1s6krwve _rfx312b0 _1cs8stnw _1kt9b3bt _154psxj9 _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
    longLozenge: "_18zr12x7",
    shortcutKeyWrapper: "_ca0qidpf _u5f31y44 _n3tdidpf _19bv1y44 _1ul91tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o"
};

});
const $09f953b7673081a6$export$cd62afa4691c297 = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-icon';
const $09f953b7673081a6$export$e06ad7c09a29974b = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-divider';
const $09f953b7673081a6$export$ec8260df4f23714c = 'command-palette.ui.modal.modal-content.body.command-row.shortcuts.shortcut-container';

parcelRegister("ey2FZ", function(module, exports) {
$parcel$export(module.exports, "messages", () => $e4fcfaa38e4e2d0e$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $e4fcfaa38e4e2d0e$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    shortcutThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-then",
        "defaultMessage": "{shortcutA} <divisor>then</divisor> {shortcutB}"
    },
    shortcutOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-or",
        "defaultMessage": "{shortcutA} <divisor>or</divisor> {shortcutB}"
    },
    shortcutPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-plus",
        "defaultMessage": "{shortcutA} <divisor>+</divisor> {shortcutB}"
    },
    divisorThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-then",
        "defaultMessage": "then"
    },
    divisorOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-or",
        "defaultMessage": "or"
    },
    divisorPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-plus",
        "defaultMessage": "+"
    }
});

});


parcelRegister("d6dCH", function(module, exports) {
$parcel$export(module.exports, "TRANSITION_STEP", () => $b2e6d0fa9dbab6a6$export$42d8d7c94c5a11e9);
$parcel$export(module.exports, "TRANSITION_INITIAL_DELAY_TIME_MS", () => $b2e6d0fa9dbab6a6$export$82cfc253a6c33f59);
$parcel$export(module.exports, "TRANSITION_HOVER_DELAY_TIME_MS", () => $b2e6d0fa9dbab6a6$export$e092796a9af3633b);
$parcel$export(module.exports, "TRANSITION_DURATION_MS", () => $b2e6d0fa9dbab6a6$export$1cad4f611a1c0229);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $b2e6d0fa9dbab6a6$export$42d8d7c94c5a11e9 = /*#__PURE__*/ function(TRANSITION_STEP) {
    TRANSITION_STEP["INITIAL"] = "initial";
    TRANSITION_STEP["DELAYING"] = "delaying";
    TRANSITION_STEP["TRANSITIONING"] = "transitioning";
    TRANSITION_STEP["FINISHED"] = "finished";
    TRANSITION_STEP["DELAYING_FADE_OUT"] = "delaying-fade-out";
    TRANSITION_STEP["TRANSITIONING_FADE_OUT"] = "transitioning-fade-out";
    return TRANSITION_STEP;
}({});
const $b2e6d0fa9dbab6a6$export$82cfc253a6c33f59 = 600;
const $b2e6d0fa9dbab6a6$export$e092796a9af3633b = 300;
const $b2e6d0fa9dbab6a6$export$1cad4f611a1c0229 = 350;

});

parcelRegister("i7euV", function(module, exports) {
$parcel$export(module.exports, "useHoverTransitionStep", () => $f0a4c8d4492da351$export$eefd045a02bab4c6);

var $eJOHy = parcelRequire("eJOHy");

var $kk5YU = parcelRequire("kk5YU");

var $9pTd3 = parcelRequire("9pTd3");

var $2OtIa = parcelRequire("2OtIa");

var $d6dCH = parcelRequire("d6dCH");
const $f0a4c8d4492da351$export$eefd045a02bab4c6 = (command, isActive, isFirstCommand)=>{
    const [hasTransitionedFirstCommand, setHasTransitionedFirstCommand] = (0, $eJOHy.useState)(false);
    const [transitionStep, setTransitionStep] = (0, $eJOHy.useState)((0, $d6dCH.TRANSITION_STEP).INITIAL);
    const timerRef = (0, $eJOHy.useRef)(null);
    const isReducedMotion = (0, $kk5YU.useIsReducedMotion)();
    const commandHasChildren = (0, $2OtIa.hasChildren)(command);
    (0, $eJOHy.useEffect)(()=>{
        setTransitionStep((0, $d6dCH.TRANSITION_STEP).INITIAL);
        if (timerRef.current) clearTimeout(timerRef.current);
    }, [
        command
    ]);
    const startTimerForNextStep = (nextStep, durationMs)=>{
        timerRef.current = setTimeout(()=>{
            setTransitionStep(nextStep);
            timerRef.current = null;
        }, durationMs);
    };
    const handleReducedMotionTransition = (0, $eJOHy.useCallback)(()=>{
        if (isActive) setTransitionStep((0, $d6dCH.TRANSITION_STEP).FINISHED);
        else setTransitionStep((0, $d6dCH.TRANSITION_STEP).INITIAL);
    }, [
        isActive
    ]);
    const handleWithMotionTransition = (0, $eJOHy.useCallback)(()=>{
        switch(transitionStep){
            case (0, $d6dCH.TRANSITION_STEP).INITIAL:
                if (isActive) {
                    setTransitionStep((0, $d6dCH.TRANSITION_STEP).DELAYING);
                    startTimerForNextStep((0, $d6dCH.TRANSITION_STEP).TRANSITIONING, isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand ? (0, $d6dCH.TRANSITION_INITIAL_DELAY_TIME_MS) : (0, $d6dCH.TRANSITION_HOVER_DELAY_TIME_MS));
                }
                break;
            case (0, $d6dCH.TRANSITION_STEP).DELAYING:
                if (!isActive) {
                    timerRef.current && clearTimeout(timerRef.current);
                    timerRef.current = null;
                    setTransitionStep((0, $d6dCH.TRANSITION_STEP).INITIAL);
                }
                break;
            case (0, $d6dCH.TRANSITION_STEP).TRANSITIONING:
                if (isActive) {
                    if (isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand) setHasTransitionedFirstCommand(true);
                    if (!timerRef.current) startTimerForNextStep((0, $d6dCH.TRANSITION_STEP).FINISHED, (0, $d6dCH.TRANSITION_DURATION_MS));
                }
                break;
            case (0, $d6dCH.TRANSITION_STEP).FINISHED:
                if (!isActive) setTransitionStep((0, $d6dCH.TRANSITION_STEP).DELAYING_FADE_OUT);
                break;
            case (0, $d6dCH.TRANSITION_STEP).DELAYING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT, (0, $d6dCH.TRANSITION_HOVER_DELAY_TIME_MS));
                break;
            case (0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $d6dCH.TRANSITION_STEP).INITIAL, (0, $d6dCH.TRANSITION_DURATION_MS));
                break;
            default:
                (0, $9pTd3.fireErrorAnalytics)({
                    error: new Error('Invalid transition step for command'),
                    meta: {
                        id: 'useTransitionStep',
                        packageName: 'jiraCommandPalette',
                        teamName: 'deliveroo'
                    }
                });
        }
    }, [
        command.shortcut,
        hasTransitionedFirstCommand,
        isActive,
        isFirstCommand,
        transitionStep
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (commandHasChildren) {
            if (isReducedMotion) handleReducedMotionTransition();
            else handleWithMotionTransition();
        }
    }, [
        commandHasChildren,
        isReducedMotion,
        handleReducedMotionTransition,
        handleWithMotionTransition
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!isFirstCommand) // eslint-disable-next-line react-you-might-not-need-an-effect/no-adjust-state-on-prop-change
        setHasTransitionedFirstCommand(false);
    }, [
        isFirstCommand
    ]);
    (0, $eJOHy.useEffect)(()=>()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        }, []);
    return transitionStep;
};

});




parcelRegister("6b4EO", function(module, exports) {
$parcel$export(module.exports, "COMMAND_CONTAINER_ROW_TEST_ID", () => $354f8ec6615134bc$export$617744f059bfc3ba);
$parcel$export(module.exports, "GROUP_TEST_ID", () => $354f8ec6615134bc$export$d83f892940e54128);
$parcel$export(module.exports, "NO_RESULTS_TEST_ID", () => $354f8ec6615134bc$export$bf182a53106ca02e);
$parcel$export(module.exports, "SCROLL_DIRECTION", () => $354f8ec6615134bc$export$a6d65a8fb7b912d6);
const $354f8ec6615134bc$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $354f8ec6615134bc$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $354f8ec6615134bc$export$d83f892940e54128 = 'command-palette.ui.modal.body.group-container';
const $354f8ec6615134bc$export$707f57180c76458e = 'command-palette.ui.modal.body.spinner-container';
const $354f8ec6615134bc$export$bf182a53106ca02e = 'command-palette.ui.modal.body.no-results-container';
var $354f8ec6615134bc$export$a6d65a8fb7b912d6 = /*#__PURE__*/ function(SCROLL_DIRECTION) {
    SCROLL_DIRECTION["START"] = "start";
    SCROLL_DIRECTION["END"] = "end";
    return SCROLL_DIRECTION;
}({});

});

parcelRegister("5IbG4", function(module, exports) {
$parcel$export(module.exports, "isElementVisibleInContainer", () => $a1ee1680b73743ba$export$b9dc8b6556026098);
$parcel$export(module.exports, "getScrollToIndex", () => $a1ee1680b73743ba$export$56068eb4c4e3a63c);
$parcel$export(module.exports, "scrollResultIntoView", () => $a1ee1680b73743ba$export$6be8a7238febd54f);

var $2OtIa = parcelRequire("2OtIa");

var $6b4EO = parcelRequire("6b4EO");
const $a1ee1680b73743ba$export$b9dc8b6556026098 = (element, container)=>{
    const modalBodyRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    return elementRect.top >= modalBodyRect.top && elementRect.bottom <= modalBodyRect.bottom;
};
const $a1ee1680b73743ba$export$56068eb4c4e3a63c = (results, newActiveIndex, scrollTo)=>{
    const commandResultIndex = results.findIndex((result)=>!result.isGroup && result.index === newActiveIndex);
    if (scrollTo === (0, $6b4EO.SCROLL_DIRECTION).START && commandResultIndex > 0) {
        // Verify if there is any active command before this id
        const prevActiveCommandIndex = results.findIndex((result, index)=>index < commandResultIndex && !result.isGroup && (0, $2OtIa.hasAction)(result.command));
        if (prevActiveCommandIndex === -1) return 0;
    }
    if (scrollTo === (0, $6b4EO.SCROLL_DIRECTION).END) {
        // Verify if there is any active command after this id
        const afterActiveCommandIndex = results.findIndex((result, index)=>index > commandResultIndex && !result.isGroup && (0, $2OtIa.hasAction)(result.command));
        if (afterActiveCommandIndex === -1) return results.length - 1;
        // Scrolling down, so group headings don't need to be taken into account
        return commandResultIndex;
    }
    const isCommandAfterGroupHeading = commandResultIndex > 0 && results[commandResultIndex - 1].isGroup;
    return isCommandAfterGroupHeading ? commandResultIndex - 1 : commandResultIndex;
};
const $a1ee1680b73743ba$export$6be8a7238febd54f = ({ target: target, direction: direction, scrollContainer: scrollContainer })=>{
    const targetRect = target.getBoundingClientRect();
    const containerRect = scrollContainer.getBoundingClientRect();
    const gapScroll = 4;
    if (direction === (0, $6b4EO.SCROLL_DIRECTION).END) {
        const commandPosition = targetRect.bottom - containerRect.top;
        const amountToScroll = commandPosition - containerRect.height;
        const pos = amountToScroll + gapScroll + scrollContainer.scrollTop;
        scrollContainer.scrollTo({
            top: pos
        });
    } else {
        const commandPosition = containerRect.top - targetRect.top;
        const amountToScroll = scrollContainer.scrollTop - commandPosition;
        const pos = amountToScroll - gapScroll;
        scrollContainer.scrollTo({
            top: pos
        });
    }
};

});


parcelRegister("lKFw0", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $0deb62bf7e6b3b6e$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8IeH1 = parcelRequire("8IeH1");

var $4cTDP = parcelRequire("4cTDP");

const $0deb62bf7e6b3b6e$var$styles = {
    root: "_1e0c1txw _4cvr1h6o _mrkb1kw7 _1o0z1kw7 _1i53muej _uwhke4h9 _15a5nqa1 _ca0qutpp _u5f3pxbi _n3tdutpp _19bvpxbi _4t3ickbl"
};
const $0deb62bf7e6b3b6e$export$a06f1c675e846f6f = ({ defaultFooterContent: defaultFooterContent, children: children })=>{
    const footerChildren = children || defaultFooterContent;
    if (!footerChildren) return null;
    if ((0, $4cTDP.fg)('compal_jifjam_navigation_new_filters')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $0deb62bf7e6b3b6e$var$styles.root,
        testId: (0, $19b63b11e263f76d$export$aca3e1b45b29f2bb)
    }, footerChildren);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0deb62bf7e6b3b6e$var$ModalFooterOld, {
        "data-testid": (0, $19b63b11e263f76d$export$aca3e1b45b29f2bb)
    }, footerChildren);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0deb62bf7e6b3b6e$var$ModalFooterOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3dozgxb _mrkb1kw7 _1o0z1kw7 _ca0qutpp _u5f3pxbi _n3tdutpp _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
const $19b63b11e263f76d$export$aca3e1b45b29f2bb = 'command-palette.ui.modal.footer.footer';


parcelRegister("b4bRO", function(module, exports) {
$parcel$export(module.exports, "Header", () => $6a7be27086db7192$export$8b251419efc915eb);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

const $6a7be27086db7192$export$8b251419efc915eb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6a7be27086db7192$var$headerStyles,
        testId: (0, $dea6840b8c2241ed$export$bf5b960a2e79e6cf)
    }, children);
const $6a7be27086db7192$var$headerStyles = (0, $1DXK0.xcss)({
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit',
    padding: 'space.200',
    borderBottom: `solid 1px ${"var(--ds-border, #091E4224)"}`
});

});
const $dea6840b8c2241ed$export$bf5b960a2e79e6cf = 'command-palette.ui.modal.header.modal-header';



parcelRegister("d9bSz", function(module, exports) {
$parcel$export(module.exports, "IssueTag", () => $8cd762bdcfb2eb4a$export$a342a0ad2c552031);

var $eJOHy = parcelRequire("eJOHy");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $6QZlQ = parcelRequire("6QZlQ");

var $fygkY = parcelRequire("fygkY");

var $bmoS1 = parcelRequire("bmoS1");

var $1LCJW = parcelRequire("1LCJW");

var $3EmVH = parcelRequire("3EmVH");
const $8cd762bdcfb2eb4a$export$a342a0ad2c552031 = ({ issueKey: issueKey })=>{
    const issueId = (0, $bmoS1.useIssueId)();
    const [{ value: summary }] = (0, $3EmVH.useSummaryField)({
        issueKey: issueKey,
        issueId: issueId
    });
    const [{ value: issueType }] = (0, $1LCJW.useIssueTypeField)({
        issueKey: issueKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $8cd762bdcfb2eb4a$var$issueTagContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $8cd762bdcfb2eb4a$var$issueTagStyles,
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6QZlQ.IssueLeftIcon), {
        issueTypeName: issueType?.name,
        iconUrl: issueType?.iconUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fygkY.TruncateWithTooltipOnHover), null, `${issueKey} ${summary}`)));
};
const $8cd762bdcfb2eb4a$var$issueTagContainerStyles = (0, $1DXK0.xcss)({
    width: '100%',
    minWidth: '0'
});
const $8cd762bdcfb2eb4a$var$issueTagStyles = (0, $1DXK0.xcss)({
    maxWidth: '100%',
    padding: 'space.050',
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.small',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtle',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1
});

});
parcelRegister("6QZlQ", function(module, exports) {
$parcel$export(module.exports, "IssueLeftIcon", () => $7c8046d8cc67e0c4$export$b1b562672a76ad84);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $egRFv = parcelRequire("egRFv");
const $7c8046d8cc67e0c4$export$b1b562672a76ad84 = ({ iconUrl: iconUrl, issueTypeName: issueTypeName })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: iconUrl,
        alt: !issueTypeName && (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage(// eslint-disable-next-line no-nested-ternary
        (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? (0, $egRFv.messages).workTypeIconAltText : (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $egRFv.messages).issueIconAltTextIssueTermRefresh : (0, $egRFv.messages).issueIconAltText, {
            issueTypeName: issueTypeName
        }),
        height: "16"
    });
};

});
parcelRegister("egRFv", function(module, exports) {
$parcel$export(module.exports, "messages", () => $d752c1cd111ca5da$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $d752c1cd111ca5da$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    // Delete when cleaning up deliveroo_compal_a11y_fixes
    issueIconAltText: {
        "id": "command-palette-common.common.command.issue.issue-left-icon.issue-icon-alt-text",
        "defaultMessage": "Icon for the issue type {issueTypeName}"
    },
    // Delete when cleaning up deliveroo_compal_a11y_fixes
    issueIconAltTextIssueTermRefresh: {
        "id": "command-palette-common.common.command.issue.issue-left-icon.issue-icon-alt-text-issue-term-refresh",
        "defaultMessage": "Icon for the work type {issueTypeName}"
    },
    workTypeIconAltText: {
        "id": "command-palette-common.common.command.issue.issue-left-icon.work-type-icon-alt-text",
        "defaultMessage": "Work type {issueTypeName}"
    }
});

});


parcelRegister("fygkY", function(module, exports) {
$parcel$export(module.exports, "TruncateWithTooltipOnHover", () => $062533dcadb4afe9$export$b2323503daaefa);

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $i92Id = parcelRequire("i92Id");


var $fu9LY = parcelRequire("fu9LY");
const $062533dcadb4afe9$export$70f47de153e915ed = ()=>(0, $eJOHy.useRef)(null);
const $062533dcadb4afe9$export$b2323503daaefa = ({ children: children })=>{
    const containerRef = $062533dcadb4afe9$export$70f47de153e915ed();
    const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $fu9LY.useTruncatedTooltip)({
        containerRef: containerRef,
        // Tooltip delay is set on the tooltip component
        tooltipDelay: 0
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: shouldShowTruncatedTooltip ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i92Id.TooltipContent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-hover.tooltip-content"
            }, children) : '',
        component: (0, $i92Id.TooltipComponent),
        position: "bottom-end",
        delay: (0, $4c1f11f798b8ffde$export$f9e3e7ede9ba929d)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i92Id.TooltipTrigger), {
            "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-hover.tooltip-trigger",
            ...tooltipProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i92Id.TruncateWithTooltipContainer), {
            ref: containerRef
        }, children)));
};

});

parcelRegister("1LCJW", function(module, exports) {
$parcel$export(module.exports, "useIssueTypeField", () => $bfeca37ca68a770a$export$3da96c4009e089ca);

var $9Dhvc = parcelRequire("9Dhvc");

var $2QNHW = parcelRequire("2QNHW");

var $2rHwS = parcelRequire("2rHwS");

var $3mZMJ = parcelRequire("3mZMJ");
const $bfeca37ca68a770a$export$3da96c4009e089ca = ({ issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [{ value: fieldConfig }] = (0, $2rHwS.useFieldConfig)(issueKey, (0, $3mZMJ.ISSUE_TYPE));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(fieldConfig, 'schema.type', (0, $3mZMJ.ISSUE_TYPE));
    const [{ value: value, error: error, loading: loading }, { saveValue: saveValue, resetError: resetError }] = (0, $2QNHW.useEditField)({
        fieldKey: (0, $3mZMJ.ISSUE_TYPE),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig,
            loading: loading
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("2QNHW", function(module, exports) {
$parcel$export(module.exports, "useContextualIssueIdForIssueKey", () => $bce61970be345088$export$76d937477b5f784a);
$parcel$export(module.exports, "useEditField", () => $bce61970be345088$export$343e962d356c0af1);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $8Z9Ld = parcelRequire("8Z9Ld");

var $eSnSE = parcelRequire("eSnSE");

var $14RSn = parcelRequire("14RSn");

var $dMM78 = parcelRequire("dMM78");

var $d2AGn = parcelRequire("d2AGn");

var $eDOqM = parcelRequire("eDOqM");

var $bmoS1 = parcelRequire("bmoS1");

var $1Elll = parcelRequire("1Elll");

var $4TKh4 = parcelRequire("4TKh4");

var $4im1M = parcelRequire("4im1M");

var $kRgKj = parcelRequire("kRgKj");

var $eaTQ3 = parcelRequire("eaTQ3");

var $iaPZb = parcelRequire("iaPZb");
/**
 * Some responses contain `fields` property without `fieldKey`.
 * We must avoid changing the state of this fields by checking `fieldKey` property in the `fields`.
 * @param response
 * @param fieldKey
 */ const $bce61970be345088$var$getFieldValue = (response, fieldKey)=>{
    if (!response) return null;
    if (response.fields) {
        if (Object.hasOwnProperty.call(response.fields, fieldKey)) return response.fields[fieldKey];
        return null;
    }
    return response;
};
const $bce61970be345088$var$shouldCallSetFieldValue = (response, fieldKey)=>{
    if (!response) return false;
    if (response.fields) return !!Object.hasOwnProperty.call(response.fields, fieldKey);
    return true;
};
const $bce61970be345088$var$useEditFieldOriginal = (fieldOptions)=>{
    // di-ignore - Please fix parent-switcher examples
    const { issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, fieldType: fieldType, initialValue: initialValue, analyticsFieldKeyAlias: analyticsFieldKeyAlias, analyticsFieldTypeAlias: analyticsFieldTypeAlias, mapNonOptimisticResponse: mapNonOptimisticResponse = $bce61970be345088$var$getFieldValue, saveField: saveField = (0, $iaPZb.defaultSaveField), saveFieldById: saveFieldById = (0, $iaPZb.defaultSaveFieldById), addValuesToField: addValuesToField = (0, $iaPZb.defaultAddValuesToField), removeValuesFromField: removeValuesFromField = (0, $iaPZb.defaultRemoveValuesFromField), onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) } = fieldOptions;
    // We need to track the mounted state as it is possible that a component
    // using this hook can be unmounted before the async edit operation is completed.
    // Causing a react warning about setting state on an unmounted component.
    const isMounted = (0, $4im1M.useIsMounted)();
    const [fieldPersistedValue, { setFieldValue: setFieldValue }] = (0, $eaTQ3.useFieldValue)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const fieldValue = fieldPersistedValue !== undefined ? fieldPersistedValue : initialValue;
    const [error, setError] = (0, $eJOHy.useState)(null);
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    const resetError = (0, $eJOHy.useCallback)(()=>{
        if (isMounted.current) setError(null);
    }, [
        setError,
        isMounted
    ]);
    const editFieldValue = (0, $eJOHy.useCallback)(async (editOperation, editOperationType, valuesForOperation, valuesForUI, meta, analyticsEvent, options = {
        isOptimistic: true
    })=>{
        let result;
        const actualFieldType = analyticsFieldTypeAlias ?? fieldType;
        const analyticsData = {
            editOperationType: editOperationType,
            issueId: issueId,
            fieldKey: analyticsFieldKeyAlias ?? fieldKey,
            fieldType: actualFieldType
        };
        if (isMounted.current) {
            setLoading(true);
            setError(null);
        }
        try {
            onSubmit(fieldValue, valuesForOperation, meta, analyticsEvent);
            if (options.isOptimistic) setFieldValue(issueKey, fieldKey, valuesForUI);
            result = await editOperation(issueKey, fieldKey, valuesForOperation, meta);
            const fieldValueResponse = mapNonOptimisticResponse(result, fieldKey);
            $bce61970be345088$var$shouldCallSetFieldValue(result, fieldKey) && setFieldValue(issueKey, fieldKey, fieldValueResponse);
            onSuccess(fieldValueResponse ?? valuesForOperation, analyticsEvent, meta);
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'field updated', analyticsData);
            (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', analyticsData);
            (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd(fieldKey, {
                analytics: analyticsEvent,
                attributes: {
                    fieldType: actualFieldType,
                    isInlineEditing: !(0, $eDOqM.getIsEditFromIssueView)(analyticsEvent),
                    issueId: issueId
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (ex) {
            result = Promise.reject(ex);
            onFailure(ex, valuesForOperation);
            setFieldValue(issueKey, fieldKey, fieldValue);
            if (isMounted.current) setError(ex);
            const isValidationError = ex instanceof (0, $14RSn.ValidationError);
            if (!isValidationError) (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-field.save-value', `Failed to update field ${fieldKey} of type ${fieldType}`, ex);
            (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                fieldKey: fieldKey,
                fieldType: analyticsFieldTypeAlias ?? fieldType,
                isValidationError: isValidationError,
                isClientFetchError: (0, $dMM78.isClientFetchError)(ex)
            });
            (0, $d2AGn.getUpdateAnalyticsFlowHelper)().endSession(fieldKey);
        }
        if (isMounted.current) setLoading(false);
        return result;
    }, [
        analyticsFieldTypeAlias,
        fieldType,
        issueId,
        analyticsFieldKeyAlias,
        fieldKey,
        isMounted,
        onSubmit,
        fieldValue,
        issueKey,
        mapNonOptimisticResponse,
        setFieldValue,
        onSuccess,
        onFailure
    ]);
    const saveValue = (0, $eJOHy.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveField, 'set', newValue, newValue, meta, analyticsEvent), [
        editFieldValue,
        saveField
    ]);
    const saveById = (0, $eJOHy.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveFieldById, 'set', newValue, newValue, meta, analyticsEvent, {
            isOptimistic: false
        }), [
        editFieldValue,
        saveFieldById
    ]);
    const addValues = (0, $eJOHy.useCallback)(async (valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent)=>editFieldValue(addValuesToField, 'add', valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent), [
        editFieldValue,
        addValuesToField
    ]);
    const removeValues = (0, $eJOHy.useCallback)(async (valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent)=>editFieldValue(removeValuesFromField, 'remove', valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent), [
        editFieldValue,
        removeValuesFromField
    ]);
    return [
        {
            value: fieldValue,
            loading: loading,
            error: error
        },
        {
            saveById: saveById,
            saveValue: saveValue,
            addValues: addValues,
            removeValues: removeValues,
            resetError: resetError
        }
    ];
};
const $bce61970be345088$export$76d937477b5f784a = (issueKey)=>{
    const contextualIssueId = (0, $bmoS1.useIssueId)();
    const contextualIssueKey = (0, $bmoS1.useIssueKey)();
    return contextualIssueKey === issueKey ? contextualIssueId : null;
};
const $bce61970be345088$var$getAdditionalProperties = (meta, isEditFromIssueView)=>{
    if (!meta || typeof meta === 'object') return {
        ...meta ?? {},
        isEditFromIssueView: isEditFromIssueView
    };
    return meta;
};
const $bce61970be345088$export$343e962d356c0af1 = (fieldOptions)=>{
    const { fieldKey: fieldKey, issueId: issueIdFromFieldOptions, issueKey: issueKey, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), shouldPreventIssueViewSoftRefresh: shouldPreventIssueViewSoftRefresh = false } = fieldOptions;
    const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, $4TKh4.useIssueViewFieldUpdateEvents)();
    const contextualIssueId = $bce61970be345088$export$76d937477b5f784a(issueKey);
    const issueId = issueIdFromFieldOptions ?? contextualIssueId;
    const onSubmitFn = (0, $eJOHy.useCallback)((oldValue, newValue, meta, event)=>{
        onSubmit(oldValue, newValue, meta, event);
        issueId && fieldChangeRequested(issueId, fieldKey, newValue, meta);
    }, [
        fieldChangeRequested,
        fieldKey,
        issueId,
        onSubmit
    ]);
    const onSuccessFn = (0, $eJOHy.useCallback)(async (fieldValue, event, meta)=>{
        onSuccess(fieldValue);
        issueId && fieldChanged(issueId, fieldKey, fieldValue, undefined, $bce61970be345088$var$getAdditionalProperties(meta, (0, $eDOqM.getIsEditFromIssueView)(event)));
        if (!shouldPreventIssueViewSoftRefresh && !(0, $eDOqM.getIsEditFromIssueView)(event)) try {
            const reason = (0, $1Elll.Reason).SoftRefresh;
            await (0, $8Z9Ld.default).refreshIssuePageThrowable(issueKey, reason);
        } catch (error) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('issue.fields.use-edit-field.refresh', error instanceof Error ? error.message : 'useEditField issue refresh failed');
        }
    }, [
        fieldChanged,
        fieldKey,
        shouldPreventIssueViewSoftRefresh,
        issueId,
        issueKey,
        onSuccess
    ]);
    const onFailureFn = (0, $eJOHy.useCallback)((error, failedValue)=>{
        onFailure(error, failedValue);
        issueId && fieldChangeFailed(issueId, fieldKey);
    }, [
        fieldChangeFailed,
        fieldKey,
        issueId,
        onFailure
    ]);
    return $bce61970be345088$var$useEditFieldOriginal({
        ...fieldOptions,
        onSubmit: onSubmitFn,
        onSuccess: onSuccessFn,
        onFailure: onFailureFn
    });
};

});
parcelRegister("8Z9Ld", function(module, exports) {
$parcel$export(module.exports, "default", () => $625abf3f3d5ba00e$export$2e2bcd8739ae039);
const $625abf3f3d5ba00e$var$REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
const $625abf3f3d5ba00e$var$UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $625abf3f3d5ba00e$var$addEventListener = (event, callback)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.addEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $625abf3f3d5ba00e$var$removeEventListener = (event, callback)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.removeEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $625abf3f3d5ba00e$var$addRefreshIssueListener = (callback)=>$625abf3f3d5ba00e$var$addEventListener($625abf3f3d5ba00e$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $625abf3f3d5ba00e$var$removeRefreshIssueListener = (callback)=>$625abf3f3d5ba00e$var$removeEventListener($625abf3f3d5ba00e$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $625abf3f3d5ba00e$var$addUpdateIssueGlanceListener = (callback)=>$625abf3f3d5ba00e$var$addEventListener($625abf3f3d5ba00e$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $625abf3f3d5ba00e$var$removeUpdateIssueGlanceListener = (callback)=>$625abf3f3d5ba00e$var$removeEventListener($625abf3f3d5ba00e$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
const $625abf3f3d5ba00e$var$refreshIssuePageThrowable = (issueKey, reason = 'ON_DEMAND')=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.dispatchEvent(new CustomEvent($625abf3f3d5ba00e$var$REFRESH_ISSUE_PAGE_EVENT, {
            detail: [
                issueKey,
                {
                    mergeIntoCurrent: false,
                    reason: reason
                }
            ]
        }));
        return Promise.resolve();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Promise.reject(e);
    }
};
const $625abf3f3d5ba00e$var$refreshIssuePage = (issueKey)=>// Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    $625abf3f3d5ba00e$var$refreshIssuePageThrowable(issueKey).catch(()=>{});
const $625abf3f3d5ba00e$var$jiraBridge = {
    addRefreshIssueListener: $625abf3f3d5ba00e$var$addRefreshIssueListener,
    removeRefreshIssueListener: $625abf3f3d5ba00e$var$removeRefreshIssueListener,
    addUpdateIssueGlanceListener: $625abf3f3d5ba00e$var$addUpdateIssueGlanceListener,
    removeUpdateIssueGlanceListener: $625abf3f3d5ba00e$var$removeUpdateIssueGlanceListener,
    refreshIssuePageThrowable: $625abf3f3d5ba00e$var$refreshIssuePageThrowable,
    refreshIssuePage: $625abf3f3d5ba00e$var$refreshIssuePage
};
var $625abf3f3d5ba00e$export$2e2bcd8739ae039 = $625abf3f3d5ba00e$var$jiraBridge;

});

parcelRegister("1Elll", function(module, exports) {
$parcel$export(module.exports, "Reason", () => $a34fa8d661c29191$export$fe867595c4640fb1);
const $a34fa8d661c29191$export$fe867595c4640fb1 = {
    /**
	 * Aka hard refresh, used by Ecosystem apps to refresh issue view on demand
	 * 1) Full issue view refresh
	 * 2) Hard Ecosystem apps refresh (causes remounting of the apps)
	 */ OnDemand: 'ON_DEMAND',
    /**
	 * Used by Jira internally to update issue view on demand without forcing Ecosystem apps to rerender
	 * 1) Full issue view refresh only
	 * 2) Ecosystem app aren't hard refreshed, however, if field's value has changed, Forge custom field will rerender
	 */ SoftRefresh: 'SOFT_REFRESH',
    /**
	 * Issue view refresh caused by Realtime service (Jirt)
	 */ Realtime: 'REALTIME',
    /**
	 * Issue view refresh caused by Rovo broadcast action
	 */ RovoBroadcastAction: 'ROVO_BROADCAST_ACTION'
};

});

parcelRegister("4TKh4", function(module, exports) {
$parcel$export(module.exports, "useIssueViewFieldUpdateEvents", () => $f55e0c2b65585da2$export$444af741f6d8f512);
$parcel$export(module.exports, "IssueViewFieldUpdateEventContainer", () => $f55e0c2b65585da2$export$f9eb49cc2f0e28ce);

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $bOaiQ = parcelRequire("bOaiQ");

var $4P77p = parcelRequire("4P77p");
const $f55e0c2b65585da2$var$registerEventHandler = (type, eventHandler)=>({ getState: getState, setState: setState })=>{
        if (typeof eventHandler !== 'function') // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const { eventHandlers: eventHandlers } = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
        const typeEventHandlers = eventHandlers[type];
        setState({
            eventHandlers: {
                ...eventHandlers,
                [type]: typeEventHandlers.concat([
                    eventHandler
                ])
            }
        });
        return ()=>{
            const { eventHandlers: eventHandlersForUnregister } = getState();
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
            const typeEventHandlersForUnregister = eventHandlersForUnregister[type];
            const newTypeEventHandlers = typeEventHandlersForUnregister.filter(// @ts-expect-error - TS7006 - Parameter 'handler' implicitly has an 'any' type.
            (handler)=>handler !== eventHandler);
            setState({
                eventHandlers: {
                    ...eventHandlersForUnregister,
                    [type]: newTypeEventHandlers
                }
            });
        };
    };
const $f55e0c2b65585da2$var$fieldChanged = (issueId, fieldId, fieldValue, aggFieldChangeProps, additionalProperties)=>({ getState: getState })=>{
        let value = fieldValue;
        if (aggFieldChangeProps) value = (0, $bOaiQ.transformAggToLegacy)({
            fieldValue: fieldValue,
            aggFieldChangeProps: aggFieldChangeProps
        });
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                fieldId: // field id is required to be compatible with v1 onChange API
                fieldId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    additionalProperties: additionalProperties
                },
                type: (0, $4P77p.ChangeEventTypes).FIELD_CHANGED
            });
        });
    };
const $f55e0c2b65585da2$var$fieldChangeFailed = (issueId, fieldId)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId
                },
                type: (0, $4P77p.ChangeEventTypes).FIELD_CHANGE_FAILED
            });
        });
    };
const $f55e0c2b65585da2$var$fieldChangeRequested = (issueId, fieldId, fieldValue, additionalProperties, aggFieldChangeProps)=>({ getState: getState })=>{
        let value = fieldValue;
        if (aggFieldChangeProps) value = (0, $bOaiQ.transformAggToLegacy)({
            fieldValue: fieldValue,
            aggFieldChangeProps: aggFieldChangeProps
        });
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    additionalProperties: additionalProperties
                },
                type: (0, $4P77p.ChangeEventTypes).FIELD_CHANGE_REQUESTED
            });
        });
    };
const $f55e0c2b65585da2$var$actions = {
    fieldChanged: $f55e0c2b65585da2$var$fieldChanged,
    fieldChangeFailed: $f55e0c2b65585da2$var$fieldChangeFailed,
    fieldChangeRequested: $f55e0c2b65585da2$var$fieldChangeRequested,
    registerEventHandler: $f55e0c2b65585da2$var$registerEventHandler
};
// this is a global state
const $f55e0c2b65585da2$var$store = (0, $GtRbT.createStore)({
    name: 'issue-view-field-update-events',
    initialState: {
        eventHandlers: {
            onChange: []
        }
    },
    actions: $f55e0c2b65585da2$var$actions
});
const $f55e0c2b65585da2$export$444af741f6d8f512 = (0, $iJq0l.createHook)($f55e0c2b65585da2$var$store, {
    selector: null
});
const $f55e0c2b65585da2$export$f9eb49cc2f0e28ce = (0, $6E16M.createContainer)($f55e0c2b65585da2$var$store);

});
parcelRegister("bOaiQ", function(module, exports) {
$parcel$export(module.exports, "transformAggToLegacy", () => $a6ba0b2822402a6d$export$d951e3c38e10736d);

var $dJvZv = parcelRequire("dJvZv");

var $3mZMJ = parcelRequire("3mZMJ");

var $7QMat = parcelRequire("7QMat");

var $i6YHz = parcelRequire("i6YHz");
const $a6ba0b2822402a6d$export$d951e3c38e10736d = ({ fieldValue: fieldValue, aggFieldChangeProps: aggFieldChangeProps })=>{
    if (!aggFieldChangeProps?.__typename) throw new Error('node did not have __typename');
    switch(aggFieldChangeProps.__typename){
        // These fields require context for their transform in transformAggFieldToLegacyField so need to be manually implemented
        // This is not an exhaustive list, I did a quick check is all, so best to check the transform works as expected as you migrate fields to relay
        // These are commented out because they are not implemented and due to types can't just be added here until implemented
        // case JSM_PEOPLE_GQL_FIELD:
        // case ISSUE_RESTRICTION_GQL_FIELD:
        // otherwise we can default to the existing package
        case 0, $3mZMJ.RADIO_GQL_FIELD:
        case 0, $3mZMJ.TEAM_VIEW_GQL_FIELD:
        case 0, $3mZMJ.MULTI_GROUP_PICKER_GQL_FIELD:
        case 0, $3mZMJ.SINGLE_GROUP_PICKER_GQL_FIELD:
        case 0, $3mZMJ.MULTI_USER_PICKER_GQL_FIELD:
        case 0, $3mZMJ.PEOPLE_GQL_FIELD:
        case 0, $3mZMJ.SECURITY_GQL_FIELD:
        case 0, $3mZMJ.NUMBER_GQL_FIELD:
        case 0, $3mZMJ.TEXT_GQL_FIELD:
        case 0, $3mZMJ.USER_PICKER_GQL_FIELD:
        case 0, $3mZMJ.PRIORITY_GQL_FIELD:
        case 0, $3mZMJ.URL_GQL_FIELD:
        case 0, $3mZMJ.DATE_PICKER_GQL_FIELD:
        case 0, $3mZMJ.PROJECT_GQL_FIELD:
        case 0, $3mZMJ.DATE_TIME_GQL_FIELD:
        case 0, $3mZMJ.COLOR_GQL_FIELD:
        case 0, $3mZMJ.ORIGINAL_ESTIMATE_GQL_FIELD:
        case 0, $3mZMJ.ISSUE_TYPE_GQL_FIELD:
        case 0, $3mZMJ.VOTES_GQL_FIELD:
        case 0, $3mZMJ.WATCHES_GQL_FIELD:
        case 0, $3mZMJ.RESOLUTION_GQL_FIELD:
        case 0, $3mZMJ.STATUS_GQL_FIELD:
            // @ts-expect-error TODO JPX-164
            return (0, $dJvZv.transformAggFieldToLegacyField)({
                [$a6ba0b2822402a6d$var$getValueKey(aggFieldChangeProps.__typename)]: fieldValue,
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type
            })?.value;
        case 0, $3mZMJ.RICH_TEXT_GQL_FIELD:
            return (0, $i6YHz.transformAggRichTextFieldValueToLegacyFieldValue)(fieldValue, aggFieldChangeProps.renderer);
        case 0, $3mZMJ.PARENT_GQL_FIELD:
            return (0, $7QMat.transformAggParentFieldValueToLegacyFieldValue)(fieldValue);
        case 0, $3mZMJ.SPRINT_GQL_FIELD:
            return (0, $dJvZv.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                ...fieldValue
            })?.value;
        case 0, $3mZMJ.TIME_TRACKING_GQL_FIELD:
            // @ts-expect-error TODO JPX-164
            return (0, $dJvZv.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                originalEstimate: fieldValue.originalEstimate,
                remainingEstimate: fieldValue.remainingEstimate,
                timeSpent: fieldValue.timeSpent
            })?.value;
        case 0, $3mZMJ.CHECKBOX_GQL_FIELD:
            // @ts-expect-error TODO JPX-164
            return (0, $dJvZv.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                selectedOptions: fieldValue.selectedOptions
            })?.value;
        case 0, $3mZMJ.COMPONENTS_GQL_FIELD:
            // @ts-expect-error TODO JPX-164
            return (0, $dJvZv.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                selectedComponentsConnection: fieldValue.selectedComponentsConnection
            })?.value;
        default:
            throw new Error('__typename not implemented');
    }
};
const $a6ba0b2822402a6d$var$getValueKey = (__typename)=>{
    const VALUE_KEYS = {
        [(0, $3mZMJ.TEXT_GQL_FIELD)]: 'text',
        [(0, $3mZMJ.NUMBER_GQL_FIELD)]: 'number',
        [(0, $3mZMJ.PRIORITY_GQL_FIELD)]: 'priority',
        [(0, $3mZMJ.USER_PICKER_GQL_FIELD)]: 'user',
        [(0, $3mZMJ.DATE_PICKER_GQL_FIELD)]: 'date',
        [(0, $3mZMJ.PROJECT_GQL_FIELD)]: 'project',
        [(0, $3mZMJ.DATE_TIME_GQL_FIELD)]: 'dateTime',
        [(0, $3mZMJ.ORIGINAL_ESTIMATE_GQL_FIELD)]: 'originalEstimate',
        [(0, $3mZMJ.URL_GQL_FIELD)]: 'uri',
        [(0, $3mZMJ.SECURITY_GQL_FIELD)]: 'securityLevel',
        [(0, $3mZMJ.PEOPLE_GQL_FIELD)]: 'selectedUsersConnection',
        [(0, $3mZMJ.WATCHES_GQL_FIELD)]: 'watch',
        [(0, $3mZMJ.VOTES_GQL_FIELD)]: 'vote',
        [(0, $3mZMJ.COLOR_GQL_FIELD)]: 'color',
        [(0, $3mZMJ.MULTI_USER_PICKER_GQL_FIELD)]: 'selectedUsersConnection',
        [(0, $3mZMJ.ISSUE_TYPE_GQL_FIELD)]: 'issueType',
        [(0, $3mZMJ.RESOLUTION_GQL_FIELD)]: 'resolution',
        [(0, $3mZMJ.MULTI_GROUP_PICKER_GQL_FIELD)]: 'selectedGroupsConnection',
        [(0, $3mZMJ.SINGLE_GROUP_PICKER_GQL_FIELD)]: 'selectedGroup',
        [(0, $3mZMJ.TEAM_VIEW_GQL_FIELD)]: 'selectedTeam',
        [(0, $3mZMJ.STATUS_GQL_FIELD)]: 'status',
        [(0, $3mZMJ.RADIO_GQL_FIELD)]: 'selectedOption',
        [(0, $3mZMJ.RICH_TEXT_GQL_FIELD)]: 'richText'
    };
    const value = VALUE_KEYS[__typename];
    if (value) return value;
    throw new Error(`Did you forget to implement getValueKey for your field type? Couldn't find a value in the map for ${__typename}`);
};

});
parcelRegister("dJvZv", function(module, exports) {
$parcel$export(module.exports, "transformAggFieldToLegacyField", () => $2bc37c1610784c31$export$586ba15cbf3d3031);
$parcel$export(module.exports, "transformAggFieldsToLegacyFields", () => $2bc37c1610784c31$export$ba106ff8c087e6b1);

var $LFmXM = parcelRequire("LFmXM");

var $3mZMJ = parcelRequire("3mZMJ");

var $aFoDn = parcelRequire("aFoDn");

var $b8cRA = parcelRequire("b8cRA");

var $avDDJ = parcelRequire("avDDJ");

var $kHeCF = parcelRequire("kHeCF");

var $2Emz9 = parcelRequire("2Emz9");

var $3z9ZQ = parcelRequire("3z9ZQ");

var $kIiU4 = parcelRequire("kIiU4");

var $eOcuA = parcelRequire("eOcuA");

var $buly8 = parcelRequire("buly8");

var $4w7K1 = parcelRequire("4w7K1");

var $5p7Yl = parcelRequire("5p7Yl");

var $38Ayh = parcelRequire("38Ayh");

var $A0nGG = parcelRequire("A0nGG");

var $9YIgG = parcelRequire("9YIgG");

var $78GMW = parcelRequire("78GMW");

var $atdJk = parcelRequire("atdJk");

var $hWz6P = parcelRequire("hWz6P");

var $h6tdv = parcelRequire("h6tdv");

var $5IGk7 = parcelRequire("5IGk7");

var $aPcUN = parcelRequire("aPcUN");

var $1ZZyu = parcelRequire("1ZZyu");

var $dTYkW = parcelRequire("dTYkW");

var $esMH6 = parcelRequire("esMH6");

var $hqVWW = parcelRequire("hqVWW");

var $eDXnT = parcelRequire("eDXnT");

var $gmqe0 = parcelRequire("gmqe0");

var $95NMG = parcelRequire("95NMG");

var $kctB6 = parcelRequire("kctB6");

var $lBZeI = parcelRequire("lBZeI");

var $bl4cc = parcelRequire("bl4cc");

var $5D0JM = parcelRequire("5D0JM");

var $fj4N6 = parcelRequire("fj4N6");

var $7Elqr = parcelRequire("7Elqr");

var $eC8dc = parcelRequire("eC8dc");

var $7Qjvd = parcelRequire("7Qjvd");

var $iHCXo = parcelRequire("iHCXo");

var $2ZqHG = parcelRequire("2ZqHG");

var $kk6ni = parcelRequire("kk6ni");

var $5x8Qz = parcelRequire("5x8Qz");

var $5A5gO = parcelRequire("5A5gO");

var $fw41c = parcelRequire("fw41c");

var $8H6KM = parcelRequire("8H6KM");

var $iyjVB = parcelRequire("iyjVB");

var $lMiiC = parcelRequire("lMiiC");

var $gFEWP = parcelRequire("gFEWP");

var $a0aZw = parcelRequire("a0aZw");

var $7pxBz = parcelRequire("7pxBz");

var $dAiWn = parcelRequire("dAiWn");

var $a6vLL = parcelRequire("a6vLL");

var $gECU8 = parcelRequire("gECU8");

var $c8gRg = parcelRequire("c8gRg");

var $1exBo = parcelRequire("1exBo");

var $gtUzp = parcelRequire("gtUzp");

var $5iFQF = parcelRequire("5iFQF");

var $dSS0X = parcelRequire("dSS0X");

var $hpJ0s = parcelRequire("hpJ0s");

var $8plR2 = parcelRequire("8plR2");

var $92N3i = parcelRequire("92N3i");

var $lR2em = parcelRequire("lR2em");

var $9dsiy = parcelRequire("9dsiy");

var $2eP7x = parcelRequire("2eP7x");

var $ksE6r = parcelRequire("ksE6r");

var $dN5mk = parcelRequire("dN5mk");

var $2CpT2 = parcelRequire("2CpT2");

var $4MVer = parcelRequire("4MVer");

var $kPSkL = parcelRequire("kPSkL");

var $gpNkV = parcelRequire("gpNkV");

var $jE1Uq = parcelRequire("jE1Uq");

var $btvTF = parcelRequire("btvTF");

var $gujad = parcelRequire("gujad");
// We're memoising this just in case we FF another field
const $2bc37c1610784c31$var$getTransformersNonMemoised = ()=>({
        '%other': null,
        [(0, $3mZMJ.AFFECTED_SERVICES_GQL_FIELD)]: (0, $aFoDn.transformAggAffectedServicesToLegacyField),
        [(0, $3mZMJ.BOOLEAN_GQL_FIELD)]: (0, $avDDJ.transformAggBooleanToLegacyField),
        [(0, $3mZMJ.CASCADING_SELECT_GQL_FIELD)]: (0, $kHeCF.transformAggCascadingSelectToLegacyField),
        [(0, $3mZMJ.CHECKBOX_GQL_FIELD)]: (0, $2Emz9.transformAggCheckboxToLegacyField),
        [(0, $3mZMJ.CMDB_GQL_FIELD)]: (0, $3z9ZQ.transformAggCMDBToLegacyField),
        [(0, $3mZMJ.MULTI_SELECT_GQL_FIELD)]: (0, $a0aZw.transformAggMultipleSelectToLegacyField),
        [(0, $3mZMJ.COMPONENTS_GQL_FIELD)]: (0, $eOcuA.transformAggComponentsToLegacyField),
        [(0, $3mZMJ.CONNECT_DATE_TIME_GQL_FIELD)]: (0, $buly8.transformAggConnectDateTimeToLegacyField),
        [(0, $3mZMJ.CONNECT_MULTI_SELECT_GQL_FIELD)]: (0, $4w7K1.transformAggConnectMultipleSelectToLegacyField),
        [(0, $3mZMJ.CONNECT_NUMBER_GQL_FIELD)]: (0, $5p7Yl.transformAggConnectNumberToLegacyField),
        [(0, $3mZMJ.CONNECT_RICH_TEXT_GQL_FIELD)]: (0, $38Ayh.transformAggConnectRichTextToLegacyField),
        [(0, $3mZMJ.CONNECT_SINGLE_SELECT_GQL_FIELD)]: (0, $A0nGG.transformAggConnectSingleSelectToLegacyField),
        [(0, $3mZMJ.CONNECT_TEXT_GQL_FIELD)]: (0, $9YIgG.transformAggConnectTextToLegacyField),
        [(0, $3mZMJ.COLOR_GQL_FIELD)]: (0, $kIiU4.transformAggColorToLegacyField),
        [(0, $3mZMJ.DATE_PICKER_GQL_FIELD)]: (0, $atdJk.transformAggDatePickerToLegacyField),
        [(0, $3mZMJ.DATE_TIME_GQL_FIELD)]: (0, $hWz6P.transformAggDateTimePickerToLegacyField),
        [(0, $3mZMJ.EPIC_LINK_GQL_FIELD)]: (0, $h6tdv.transformAggEpicLinkToLegacyField),
        [(0, $3mZMJ.FLAG_GQL_FIELD)]: (0, $5IGk7.transformAggFlagToLegacyField),
        [(0, $3mZMJ.FORGE_DATETIME_GQL_FIELD)]: (0, $1ZZyu.transformAggForgeDateTimeToLegacyField),
        [(0, $3mZMJ.FORGE_DATE_GQL_FIELD)]: (0, $aPcUN.transformAggForgeDateToLegacyField),
        [(0, $3mZMJ.FORGE_GROUP_GQL_FIELD)]: (0, $dTYkW.transformAggForgeGroupToLegacyField),
        [(0, $3mZMJ.FORGE_GROUPS_GQL_FIELD)]: (0, $esMH6.transformAggForgeGroupsToLegacyField),
        [(0, $3mZMJ.FORGE_NUMBER_GQL_FIELD)]: (0, $hqVWW.transformAggForgeNumberToLegacyField),
        [(0, $3mZMJ.FORGE_OBJECT_GQL_FIELD)]: (0, $eDXnT.transformAggForgeObjectToLegacyField),
        [(0, $3mZMJ.FORGE_STRING_GQL_FIELD)]: (0, $gmqe0.transformAggForgeStringToLegacyField),
        [(0, $3mZMJ.FORGE_STRINGS_GQL_FIELD)]: (0, $95NMG.transformAggForgeStringsToLegacyField),
        [(0, $3mZMJ.FORGE_USER_GQL_FIELD)]: (0, $kctB6.transformAggForgeUserToLegacyField),
        [(0, $3mZMJ.FORGE_USERS_GQL_FIELD)]: (0, $lBZeI.transformAggForgeUsersToLegacyField),
        [(0, $3mZMJ.ISSUE_RESTRICTION_GQL_FIELD)]: (0, $fj4N6.transformAggIssueRestrictionToLegacyField),
        [(0, $3mZMJ.ISSUE_TYPE_GQL_FIELD)]: (0, $7Elqr.transformAggIssueTypeToLegacyField),
        [(0, $3mZMJ.JSM_APPROVAL_GQL_FIELD)]: (0, $eC8dc.transformAggJSMApprovalsToLegacyField),
        [(0, $3mZMJ.JSM_ASSETS_GQL_FIELD)]: (0, $b8cRA.transformAggAssetToLegacyField),
        [(0, $3mZMJ.JSM_MAJOR_INCIDENT_FIELD)]: (0, $iHCXo.transformAggJSMMajorIncidentToLegacyField),
        [(0, $3mZMJ.JSM_ORGANIZATION_GQL_FIELD)]: (0, $2ZqHG.transformAggJSMOrganizationToLegacyField),
        [(0, $3mZMJ.JSM_ENTITLEMENTS_GQL_FIELD)]: (0, $7Qjvd.transformAggJSMEntitlementsToLegacyField),
        [(0, $3mZMJ.JSM_SENTIMENT_GQL_FIELD)]: (0, $iyjVB.transformAggJSMSentimentToLegacyField),
        [(0, $3mZMJ.JSM_PEOPLE_GQL_FIELD)]: (0, $7pxBz.transformAggMultipleUserPickerToLegacyField),
        [(0, $3mZMJ.JSM_REQUEST_FEEDBACK_GQL_FIELD)]: (0, $5x8Qz.transformAggJSMRequestFeedbackToLegacyField),
        [(0, $3mZMJ.JSM_REQUEST_LANGUAGE_GQL_FIELD)]: (0, $5A5gO.transformAggJSMRequestLanguageToLegacyField),
        [(0, $3mZMJ.JSM_REQUEST_TYPE_GQL_FIELD)]: (0, $fw41c.transformAggJSMRequestTypeToLegacyField),
        [(0, $3mZMJ.JSM_RESPONDERS_GQL_FIELD)]: (0, $8H6KM.transformAggJSMRespondersToLegacyField),
        [(0, $3mZMJ.LABEL_GQL_FIELD)]: (0, $lMiiC.transformAggLabelsNodeToLegacyField),
        [(0, $3mZMJ.PRIORITY_GQL_FIELD)]: (0, $c8gRg.transformAggPriorityToLegacyField),
        [(0, $3mZMJ.MULTI_GROUP_PICKER_GQL_FIELD)]: (0, $gFEWP.transformAggMultiGroupPickerToLegacyField),
        [(0, $3mZMJ.MULTI_USER_PICKER_GQL_FIELD)]: (0, $7pxBz.transformAggMultipleUserPickerToLegacyField),
        [(0, $3mZMJ.NUMBER_GQL_FIELD)]: (0, $a6vLL.transformAggNumberToLegacyField),
        [(0, $3mZMJ.ORIGINAL_ESTIMATE_GQL_FIELD)]: (0, $gECU8.transformAggOriginalEstimateToLegacyField),
        [(0, $3mZMJ.PARENT_GQL_FIELD)]: null,
        [(0, $3mZMJ.PEOPLE_GQL_FIELD)]: (0, $7pxBz.transformAggMultipleUserPickerToLegacyField),
        [(0, $3mZMJ.PROFORMA_FORMS_GQL_FIELD)]: (0, $1exBo.transformAggProformaFormsToLegacyField),
        [(0, $3mZMJ.PROJECT_GQL_FIELD)]: (0, $gtUzp.transformAggProjectToLegacyField),
        [(0, $3mZMJ.MULTI_VERSION_GQL_FIELD)]: (0, $dAiWn.transformAggMultipleVersionPickerToLegacyField),
        [(0, $3mZMJ.RADIO_GQL_FIELD)]: (0, $5iFQF.transformAggRadioSelectToLegacyField),
        [(0, $3mZMJ.RICH_TEXT_GQL_FIELD)]: (0, $hpJ0s.transformAggRichTextToLegacyField),
        [(0, $3mZMJ.RESOLUTION_GQL_FIELD)]: (0, $dSS0X.transformAggResolutionToLegacyField),
        [(0, $3mZMJ.SECURITY_GQL_FIELD)]: (0, $8plR2.transformAggSecurityLevelToLegacyField),
        [(0, $3mZMJ.SPRINT_GQL_FIELD)]: (0, $dN5mk.transformAggSprintToLegacyField),
        [(0, $3mZMJ.STATUS_GQL_FIELD)]: (0, $2CpT2.transformAggStatusToLegacyField),
        [(0, $3mZMJ.SINGLE_GROUP_PICKER_GQL_FIELD)]: (0, $92N3i.transformAggSingleGroupPickerToLegacyField),
        [(0, $3mZMJ.SINGLE_SELECT_GQL_FIELD)]: (0, $9dsiy.transformAggSingleSelectToLegacyField),
        [(0, $3mZMJ.TEAM_GQL_FIELD)]: (0, $4MVer.transformAggTeamToLegacyField),
        [(0, $3mZMJ.TEAM_VIEW_GQL_FIELD)]: (0, $kPSkL.transformAggTeamViewToLegacyField),
        [(0, $3mZMJ.TEXT_GQL_FIELD)]: (0, $lR2em.transformAggSingleLineTextToLegacyField),
        [(0, $3mZMJ.TIME_TRACKING_GQL_FIELD)]: (0, $gpNkV.transformAggTimeTrackingToLegacyField),
        [(0, $3mZMJ.USER_PICKER_GQL_FIELD)]: (0, $2eP7x.transformAggSingleSelectUserPickerToLegacyField),
        [(0, $3mZMJ.URL_GQL_FIELD)]: (0, $jE1Uq.transformAggUrlToLegacyField),
        [(0, $3mZMJ.VERSION_GQL_FIELD)]: (0, $ksE6r.transformAggSingleVersionPickerToLegacyField),
        [(0, $3mZMJ.VOTES_GQL_FIELD)]: (0, $btvTF.transformAggVotesToLegacyField),
        [(0, $3mZMJ.WATCHES_GQL_FIELD)]: (0, $gujad.transformAggWatchesToLegacyField),
        [(0, $3mZMJ.DATA_CLASSIFICATION_FIELD)]: (0, $78GMW.transformAggDataClassificationToLegacyField),
        [(0, $3mZMJ.GOALS_GQL_FIELD)]: (0, $bl4cc.transformAggGoalsToLegacyField),
        [(0, $3mZMJ.ATLAS_PROJECT_GQL_FIELD)]: (0, $5D0JM.transformAggAtlasProjectToLegacyField),
        [(0, $3mZMJ.JCS_ORGANIZATION_GQL_FIELD)]: (0, $kk6ni.transformAggJCSOrganizationToLegacyField)
    });
const $2bc37c1610784c31$var$getTransformers = (0, $LFmXM.default)($2bc37c1610784c31$var$getTransformersNonMemoised);
const $2bc37c1610784c31$export$586ba15cbf3d3031 = (node, projectContext)=>{
    // @ts-expect-error the relay type for `__typename` is `string`, now. Not ideal, but manageable. We could log it.
    const typename = node.__typename;
    const transformer = $2bc37c1610784c31$var$getTransformers()[typename];
    return transformer ? transformer(node, projectContext) : undefined;
};
const $2bc37c1610784c31$export$ba106ff8c087e6b1 = (fields, projectField)=>{
    if (fields == null) return {};
    const projectContext = projectField != null ? projectField : (0, $gtUzp.getProjectField)(fields)?.project;
    return fields.reduce((fieldsState, fieldEdge)=>{
        if (fieldEdge?.node != null) {
            const transformedField = $2bc37c1610784c31$export$586ba15cbf3d3031(fieldEdge.node, projectContext);
            if (transformedField != null) {
                const fieldData = 'key' in transformedField ? {
                    [transformedField.key]: transformedField
                } : transformedField;
                Object.assign(fieldsState, fieldData);
            }
        }
        return fieldsState;
    }, {});
};

});
parcelRegister("aFoDn", function(module, exports) {
$parcel$export(module.exports, "transformAggAffectedServicesToLegacyField", () => $fbc7a191f371631a$export$231e0419515441d4);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
// @ts-expect-error TODO JPX-157
const $fbc7a191f371631a$var$transformJiraServicesToLegacyServices = ({ serviceId: serviceId, name: name })=>({
        id: serviceId,
        name: name ?? undefined
    });
const $fbc7a191f371631a$export$231e0419515441d4 = (node)=>{
    if (node.type !== (0, $3mZMJ.SERVICE_ENTITY_CF_TYPE)) return undefined;
    const hasValue = Boolean(node.selectedAffectedServicesConnection?.edges?.length);
    const value = hasValue ? (0, $8Tw1Q.transformAggConnection)(node.selectedAffectedServicesConnection, $fbc7a191f371631a$var$transformJiraServicesToLegacyServices) : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: value,
        schema: {
            configuration: null,
            custom: (0, $3mZMJ.SERVICE_ENTITY_CF_TYPE),
            items: 'service-entity-field',
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});
const $57c87778b42e34da$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $57c87778b42e34da$export$a4a240cb4053b29f = 'jira-text-renderer';
const $57c87778b42e34da$export$840ed33fa94f7693 = 'frother-control-renderer';

parcelRegister("8Tw1Q", function(module, exports) {
$parcel$export(module.exports, "transformAggNodeToLegacyField", () => $b9bdfd906e198405$export$e7ea61856a169c36);
$parcel$export(module.exports, "transformAggConnection", () => $b9bdfd906e198405$export$daf92cda81d86cdc);
$parcel$export(module.exports, "toLegacyConnectOption", () => $b9bdfd906e198405$export$b5de5f3d2de73afc);
const $b9bdfd906e198405$var$isEditableFromFieldConfig = (node)=>{
    return Boolean('fieldConfig' in node && node.fieldConfig != null && 'isEditable' in node.fieldConfig && node.fieldConfig.isEditable);
};
const $b9bdfd906e198405$var$isRequiredFromFieldConfig = (node)=>{
    return Boolean('fieldConfig' in node && node.fieldConfig != null && 'isRequired' in node.fieldConfig && node.fieldConfig.isRequired);
};
const $b9bdfd906e198405$export$e7ea61856a169c36 = (node)=>({
        ari: 'id' in node ? node.id : undefined,
        key: node.fieldId || '',
        title: node.name || '',
        editable: Boolean('isEditableInIssueView' in node ? node.isEditableInIssueView : $b9bdfd906e198405$var$isEditableFromFieldConfig(node)),
        required: $b9bdfd906e198405$var$isRequiredFromFieldConfig(node),
        autoCompleteUrl: 'searchUrl' in node ? node.searchUrl : null,
        allowedValues: [],
        value: null,
        schema: {
            type: node.type || '',
            custom: null,
            system: null
        },
        description: 'description' in node && node.description ? node.description : undefined
    });
const $b9bdfd906e198405$export$daf92cda81d86cdc = (connection, transformCallback)=>{
    const edges = connection?.edges ?? [];
    if (transformCallback) return edges.map((edge)=>edge?.node != null ? transformCallback(edge.node) : null).filter(Boolean);
    return edges.map((edge)=>edge?.node).filter(Boolean);
};
const $b9bdfd906e198405$export$b5de5f3d2de73afc = (node)=>{
    if (!node) return null;
    return {
        value: node.value ?? null,
        id: parseInt(node.optionId, 10)
    };
};

});


parcelRegister("b8cRA", function(module, exports) {
$parcel$export(module.exports, "transformAggAssetToLegacyField", () => $b693f7b60620dcc9$export$2136dcd78a2ef18f);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $b693f7b60620dcc9$export$2136dcd78a2ef18f = (node)=>{
    switch(node.type){
        case 0, $3mZMJ.ASSETS_CF_TYPE:
            {
                const hasValue = Boolean(node.selectedAssetsConnection?.edges?.length);
                const assetValue = hasValue ? (0, $8Tw1Q.transformAggConnection)(node.selectedAssetsConnection, ({ appKey: appKey, originId: originId, serializedOrigin: serializedOrigin, value: value })=>({
                        appKey: appKey,
                        originId: originId,
                        serializedOrigin: serializedOrigin,
                        value: value
                    })) : null;
                return {
                    ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                    autoCompleteUrl: node.searchUrl,
                    value: assetValue,
                    schema: {
                        custom: node.type,
                        system: null,
                        items: 'sd-asset',
                        type: 'array',
                        renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("avDDJ", function(module, exports) {
$parcel$export(module.exports, "transformAggBooleanToLegacyField", () => $19076dc45029b83c$export$4bd89b95f0d10de9);

var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $19076dc45029b83c$export$4bd89b95f0d10de9 = (node)=>{
    switch(node.type){
        case 0, $3mZMJ.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: {
                    alertLinking: {
                        enabled: node.value
                    }
                },
                schema: {
                    configuration: null,
                    items: null,
                    renderer: null,
                    custom: null,
                    system: (0, $3mZMJ.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE),
                    type: (0, $3mZMJ.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("kHeCF", function(module, exports) {
$parcel$export(module.exports, "transformAggCascadingSelectToLegacyField", () => $34b9c9aeef57642b$export$a8778af5ceb1017c);


var $8Tw1Q = parcelRequire("8Tw1Q");
const $34b9c9aeef57642b$export$a8778af5ceb1017c = (node)=>{
    let value = null;
    if (node.cascadingOption) {
        const { childOptionValue: childOptionValue, parentOptionValue: parentOptionValue } = node.cascadingOption;
        const child = childOptionValue ? {
            child: {
                id: childOptionValue.optionId,
                value: childOptionValue.value
            }
        } : {};
        value = {
            // assigned in the statement above
            id: parentOptionValue?.optionId,
            value: parentOptionValue?.value,
            ...child
        };
    }
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: [],
        schema: {
            type: 'option-with-child',
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2Emz9", function(module, exports) {
$parcel$export(module.exports, "transformAggCheckboxToLegacyField", () => $c452c87cf3235dda$export$baa5afdbd8fd12d3);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $c452c87cf3235dda$export$baa5afdbd8fd12d3 = (node)=>{
    switch(node.type){
        case 0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE:
            {
                // We're inlining the transformers per field here so it'll be easy to remove them once we make the allowedValues async
                const value = (0, $8Tw1Q.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: [],
                    schema: {
                        type: 'array',
                        renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("3z9ZQ", function(module, exports) {
$parcel$export(module.exports, "transformObjectAttributesToLegacyObjectAttributes", () => $f335a71a0f3327b1$export$4a1f73d4c9d3b36e);
$parcel$export(module.exports, "transformAggCMDBToLegacyField", () => $f335a71a0f3327b1$export$93506453d9bb56ae);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
// @ts-expect-error TODO JPX-157
const $f335a71a0f3327b1$var$transformObjectTypeToLegacy = (attribute, workspaceId)=>{
    if (!attribute) return null;
    return {
        workspaceId: workspaceId,
        id: `${workspaceId}:${attribute.objectTypeId}`,
        name: attribute.name,
        objectSchemaId: attribute.objectSchemaId,
        objectTypeId: attribute.objectTypeId,
        // `icon` is unused
        icon: attribute.icon
    };
};
const $f335a71a0f3327b1$var$transformCMDBConfigurationToLegacyConfiguration = (node)=>{
    if (!node.cmdbFieldConfig) return node.isInsightAvailable === false ? {
        isInsightAvailable: node.isInsightAvailable
    } : {};
    return {
        cmdbFieldConfig: {
            multiple: node.cmdbFieldConfig.multiple,
            objectSchemaId: node.cmdbFieldConfig.objectSchemaId.split('/')[2],
            attributesDisplayedOnIssue: (0, $8Tw1Q.transformAggConnection)(node.cmdbFieldConfig?.attributesDisplayedOnIssue),
            attributesIncludedInAutoCompleteSearch: (0, $8Tw1Q.transformAggConnection)(node.cmdbFieldConfig?.attributesIncludedInAutoCompleteSearch)
        },
        isInsightAvailable: node.isInsightAvailable,
        wasInsightRequestSuccessful: node.wasInsightRequestSuccessful
    };
};
// @ts-expect-error TODO JPX-157
const $f335a71a0f3327b1$var$transformObjectTypeAttributeToLegacy = (type)=>{
    switch(type){
        case 'REFERENCED_OBJECT':
            return 1;
        case 'USER':
            return 2;
        case 'GROUP':
            return 4;
        case 'PROJECT':
            return 6;
        case 'STATUS':
            return 7;
        case 'BITBUCKET_REPO':
            return 8;
        case 'OPSGENIE_TEAM':
            return 9;
        case 'DEFAULT':
            return 0;
        default:
            // eslint-disable-next-line no-console
            console.error(new Error(`Unknown attribute type found in transformObjectTypeAttributeToLegacy: ${type}. Mapping type to '-1'`));
            return -1;
    }
};
// @ts-expect-error TODO JPX-157
const $f335a71a0f3327b1$var$transformReferencedObject = (node)=>({
        id: node.objectGlobalId,
        workspaceId: node.workspaceId,
        objectKey: node.objectKey,
        label: node.label,
        avatar: node.avatar,
        objectId: node.objectId
    });
// @ts-expect-error TODO JPX-157
const $f335a71a0f3327b1$var$transformCmdbUser = (node)=>({
        avatarUrl: node.picture,
        displayName: node.name,
        name: node.name,
        key: node.accountId
    });
// @ts-expect-error TODO JPX-157
const $f335a71a0f3327b1$var$transformCmdbGroup = (node)=>({
        name: node.name
    });
// @ts-expect-error TODO JPX-157
const $f335a71a0f3327b1$var$transformCmdbProject = (node)=>({
        avatarUrl: node.avatar?.large,
        id: Number(node.id),
        key: node.key,
        name: node.name
    });
// @ts-expect-error TODO JPX-157
const $f335a71a0f3327b1$var$transformCmdbBitbucketRepo = (node)=>({
        uuid: node.uuid,
        name: node.name,
        url: node.url,
        avatarUrl: node.avatarUrl
    });
// @ts-expect-error TODO JPX-157
const $f335a71a0f3327b1$var$transformCmdbOpsgenieTeam = (node)=>({
        id: node.id,
        name: node.name,
        url: node.url
    });
// @ts-expect-error TODO JPX-157
const $f335a71a0f3327b1$var$transformCmdbStatus = (node)=>({
        id: node.id,
        name: node.name,
        category: node.category
    });
// @ts-expect-error TODO JPX-157
const $f335a71a0f3327b1$var$transformObjectAttributeValuesToLegacy = (node)=>{
    if (!node) return null;
    const defaultObjectValue = {
        displayValue: node.displayValue,
        searchValue: node.searchValue,
        ...node.value != null ? {
            value: node.value
        } : {}
    };
    if (node.referencedObject) return {
        ...defaultObjectValue,
        referencedObject: $f335a71a0f3327b1$var$transformReferencedObject(node.referencedObject)
    };
    if (node.user) return {
        ...defaultObjectValue,
        user: $f335a71a0f3327b1$var$transformCmdbUser(node.user)
    };
    if (node.group) return {
        ...defaultObjectValue,
        group: $f335a71a0f3327b1$var$transformCmdbGroup(node.group)
    };
    if (node.project) return {
        ...defaultObjectValue,
        project: $f335a71a0f3327b1$var$transformCmdbProject(node.project)
    };
    if (node.bitbucketRepo) return {
        ...defaultObjectValue,
        bitbucketRepo: $f335a71a0f3327b1$var$transformCmdbBitbucketRepo(node.bitbucketRepo)
    };
    if (node.opsgenieTeam) return {
        ...defaultObjectValue,
        opsgenieTeam: $f335a71a0f3327b1$var$transformCmdbOpsgenieTeam(node.opsgenieTeam)
    };
    if (node.status) return {
        ...defaultObjectValue,
        status: $f335a71a0f3327b1$var$transformCmdbStatus(node.status)
    };
    return defaultObjectValue;
};
const $f335a71a0f3327b1$export$4a1f73d4c9d3b36e = (node, workspaceId)=>{
    if (!node) return null;
    const { objectTypeAttributeId: objectTypeAttributeId } = node;
    const objectTypeAttribute = node.objectTypeAttribute;
    return {
        objectTypeAttributeId: objectTypeAttributeId,
        workspaceId: workspaceId,
        objectAttributeValues: (0, $8Tw1Q.transformAggConnection)(node.objectAttributeValues, $f335a71a0f3327b1$var$transformObjectAttributeValuesToLegacy),
        objectTypeAttribute: {
            id: objectTypeAttributeId,
            label: objectTypeAttribute.label,
            name: objectTypeAttribute.name,
            workspaceId: workspaceId,
            type: $f335a71a0f3327b1$var$transformObjectTypeAttributeToLegacy(objectTypeAttribute.type),
            ...objectTypeAttribute.defaultType ? {
                defaultType: {
                    id: objectTypeAttribute.defaultType.id,
                    name: objectTypeAttribute.defaultType.name
                }
            } : {}
        }
    };
};
// @ts-expect-error TODO JPX-157
const $f335a71a0f3327b1$var$transformJiraCMDBToLegacyCMDB = (node)=>{
    if (!node) return null;
    const { label: label, objectGlobalId: objectGlobalId, objectId: objectId, objectKey: objectKey, webUrl: webUrl, avatar: avatar } = node;
    const workspaceId = node.workspaceId;
    return {
        attributes: (0, $8Tw1Q.transformAggConnection)(node.attributes, (nodeAttribute)=>$f335a71a0f3327b1$export$4a1f73d4c9d3b36e(nodeAttribute, workspaceId)),
        avatar: avatar,
        label: label,
        id: objectGlobalId,
        objectId: objectId,
        objectKey: objectKey,
        workspaceId: workspaceId,
        links: {
            self: webUrl
        },
        objectType: $f335a71a0f3327b1$var$transformObjectTypeToLegacy(node.objectType, workspaceId)
    };
};
const $f335a71a0f3327b1$export$93506453d9bb56ae = (node)=>{
    if (node.type !== (0, $3mZMJ.CMDB_OBJECT_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?` : null,
        configuration: $f335a71a0f3327b1$var$transformCMDBConfigurationToLegacyConfiguration(node),
        value: (0, $8Tw1Q.transformAggConnection)(node.selectedCmdbObjectsConnection, $f335a71a0f3327b1$var$transformJiraCMDBToLegacyCMDB),
        schema: {
            configuration: null,
            custom: (0, $3mZMJ.CMDB_OBJECT_CF_TYPE),
            items: 'cmdb-object-field',
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("kIiU4", function(module, exports) {
$parcel$export(module.exports, "transformAggColorToLegacyField", () => $46915e9bf9032cfd$export$587c178f1b45e5e9);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $46915e9bf9032cfd$export$587c178f1b45e5e9 = (node)=>{
    const value = node.color?.colorKey ?? null;
    switch(node.type){
        case 0, $3mZMJ.EPIC_COLOR_TYPE:
        case 0, $3mZMJ.COLOR_CF_TYPE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: value,
                schema: {
                    configuration: null,
                    type: (0, $3mZMJ.ISSUE_FIELD_STRING_CF_TYPE),
                    renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
                    custom: node.type,
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("eOcuA", function(module, exports) {
$parcel$export(module.exports, "transformAggComponentsToLegacyField", () => $65b417152350f194$export$97a9275777684b77);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
// @DoNotExport Flow is deriving component's type
// @ts-expect-error TODO JPX-157
const $65b417152350f194$var$transformJiraComponentToLegacyComponent = (component)=>{
    if (component == null) return null;
    return {
        id: component.componentId,
        name: component.name,
        ari: component.ari,
        metadata: component.metadata
    };
};
const $65b417152350f194$export$97a9275777684b77 = (node)=>{
    if (node.type !== (0, $3mZMJ.COMPONENTS_TYPE)) return undefined;
    const value = (0, $8Tw1Q.transformAggConnection)(node.selectedComponentsConnection, $65b417152350f194$var$transformJiraComponentToLegacyComponent);
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: value,
        schema: {
            configuration: null,
            items: 'component',
            renderer: (0, $57c87778b42e34da$export$840ed33fa94f7693),
            type: (0, $3mZMJ.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            custom: null,
            system: (0, $3mZMJ.COMPONENTS_TYPE)
        }
    };
};

});

parcelRegister("buly8", function(module, exports) {
$parcel$export(module.exports, "transformAggConnectDateTimeToLegacyField", () => $221506f594bc9cb4$export$e6d015aa746cbdaf);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $221506f594bc9cb4$export$e6d015aa746cbdaf = (node)=>({
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.dateTime ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $3mZMJ.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    });

});

parcelRegister("4w7K1", function(module, exports) {
$parcel$export(module.exports, "transformAggConnectMultipleSelectToLegacyField", () => $b8b4e3981ba17f3d$export$edf5c98d20696686);


var $3mZMJ = parcelRequire("3mZMJ");

var $4cTDP = parcelRequire("4cTDP");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $b8b4e3981ba17f3d$var$transformAggConnectMultipleSelectToLegacyFieldOld = (node)=>{
    const value = (0, $8Tw1Q.transformAggConnection)(node.selectedOptions, (0, $8Tw1Q.toLegacyConnectOption));
    const allowedValues = (0, $8Tw1Q.transformAggConnection)(node.connectMultiSelectFieldOptions, (0, $8Tw1Q.toLegacyConnectOption));
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value.length ? value : null,
        allowedValues: allowedValues,
        schema: {
            type: (0, $3mZMJ.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: (0, $3mZMJ.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
            configuration: null
        }
    };
};
const $b8b4e3981ba17f3d$var$transformAggConnectMultipleSelectToLegacyFieldNew = (node)=>{
    const value = (0, $8Tw1Q.transformAggConnection)(node.selectedOptions, (option)=>({
            id: option.optionId,
            value: option.value ?? null,
            ari: option.id
        }));
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value.length ? value : null,
        allowedValues: [],
        schema: {
            type: (0, $3mZMJ.MULTI_SELECT_CF_TYPE),
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: (0, $3mZMJ.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
            configuration: null
        }
    };
};
const $b8b4e3981ba17f3d$export$edf5c98d20696686 = (node)=>(0, $4cTDP.fg)('dfo_remove_connect_multi_select_field_options_agg') ? $b8b4e3981ba17f3d$var$transformAggConnectMultipleSelectToLegacyFieldNew(node) : $b8b4e3981ba17f3d$var$transformAggConnectMultipleSelectToLegacyFieldOld(node);

});

parcelRegister("5p7Yl", function(module, exports) {
$parcel$export(module.exports, "transformAggConnectNumberToLegacyField", () => $d4146295cc2f8675$export$4638a5dd3285d8f2);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $d4146295cc2f8675$export$4638a5dd3285d8f2 = (node)=>({
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.number ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $3mZMJ.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    });

});

parcelRegister("38Ayh", function(module, exports) {
$parcel$export(module.exports, "transformAggConnectRichTextToLegacyField", () => $ccba2b4e2894a74a$export$11063e1f9210f191);

var $clRM1 = parcelRequire("clRM1");


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");

var $hpJ0s = parcelRequire("hpJ0s");
const $ccba2b4e2894a74a$var$emptyAdfObject = (0, $clRM1.getEmptyADF)();
const $ccba2b4e2894a74a$export$11063e1f9210f191 = (node)=>{
    const { renderer: renderer } = node;
    if ((0, $h9Xzk.default)(node)) return undefined;
    const isPlainTextRenderer = renderer === (0, $57c87778b42e34da$export$a4a240cb4053b29f);
    const values = isPlainTextRenderer ? {
        value: (0, $hpJ0s.getPlainTextValue)(node)
    } : {
        adfValue: node.richText?.adfValue?.json || $ccba2b4e2894a74a$var$emptyAdfObject
    };
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        ...values,
        schema: {
            custom: (0, $3mZMJ.TEXT_AREA_CF_TYPE),
            renderer: renderer,
            type: (0, $3mZMJ.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            configuration: null,
            items: null
        }
    };
};

});
parcelRegister("clRM1", function(module, exports) {
$parcel$export(module.exports, "getEmptyADF", () => $5304529a0b87b9ee$export$d109ab46c9575565);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $i429R = parcelRequire("i429R");
const $5304529a0b87b9ee$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });

});
parcelRegister("i429R", function(module, exports) {
$parcel$export(module.exports, "isEmpty", () => $f633a00593707962$export$dd1bc94b04021eeb);
const $f633a00593707962$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;

});


parcelRegister("h9Xzk", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7b33a46f73dd986$export$2e2bcd8739ae039);

var $eSnSE = parcelRequire("eSnSE");
const $a7b33a46f73dd986$export$c63f561360bafed1 = 'issue.agg-field-transformers.missing-renderer';
// If the renderer is missing, log an error and return true.
// This was added as part of https://jplat.atlassian.net/browse/JIV-14881 to help identify why
// fields are sometimes missing the renderer.
const $a7b33a46f73dd986$var$isFieldMissingRenderer = (field)=>{
    try {
        // Narrow the type of field to fields with a renderer
        // @ts-expect-error TODO JPX-157
        if (!('renderer' in field)) return false;
        if (field?.renderer) return false;
        (0, $eSnSE.default).safeErrorWithoutCustomerData($a7b33a46f73dd986$export$c63f561360bafed1, `Field ${field.fieldId} of type ${field.__typename} has missing renderer: ${field.renderer}`);
        return true;
    } catch  {
        return false;
    }
};
var $a7b33a46f73dd986$export$2e2bcd8739ae039 = $a7b33a46f73dd986$var$isFieldMissingRenderer;

});

parcelRegister("hpJ0s", function(module, exports) {
$parcel$export(module.exports, "getPlainTextValue", () => $f231e7baf13c7424$export$2f3bc284556ec720);
$parcel$export(module.exports, "transformAggRichTextToLegacyField", () => $f231e7baf13c7424$export$e65ff2ce94be106e);

var $clRM1 = parcelRequire("clRM1");


var $dk7W5 = parcelRequire("dk7W5");

var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $f231e7baf13c7424$var$emptyAdfObject = (0, $clRM1.getEmptyADF)();
// @ts-expect-error TODO JPX-157
const $f231e7baf13c7424$var$getSchema = (aggType, renderer)=>{
    switch(aggType){
        case 0, $3mZMJ.TEXT_AREA_CF_TYPE:
            return {
                custom: aggType,
                renderer: renderer,
                type: (0, $3mZMJ.ISSUE_FIELD_STRING_CF_TYPE),
                system: null,
                configuration: null,
                items: null
            };
        case 0, $3mZMJ.DESCRIPTION_TYPE:
        case 0, $3mZMJ.ENVIRONMENT_TYPE:
        default:
            return {
                system: aggType,
                renderer: renderer,
                type: (0, $3mZMJ.ISSUE_FIELD_STRING_CF_TYPE),
                custom: null,
                configuration: null,
                items: null
            };
    }
};
const $f231e7baf13c7424$export$2f3bc284556ec720 = (node)=>{
    // When the field is empty and a value has never been set
    if (!node.richText) return null;
    // When the field has been set to a value, and then set back to empty
    if (node.richText?.plainText == null) return '';
    return node.richText?.plainText;
};
const $f231e7baf13c7424$export$e65ff2ce94be106e = (node)=>{
    // Description field always renders with ADF
    const { renderer: renderer } = node;
    if ((0, $h9Xzk.default)(node)) return undefined;
    const isPlainTextRenderer = node.type !== (0, $3mZMJ.DESCRIPTION_TYPE) && renderer === (0, $57c87778b42e34da$export$a4a240cb4053b29f);
    if (isPlainTextRenderer) return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: $f231e7baf13c7424$export$2f3bc284556ec720(node),
        schema: $f231e7baf13c7424$var$getSchema(node.type, renderer)
    };
    const adfValueJson = node.richText?.adfValue?.json ?? null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        // The usages of the collection is deprecated.
        adfValue: adfValueJson ? (0, $dk7W5.removeCollectionFromAdf)(adfValueJson) : $f231e7baf13c7424$var$emptyAdfObject,
        value: null,
        schema: $f231e7baf13c7424$var$getSchema(node.type, renderer)
    };
};

});


parcelRegister("A0nGG", function(module, exports) {
$parcel$export(module.exports, "transformAggConnectSingleSelectToLegacyField", () => $f44e8e94ee36a4ad$export$e44db7cf61369a28);


var $3mZMJ = parcelRequire("3mZMJ");

var $4cTDP = parcelRequire("4cTDP");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $f44e8e94ee36a4ad$var$transformAggConnectSingleSelectToLegacyFieldOld = (node)=>{
    let value = null;
    if (node.fieldOption != null) value = {
        id: parseInt(node.fieldOption?.optionId, 10),
        value: node.fieldOption?.value
    };
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: (0, $8Tw1Q.transformAggConnection)(node.connectSingleSelectFieldOptions, (0, $8Tw1Q.toLegacyConnectOption)),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $3mZMJ.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)
        }
    };
};
const $f44e8e94ee36a4ad$var$transformAggConnectSingleSelectToLegacyFieldNew = (node)=>{
    let value = null;
    if (node.fieldOption != null) value = {
        id: node.fieldOption.optionId,
        value: node.fieldOption.value ?? null,
        ari: node.fieldOption.id
    };
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: [],
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $3mZMJ.CONNECT_SELECT_CF_TYPE)
        }
    };
};
const $f44e8e94ee36a4ad$export$e44db7cf61369a28 = (node)=>{
    return (0, $4cTDP.fg)('dfo_remove_connect_single_select_field_options_agg') ? $f44e8e94ee36a4ad$var$transformAggConnectSingleSelectToLegacyFieldNew(node) : $f44e8e94ee36a4ad$var$transformAggConnectSingleSelectToLegacyFieldOld(node);
};

});

parcelRegister("9YIgG", function(module, exports) {
$parcel$export(module.exports, "transformAggConnectTextToLegacyField", () => $fb3ccbbdcae36154$export$dd05277f5aa90657);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $fb3ccbbdcae36154$export$dd05277f5aa90657 = (node)=>({
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            type: (0, $3mZMJ.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("78GMW", function(module, exports) {
$parcel$export(module.exports, "transformAggDataClassificationToLegacyField", () => $ed99b79bb25d8ed0$export$b5edfdc89a7a2932);

var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $ed99b79bb25d8ed0$export$b5edfdc89a7a2932 = (node)=>({
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        key: (0, $3mZMJ.DATA_CLASSIFICATION_TYPE),
        value: node,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            custom: null,
            system: null,
            type: (0, $3mZMJ.DATA_CLASSIFICATION_TYPE)
        }
    });

});

parcelRegister("atdJk", function(module, exports) {
$parcel$export(module.exports, "transformAggDatePickerToLegacyField", () => $4b9ed7131bec6e05$export$3d6e51d37c0454a9);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $4b9ed7131bec6e05$export$3d6e51d37c0454a9 = (node)=>{
    switch(node.type){
        case 0, $3mZMJ.DUE_DATE_TYPE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $3mZMJ.ISSUE_FIELD_DATE_CF_TYPE),
                    configuration: null,
                    system: node.type,
                    renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
                    custom: null,
                    items: null
                }
            };
        case 0, $3mZMJ.DATE_CF_TYPE:
        case 0, $3mZMJ.BASELINE_START_CF_TYPE:
        case 0, $3mZMJ.BASELINE_END_CF_TYPE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $3mZMJ.ISSUE_FIELD_DATE_CF_TYPE),
                    custom: node.type,
                    configuration: null,
                    renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("hWz6P", function(module, exports) {
$parcel$export(module.exports, "transformAggDateTimePickerToLegacyField", () => $1a0e6d673c934121$export$3de22f1277f0c239);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $1a0e6d673c934121$var$defaultSchema = {
    type: (0, $3mZMJ.ISSUE_FIELD_DATETIME_CF_TYPE),
    custom: null,
    system: null,
    configuration: null,
    items: null,
    renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f)
};
const $1a0e6d673c934121$export$3de22f1277f0c239 = (node)=>{
    switch(node.type){
        case 0, $3mZMJ.CREATED:
        case 0, $3mZMJ.UPDATED:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: node.dateTime || '',
                schema: {
                    ...$1a0e6d673c934121$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $3mZMJ.RESOLUTION_DATE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$1a0e6d673c934121$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $3mZMJ.DATETIME_CF_TYPE:
        case 0, $3mZMJ.FIRST_RESPONSE_DATE_CF_TYPE:
        case 0, $3mZMJ.REQUEST_FEEDBACK_DATE_CF_TYPE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$1a0e6d673c934121$var$defaultSchema,
                    custom: node.type
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("h6tdv", function(module, exports) {
$parcel$export(module.exports, "transformAggEpicLinkToLegacyField", () => $e459964244aebe6e$export$1311f30c94840aa2);

var $38IWH = parcelRequire("38IWH");

var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
// @ts-expect-error TODO JPX-157
const $e459964244aebe6e$var$transformJiraEpicToLegacyEpicLink = (epic)=>{
    if (epic == null) return null;
    return {
        id: Number(epic.issueId),
        key: epic.key || '',
        done: !!epic.done,
        name: epic.name || '',
        summary: epic.summary || '',
        color: {
            key: epic.color ?? (0, $38IWH.AgileColors).AGILE_COLOR_1
        },
        // This can only be set from cache handlers
        fromCache: false
    };
};
const $e459964244aebe6e$export$1311f30c94840aa2 = (node)=>{
    if (node.type !== (0, $3mZMJ.EPIC_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl,
        value: $e459964244aebe6e$var$transformJiraEpicToLegacyEpicLink(node.epic),
        schema: {
            configuration: null,
            items: null,
            renderer: 'jira-text-renderer',
            type: 'any',
            custom: (0, $3mZMJ.EPIC_TYPE),
            system: null
        }
    };
};

});

parcelRegister("5IGk7", function(module, exports) {
$parcel$export(module.exports, "transformAggFlagToLegacyField", () => $a3532dc678d08ada$export$31555b6ea19f4c2);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $a3532dc678d08ada$var$transformJiraFlagToLegacyFlag = (flag)=>{
    if (flag == null || flag.isFlagged == null) return null;
    return [
        {
            value: flag.isFlagged
        }
    ];
};
const $a3532dc678d08ada$export$31555b6ea19f4c2 = (node)=>{
    // Agg flag field comes back as multichecbox CF type instead of current graphql flagged CF type
    if (node.type !== (0, $3mZMJ.MULTI_CHECKBOXES_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: $a3532dc678d08ada$var$transformJiraFlagToLegacyFlag(node.flag),
        schema: {
            configuration: null,
            custom: (0, $3mZMJ.FLAGGED_CF_TYPE),
            items: 'option',
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("aPcUN", function(module, exports) {
$parcel$export(module.exports, "transformAggForgeDateToLegacyField", () => $45d2a807fecba84f$export$30fccfce22948120);

var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $45d2a807fecba84f$export$30fccfce22948120 = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.date,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $3mZMJ.ISSUE_FIELD_DATE_CF_TYPE)
        }
    };
};

});

parcelRegister("1ZZyu", function(module, exports) {
$parcel$export(module.exports, "transformAggForgeDateTimeToLegacyField", () => $e0a4b577749ae3db$export$61b1f0cbd04c7b9c);

var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $e0a4b577749ae3db$export$61b1f0cbd04c7b9c = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.dateTime,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $3mZMJ.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    };
};

});

parcelRegister("dTYkW", function(module, exports) {
$parcel$export(module.exports, "transformAggForgeGroupToLegacyField", () => $6c830c67e2d50cb9$export$60b03d63015cbb9f);

var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $6c830c67e2d50cb9$export$60b03d63015cbb9f = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.selectedGroup ? {
            name: node.selectedGroup.name
        } : null,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $3mZMJ.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE)
        }
    };
};

});

parcelRegister("esMH6", function(module, exports) {
$parcel$export(module.exports, "transformAggForgeGroupsToLegacyField", () => $09a4b6c46d9b3fa9$export$2dfa4944fba5d1f5);

var $3mZMJ = parcelRequire("3mZMJ");

var $h9Xzk = parcelRequire("h9Xzk");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $09a4b6c46d9b3fa9$export$2dfa4944fba5d1f5 = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    const value = node.selectedGroupsConnection?.edges?.length ? (0, $8Tw1Q.transformAggConnection)(node.selectedGroupsConnection, ({ name: name })=>({
            name: name
        })) : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $3mZMJ.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $3mZMJ.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("hqVWW", function(module, exports) {
$parcel$export(module.exports, "transformAggForgeNumberToLegacyField", () => $19fcb5a1ca2a0e66$export$5dab8986dc45db07);

var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $19fcb5a1ca2a0e66$export$5dab8986dc45db07 = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.number,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $3mZMJ.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    };
};

});

parcelRegister("eDXnT", function(module, exports) {
$parcel$export(module.exports, "transformAggForgeObjectToLegacyField", () => $84e4daeebd05036a$export$fbdabdbae2a203b9);

var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $84e4daeebd05036a$export$fbdabdbae2a203b9 = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    const value = (()=>{
        if (node.object == null) return null;
        try {
            return JSON.parse(node.object);
        } catch (e) {
            throw new Error('Failed to transform forge object field: node.object was invalid JSON object');
        }
    })();
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $3mZMJ.ISSUE_FIELD_OBJECT_CF_TYPE)
        }
    };
};

});

parcelRegister("gmqe0", function(module, exports) {
$parcel$export(module.exports, "transformAggForgeStringToLegacyField", () => $ac8fda7c9b1a7eca$export$3a581fb4b3e578bd);

var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $ac8fda7c9b1a7eca$export$3a581fb4b3e578bd = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $3mZMJ.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("95NMG", function(module, exports) {
$parcel$export(module.exports, "transformAggForgeStringsToLegacyField", () => $8d8cd734e91ff053$export$418a06cb5dc6aba5);

var $3mZMJ = parcelRequire("3mZMJ");

var $h9Xzk = parcelRequire("h9Xzk");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $8d8cd734e91ff053$export$418a06cb5dc6aba5 = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    const hasValue = Boolean(node.selectedLabelsConnection?.edges?.length);
    const value = hasValue ? (0, $8Tw1Q.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name) : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: (0, $3mZMJ.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $3mZMJ.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("kctB6", function(module, exports) {
$parcel$export(module.exports, "transformAggForgeUserToLegacyField", () => $0fbafb49b1bf00d7$export$bc73c7a747f907e5);

var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");

var $74RuE = parcelRequire("74RuE");
const $0fbafb49b1bf00d7$export$bc73c7a747f907e5 = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $74RuE.transformJiraUserToLegacyServerUser)(node.user) : null,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $3mZMJ.ISSUE_FIELD_USER_CF_TYPE)
        }
    };
};

});
parcelRegister("74RuE", function(module, exports) {
$parcel$export(module.exports, "transformJiraUserToLegacyServerUser", () => $e296ae9d66be02be$export$d7b231260a016eaf);

var $4cTDP = parcelRequire("4cTDP");

// @ts-expect-error TODO JPX-157
const $e296ae9d66be02be$var$getAccountType = (objectType)=>{
    switch(objectType){
        case 'AtlassianAccountUser':
            return 0, $02cc0dbe6f88e777$export$981400c14dd99bc0;
        case 'CustomerUser':
            return 0, $02cc0dbe6f88e777$export$2823897fb92cd040;
        case 'AppUser':
            return 0, $02cc0dbe6f88e777$export$1973ca62b6c5abfe;
        default:
            return 0, $02cc0dbe6f88e777$export$d1f5101c0939e3fe;
    }
};
// @ts-expect-error TODO JPX-157
const $e296ae9d66be02be$var$generateAvatarUrls = (url)=>({
        '16x16': url,
        '24x24': url,
        '32x32': url,
        '48x48': url
    });
const $e296ae9d66be02be$export$d7b231260a016eaf = (user)=>{
    if (!user) return null;
    const userOptionalKeysMap = {
        emailAddress: 'email',
        locale: 'locale',
        timeZone: 'zoneinfo'
    };
    const optionalValues = {};
    Object.entries(userOptionalKeysMap).forEach(([key, aggKey])=>{
        const aggValue = user[aggKey];
        if (aggValue !== undefined && aggValue !== null) // @ts-expect-error TODO JPX-157
        optionalValues[key] = aggValue;
    });
    // legacy user always assumes that avatarUrls are generated, even if it is undefined
    const avatars = user.picture != null ? {
        avatarUrl: user.picture,
        avatarUrls: $e296ae9d66be02be$var$generateAvatarUrls(user.picture)
    } : {
        avatarUrls: (0, $4cTDP.fg)('remove-user-rest-api') ? $e296ae9d66be02be$var$generateAvatarUrls(user.picture) : undefined
    };
    return {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ...avatars,
        ...optionalValues,
        accountId: user.accountId,
        accountType: $e296ae9d66be02be$var$getAccountType(user.__typename),
        active: user.accountStatus === 'active',
        displayName: user.name
    };
};

});
const $02cc0dbe6f88e777$export$981400c14dd99bc0 = 'atlassian';
const $02cc0dbe6f88e777$export$2823897fb92cd040 = 'customer';
const $02cc0dbe6f88e777$export$1973ca62b6c5abfe = 'app';
const $02cc0dbe6f88e777$export$d1f5101c0939e3fe = 'unknown';



parcelRegister("lBZeI", function(module, exports) {
$parcel$export(module.exports, "transformAggForgeUsersToLegacyField", () => $312acaf5adbb266a$export$bbfea2e2f2c853b8);

var $3mZMJ = parcelRequire("3mZMJ");

var $h9Xzk = parcelRequire("h9Xzk");

var $74RuE = parcelRequire("74RuE");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $312acaf5adbb266a$export$bbfea2e2f2c853b8 = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    const value = node.selectedUsersConnection?.edges?.length ? (0, $8Tw1Q.transformAggConnection)(node.selectedUsersConnection, (0, $74RuE.transformJiraUserToLegacyServerUser)) : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $3mZMJ.ISSUE_FIELD_USER_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $3mZMJ.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("bl4cc", function(module, exports) {
$parcel$export(module.exports, "transformAggGoalsToLegacyField", () => $c42fa72110704597$export$158301a02ae4cbe7);

var $3mZMJ = parcelRequire("3mZMJ");

var $4cTDP = parcelRequire("4cTDP");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $c42fa72110704597$export$158301a02ae4cbe7 = (node)=>{
    if (node.type !== (0, $3mZMJ.GOALS_CF_TYPE)) return undefined;
    const isShowAllGoals = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4cTDP.fg)('jira-preview-panel-goals-integration') && (0, $4cTDP.fg)('jira_preview_panel_m_1_rollout') && (0, $4cTDP.fg)('jira-glance-panel');
    const activeSelectedGoals = isShowAllGoals ? node.selectedGoalsShowAllGoals : node.selectedGoals;
    const value = activeSelectedGoals ? {
        goals: activeSelectedGoals?.edges?.filter((edge)=>edge?.node !== null).map((edge)=>{
            const transformedNode = edge?.node;
            const result = {
                id: transformedNode?.id || '',
                name: transformedNode?.name || '',
                status: transformedNode?.status || null
            };
            // Include key for multi-goal case (key field is only available in selectedGoalsShowAllGoals)
            if (isShowAllGoals && transformedNode) {
                const nodeWithKey = transformedNode;
                // @ts-expect-error TODO JPX-157
                if (nodeWithKey.key) // @ts-expect-error TODO JPX-157
                result.key = nodeWithKey.key;
            }
            return result;
        }) || [],
        totalCount: activeSelectedGoals?.totalCount || 0
    } : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $3mZMJ.GOALS_CF_TYPE),
            items: null,
            renderer: null,
            system: null,
            type: (0, $3mZMJ.GOALS_CF_TYPE)
        }
    };
};

});

parcelRegister("5D0JM", function(module, exports) {
$parcel$export(module.exports, "transformAggAtlasProjectToLegacyField", () => $0d76d3a26211bd5e$export$f66d49f5acf303b3);

var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $0d76d3a26211bd5e$export$f66d49f5acf303b3 = (node)=>{
    if (node.type !== (0, $3mZMJ.ATLAS_PROJECT_CF_TYPE)) return undefined;
    const selectedProject = node.project;
    const value = selectedProject ? {
        project: selectedProject
    } : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $3mZMJ.ATLAS_PROJECT_CF_TYPE),
            items: null,
            renderer: null,
            system: null,
            type: (0, $3mZMJ.ATLAS_PROJECT_CF_TYPE)
        }
    };
};

});

parcelRegister("fj4N6", function(module, exports) {
$parcel$export(module.exports, "transformAggIssueRestrictionToLegacyField", () => $23256e2230655f0b$export$62db794d5816e28e);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
// @ts-expect-error TODO JPX-157
const $23256e2230655f0b$var$transformJiraRoleToRestriction = (role)=>{
    if (role == null) return null;
    return {
        restrictionValue: role.roleId
    };
};
const $23256e2230655f0b$export$62db794d5816e28e = (node, projectContext)=>{
    if (node.type !== (0, $3mZMJ.ISSUE_RESTRICTION_TYPE)) return undefined;
    const roles = (0, $8Tw1Q.transformAggConnection)(node.selectedRolesConnection, $23256e2230655f0b$var$transformJiraRoleToRestriction);
    const restrictions = roles.length > 0 ? {
        projectrole: roles
    } : {};
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: {
            shouldDisplay: projectContext?.canSetIssueRestriction === true,
            issuerestrictions: restrictions
        },
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            type: (0, $3mZMJ.ISSUE_RESTRICTION_TYPE),
            custom: null,
            system: node.type
        }
    };
};

});

parcelRegister("7Elqr", function(module, exports) {
$parcel$export(module.exports, "getSystemAggJiraIssueType", () => $b196dfe2103ffd7c$export$b4644a0cc2f2935e);
$parcel$export(module.exports, "transformJiraIssueTypeToLegacyIssueType", () => $b196dfe2103ffd7c$export$2356062173546155);
$parcel$export(module.exports, "transformAggIssueTypeToLegacyField", () => $b196dfe2103ffd7c$export$de2eb3b47c7c887b);


var $dw68i = parcelRequire("dw68i");

var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $b196dfe2103ffd7c$export$d95e76b2d065f98d = {
    avatarId: 0,
    self: ''
};
const $b196dfe2103ffd7c$export$b4644a0cc2f2935e = (fields)=>{
    const issueTypeField = fields?.find(// @ts-expect-error TODO JPX-157
    (edge)=>edge?.node != null && edge.node.__typename === (0, $3mZMJ.ISSUE_TYPE_GQL_FIELD) && edge.node.type === (0, $3mZMJ.ISSUE_TYPE))?.node;
    if (issueTypeField == null || issueTypeField.__typename !== (0, $3mZMJ.ISSUE_TYPE_GQL_FIELD) || issueTypeField.type !== (0, $3mZMJ.ISSUE_TYPE)) throw new Error(`Failed to get system issue type: ${(0, $3mZMJ.ISSUE_TYPE_GQL_FIELD)} with ${(0, $3mZMJ.ISSUE_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (issueTypeField.issueType == null) throw new Error(`Failed to get system issue type: ${(0, $3mZMJ.ISSUE_TYPE_GQL_FIELD)}.issueType is missing [${JSON.stringify(issueTypeField)}]`);
    return issueTypeField.issueType;
};
const $b196dfe2103ffd7c$export$2356062173546155 = (issueType)=>{
    const id = issueType.issueTypeId;
    const hierarchyLevel = issueType.hierarchy?.level;
    return {
        ...$b196dfe2103ffd7c$export$d95e76b2d065f98d,
        id: id,
        iconUrl: issueType.avatar?.medium ?? '',
        name: issueType.name,
        description: 'description' in issueType && issueType.description != null ? issueType.description : '',
        hierarchyLevel: hierarchyLevel,
        subtask: hierarchyLevel === (0, $dw68i.ISSUE_TYPE_HIERARCHY_LEVEL).SUBTASK_LEVEL
    };
};
const $b196dfe2103ffd7c$export$de2eb3b47c7c887b = (node)=>{
    if (node.type !== (0, $3mZMJ.ISSUE_TYPE) || node.issueType == null) throw new Error(`Failed to transform ${(0, $3mZMJ.ISSUE_TYPE_GQL_FIELD)}: type is not ${(0, $3mZMJ.ISSUE_TYPE)} or 'issueType' is empty [${JSON.stringify(node)}]`);
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: $b196dfe2103ffd7c$export$2356062173546155(node.issueType),
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            system: (0, $3mZMJ.ISSUE_TYPE),
            type: (0, $3mZMJ.ISSUE_TYPE)
        }
    };
};

});
parcelRegister("dw68i", function(module, exports) {
$parcel$export(module.exports, "ISSUE_TYPE_HIERARCHY_LEVEL", () => $5cd5fafa31a3d7de$export$2fe6880f0073407c);

var $auYul = parcelRequire("auYul");
const $5cd5fafa31a3d7de$export$2fe6880f0073407c = {
    SUBTASK_LEVEL: (0, $auYul.ISSUE_HIERARCHY_LEVEL_SUBTASK),
    BASE_LEVEL: (0, $auYul.ISSUE_HIERARCHY_LEVEL_BASE),
    LEVEL_ONE: (0, $auYul.ISSUE_HIERARCHY_LEVEL_EPIC),
    LEVEL_TWO: 2
};

});
parcelRegister("auYul", function(module, exports) {
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_GOAL", () => $038e186eb3ddfbdc$export$2294cfc7730248df);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_STRATEGY", () => $038e186eb3ddfbdc$export$961a1d6da881600c);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_INITIATIVE", () => $038e186eb3ddfbdc$export$e11dea67b88ee556);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_EPIC", () => $038e186eb3ddfbdc$export$9ad20e435294162a);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_BASE", () => $038e186eb3ddfbdc$export$a454b3474c5ee5f5);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_SUBTASK", () => $038e186eb3ddfbdc$export$b69c1b48ce8f83de);
$parcel$export(module.exports, "BASE_HIERARCHY_TYPE", () => $038e186eb3ddfbdc$export$ba7c785763a2a58f);
$parcel$export(module.exports, "CHILD_HIERARCHY_TYPE", () => $038e186eb3ddfbdc$export$e09d07f2dcff2603);
$parcel$export(module.exports, "PARENT_HIERARCHY_TYPE", () => $038e186eb3ddfbdc$export$1165245f61159842);
$parcel$export(module.exports, "EPIC_PARENT_HIERARCHY_TYPE", () => $038e186eb3ddfbdc$export$8a96a83b3f957e58);
$parcel$export(module.exports, "toHierarchyLevel", () => $038e186eb3ddfbdc$export$c0c893ca5ccae9dd);
$parcel$export(module.exports, "isBaseHierarchyLevel", () => $038e186eb3ddfbdc$export$bcf91a9d8c5b0f58);
$parcel$export(module.exports, "isEpicHierarchyLevel", () => $038e186eb3ddfbdc$export$e415cf60723c7aae);
$parcel$export(module.exports, "isAboveEpicHierarchyLevel", () => $038e186eb3ddfbdc$export$d36b0df47d4d621c);
$parcel$export(module.exports, "isSubtaskHierarchyLevel", () => $038e186eb3ddfbdc$export$41f00a40e2ebd6e8);
$parcel$export(module.exports, "getHierarchyLevelType", () => $038e186eb3ddfbdc$export$556b686fea6fb229);
$parcel$export(module.exports, "getHierarchyLevelTypeSplitEpicFromCustom", () => $038e186eb3ddfbdc$export$638ac52227e67c8);
const $038e186eb3ddfbdc$export$2294cfc7730248df = 4;
const $038e186eb3ddfbdc$export$961a1d6da881600c = 3;
const $038e186eb3ddfbdc$export$e11dea67b88ee556 = 2;
const $038e186eb3ddfbdc$export$9ad20e435294162a = 1;
const $038e186eb3ddfbdc$export$a454b3474c5ee5f5 = 0;
const $038e186eb3ddfbdc$export$b69c1b48ce8f83de = -1;
const $038e186eb3ddfbdc$export$ba7c785763a2a58f = 'BASE';
const $038e186eb3ddfbdc$export$e09d07f2dcff2603 = 'CHILD';
const $038e186eb3ddfbdc$export$1165245f61159842 = 'PARENT';
const $038e186eb3ddfbdc$export$8a96a83b3f957e58 = 'EPIC';
const $038e186eb3ddfbdc$export$c0c893ca5ccae9dd = (level)=>level;
const $038e186eb3ddfbdc$export$bcf91a9d8c5b0f58 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return true;
    return numericLevel === $038e186eb3ddfbdc$export$a454b3474c5ee5f5;
};
const $038e186eb3ddfbdc$export$e415cf60723c7aae = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $038e186eb3ddfbdc$export$9ad20e435294162a;
};
const $038e186eb3ddfbdc$export$d36b0df47d4d621c = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel > $038e186eb3ddfbdc$export$9ad20e435294162a;
};
const $038e186eb3ddfbdc$export$41f00a40e2ebd6e8 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $038e186eb3ddfbdc$export$b69c1b48ce8f83de;
};
const $038e186eb3ddfbdc$export$556b686fea6fb229 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) > 0) return $038e186eb3ddfbdc$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $038e186eb3ddfbdc$export$e09d07f2dcff2603;
    return $038e186eb3ddfbdc$export$ba7c785763a2a58f;
};
const $038e186eb3ddfbdc$export$638ac52227e67c8 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) === 1) return $038e186eb3ddfbdc$export$8a96a83b3f957e58;
    if (Number(hierarchyLevel) > 1) return $038e186eb3ddfbdc$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $038e186eb3ddfbdc$export$e09d07f2dcff2603;
    return $038e186eb3ddfbdc$export$ba7c785763a2a58f;
};

});



parcelRegister("eC8dc", function(module, exports) {
$parcel$export(module.exports, "transformAggJSMApprovalsToLegacyField", () => $a2eea09779371a38$export$b14d30f2a9e4c343);

var $2QZBX = parcelRequire("2QZBX");

var $7Fjpe = parcelRequire("7Fjpe");

var $3mZMJ = parcelRequire("3mZMJ");

var $74RuE = parcelRequire("74RuE");

var $8Tw1Q = parcelRequire("8Tw1Q");
// @ts-expect-error TODO JPX-157
const $a2eea09779371a38$var$transformApproverPrincipalsToLegacy = (approverPrincipal)=>{
    if (!approverPrincipal) return undefined;
    switch(approverPrincipal.__typename){
        case 0, $3mZMJ.JSM_USER_APPROVER_PRINCIPAL_FIELD:
            if (!approverPrincipal.user) return undefined;
            return {
                id: (0, $2QZBX.toAccountId)(approverPrincipal.user.accountId),
                name: approverPrincipal.user.name,
                meta: {
                    jiraRest: approverPrincipal.jiraRest ?? ''
                },
                type: 'user',
                avatarUrl: approverPrincipal.user.picture
            };
        case 0, $3mZMJ.JSM_GROUP_APPROVER_PRINCIPAL_FIELD:
            if (!approverPrincipal.groupId) return undefined;
            return {
                id: (0, $7Fjpe.toGroupId)(approverPrincipal.groupId),
                meta: {
                    memberCount: approverPrincipal.memberCount || 0,
                    approvedCount: approverPrincipal.approvedCount || 0
                },
                name: approverPrincipal.name || '',
                type: 'group'
            };
        default:
            return undefined;
    }
};
// @ts-expect-error TODO JPX-157
const $a2eea09779371a38$var$getApproverDecision = (decision)=>{
    switch(decision){
        case 0, $7Fjpe.APPROVER_APPROVED:
            return 0, $7Fjpe.APPROVER_APPROVED;
        case 0, $7Fjpe.APPROVER_DECLINED:
            return 0, $7Fjpe.APPROVER_DECLINED;
        case 0, $7Fjpe.APPROVER_PENDING:
        default:
            return 0, $7Fjpe.APPROVER_PENDING;
    }
};
// @ts-expect-error TODO JPX-157
const $a2eea09779371a38$var$transformApproverToLegacy = (approvalNode)=>{
    if (!approvalNode) return undefined;
    const approver = (0, $74RuE.transformJiraUserToLegacyServerUser)(approvalNode.approver);
    if (!approver) return undefined;
    return {
        approverDecision: $a2eea09779371a38$var$getApproverDecision(approvalNode.approverDecision),
        approver: approver
    };
};
// @ts-expect-error TODO JPX-157
const $a2eea09779371a38$var$transformConfigurationToLegacy = (configurations)=>{
    // This function contains a lot of null checks and default empty values to satisfy flow because
    // the AGG type coming back is in the shape of [JiraServiceManagementApprovalConfiguration]
    // Which means technically it can be an empty array. Even though we will always only ever
    // get 1 object back.
    const { approversConfigurations: approversConfigurations = [], condition: condition } = configurations?.[0] || {};
    const approverConfiguration = approversConfigurations?.[0];
    return {
        approvers: {
            type: approverConfiguration?.type ?? '',
            customFieldName: approverConfiguration?.fieldName ?? '',
            customFieldId: approverConfiguration?.fieldId ?? ''
        },
        condition: {
            type: condition?.type ?? '',
            value: condition?.value ?? ''
        }
    };
};
// @ts-expect-error TODO JPX-157
const $a2eea09779371a38$var$transformDateToLegacy = (date)=>({
        epochMillis: date ? new Date(date).valueOf() : -1
    });
// @ts-expect-error TODO JPX-157
const $a2eea09779371a38$var$transformStatusToLegacy = (status)=>({
        name: status.name || '',
        category: Number(status.categoryId)
    });
// @ts-expect-error TODO JPX-157
const $a2eea09779371a38$var$transformActiveApprovalToLegacy = (activeApproval)=>{
    const { id: id, configurations: configurations, status: status, createdDate: createdDate, canAnswerApproval: canAnswerApproval, pendingApprovalCount: pendingApprovalCount, name: name, finalDecision: finalDecision, approvalState: approvalState, approvedStatus: approvedStatus } = activeApproval;
    return {
        id: id,
        approvalState: approvalState,
        approvedStatus: approvedStatus,
        finalDecision: $a2eea09779371a38$var$getApproverDecision(finalDecision),
        name: name,
        pendingApprovalCount: pendingApprovalCount,
        canAnswerApproval: canAnswerApproval,
        approverPrincipals: (0, $8Tw1Q.transformAggConnection)(activeApproval.approverPrincipals, $a2eea09779371a38$var$transformApproverPrincipalsToLegacy),
        approvers: (0, $8Tw1Q.transformAggConnection)(activeApproval.approvers, $a2eea09779371a38$var$transformApproverToLegacy),
        configuration: $a2eea09779371a38$var$transformConfigurationToLegacy(configurations),
        createdDate: $a2eea09779371a38$var$transformDateToLegacy(createdDate ?? ''),
        decisions: (0, $8Tw1Q.transformAggConnection)(activeApproval.decisions, $a2eea09779371a38$var$transformApproverToLegacy),
        excludedApprovers: (0, $8Tw1Q.transformAggConnection)(activeApproval.excludedApprovers, (0, $74RuE.transformJiraUserToLegacyServerUser)),
        status: status ? $a2eea09779371a38$var$transformStatusToLegacy(status) : null
    };
};
// @ts-expect-error TODO JPX-157
const $a2eea09779371a38$var$transformCompletedApprovalToLegacy = (completedApproval)=>{
    if (!completedApproval) return undefined;
    const { id: id, name: name, finalDecision: finalDecision, createdDate: createdDate, completedDate: completedDate, status: status } = completedApproval;
    return {
        id: id,
        name: name,
        finalDecision: $a2eea09779371a38$var$getApproverDecision(finalDecision),
        createdDate: $a2eea09779371a38$var$transformDateToLegacy(createdDate ?? ''),
        completedDate: $a2eea09779371a38$var$transformDateToLegacy(completedDate),
        status: status ? $a2eea09779371a38$var$transformStatusToLegacy(status) : null,
        approvers: (0, $8Tw1Q.transformAggConnection)(completedApproval.approvers, $a2eea09779371a38$var$transformApproverToLegacy)
    };
};
const $a2eea09779371a38$export$b14d30f2a9e4c343 = (node)=>{
    if (node.type !== (0, $3mZMJ.SERVICEDESK_APPROVAL_TYPE)) return undefined;
    const activeApproval = node.activeApproval ? {
        activeApproval: $a2eea09779371a38$var$transformActiveApprovalToLegacy(node.activeApproval)
    } : {};
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: {
            ...activeApproval,
            completedApprovals: (0, $8Tw1Q.transformAggConnection)(node.completedApprovalsConnection, $a2eea09779371a38$var$transformCompletedApprovalToLegacy)
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $3mZMJ.SERVICEDESK_APPROVAL_TYPE),
            type: (0, $3mZMJ.SERVICEDESK_APPROVAL_TYPE)
        }
    };
};

});
parcelRegister("7Fjpe", function(module, exports) {
$parcel$export(module.exports, "toGroupId", () => $b33e09415d64a4c5$export$779c261480444a4d);
$parcel$export(module.exports, "APPROVER_PENDING", () => $b33e09415d64a4c5$export$3b59c4db06f5829b);
$parcel$export(module.exports, "APPROVER_APPROVED", () => $b33e09415d64a4c5$export$e17ae8ca1010e2a4);
$parcel$export(module.exports, "APPROVER_DECLINED", () => $b33e09415d64a4c5$export$b5a0d270c9cd7435);
$parcel$export(module.exports, "APPROVAL_OK", () => $b33e09415d64a4c5$export$2e6187b6a4348938);
const $b33e09415d64a4c5$export$779c261480444a4d = (x)=>x;
const $b33e09415d64a4c5$export$3b59c4db06f5829b = 'pending';
const $b33e09415d64a4c5$export$e17ae8ca1010e2a4 = 'approved';
const $b33e09415d64a4c5$export$b5a0d270c9cd7435 = 'declined';
const $b33e09415d64a4c5$export$2e6187b6a4348938 = 'OK';
const $b33e09415d64a4c5$export$b5d660d719b8009 = 'INSUFFICIENT_APPROVERS';

});


parcelRegister("7Qjvd", function(module, exports) {
$parcel$export(module.exports, "transformAggJSMEntitlementsToLegacyField", () => $3e00182679906144$export$850fadda8a5e6f27);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $3e00182679906144$export$850fadda8a5e6f27 = (node)=>{
    if (node.type !== (0, $3mZMJ.ENTITLEMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.selectedEntitlement,
        schema: {
            configuration: null,
            custom: (0, $3mZMJ.ENTITLEMENT_CF_TYPE),
            items: (0, $3mZMJ.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("iHCXo", function(module, exports) {
$parcel$export(module.exports, "transformAggJSMMajorIncidentToLegacyField", () => $c7ffd6a8a8025014$export$d4e0b2288fb31144);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $c7ffd6a8a8025014$export$d4e0b2288fb31144 = (node)=>({
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.majorIncident,
        renderedValue: null,
        configuration: {},
        schema: {
            configuration: null,
            custom: (0, $3mZMJ.MAJOR_INCIDENT_CF_TYPE),
            items: null,
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            system: null,
            type: (0, $3mZMJ.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("2ZqHG", function(module, exports) {
$parcel$export(module.exports, "transformAggJSMOrganizationToLegacyField", () => $2d322beb8f2cd6d6$export$7bd14951253a7c5f);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $2d322beb8f2cd6d6$export$7bd14951253a7c5f = (node)=>{
    if (node.type !== (0, $3mZMJ.ORGANIZATIONS_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: (0, $8Tw1Q.transformAggConnection)(node.selectedOrganizationsConnection, (selectedNode)=>({
                id: selectedNode.organizationId,
                name: selectedNode.organizationName
            })),
        schema: {
            configuration: null,
            custom: (0, $3mZMJ.ORGANIZATIONS_CF_TYPE),
            items: 'sd-customerorganization',
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("kk6ni", function(module, exports) {
$parcel$export(module.exports, "transformAggJCSOrganizationToLegacyField", () => $3d5c3716e18b39d8$export$81bfe5b16f9be413);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $3d5c3716e18b39d8$export$81bfe5b16f9be413 = (node)=>{
    if (node.type !== (0, $3mZMJ.ORGANIZATION_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.selectedOrganization,
        schema: {
            configuration: null,
            custom: (0, $3mZMJ.ORGANIZATION_CF_TYPE),
            items: 'sd-customerorganization',
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("5x8Qz", function(module, exports) {
$parcel$export(module.exports, "transformAggJSMRequestFeedbackToLegacyField", () => $7269440389468f87$export$c52c6988b335096);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $7269440389468f87$export$c52c6988b335096 = (node)=>{
    if (node.type !== (0, $3mZMJ.REQUEST_FEEDBACK_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.feedback,
        schema: {
            type: 'sd-feedback',
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            custom: (0, $3mZMJ.REQUEST_FEEDBACK_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("5A5gO", function(module, exports) {
$parcel$export(module.exports, "transformAggJSMRequestLanguageToLegacyField", () => $cf1d539f2192cd8b$export$6a53240e225f742);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $cf1d539f2192cd8b$export$6a53240e225f742 = (node)=>{
    if (node.type !== (0, $3mZMJ.REQUEST_LANGUAGE_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.language,
        allowedValues: [
            ...node.languages ?? []
        ],
        schema: {
            type: 'sd-request-lang',
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            custom: (0, $3mZMJ.REQUEST_LANGUAGE_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("fw41c", function(module, exports) {
$parcel$export(module.exports, "transformAggJSMRequestTypeToLegacyField", () => $cd769e66cd433490$export$5ffaab1383177efa);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
// @ts-expect-error TODO JPX-157
const $cd769e66cd433490$var$transformRequestTypeToLegacy = (requestType)=>{
    if (!requestType) return null;
    return {
        requestType: {
            id: parseInt(requestType.requestTypeId, 10),
            issueTypeId: requestType.issueType?.issueTypeId || '',
            name: requestType.name || '',
            icon: {
                _links: {
                    iconUrls: {
                        '48x48': requestType.avatar?.large || ''
                    }
                }
            }
        }
    };
};
const $cd769e66cd433490$export$5ffaab1383177efa = (node)=>{
    if (node.type !== (0, $3mZMJ.REQUEST_TYPE_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: $cd769e66cd433490$var$transformRequestTypeToLegacy(node.requestType),
        schema: {
            configuration: null,
            custom: (0, $3mZMJ.REQUEST_TYPE_CF_TYPE),
            items: null,
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            system: null,
            type: 'sd-customerrequesttype'
        }
    };
};

});

parcelRegister("8H6KM", function(module, exports) {
$parcel$export(module.exports, "transformAggJSMRespondersToLegacyField", () => $eb05aff33486cf5e$export$5171c4d1ae5bcde5);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
// @ts-expect-error TODO JPX-157
const $eb05aff33486cf5e$var$transformJiraResponderToLegacyResponder = (responder)=>{
    if (responder == null) return undefined;
    switch(responder.__typename){
        case 0, $3mZMJ.JSM_USER_RESPONDER_GQL_FIELD:
            if (responder.user === null) return undefined;
            return {
                ari: responder.user.canonicalAccountId,
                avatarUrl: responder.user.picture,
                name: responder.user.name,
                type: 'user'
            };
        case 0, $3mZMJ.JSM_TEAM_RESPONDER_FIELD:
            return {
                ari: responder.teamId,
                name: responder.teamName,
                type: 'team'
            };
        default:
            return undefined;
    }
};
const $eb05aff33486cf5e$export$5171c4d1ae5bcde5 = (node)=>{
    if (node.type !== (0, $3mZMJ.RESPONDERS_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: (0, $8Tw1Q.transformAggConnection)(node.respondersConnection, $eb05aff33486cf5e$var$transformJiraResponderToLegacyResponder),
        schema: {
            configuration: null,
            custom: (0, $3mZMJ.RESPONDERS_CF_TYPE),
            items: (0, $3mZMJ.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("iyjVB", function(module, exports) {
$parcel$export(module.exports, "transformAggJSMSentimentToLegacyField", () => $6924b07eb4bc26b7$export$702d3754a4c7d90a);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $6924b07eb4bc26b7$export$702d3754a4c7d90a = (node)=>{
    if (node.type !== (0, $3mZMJ.SENTIMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.sentiment,
        schema: {
            configuration: null,
            custom: (0, $3mZMJ.SENTIMENT_CF_TYPE),
            items: (0, $3mZMJ.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("lMiiC", function(module, exports) {
$parcel$export(module.exports, "transformAggLabelsNodeToLegacyField", () => $b41f86ecf5e4d228$export$98e4f56e2e6c44fe);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $b41f86ecf5e4d228$var$defaultSchema = {
    configuration: null,
    items: 'string',
    type: (0, $3mZMJ.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
    renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f)
};
const $b41f86ecf5e4d228$export$98e4f56e2e6c44fe = (node)=>{
    const selectedLabels = (0, $8Tw1Q.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name);
    switch(node.type){
        case 0, $3mZMJ.LABELS_TYPE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: selectedLabels,
                schema: {
                    ...$b41f86ecf5e4d228$var$defaultSchema,
                    custom: null,
                    system: node.type
                }
            };
        case 0, $3mZMJ.LABELS_CF_TYPE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                // empty value for custom labels field is null while system labels field is `[]`
                value: selectedLabels.length === 0 ? null : selectedLabels,
                schema: {
                    ...$b41f86ecf5e4d228$var$defaultSchema,
                    custom: node.type,
                    system: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("gFEWP", function(module, exports) {
$parcel$export(module.exports, "transformAggMultiGroupPickerToLegacyField", () => $643b7d371a35e493$export$f968da580693597d);


var $8Tw1Q = parcelRequire("8Tw1Q");
const $643b7d371a35e493$export$f968da580693597d = (node)=>{
    const value = (0, $8Tw1Q.transformAggConnection)(node.selectedGroupsConnection, (groupNode)=>({
            groupId: groupNode.groupId,
            name: groupNode.name
        }));
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            type: 'array',
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: 'group',
            configuration: null
        }
    };
};

});

parcelRegister("a0aZw", function(module, exports) {
$parcel$export(module.exports, "transformAggMultipleSelectToLegacyField", () => $3dd5c1f07e748aa4$export$869fb8fbcb97e0ee);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $3dd5c1f07e748aa4$export$869fb8fbcb97e0ee = (node)=>{
    switch(node.type){
        case 0, $3mZMJ.MULTI_SELECT_CF_TYPE:
            {
                const value = (0, $8Tw1Q.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: [],
                    schema: {
                        type: 'array',
                        renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("7pxBz", function(module, exports) {
$parcel$export(module.exports, "transformAggMultipleUserPickerToLegacyField", () => $32440852381c3dc7$export$cdd9991119eb040e);

var $FhXEJ = parcelRequire("FhXEJ");


var $3mZMJ = parcelRequire("3mZMJ");

var $gtUzp = parcelRequire("gtUzp");

var $74RuE = parcelRequire("74RuE");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $32440852381c3dc7$export$cdd9991119eb040e = (node, projectContext)=>{
    const value = (0, $8Tw1Q.transformAggConnection)(node.selectedUsersConnection, (0, $74RuE.transformJiraUserToLegacyServerUser));
    const legacyFieldValues = {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            configuration: null,
            custom: node.type,
            items: 'user',
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
    switch(node.type){
        case 0, $3mZMJ.REQUEST_PARTICIPANTS_CF_TYPE:
            if (node.__typename === (0, $3mZMJ.MULTI_USER_PICKER_GQL_FIELD)) return {
                ...legacyFieldValues,
                value: value
            };
            if ((0, $gtUzp.getProjectType)(projectContext?.projectType) !== (0, $FhXEJ.SERVICE_DESK_PROJECT)) return undefined;
            // Empty array is the expected value when there are no request
            // participants.
            return {
                ...legacyFieldValues,
                value: value
            };
        case 0, $3mZMJ.PARTICIPANTS_CF_TYPE:
        case 0, $3mZMJ.MULTI_USER_CF_TYPE:
            return legacyFieldValues;
        case 0, $3mZMJ.APPROVERS_LIST_CF_TYPE:
        case 0, $3mZMJ.PEOPLE_CF_TYPE:
            {
                const schemaConfig = 'isMulti' in node && node.isMulti != null ? [
                    {
                        key: 'isMulti',
                        value: String(node.isMulti)
                    }
                ] : null;
                return {
                    ...legacyFieldValues,
                    autoCompleteUrl: node.searchUrl,
                    schema: {
                        ...legacyFieldValues.schema,
                        configuration: schemaConfig
                    }
                };
            }
        default:
            return undefined;
    }
};

});
parcelRegister("gtUzp", function(module, exports) {
$parcel$export(module.exports, "getProjectType", () => $ccb6368d5f105ec2$export$3dd0da95519c1a33);
$parcel$export(module.exports, "getProjectField", () => $ccb6368d5f105ec2$export$b19207d974ad5e77);
$parcel$export(module.exports, "getSystemAggJiraProject", () => $ccb6368d5f105ec2$export$d100105d56da4a0a);
$parcel$export(module.exports, "isAggJiraProjectClassic", () => $ccb6368d5f105ec2$export$3502ed01c034e451);
$parcel$export(module.exports, "transformAggSystemProjectToProjectContext", () => $ccb6368d5f105ec2$export$77162d1422f22f47);
$parcel$export(module.exports, "transformAggProjectToLegacyField", () => $ccb6368d5f105ec2$export$30c14b802399f417);

var $4cTDP = parcelRequire("4cTDP");


var $2QZBX = parcelRequire("2QZBX");

var $FhXEJ = parcelRequire("FhXEJ");


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $ccb6368d5f105ec2$var$getProjectStatus = (status)=>{
    switch(status){
        case 'ACTIVE':
            return 0, $788556c08796d29c$export$62113557945f790a;
        case 'ARCHIVED':
            return 0, $788556c08796d29c$export$4ccc35479ba9ad1;
        case 'DELETED':
            return 0, $788556c08796d29c$export$a95d71e582b8bc0;
        default:
            // Based on `getProjectStatus` from src/packages/issue/issue-view/src/common/service/issue/issue-transformer.js
            return 0, $788556c08796d29c$export$62113557945f790a;
    }
};
const $ccb6368d5f105ec2$export$3dd0da95519c1a33 = (projectType)=>{
    if (projectType === 'CUSTOMER_SERVICE' && (0, $4cTDP.fg)('jcs_project_type_m3')) return 0, $FhXEJ.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'SERVICE_DESK':
            return 0, $FhXEJ.SERVICE_DESK_PROJECT;
        case 'BUSINESS':
            return 0, $FhXEJ.CORE_PROJECT;
        case 'SOFTWARE':
            return 0, $FhXEJ.SOFTWARE_PROJECT;
        case 'PRODUCT_DISCOVERY':
            return 0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $ccb6368d5f105ec2$export$b19207d974ad5e77 = (fields)=>{
    /**
	 * The only way to get the type to return an optional value with `AggJiraProject` type
	 * is to re-assign the type wihtout throwing an error.
	 */ return fields?.find((edge)=>edge?.node?.__typename === (0, $3mZMJ.PROJECT_GQL_FIELD) && edge?.node?.type != null && edge.node.type === (0, $3mZMJ.PROJECT_TYPE))?.node;
};
const $ccb6368d5f105ec2$export$d100105d56da4a0a = (fields)=>{
    /**
	 * We only want the system `PROJECT_TYPE` field.
	 * For custom fields, e.g., project picker, see `transformAggProjectToLegacyField`
	 */ const projectField = $ccb6368d5f105ec2$export$b19207d974ad5e77(fields);
    // Needs the `PROJECT_GQL_FIELD` refinement so we can return as `AggJiraProject`
    if (projectField == null || projectField.__typename !== (0, $3mZMJ.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $3mZMJ.PROJECT_GQL_FIELD)} with ${(0, $3mZMJ.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $3mZMJ.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    return projectField.project;
};
const $ccb6368d5f105ec2$var$isAggJiraProjectSimplified = (project)=>project?.projectStyle === 'TEAM_MANAGED_PROJECT';
const $ccb6368d5f105ec2$export$3502ed01c034e451 = (project)=>!$ccb6368d5f105ec2$var$isAggJiraProjectSimplified(project);
// @ts-expect-error TODO JPX-157
const $ccb6368d5f105ec2$var$transformAggProjectToServerProjectOption = (project)=>{
    if (project == null) return null;
    const { projectId: projectId, key: key, name: name, avatar: avatar } = project;
    return {
        name: name,
        id: projectId ?? undefined,
        key: (0, $2QZBX.toProjectKey)(key),
        avatarUrls: {
            '48x48': avatar?.large || ''
        }
    };
};
const $ccb6368d5f105ec2$export$77162d1422f22f47 = (project)=>{
    if (!project) throw new Error('No system project field in response');
    const { projectId: projectId, name: name, key: key, avatar: avatar, status: status, projectType: type } = project;
    const projectType = $ccb6368d5f105ec2$export$3dd0da95519c1a33(type);
    // Remove boardId on cleanup of dfo_remove_navigation_metadata
    let boardId = 'navigationMetadata' in project ? project.navigationMetadata?.boardId : undefined;
    if ((0, $4cTDP.fg)('dfo_remove_navigation_metadata')) boardId = undefined;
    if (!projectId || !projectType) throw new Error(`Failed to transform system project: projectId ${projectId} and projectType ${String(type)} was invalid`);
    return {
        projectId: projectId,
        projectType: projectType,
        projectName: name,
        projectKey: key,
        projectStatus: $ccb6368d5f105ec2$var$getProjectStatus(status),
        avatarUrl: avatar?.medium,
        isSimplified: $ccb6368d5f105ec2$var$isAggJiraProjectSimplified(project),
        boardId: boardId
    };
};
const $ccb6368d5f105ec2$export$275f121d4e6f5165 = (fields)=>{
    const project = $ccb6368d5f105ec2$export$d100105d56da4a0a(fields);
    return $ccb6368d5f105ec2$export$77162d1422f22f47(project);
};
const $ccb6368d5f105ec2$var$transformAggProjectToLegacyProjectPickerField = (node)=>({
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: $ccb6368d5f105ec2$var$transformAggProjectToServerProjectOption(node.project),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            type: (0, $3mZMJ.PROJECT_TYPE),
            custom: (0, $3mZMJ.PROJECT_PICKER_CF_TYPE),
            system: null
        }
    });
// @ts-expect-error TODO JPX-157
const $ccb6368d5f105ec2$var$transformAggProjectToLegacySimilarIssuesField = (node)=>{
    // Similar issues field only exist in JSM projects
    if ($ccb6368d5f105ec2$export$3dd0da95519c1a33(node.project?.projectType) !== (0, $FhXEJ.SERVICE_DESK_PROJECT)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        key: (0, $3mZMJ.SIMILAR_ISSUES_TYPE),
        title: (0, $3mZMJ.SIMILAR_ISSUES_TYPE),
        value: node.project?.similarIssues?.featureEnabled === true,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $3mZMJ.SIMILAR_ISSUES_TYPE),
            custom: null,
            system: (0, $3mZMJ.SIMILAR_ISSUES_TYPE)
        }
    };
};
// @ts-expect-error TODO JPX-157
const $ccb6368d5f105ec2$var$transformAggProjectToLegacyProjectField = (node)=>{
    if (node?.__typename !== (0, $3mZMJ.PROJECT_GQL_FIELD) || node?.type === null || node?.type !== (0, $3mZMJ.PROJECT_TYPE)) throw new Error(`Failed to get system project data: ${(0, $3mZMJ.PROJECT_GQL_FIELD)} with ${(0, $3mZMJ.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node)}]`);
    const projectField = node;
    if (projectField == null || projectField.__typename !== (0, $3mZMJ.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $3mZMJ.PROJECT_GQL_FIELD)} with ${(0, $3mZMJ.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $3mZMJ.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    const project = projectField.project;
    const { projectType: type } = project;
    const projectType = $ccb6368d5f105ec2$export$3dd0da95519c1a33(type);
    if (projectType == null) throw new Error(`Failed to transform project: projectType ${String(project?.projectType)} was invalid`);
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: {
            projectType: projectType
        }
    };
};
// @ts-expect-error TODO JPX-157
const $ccb6368d5f105ec2$var$transformAggProjectToLegacyFieldByType = (node)=>{
    const projectType = $ccb6368d5f105ec2$export$3dd0da95519c1a33(node.project?.projectType);
    if (projectType === (0, $FhXEJ.SERVICE_DESK_PROJECT)) // Similar issues field only exist in JSM projects
    return $ccb6368d5f105ec2$var$transformAggProjectToLegacySimilarIssuesField(node);
    if (projectType === (0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT)) return $ccb6368d5f105ec2$var$transformAggProjectToLegacyProjectField(node);
    return undefined;
};
const $ccb6368d5f105ec2$export$30c14b802399f417 = (node)=>{
    if ((0, $4cTDP.fg)('jpd_idea_panel_in_issue_view')) switch(node.type){
        case 0, $3mZMJ.PROJECT_PICKER_CF_TYPE:
            return $ccb6368d5f105ec2$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $3mZMJ.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $ccb6368d5f105ec2$var$transformAggProjectToLegacyFieldByType(node);
        default:
            return undefined;
    }
    else switch(node.type){
        case 0, $3mZMJ.PROJECT_PICKER_CF_TYPE:
            return $ccb6368d5f105ec2$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $3mZMJ.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $ccb6368d5f105ec2$var$transformAggProjectToLegacySimilarIssuesField(node);
        default:
            return undefined;
    }
};

});
const $788556c08796d29c$export$62113557945f790a = 'PROJECT_ACTIVE';
const $788556c08796d29c$export$4ccc35479ba9ad1 = 'PROJECT_ARCHIVED';
const $788556c08796d29c$export$a95d71e582b8bc0 = 'PROJECT_TRASHED';



parcelRegister("dAiWn", function(module, exports) {
$parcel$export(module.exports, "transformAggMultipleVersionPickerToLegacyField", () => $e7bc731374bc7784$export$6207ea60703068d8);


var $3mZMJ = parcelRequire("3mZMJ");

var $dVGVP = parcelRequire("dVGVP");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $e7bc731374bc7784$var$defaultSchema = {
    configuration: null,
    custom: null,
    items: 'version',
    renderer: (0, $57c87778b42e34da$export$840ed33fa94f7693),
    system: null,
    type: 'array'
};
const $e7bc731374bc7784$export$6207ea60703068d8 = (node)=>{
    if (node.type !== (0, $3mZMJ.MULTI_VERSION_CF_TYPE) && node.type !== (0, $3mZMJ.AFFECTS_VERSIONS_TYPE) && node.type !== (0, $3mZMJ.FIX_VERSIONS_TYPE)) return undefined;
    const legacyFieldValues = {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: (0, $8Tw1Q.transformAggConnection)(node.selectedVersionsConnection, (0, $dVGVP.transformAggVersionToLegacyVersion))
    };
    switch(node.type){
        case 0, $3mZMJ.MULTI_VERSION_CF_TYPE:
            return {
                ...legacyFieldValues,
                value: legacyFieldValues.value.length === 0 ? null : legacyFieldValues.value,
                schema: {
                    ...$e7bc731374bc7784$var$defaultSchema,
                    custom: (0, $3mZMJ.MULTI_VERSION_CF_TYPE)
                }
            };
        case 0, $3mZMJ.AFFECTS_VERSIONS_TYPE:
        case 0, $3mZMJ.FIX_VERSIONS_TYPE:
            return {
                ...legacyFieldValues,
                schema: {
                    ...$e7bc731374bc7784$var$defaultSchema,
                    system: node.type
                }
            };
        default:
            return undefined;
    }
};

});
parcelRegister("dVGVP", function(module, exports) {
$parcel$export(module.exports, "transformAggVersionToLegacyVersion", () => $6d5aa6e85a56b096$export$becef8d087e8b62b);

var $be4Fs = parcelRequire("be4Fs");
const $6d5aa6e85a56b096$export$becef8d087e8b62b = (version)=>({
        id: version.versionId ?? '',
        name: version.name ?? '',
        description: version.description ?? '',
        archived: version.status === (0, $be4Fs.VersionStatus).ARCHIVED,
        released: version.status === (0, $be4Fs.VersionStatus).RELEASED,
        ari: version.id
    });

});
parcelRegister("be4Fs", function(module, exports) {
$parcel$export(module.exports, "VersionStatus", () => $5bceeeaddd71111f$export$8c6e0f93bfb5c6a4);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports






const $5bceeeaddd71111f$export$8c6e0f93bfb5c6a4 = {
    ARCHIVED: 'ARCHIVED',
    RELEASED: 'RELEASED',
    UNRELEASED: 'UNRELEASED'
};

});



parcelRegister("a6vLL", function(module, exports) {
$parcel$export(module.exports, "transformAggNumberToLegacyField", () => $d06856cdc1673eac$export$d754a24ed0096d2f);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $d06856cdc1673eac$export$d754a24ed0096d2f = (node)=>{
    const fieldType = node.isStoryPointField === true ? (0, $3mZMJ.STORY_POINTS_TYPE) : node.type;
    switch(fieldType){
        case 0, $3mZMJ.NUMBER_CF_TYPE:
        case 0, $3mZMJ.STORY_POINT_ESTIMATE_CF_TYPE:
        case 0, $3mZMJ.STORY_POINTS_TYPE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: node.number ?? null,
                schema: {
                    configuration: null,
                    items: null,
                    renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
                    custom: fieldType,
                    system: null,
                    type: (0, $3mZMJ.ISSUE_FIELD_NUMBER_CF_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("gECU8", function(module, exports) {
$parcel$export(module.exports, "transformAggOriginalEstimateToLegacyField", () => $b90b41b6702a4488$export$f08d02fdc74f920e);

var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $b90b41b6702a4488$export$f08d02fdc74f920e = (node)=>{
    if (node.type !== (0, $3mZMJ.TIME_ESTIMATE_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.originalEstimate?.timeInSeconds ?? null,
        schema: {
            configuration: null,
            custom: null,
            system: node.type,
            items: null,
            type: (0, $3mZMJ.ISSUE_FIELD_NUMBER_CF_TYPE),
            renderer: null
        }
    };
};

});

parcelRegister("c8gRg", function(module, exports) {
$parcel$export(module.exports, "transformAggPriorityToLegacyField", () => $e1ebf74a07d64a5c$export$9e966ce605f800d2);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
// @ts-expect-error TODO JPX-157
const $e1ebf74a07d64a5c$var$transformJiraPriorityToLegacyPriority = (priority)=>{
    if (priority == null) return null;
    return {
        id: priority.priorityId,
        iconUrl: String(priority.iconUrl || ''),
        name: priority.name || '',
        sequence: priority.sequence || undefined
    };
};
const $e1ebf74a07d64a5c$export$9e966ce605f800d2 = (node)=>{
    if (node.type !== (0, $3mZMJ.PRIORITY_TYPE)) return undefined;
    // With cleanup of dfo_remove_priority_field_from_main_query, priorities will not be in node, and allowedValues will be an empty array
    const allowedValues = (0, $8Tw1Q.transformAggConnection)('priorities' in node ? node.priorities : null, $e1ebf74a07d64a5c$var$transformJiraPriorityToLegacyPriority);
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        value: $e1ebf74a07d64a5c$var$transformJiraPriorityToLegacyPriority(node.priority),
        schema: {
            type: (0, $3mZMJ.PRIORITY_TYPE),
            custom: null,
            system: (0, $3mZMJ.PRIORITY_TYPE),
            configuration: null,
            items: null,
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f)
        }
    };
};

});

parcelRegister("1exBo", function(module, exports) {
$parcel$export(module.exports, "transformAggProformaFormsToLegacyField", () => $8e8dae50d765b259$export$fdcdbf17b0d4e36f);

var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $8e8dae50d765b259$export$fdcdbf17b0d4e36f = (node)=>{
    if (node.type !== (0, $3mZMJ.PROFORMA_FORMS)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.proformaForms,
        schema: {
            configuration: null,
            items: null,
            system: (0, $3mZMJ.PROFORMA_FORMS),
            custom: null,
            renderer: null,
            type: (0, $3mZMJ.PROFORMA_FORMS)
        }
    };
};

});

parcelRegister("5iFQF", function(module, exports) {
$parcel$export(module.exports, "transformAggRadioSelectToLegacyField", () => $c9221aeb6fc8fb91$export$f147f1eb3a15ccfc);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $c9221aeb6fc8fb91$export$f147f1eb3a15ccfc = (node)=>{
    if (node.type !== (0, $3mZMJ.RADIO_BUTTONS_CF_TYPE)) return undefined;
    const value = node.selectedOption ? {
        id: node.selectedOption?.optionId,
        value: node.selectedOption?.value,
        isDisabled: node.selectedOption?.isDisabled
    } : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'option',
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("dSS0X", function(module, exports) {
$parcel$export(module.exports, "transformAggResolutionToLegacyField", () => $7eee2703929d5623$export$179f600c7e1d0230);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
// @ts-expect-error TODO JPX-157
const $7eee2703929d5623$var$resolutionTransformer = (resolution)=>{
    if (resolution == null) return null;
    return {
        id: resolution.resolutionId,
        name: resolution.name || ''
    };
};
const $7eee2703929d5623$export$179f600c7e1d0230 = (node)=>{
    if (node.type !== (0, $3mZMJ.RESOLUTION_TYPE)) return undefined;
    const value = $7eee2703929d5623$var$resolutionTransformer(node.resolution);
    // @ts-expect-error: node.resolutions does not exist in jiraIssueFieldsFragmentLegacyRedux. These transformations will be deleted when IV is migrated to Relay
    const allowedValues = (0, $8Tw1Q.transformAggConnection)(node.resolutions, $7eee2703929d5623$var$resolutionTransformer);
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: (0, $3mZMJ.RESOLUTION_TYPE),
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $3mZMJ.RESOLUTION_TYPE),
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("8plR2", function(module, exports) {
$parcel$export(module.exports, "transformAggSecurityLevelToLegacyField", () => $d33aa6cc7441217e$export$45e25e2a6750ea5a);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
// @ts-expect-error TODO JPX-157
const $d33aa6cc7441217e$var$transformJiraSecurityLevel = (securityLevel)=>{
    if (securityLevel == null) return null;
    return {
        id: securityLevel.securityId,
        description: securityLevel.description || '',
        name: securityLevel.name || ''
    };
};
const $d33aa6cc7441217e$export$45e25e2a6750ea5a = (node)=>({
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: $d33aa6cc7441217e$var$transformJiraSecurityLevel(node.securityLevel),
        allowedValues: (0, $8Tw1Q.transformAggConnection)(node.securityLevels, $d33aa6cc7441217e$var$transformJiraSecurityLevel),
        schema: {
            configuration: null,
            type: (0, $3mZMJ.SECURITY_LEVEL_TYPE_OVERRIDE),
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $3mZMJ.SECURITY_LEVEL_TYPE),
            items: null
        }
    });

});

parcelRegister("92N3i", function(module, exports) {
$parcel$export(module.exports, "transformAggSingleGroupPickerToLegacyField", () => $8b96c0b3204c894a$export$e6697ec5bdac9ec0);


var $8Tw1Q = parcelRequire("8Tw1Q");
const $8b96c0b3204c894a$export$e6697ec5bdac9ec0 = (node)=>{
    const value = node.selectedGroup != null ? {
        groupId: node.selectedGroup.groupId,
        name: node.selectedGroup.name
    } : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'group',
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("lR2em", function(module, exports) {
$parcel$export(module.exports, "transformAggSingleLineTextToLegacyField", () => $659d7d4b8257722d$export$31f32b3fd9e5ab6);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $659d7d4b8257722d$var$defaultSchema = {
    configuration: null,
    items: null,
    renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f)
};
const $659d7d4b8257722d$export$31f32b3fd9e5ab6 = (node)=>{
    const defaultTransformedField = {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.text
    };
    switch(node.type){
        case 0, $3mZMJ.EPIC_NAME_TYPE:
        case 0, $3mZMJ.MESSAGE_EDIT_CF_TYPE:
        case 0, $3mZMJ.MESSAGE_VIEW_CF_TYPE:
        case 0, $3mZMJ.READ_ONLY_CF_TYPE:
        case 0, $3mZMJ.TEXT_CF_TYPE:
        case 0, $3mZMJ.USER_PROPERTY_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$659d7d4b8257722d$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $3mZMJ.ISSUE_FIELD_STRING_CF_TYPE)
                }
            };
        case 0, $3mZMJ.RANK_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$659d7d4b8257722d$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $3mZMJ.ISSUE_FIELD_ANY_CF_TYPE)
                }
            };
        case 0, $3mZMJ.SUMMARY_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$659d7d4b8257722d$var$defaultSchema,
                    type: (0, $3mZMJ.ISSUE_FIELD_STRING_CF_TYPE),
                    custom: null,
                    system: node.type
                }
            };
        case 0, $3mZMJ.SERVICEDESK_PRACTICES_TYPE:
            // Transform field only if the practice has a value
            return node.text != null ? {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: [
                    node.text
                ],
                schema: {
                    ...$659d7d4b8257722d$var$defaultSchema,
                    renderer: null,
                    custom: null,
                    system: node.type,
                    type: (0, $3mZMJ.SERVICEDESK_PRACTICES_TYPE)
                }
            } : undefined;
        default:
            return undefined;
    }
};

});

parcelRegister("9dsiy", function(module, exports) {
$parcel$export(module.exports, "transformAggSingleSelectToLegacyField", () => $1f5f63ca883225b4$export$4e113f935e09d226);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
// @ts-expect-error TODO JPX-157
const $1f5f63ca883225b4$var$getField = (node, customType)=>{
    const value = node.fieldOption != null ? {
        ari: node.fieldOption.id,
        id: node.fieldOption.optionId,
        value: node.fieldOption.value
    } : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'option',
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            custom: customType || node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};
const $1f5f63ca883225b4$export$4e113f935e09d226 = (node)=>{
    switch(node.type){
        case 0, $3mZMJ.EPIC_STATUS_TYPE:
        case 0, $3mZMJ.SELECT_CF_TYPE:
            // @ts-expect-error TODO JPX-157
            return $1f5f63ca883225b4$var$getField(node);
        case 0, $3mZMJ.CATEGORY_TYPE:
            return $1f5f63ca883225b4$var$getField(node, (0, $3mZMJ.SELECT_CF_TYPE));
        default:
            return undefined;
    }
};

});

parcelRegister("2eP7x", function(module, exports) {
$parcel$export(module.exports, "transformAggSingleSelectUserPickerToLegacyField", () => $b86adefd697ce3f4$export$7bf73fc06c6d71be);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $74RuE = parcelRequire("74RuE");
const $b86adefd697ce3f4$export$7bf73fc06c6d71be = (node)=>{
    const legacyField = {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $74RuE.transformJiraUserToLegacyServerUser)(node.user) : null
    };
    switch(node.type){
        case 0, $3mZMJ.ASSIGNEE_TYPE:
        case 0, $3mZMJ.REPORTER_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $3mZMJ.ISSUE_FIELD_USER_CF_TYPE),
                    custom: null,
                    system: node.type,
                    renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        case 0, $3mZMJ.USER_CF_TYPE:
        case 0, $3mZMJ.LAST_UPDATER_OR_COMMENTER_CF_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $3mZMJ.ISSUE_FIELD_USER_CF_TYPE),
                    custom: node.type,
                    system: null,
                    renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("ksE6r", function(module, exports) {
$parcel$export(module.exports, "transformAggSingleVersionPickerToLegacyField", () => $fa047c4e6c9f5935$export$d03f622577260442);


var $3mZMJ = parcelRequire("3mZMJ");

var $dVGVP = parcelRequire("dVGVP");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $fa047c4e6c9f5935$export$d03f622577260442 = (node)=>{
    if (node.type !== (0, $3mZMJ.VERSION_CF_TYPE)) return undefined;
    const allowedValues = (0, $8Tw1Q.transformAggConnection)(null, (0, $dVGVP.transformAggVersionToLegacyVersion));
    const value = node.version ? (0, $dVGVP.transformAggVersionToLegacyVersion)(node.version) : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        value: value,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            type: (0, $3mZMJ.ISSUE_FIELD_VERSION_CF_TYPE),
            custom: (0, $3mZMJ.VERSION_CF_TYPE),
            system: null
        }
    };
};

});

parcelRegister("dN5mk", function(module, exports) {
$parcel$export(module.exports, "transformAggSprintToLegacyField", () => $01a8b99e170d26ed$export$9b5bb05d50970021);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $01a8b99e170d26ed$var$SprintOptionalKeyMap = {
    goal: 'goal',
    completeDate: 'completionDate',
    startDate: 'startDate',
    endDate: 'endDate'
};
// @ts-expect-error TODO JPX-157
const $01a8b99e170d26ed$var$transformAggSprintToLegacySprint = (sprint)=>{
    const optionalValues = {};
    Object.keys($01a8b99e170d26ed$var$SprintOptionalKeyMap).forEach((key)=>{
        // @ts-expect-error TODO JPX-157
        const aggKey = $01a8b99e170d26ed$var$SprintOptionalKeyMap[key];
        const aggValue = sprint[aggKey];
        if (aggValue !== undefined && aggValue !== null) // @ts-expect-error TODO JPX-157
        optionalValues[key] = aggValue;
    });
    return {
        id: Number(sprint.sprintId),
        name: sprint?.name ?? '',
        state: sprint.state?.toLowerCase(),
        boardId: Number(sprint.boardName) || 0,
        ...optionalValues
    };
};
const $01a8b99e170d26ed$export$9b5bb05d50970021 = (node)=>{
    if (node.type !== (0, $3mZMJ.SPRINT_TYPE)) return undefined;
    const sprints = (0, $8Tw1Q.transformAggConnection)(node.selectedSprintsConnection, $01a8b99e170d26ed$var$transformAggSprintToLegacySprint);
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: sprints,
        schema: {
            configuration: null,
            custom: (0, $3mZMJ.SPRINT_TYPE),
            items: 'json',
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("2CpT2", function(module, exports) {
$parcel$export(module.exports, "getStatusesDeprecatedValue", () => $f310693121110726$export$b80ec59d806c2f94);
$parcel$export(module.exports, "transformAggStatusToLegacyField", () => $f310693121110726$export$c80e5acb1c882c48);

var $jx0Vw = parcelRequire("jx0Vw");

var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $f310693121110726$export$b80ec59d806c2f94 = (fields)=>{
    const { status: status } = fields;
    if (!status || status.value == null) return {};
    const { value: value } = status;
    return {
        [value.id]: {
            id: value.id,
            name: value.name,
            statusCategory: (0, $jx0Vw.statusCategoryForId)(value.statusCategory?.id)
        }
    };
};
// @ts-expect-error TODO JPX-157
const $f310693121110726$var$transformJiraStatusToLegacyStatus = (status)=>{
    if (!status || !status.statusCategory) return null;
    const { statusCategory: statusCategory } = status;
    return {
        id: status.statusId,
        name: status.name || '',
        statusCategory: {
            id: Number(statusCategory.statusCategoryId)
        }
    };
};
const $f310693121110726$export$c80e5acb1c882c48 = (node)=>{
    if (node.type !== (0, $3mZMJ.STATUS_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: $f310693121110726$var$transformJiraStatusToLegacyStatus(node.status),
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $3mZMJ.STATUS_TYPE),
            custom: null,
            system: (0, $3mZMJ.STATUS_TYPE)
        }
    };
};

});

parcelRegister("4MVer", function(module, exports) {
$parcel$export(module.exports, "transformAggTeamToLegacyField", () => $0bbc3c7042b91d39$export$fb1b80497e96456f);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $0bbc3c7042b91d39$export$fb1b80497e96456f = (node)=>{
    if (node.type !== (0, $3mZMJ.TEAM_CF_TYPE)) return undefined;
    const value = node.selectedTeam ? {
        id: node.selectedTeam.teamId,
        title: node.selectedTeam.name,
        isShared: node.selectedTeam.isShared,
        avatarUrl: node.selectedTeam.avatar?.medium
    } : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $3mZMJ.TEAM_CF_TYPE),
            items: null,
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            system: null,
            type: (0, $3mZMJ.ISSUE_FIELD_ANY_CF_TYPE)
        }
    };
};

});

parcelRegister("kPSkL", function(module, exports) {
$parcel$export(module.exports, "transformAggTeamViewToLegacyField", () => $ce17f04c98aba2c2$export$6f6aaafb49bd4769);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
// @ts-expect-error TODO JPX-157
const $ce17f04c98aba2c2$var$transformAggTeamViewToLegacyTeam = (team)=>{
    if (team == null) return null;
    return {
        id: team.jiraSuppliedTeamId || '',
        name: team.jiraSuppliedName || '',
        isVisible: team.jiraSuppliedVisibility || false,
        avatarUrl: team.jiraSuppliedAvatar?.xsmall || '',
        isVerified: team.jiraSuppliedIsVerified || false
    };
};
const $ce17f04c98aba2c2$export$6f6aaafb49bd4769 = (node)=>{
    if (node.type !== (0, $3mZMJ.TEAMS_PLATFORM_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: $ce17f04c98aba2c2$var$transformAggTeamViewToLegacyTeam(node.selectedTeam),
        schema: {
            configuration: null,
            custom: (0, $3mZMJ.TEAMS_PLATFORM_CF_TYPE),
            items: null,
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            system: null,
            type: 'team'
        }
    };
};

});

parcelRegister("gpNkV", function(module, exports) {
$parcel$export(module.exports, "transformAggTimeTrackingToLegacyField", () => $ee864f653750a614$export$874d9bd14269ec6f);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
// @ts-expect-error TODO JPX-157
const $ee864f653750a614$var$getEstimateValues = (estimate, key)=>{
    if (estimate) return {
        [key]: estimate.timeInSeconds || 0
    };
    return {};
};
const $ee864f653750a614$export$874d9bd14269ec6f = (node)=>{
    if (node.type !== (0, $3mZMJ.TIME_TRACKING_TYPE)) return undefined;
    const originalEstimate = $ee864f653750a614$var$getEstimateValues(node.originalEstimate || null, 'originalEstimateSeconds');
    const remainingEstimate = $ee864f653750a614$var$getEstimateValues(node.remainingEstimate || null, 'remainingEstimateSeconds');
    const timeSpent = $ee864f653750a614$var$getEstimateValues(node.timeSpent || null, 'timeSpentSeconds');
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: {
            ...originalEstimate,
            ...remainingEstimate,
            ...timeSpent
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            system: (0, $3mZMJ.TIME_TRACKING_TYPE),
            type: (0, $3mZMJ.TIME_TRACKING_TYPE)
        }
    };
};

});

parcelRegister("jE1Uq", function(module, exports) {
$parcel$export(module.exports, "transformAggUrlToLegacyField", () => $f61b428b363526c3$export$6e950e0ec9801f6c);


var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $f61b428b363526c3$export$6e950e0ec9801f6c = (node)=>{
    if (node.type !== (0, $3mZMJ.URL_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.uri ?? null,
        schema: {
            configuration: null,
            custom: (0, $3mZMJ.URL_CF_TYPE),
            items: null,
            renderer: (0, $57c87778b42e34da$export$a4a240cb4053b29f),
            system: null,
            type: (0, $3mZMJ.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("btvTF", function(module, exports) {
$parcel$export(module.exports, "transformAggVotesToLegacyField", () => $95434af0f8409f2f$export$8966614b8594736);

var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
// @ts-expect-error TODO JPX-157
const $95434af0f8409f2f$var$transformAggVoteToLegacyVote = (vote, isEnabled)=>({
        votes: vote.count != null ? Number(vote.count) : 0,
        hasVoted: vote.hasVoted ?? false,
        isEnabled: isEnabled
    });
const $95434af0f8409f2f$export$8966614b8594736 = (node)=>{
    if (node.type !== (0, $3mZMJ.VOTES_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.vote ? $95434af0f8409f2f$var$transformAggVoteToLegacyVote(node.vote, !!node.selectedUsersConnection?.edges) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $3mZMJ.VOTES_TYPE),
            type: (0, $3mZMJ.VOTES_TYPE)
        }
    };
};

});

parcelRegister("gujad", function(module, exports) {
$parcel$export(module.exports, "transformAggWatchesToLegacyField", () => $e1ddb36e41b722e0$export$6730cb17d10d6156);

var $3mZMJ = parcelRequire("3mZMJ");

var $8Tw1Q = parcelRequire("8Tw1Q");
// @ts-expect-error TODO JPX-157
const $e1ddb36e41b722e0$var$transformAggWatchesToLegacyWatches = (watch)=>({
        watchCount: watch.count != null ? Number(watch.count) : 0,
        isWatching: watch.isWatching ?? false
    });
const $e1ddb36e41b722e0$export$6730cb17d10d6156 = (node)=>{
    if (node.type !== (0, $3mZMJ.WATCHES_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.watch ? $e1ddb36e41b722e0$var$transformAggWatchesToLegacyWatches(node.watch) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $3mZMJ.WATCHES_TYPE),
            type: (0, $3mZMJ.WATCHES_TYPE)
        }
    };
};

});


parcelRegister("7QMat", function(module, exports) {
$parcel$export(module.exports, "transformAggParentFieldValueToLegacyFieldValue", () => $24cb110b5fbfe797$export$d8a5feb2bb0425b4);
const $24cb110b5fbfe797$export$d8a5feb2bb0425b4 = (parentIssue)=>{
    if (!parentIssue) return null;
    return {
        id: parentIssue.issueId,
        ari: parentIssue.id,
        key: parentIssue.key,
        self: parentIssue.webUrl,
        color: parentIssue.issueColorField?.color?.colorKey,
        fields: {
            summary: parentIssue.summaryField?.text,
            issuetype: {
                name: parentIssue.issueTypeField?.issueType?.name,
                iconUrl: parentIssue.issueTypeField?.issueType?.avatar?.xsmall,
                // We do not have this data
                id: '',
                self: '',
                description: '',
                subtask: false,
                avatarId: 0,
                hierarchyLevel: 0
            }
        }
    };
};

});

parcelRegister("i6YHz", function(module, exports) {
$parcel$export(module.exports, "transformAggRichTextFieldValueToLegacyFieldValue", () => $3ee48b837f83cdcc$export$b3a2c3992977726e);

var $clRM1 = parcelRequire("clRM1");


var $dk7W5 = parcelRequire("dk7W5");
const $3ee48b837f83cdcc$var$emptyAdfObject = (0, $clRM1.getEmptyADF)();
const $3ee48b837f83cdcc$export$b3a2c3992977726e = (richText, renderer)=>{
    if (!renderer) throw new Error('aggFieldChangeProps did not have renderer');
    if (renderer === (0, $57c87778b42e34da$export$a4a240cb4053b29f)) {
        if (richText.plainText !== undefined) return richText.plainText;
        return richText?.adfValue?.convertedPlainText?.plainText;
    }
    return richText?.adfValue?.json ? (0, $dk7W5.removeCollectionFromAdf)(richText?.adfValue?.json) : $3ee48b837f83cdcc$var$emptyAdfObject;
};

});


parcelRegister("4P77p", function(module, exports) {
$parcel$export(module.exports, "ChangeEventTypes", () => $5d2cfcdff3aefb29$export$8db21fc94823e1cc);
// Copied over from `src/packages/issue/issue-view/src/model/change-type.js`
const $5d2cfcdff3aefb29$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $5d2cfcdff3aefb29$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $5d2cfcdff3aefb29$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $5d2cfcdff3aefb29$export$8db21fc94823e1cc = {
    [$5d2cfcdff3aefb29$var$FIELD_CHANGE_REQUESTED]: $5d2cfcdff3aefb29$var$FIELD_CHANGE_REQUESTED,
    [$5d2cfcdff3aefb29$var$FIELD_CHANGE_FAILED]: $5d2cfcdff3aefb29$var$FIELD_CHANGE_FAILED,
    [$5d2cfcdff3aefb29$var$FIELD_CHANGED]: $5d2cfcdff3aefb29$var$FIELD_CHANGED
};

});


parcelRegister("iaPZb", function(module, exports) {
$parcel$export(module.exports, "defaultSaveField", () => $21527ec442db63fe$export$b74e6b7f831f1cb2);
$parcel$export(module.exports, "defaultSaveFieldById", () => $21527ec442db63fe$export$b2c49aae5d84cced);
$parcel$export(module.exports, "defaultAddValuesToField", () => $21527ec442db63fe$export$c46c7284cd9c5d3);
$parcel$export(module.exports, "defaultRemoveValuesFromField", () => $21527ec442db63fe$export$33b78476f5d734b3);

var $keOPi = parcelRequire("keOPi");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $21527ec442db63fe$var$getFieldUpdate = (fieldKey, value)=>({
        fields: {
            [fieldKey]: value
        }
    });
const $21527ec442db63fe$export$b74e6b7f831f1cb2 = async (issueKey, fieldKey, newValue)=>(0, $keOPi.performIssuePutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify($21527ec442db63fe$var$getFieldUpdate(fieldKey, newValue))
    }, 'fields/field-base/src/services/edit-field-service/utils');
const $21527ec442db63fe$export$b2c49aae5d84cced = async (issueKey, fieldKey, newValue)=>(0, $keOPi.performIssuePutRequest)(`/rest/api/3/issue/${issueKey}/?returnIssue=true`, {
        body: JSON.stringify($21527ec442db63fe$var$getFieldUpdate(fieldKey, newValue))
    }, 'fields/field-base/src/services/edit-field-service/utils');
const $21527ec442db63fe$export$c46c7284cd9c5d3 = async (issueKey, fieldKey, valuesToAdd)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'add',
                    value: valuesToAdd
                }
            ]
        }
    };
    return (0, $keOPi.performIssuePutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    }, 'fields/field-base/src/services/edit-field-service/utils');
};
const $21527ec442db63fe$export$33b78476f5d734b3 = async (issueKey, fieldKey, valuesToRemove)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'remove',
                    value: valuesToRemove
                }
            ]
        }
    };
    return (0, $keOPi.performIssuePutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    }, 'fields/field-base/src/services/edit-field-service/utils');
};

});


parcelRegister("2rHwS", function(module, exports) {
$parcel$export(module.exports, "useIssueFieldConfig", () => $9c87b1a177d5273e$export$5406c21e0d275680);
$parcel$export(module.exports, "useIssueFieldConfigWithoutRefetch", () => $9c87b1a177d5273e$export$217a0e2f2962f4ae);
$parcel$export(module.exports, "useIssueFieldConfigWithoutUimOverrides", () => $9c87b1a177d5273e$export$5f641a998c6dfa06);
$parcel$export(module.exports, "useFieldConfig", () => $9c87b1a177d5273e$export$70da50df1be2dbe1);
$parcel$export(module.exports, "useFieldConfigWithoutRefetch", () => $9c87b1a177d5273e$export$1eed575f8f3334eb);
$parcel$export(module.exports, "useFieldConfigActions", () => $9c87b1a177d5273e$export$28a22fd0dedf31b7);

var $eJOHy = parcelRequire("eJOHy");

var $jPROM = parcelRequire("jPROM");

var $4cTDP = parcelRequire("4cTDP");

var $14RSn = parcelRequire("14RSn");

var $keOPi = parcelRequire("keOPi");

var $XGDec = parcelRequire("XGDec");

var $3KXZZ = parcelRequire("3KXZZ");

var $3ibpe = parcelRequire("3ibpe");

var $4im1M = parcelRequire("4im1M");

var $b1smt = parcelRequire("b1smt");
const $9c87b1a177d5273e$export$9715ac6597e498fd = ()=>`
  query fieldConfigurationQuery($issueKey: String) {
    issue(issueIdOrKey: $issueKey, latestVersion: true, screen: "view") {
      fields {
        key
        schema {
          type
          custom
          customId
          system
          renderer
        }
        autoCompleteUrl
        allowedValues
        operations
        required
        editable
        title
        description
      }
    }
  }`;
const $9c87b1a177d5273e$var$fieldConfigurationQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId })=>{
    const errorMessageItem = errorMessage != null ? {
        errorMessage: errorMessage
    } : {};
    const traceIdItem = traceId != null ? {
        traceId: traceId
    } : {};
    return {
        experience: (0, $3KXZZ.IssueViewFetchOperations).FIELD_CONFIGURATION,
        wasExperienceSuccesful: wasExperienceSuccessful,
        analyticsSource: 'Issue View Field Configuration Query',
        additionalAttributes: {
            method: 'GET',
            ...errorMessageItem,
            ...traceIdItem
        },
        application: null,
        edition: null
    };
};
const $9c87b1a177d5273e$var$fieldConfigurationQueryExperienceTracking = ({ wasExperienceSuccessful: wasExperienceSuccessful, error: error })=>{
    (0, $3ibpe.sendExperienceAnalytics)($9c87b1a177d5273e$var$fieldConfigurationQueryExperienceDescription({
        wasExperienceSuccessful: wasExperienceSuccessful,
        ...error?.message != null ? {
            errorMessage: error.message
        } : {},
        ...error instanceof (0, $14RSn.default) && error.traceId != null ? {
            traceId: error.traceId
        } : {}
    }));
};
const $9c87b1a177d5273e$var$fetchData = async (issueKey)=>{
    try {
        const response = await (0, $keOPi.performIssuePostRequest)((0, $XGDec.getGraphQlUrl)((0, $3KXZZ.IssueViewFetchOperations).FIELD_CONFIGURATION), {
            body: JSON.stringify({
                query: $9c87b1a177d5273e$export$9715ac6597e498fd(),
                variables: {
                    issueKey: issueKey
                }
            })
        }, 'fields/field-base/src/services/field-config-service/main');
        if (response?.data?.issue?.fields) {
            const fieldConfigData = response.data.issue.fields.reduce(// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'field' implicitly has an 'any' type.
            (result, field)=>({
                    // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                    ...result,
                    [field.key]: {
                        autoCompleteUrl: field.autoCompleteUrl,
                        allowedValues: field.allowedValues,
                        isEditable: field.editable,
                        isRequired: field.required,
                        schema: field.schema,
                        title: field.title,
                        ...field.description ? {
                            description: field.description
                        } : {}
                    }
                }), {});
            $9c87b1a177d5273e$var$fieldConfigurationQueryExperienceTracking({
                wasExperienceSuccessful: true
            });
            return fieldConfigData;
        }
        $9c87b1a177d5273e$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: new Error('Unexpected field configuration response')
        });
        return null;
    } catch (error) {
        $9c87b1a177d5273e$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: error instanceof (0, $14RSn.default) ? error : undefined
        });
        return null;
    }
};
const $9c87b1a177d5273e$var$requestSet = new Set();
const $9c87b1a177d5273e$var$issueFieldConfigServiceDefaultOptions = {
    skipRefresh: false
};
const $9c87b1a177d5273e$var$useIssueFieldConfigRefetch = (issueKey, value, { skipRefresh: skipRefresh } = $9c87b1a177d5273e$var$issueFieldConfigServiceDefaultOptions)=>{
    const isMounted = (0, $4im1M.useIsMounted)();
    const [, { setIssueConfig: setIssueConfig }] = (0, $b1smt.useFieldConfigStoreActions)();
    const [loading, setLoading] = (0, $eJOHy.useState)(()=>!skipRefresh && value === undefined && !$9c87b1a177d5273e$var$requestSet.has(issueKey));
    const getData = (0, $eJOHy.useCallback)(async ()=>{
        setLoading(true);
        $9c87b1a177d5273e$var$requestSet.add(issueKey);
        const result = await $9c87b1a177d5273e$var$fetchData(issueKey);
        setIssueConfig(issueKey, result);
        $9c87b1a177d5273e$var$requestSet.delete(issueKey);
        if (isMounted.current) setLoading(false);
    }, [
        isMounted,
        issueKey,
        setIssueConfig
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const shouldGetData = (0, $4cTDP.fg)('jiv-19312-fix-fieldconfigurationquery-refetch') ? !skipRefresh && !$9c87b1a177d5273e$var$requestSet.has(issueKey) && value === undefined && issueKey !== '' : !skipRefresh && !$9c87b1a177d5273e$var$requestSet.has(issueKey) && value === undefined;
        if (shouldGetData) getData();
    }, [
        issueKey,
        value,
        getData,
        skipRefresh
    ]);
    return (0, $eJOHy.useMemo)(()=>[
            {
                loading: loading
            }
        ], [
        loading
    ]);
};
const $9c87b1a177d5273e$var$useIssueFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey })=>{
    const [value] = (0, $b1smt.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [overrides] = (0, $b1smt.useIssueOverridesStore)({
        issueKey: issueKey
    });
    return (0, $eJOHy.useMemo)(()=>{
        if (// When fields configurations are not valid, we don't want overrides
        !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(value) && // We should not override if UI modifications is not available in general or for the field
        overrides !== undefined) {
            // Iteration over the base fields (`value`) prevents creation of partial configs with just UIM overrides.
            const issueWithOverrides = Object.entries(value).reduce((acc, [fieldKey, fieldValues])=>{
                acc[fieldKey] = {
                    ...fieldValues,
                    ...overrides[fieldKey]
                };
                return acc;
            }, {});
            return [
                issueWithOverrides
            ];
        }
        return [
            value
        ];
    }, [
        value,
        overrides
    ]);
};
const $9c87b1a177d5273e$var$useFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
    const [value] = (0, $b1smt.useFieldConfigStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [overrides] = (0, $b1smt.useFieldOverridesStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    if (// When fields configurations are not valid, we don't want overrides
    !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(value) && // We should not override if UI modifications is not available in general or for the field
    overrides !== undefined) return [
        {
            ...value,
            ...overrides
        }
    ];
    return [
        value
    ];
};
const $9c87b1a177d5273e$export$5406c21e0d275680 = (issueKey)=>{
    const [value] = $9c87b1a177d5273e$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $9c87b1a177d5273e$var$useIssueFieldConfigRefetch(issueKey, value);
    return (0, $eJOHy.useMemo)(()=>[
            {
                value: value,
                loading: loading
            }
        ], [
        loading,
        value
    ]);
};
const $9c87b1a177d5273e$export$217a0e2f2962f4ae = (issueKey)=>{
    const [value] = $9c87b1a177d5273e$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    return (0, $eJOHy.useMemo)(()=>[
            {
                value: value
            }
        ], [
        value
    ]);
};
const $9c87b1a177d5273e$export$5f641a998c6dfa06 = ({ issueKey: issueKey })=>{
    const [value] = (0, $b1smt.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $9c87b1a177d5273e$var$useIssueFieldConfigRefetch(issueKey, value);
    return (0, $eJOHy.useMemo)(()=>[
            {
                value: value,
                loading: loading
            }
        ], [
        loading,
        value
    ]);
};
const $9c87b1a177d5273e$export$70da50df1be2dbe1 = (issueKey, fieldKey, options = $9c87b1a177d5273e$var$issueFieldConfigServiceDefaultOptions)=>{
    const [value] = $9c87b1a177d5273e$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [{ loading: loading }] = $9c87b1a177d5273e$var$useIssueFieldConfigRefetch(issueKey, value, options);
    return (0, $eJOHy.useMemo)(()=>[
            {
                value: value,
                loading: loading
            }
        ], [
        loading,
        value
    ]);
};
const $9c87b1a177d5273e$export$1eed575f8f3334eb = (issueKey, fieldKey)=>{
    const [value] = $9c87b1a177d5273e$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    return (0, $eJOHy.useMemo)(()=>[
            {
                value: value
            }
        ], [
        value
    ]);
};
const $9c87b1a177d5273e$export$28a22fd0dedf31b7 = ()=>{
    const [, setIssueConfigActions] = (0, $b1smt.useFieldConfigStoreActions)();
    const actions = (0, $eJOHy.useMemo)(()=>{
        const setIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.setIssueConfig(issueKey, issueConfig);
        const setIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.setIssuesConfig(issuesWithConfigurations);
        const mergeIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.mergeIssueConfig(issueKey, issueConfig);
        const mergeIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.mergeIssuesConfig(issuesWithConfigurations);
        const setFieldConfigValue = (issueKey, fieldKey, fieldConfigValue)=>setIssueConfigActions.setFieldConfigValue(issueKey, fieldKey, fieldConfigValue);
        return {
            setIssueConfig: setIssueConfig,
            setIssuesConfig: setIssuesConfig,
            mergeIssueConfig: mergeIssueConfig,
            mergeIssuesConfig: mergeIssuesConfig,
            setFieldConfigValue: setFieldConfigValue
        };
    }, [
        setIssueConfigActions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("XGDec", function(module, exports) {
$parcel$export(module.exports, "getGraphQlUrl", () => $d2d607861b22c2c1$export$5647e6bbf2b3526f);
$parcel$export(module.exports, "getFieldDataOptions", () => $d2d607861b22c2c1$export$f2fec0cacdfabaaf);

var $cTI7h = parcelRequire("cTI7h");

var $bcdww = parcelRequire("bcdww");

const $d2d607861b22c2c1$export$5647e6bbf2b3526f = (operation)=>`/rest/graphql/1/${(0, $cTI7h.appendOperationQuery)(operation)}`;
const $d2d607861b22c2c1$export$f2fec0cacdfabaaf = (issueKey, projectKey)=>({
        method: 'POST',
        body: JSON.stringify({
            query: (0, $bcdww.default)(issueKey, projectKey)
        })
    });

});
parcelRegister("cTI7h", function(module, exports) {
$parcel$export(module.exports, "appendOperationQuery", () => $237ed4c9607e5b1c$export$69694c3add0f6058);
const $237ed4c9607e5b1c$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';

});

parcelRegister("bcdww", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8ded878d9b9c772$export$2e2bcd8739ae039);
const $c8ded878d9b9c772$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};
const $c8ded878d9b9c772$var$getIsHybridAgilityProjectQuery = ()=>`
    isHybridAgilityProject
    `;
const $c8ded878d9b9c772$var$getEnvironmentQuery = ()=>`environmentAdf {
        value
    }`;
const $c8ded878d9b9c772$var$getAgileQuery = ()=>`
    agile {
        epic {
          key
        },
    }`;
const $c8ded878d9b9c772$var$getCustomFieldSchemaConfiguration = ()=>`configuration {
        key
        value
    }
    `;
const $c8ded878d9b9c772$var$getProjectQuery = (projectKey)=>`
        project(projectIdOrKey: "${projectKey}") {
            id
            name
            key
            projectTypeKey
            simplified
            avatarUrls {
                key
                value
            }
            archived
            deleted
        }`;
// Disable this eslint rule temporarily so we can query for configuration
const $c8ded878d9b9c772$var$createIssueDataQuery = (issueKey, projectKey)=>$c8ded878d9b9c772$export$ecc155df19ba52ff`query issueDataQuery {
        issue(issueIdOrKey: "${issueKey}", latestVersion: true, screen: "view") {
            id
            viewScreenId
            fields {
                key
                title
                editable
                required
                autoCompleteUrl
                allowedValues
                content
                renderedContent
                schema {
                    custom
                    system
                    ${$c8ded878d9b9c772$var$getCustomFieldSchemaConfiguration()}
                    items
                    type
                    renderer
                }
                configuration
            }
            expandAssigneeInSubtasks
            expandAssigneeInIssuelinks
            expandTimeTrackingInSubtasks
            systemFields {
                descriptionAdf {
                    value
                }
                ${$c8ded878d9b9c772$var$getEnvironmentQuery()}
            }
            customFields {
                textareaAdf {
                    key
                    value
                }
            }
            ${$c8ded878d9b9c772$var$getIsHybridAgilityProjectQuery()}
            ${$c8ded878d9b9c772$var$getAgileQuery()}
        }
        ${$c8ded878d9b9c772$var$getProjectQuery(projectKey)}
    }`;
var $c8ded878d9b9c772$export$2e2bcd8739ae039 = $c8ded878d9b9c772$var$createIssueDataQuery;

});


parcelRegister("3KXZZ", function(module, exports) {
$parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", () => $cc433f27aee6ba76$export$9f4ee8e6dc9a0a55);
$parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", () => $cc433f27aee6ba76$export$e7d75f9d93dfa3df);
$parcel$export(module.exports, "IssueViewFetchOperations", () => $cc433f27aee6ba76$export$b38f30d67f730bc4);
const $cc433f27aee6ba76$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
const $cc433f27aee6ba76$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
const $cc433f27aee6ba76$export$b38f30d67f730bc4 = {
    EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
    INITIAL_GRAPHQL: 'issueDataQuery',
    EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
    INITIAL_GIRA: 'issueViewInteractiveQuery',
    EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
    INITIAL_AGG: 'mainIssueAggQuery',
    EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
    NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery',
    VIEW_SCREEN_ID: 'viewScreenIdQuery',
    FIELD_CONFIGURATION: 'fieldConfigurationQuery',
    FIELD_DESCRIPTION: 'fieldDescriptionQuery',
    ATTACHMENT: 'attachmentsQuery'
};

});

parcelRegister("b1smt", function(module, exports) {
$parcel$export(module.exports, "useIssueFieldConfigStore", () => $f4887671cea7e277$export$52f51db4e2b3da57);
$parcel$export(module.exports, "useFieldConfigStore", () => $f4887671cea7e277$export$f9beb98c7488fd61);
$parcel$export(module.exports, "useFieldConfigStoreActions", () => $f4887671cea7e277$export$314199caf05d245);
$parcel$export(module.exports, "useIssueOverridesStore", () => $f4887671cea7e277$export$ff357cf5a96ec0c6);
$parcel$export(module.exports, "useFieldOverridesStore", () => $f4887671cea7e277$export$6e41e9c34587d557);
$parcel$export(module.exports, "useFieldOverridesStoreWithLabel", () => $f4887671cea7e277$export$e704d739927bd1d6);
$parcel$export(module.exports, "useOverridesStoreActions", () => $f4887671cea7e277$export$d94ae842140da412);
$parcel$export(module.exports, "useFieldOptionsOverrides", () => $f4887671cea7e277$export$bfea9bb9bad7bc8f);
$parcel$export(module.exports, "useIsFieldBusy", () => $f4887671cea7e277$export$982ff1008c2e2780);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $ahm5r = parcelRequire("ahm5r");

var $1O6Yz = parcelRequire("1O6Yz");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $f4887671cea7e277$var$setIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: IssueConfiguration | null; }' is not assignable to parameter of type 'Partial<Partial<Record<string, IssueConfiguration>>>'.
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: issueConfiguration
        });
    };
const $f4887671cea7e277$var$mergeIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, getState()[issueKey], issueConfiguration)
        });
    };
const $f4887671cea7e277$var$setIssuesConfig = (issuesWithConfigurations)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = issuesWithConfigurations.reduce((acc, issue)=>({
                ...acc,
                ...issue
            }), {});
        setState(newIssues);
    };
const $f4887671cea7e277$var$mergeIssuesConfig = (issuesWithConfigurations)=>({ setState: setState, getState: getState })=>{
        if (issuesWithConfigurations.length === 0) return;
        const newIssues = {};
        issuesWithConfigurations.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, getState(), newIssues));
    };
const $f4887671cea7e277$var$setFieldConfigValue = (issueKey, fieldKey, fieldConfiguration)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfiguration = getState()[issueKey];
        if (issueKeyFieldConfiguration && issueKeyFieldConfiguration[fieldKey]) setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: {
                    ...getState()[issueKey][fieldKey],
                    ...fieldConfiguration
                }
            }
        });
    };
const $f4887671cea7e277$var$actions = {
    setIssueConfig: $f4887671cea7e277$var$setIssueConfig,
    setIssuesConfig: $f4887671cea7e277$var$setIssuesConfig,
    mergeIssueConfig: $f4887671cea7e277$var$mergeIssueConfig,
    mergeIssuesConfig: $f4887671cea7e277$var$mergeIssuesConfig,
    setFieldConfigValue: $f4887671cea7e277$var$setFieldConfigValue
};
// this is a global state
const $f4887671cea7e277$var$store = (0, $GtRbT.createStore)({
    name: 'issue-field-config',
    initialState: {},
    actions: $f4887671cea7e277$var$actions
});
const $f4887671cea7e277$var$getIssueFieldConfig = (0, $ahm5r.createSelector)((state, props)=>state[props.issueKey], (issue)=>issue);
const $f4887671cea7e277$export$52f51db4e2b3da57 = (0, $iJq0l.createHook)($f4887671cea7e277$var$store, {
    selector: $f4887671cea7e277$var$getIssueFieldConfig
});
const $f4887671cea7e277$var$getFieldConfig = (0, $ahm5r.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey] : null;
});
const $f4887671cea7e277$var$getFieldConfigWithLabel = (0, $ahm5r.createSelector)($f4887671cea7e277$var$getFieldConfig, (fieldConfig)=>{
    if (fieldConfig?.title === undefined) return fieldConfig;
    return {
        ...fieldConfig,
        label: fieldConfig.title
    };
});
const $f4887671cea7e277$var$getFieldOptionsOverrides = (0, $ahm5r.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey].allowedValuesOverrides : null;
});
const $f4887671cea7e277$export$f9beb98c7488fd61 = (0, $iJq0l.createHook)($f4887671cea7e277$var$store, {
    selector: $f4887671cea7e277$var$getFieldConfig
});
const $f4887671cea7e277$export$314199caf05d245 = (0, $iJq0l.createHook)($f4887671cea7e277$var$store, {
    selector: null
});
const $f4887671cea7e277$var$setOverrides = (issueKey, fieldKey, fieldConfigOverrides)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfigurationWithOverrides = getState()[issueKey] ?? {};
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...issueKeyFieldConfigurationWithOverrides,
                [fieldKey]: {
                    ...issueKeyFieldConfigurationWithOverrides[fieldKey],
                    ...fieldConfigOverrides
                }
            }
        });
    };
const $f4887671cea7e277$var$resetOverridesStore = (issueKey)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [issueKey]: undefined
        });
    };
const $f4887671cea7e277$var$overridesActions = {
    setFieldConfigOverridesValue: $f4887671cea7e277$var$setOverrides,
    resetOverridesStore: $f4887671cea7e277$var$resetOverridesStore
};
// Store contains overrides to the field config. It is used by UI modifications to override field config properties by apps.
// UI modifications is a Forge extension point providing apps JS API to override field's properties: name, description, isEditable
// and limit visibility of select fields options.
const $f4887671cea7e277$var$overridesStore = (0, $GtRbT.createStore)({
    name: 'issue-field-overrides',
    initialState: {},
    actions: $f4887671cea7e277$var$overridesActions
});
const $f4887671cea7e277$export$ff357cf5a96ec0c6 = (0, $iJq0l.createHook)($f4887671cea7e277$var$overridesStore, {
    selector: $f4887671cea7e277$var$getIssueFieldConfig
});
const $f4887671cea7e277$export$6e41e9c34587d557 = (0, $iJq0l.createHook)($f4887671cea7e277$var$overridesStore, {
    selector: $f4887671cea7e277$var$getFieldConfig
});
const $f4887671cea7e277$export$e704d739927bd1d6 = (0, $iJq0l.createStateHook)($f4887671cea7e277$var$overridesStore, {
    selector: $f4887671cea7e277$var$getFieldConfigWithLabel
});
const $f4887671cea7e277$export$d94ae842140da412 = (0, $iJq0l.createActionsHook)($f4887671cea7e277$var$overridesStore);
const $f4887671cea7e277$export$bfea9bb9bad7bc8f = (0, $iJq0l.createHook)($f4887671cea7e277$var$overridesStore, {
    selector: $f4887671cea7e277$var$getFieldOptionsOverrides
});
const $f4887671cea7e277$var$getIsFieldBusySelector = (state, args)=>{
    const { fieldId: fieldId, issueKey: issueKey } = args;
    return fieldId !== undefined && !!state[issueKey]?.[fieldId]?.isBusy;
};
const $f4887671cea7e277$export$982ff1008c2e2780 = (0, $iJq0l.createStateHook)($f4887671cea7e277$var$overridesStore, {
    selector: $f4887671cea7e277$var$getIsFieldBusySelector
});

});



parcelRegister("3EmVH", function(module, exports) {
$parcel$export(module.exports, "useSummaryField", () => $6294e624de06ab59$export$a01f0885983ceff0);

var $9Dhvc = parcelRequire("9Dhvc");

var $2QNHW = parcelRequire("2QNHW");

var $2rHwS = parcelRequire("2rHwS");

var $3mZMJ = parcelRequire("3mZMJ");

var $9kwVk = parcelRequire("9kwVk");
const $6294e624de06ab59$export$a01f0885983ceff0 = ({ issueId: issueId, issueKey: issueKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure, onSaveField: onSaveField })=>{
    const [fieldConfig] = (0, $2rHwS.useFieldConfig)(issueKey, (0, $3mZMJ.SUMMARY_TYPE));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(fieldConfig.value, 'schema.type', 'string');
    const saveField = (0, $9kwVk.useSaveSummaryField)(issueId);
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $2QNHW.useEditField)({
        fieldKey: (0, $3mZMJ.SUMMARY_TYPE),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        saveField: saveField,
        // delete this condition and keep code inside when removing the isIncrementPlanningEnabled FF
        ...onSaveField && {
            saveField: onSaveField
        }
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("9kwVk", function(module, exports) {
$parcel$export(module.exports, "useSaveSummaryField", () => $6fe73ae90d5d1945$export$2429979662d1fc23);

var $hi3jH = parcelRequire("hi3jH");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3pSHx = parcelRequire("3pSHx");

var $14RSn = parcelRequire("14RSn");

var $4cTDP = parcelRequire("4cTDP");

var $jHI6h = parcelRequire("jHI6h");

var $cHtIB = parcelRequire("cHtIB");
const $6fe73ae90d5d1945$var$MUTATION_NAME = 'singleLineTextHeading_issueFieldSingleLineTextHeading_SingleLineTextHeadingField_Mutation';
const $6fe73ae90d5d1945$export$2429979662d1fc23 = (issueId)=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    // eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
    const [commit] = (0, $j4oe4.useMutation)((0, $hi3jH.default));
    return (0, $eJOHy.useCallback)(async (_issueKey, fieldId, newValue)=>new Promise((resolve, reject)=>{
            let JiraFieldAri = '';
            if ((0, $4cTDP.fg)('edit_issue_summary_slo_error_logging')) {
                (0, $jHI6h.startCapturingTraceIds)($6fe73ae90d5d1945$var$MUTATION_NAME);
                try {
                    JiraFieldAri = (0, $3pSHx.JiraIssuefieldvalueAri).create({
                        siteId: cloudId,
                        issueId: issueId || '',
                        fieldId: fieldId
                    }).toString();
                } catch (error) {
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    return reject(new (0, $14RSn.ValidationError)(error.message));
                }
            }
            commit({
                variables: {
                    input: {
                        id: (0, $4cTDP.fg)('edit_issue_summary_slo_error_logging') ? JiraFieldAri : (0, $3pSHx.JiraIssuefieldvalueAri).create({
                            siteId: cloudId,
                            issueId: issueId || '',
                            fieldId: fieldId
                        }).toString(),
                        operation: {
                            operation: 'SET',
                            text: newValue
                        }
                    }
                },
                onCompleted (response) {
                    if (response.jira?.updateSingleLineTextField) {
                        const { success: success, errors: responseErrors } = response.jira?.updateSingleLineTextField;
                        if (success) {
                            resolve();
                            return;
                        }
                        let traceIds = [];
                        if ((0, $4cTDP.fg)('edit_issue_summary_slo_error_logging')) {
                            traceIds = (0, $jHI6h.getTraceIds)($6fe73ae90d5d1945$var$MUTATION_NAME);
                            (0, $jHI6h.stopCapturingTraceIds)($6fe73ae90d5d1945$var$MUTATION_NAME);
                        }
                        if (responseErrors?.length) {
                            // passing the status code
                            if (responseErrors?.[0].extensions?.statusCode && (0, $4cTDP.fg)('edit_issue_summary_slo_error_logging')) {
                                const errorWithTraceId = new (0, $14RSn.default)(responseErrors?.[0].extensions?.statusCode, responseErrors?.[0].message || 'Unknown error when mutating summary', traceIds?.[0]);
                                return reject(errorWithTraceId);
                            }
                            reject(responseErrors[0].message ? new (0, $14RSn.ValidationError)(responseErrors[0].message) : new Error('Unknown error when mutating summary'));
                        }
                    } else reject(new Error('Unknown error when mutating summary'));
                },
                onError (error) {
                    if ((0, $4cTDP.fg)('edit_issue_summary_slo_error_logging')) (0, $jHI6h.stopCapturingTraceIds)($6fe73ae90d5d1945$var$MUTATION_NAME);
                    reject(error);
                }
            });
        }), [
        cloudId,
        commit,
        issueId
    ]);
};

});
parcelRegister("hi3jH", function(module, exports) {
$parcel$export(module.exports, "default", () => $52e766833f477698$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<099634c95eff3fd30acdeb7f5ec5a76b>>
 * @relayHash 3ae906955191bd1a18d08fa7d3eaa737
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d4bc262352a6c48b7c56f3ffba3f28502604dc9ba301c9ee6fa144c52b8d0fb3
const $52e766833f477698$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSaveSummaryFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleLineTextFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleLineTextField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ 
                                            ]
                                        },
                                        v4 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraSingleLineTextField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "singleLineTextHeading_issueFieldSingleLineTextInlineEditHeading_SingleLineTextHeadingInlineEditView"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSaveSummaryFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleLineTextFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleLineTextField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        },
                                        v4 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraSingleLineTextField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEditableInIssueView"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "text"
                                        },
                                        {
                                            "concreteType": "JiraFieldConfig",
                                            "kind": "LinkedField",
                                            "name": "fieldConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isRequired"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d4bc262352a6c48b7c56f3ffba3f28502604dc9ba301c9ee6fa144c52b8d0fb3",
            "metadata": {},
            "name": "useSaveSummaryFieldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$52e766833f477698$var$node.hash = "04659fa002699dfcfdf675c6e4871980";
var $52e766833f477698$export$2e2bcd8739ae039 = $52e766833f477698$var$node;

});

parcelRegister("3pSHx", function(module, exports) {
$parcel$export(module.exports, "JiraIssuefieldvalueAri", () => $27ce236fe1a3184f$export$828c4931ae562af7);

var $caazz = parcelRequire("caazz");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/issuefieldvalue/manifest.ts
var $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $caazz.JiraIssuefieldvalueAriResourceOwner),
    resourceType: (0, $caazz.JiraIssuefieldvalueAriResourceType),
    resourceIdSlug: "{issueId}/{fieldId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[a-zA-Z0-9_\-]+/
    }
};
// src/jira/issuefieldvalue/index.ts
var $27ce236fe1a3184f$export$828c4931ae562af7 = class _JiraIssuefieldvalueAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId, this._fieldId = opts.resourceIdSegmentValues.fieldId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    get fieldId() {
        return this._fieldId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.qualifier,
            platformQualifier: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.resourceOwner,
            resourceType: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}/${opts.fieldId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId,
                fieldId: opts.fieldId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId,
            fieldId: this.fieldId
        };
    }
};

});
parcelRegister("caazz", function(module, exports) {
$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceOwner", () => $8dae9ec06e7b65f0$export$39e9358142fbbc64);
$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceType", () => $8dae9ec06e7b65f0$export$f9e57427271adc95);
// src/jira/issuefieldvalue/types.ts
var $8dae9ec06e7b65f0$export$39e9358142fbbc64 = "jira", $8dae9ec06e7b65f0$export$f9e57427271adc95 = "issuefieldvalue";

});






parcelRegister("efhOD", function(module, exports) {
$parcel$export(module.exports, "useSubscribeCommands", () => $69e1ecd0b4d95d40$export$c13b008422be19c7);

var $iTb6Y = parcelRequire("iTb6Y");
const $69e1ecd0b4d95d40$export$c13b008422be19c7 = (0, $iTb6Y.useSubscribeCommandsWithRegistry);

});

const $57e4b742849c62a3$export$5252a6a6e4e4a774 = 'issue-field-status.ui.status-view.command-palette.issue-status';

parcelRegister("dnUkW", function(module, exports) {
$parcel$export(module.exports, "messages", () => $5f3068940e39da9d$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $5f3068940e39da9d$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    editStatus: {
        "id": "issue-field-status.status-view.command-palette.edit-status",
        "defaultMessage": "Edit status"
    },
    searchTransition: {
        "id": "issue-field-status.status-view.command-palette.search-transition",
        "defaultMessage": "Search a status or transition"
    },
    current: {
        "id": "issue-field-status.status-view.command-palette.current",
        "defaultMessage": "Current"
    },
    fallbackNoResults: {
        "id": "issue-field-status.status-view.command-palette.fallback-no-results",
        "defaultMessage": "No results match your search."
    },
    fallbackError: {
        "id": "issue-field-status.status-view.command-palette.fallback-error",
        "defaultMessage": "We're having trouble loading this data. Wait a few moments, then try again."
    }
});

});

parcelRegister("jXut7", function(module, exports) {
$parcel$export(module.exports, "useSaveStatusField", () => $1d9660599602eb4b$export$c6a3d42f97df89c9);

var $eJOHy = parcelRequire("eJOHy");

var $g51Bg = parcelRequire("g51Bg");

var $9pTd3 = parcelRequire("9pTd3");

var $4cTDP = parcelRequire("4cTDP");

var $keOPi = parcelRequire("keOPi");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $eaTQ3 = parcelRequire("eaTQ3");

var $f9jBk = parcelRequire("f9jBk");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");


var $ar711 = parcelRequire("ar711");
const $1d9660599602eb4b$export$c6a3d42f97df89c9 = (issueKey, issueId, onUpdateStatusMutation)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [{ commandPaletteSessionId: commandPaletteSessionId }] = (0, $g51Bg.useCommandPaletteSessionId)();
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [, { setFieldValue: setFieldValue }] = (0, $eaTQ3.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $c78d361852e02509$export$4420b7468f889692)
    });
    const onSaveSuccessfully = (0, $eJOHy.useCallback)((transition, callback)=>{
        const action = 'commandPalette';
        const actionSubject = 'changeStatus';
        const eventActionAndSubject = `${actionSubject} ${action}`;
        const event = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        });
        setFieldValue(issueKey, (0, $c78d361852e02509$export$4420b7468f889692), transition.to);
        callback?.();
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $kRgKj.fireTrackAnalytics)(event, eventActionAndSubject, {
            transitionId: transition.id,
            commandPaletteSessionId: commandPaletteSessionId
        });
        (0, $kRgKj.fireTrackAnalytics)(createAnalyticsEvent({}), 'statusField transitioned', 'statusField');
        showFlag({
            messageId: 'issue-field-status.ui.status-view.command-palette.use-save-status-field.show-flag.success',
            messageType: 'transactional',
            type: 'success',
            title: formatMessage((0, $ar711.messages).successFlagMessage)
        });
    }, [
        commandPaletteSessionId,
        createAnalyticsEvent,
        formatMessage,
        issueKey,
        setFieldValue,
        showFlag
    ]);
    const onFailSave = (0, $eJOHy.useCallback)((error)=>{
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'commandPaletteIssueStatus',
                packageName: 'jiraIssueFieldStatus',
                teamName: 'deliveroo'
            }
        });
        showFlag({
            messageId: 'issue-field-status.ui.status-view.command-palette.use-save-status-field.show-flag.error',
            messageType: 'transactional',
            type: 'error',
            title: formatMessage((0, $ar711.messages).errorFlagTitle),
            description: formatMessage((0, $ar711.messages).errorFlagDescription)
        });
    }, [
        formatMessage,
        showFlag
    ]);
    const openIssueTransitionModal = (0, $f9jBk.useOpenIssueTransitionModal)();
    const saveStatusField = (0, $eJOHy.useCallback)(async (transition, callback)=>{
        try {
            if (transition.hasScreen) {
                const handleDialogSuccess = ()=>onSaveSuccessfully(transition, callback);
                const handleDialogError = (err)=>onFailSave(err instanceof Error ? err : new Error('Something went wrong trying to update the status with screen using the command palette'));
                const transitionId = transition.id;
                openIssueTransitionModal({
                    payload: {
                        issueId: issueId,
                        issueKey: issueKey,
                        transitionId: transitionId
                    },
                    triggerPointKey: 'issue-transition-command-palette-status-field-transition',
                    onDialogSuccess: handleDialogSuccess,
                    onDialogError: handleDialogError
                });
            } else {
                if (onUpdateStatusMutation && (0, $4cTDP.fg)('relay-migration-issue-fields-status')) await onUpdateStatusMutation?.({
                    transitionId: transition.id,
                    newStatus: transition.to
                });
                else await (0, $keOPi.performIssuePostRequest)(`/rest/api/3/issue/${issueKey}/transitions`, {
                    body: JSON.stringify({
                        transition: transition
                    })
                }, 'fields/status/src/ui/status-view/command-palette/use-save-status-field');
                onSaveSuccessfully(transition, callback);
            }
        } catch (err) {
            const error = err instanceof Error ? err : new Error('Something went wrong trying to update the status using the command palette');
            onFailSave(error);
        }
    }, [
        issueId,
        issueKey,
        onFailSave,
        onSaveSuccessfully,
        onUpdateStatusMutation,
        openIssueTransitionModal
    ]);
    return {
        saveStatusField: saveStatusField
    };
};

});
const $c78d361852e02509$export$e18419056f3d184a = 'assignee';
const $c78d361852e02509$export$45cafdfd629c3ca1 = 'reporter';
const $c78d361852e02509$export$d5bc879e3b748593 = 'description';
const $c78d361852e02509$export$a68dbc90211df1a8 = 'fixVersions';
const $c78d361852e02509$export$93605f2a09aa8d26 = 'labels';
const $c78d361852e02509$export$4420b7468f889692 = 'status';
const $c78d361852e02509$export$e7cf1830fe735d1f = 'summary';
const $c78d361852e02509$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $c78d361852e02509$export$3fb78a14b7a56ff9 = 'timeestimate';
const $c78d361852e02509$export$a5fc282ab2bf9b89 = 'issuelinks';
const $c78d361852e02509$export$b52547457d714bc0 = 'epic-issues';
const $c78d361852e02509$export$3cca6e37a5823d5a = 'children-issues';
const $c78d361852e02509$export$98a935eb30de54ab = 'components';
const $c78d361852e02509$export$f7a17147527dd688 = 'flag';

parcelRegister("ar711", function(module, exports) {
$parcel$export(module.exports, "messages", () => $facc571c7d7ed7b8$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $facc571c7d7ed7b8$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    successFlagMessage: {
        "id": "issue-field-status.status-view.command-palette.use-save-status-field.success-flag-message",
        "defaultMessage": "Status updated"
    },
    errorFlagTitle: {
        "id": "issue-field-status.status-view.command-palette.use-save-status-field.error-flag-title",
        "defaultMessage": "We're unable to edit status"
    },
    errorFlagDescription: {
        "id": "issue-field-status.status-view.command-palette.use-save-status-field.error-flag-description",
        "defaultMessage": "Wait a few moments, then try again."
    }
});

});


parcelRegister("ku7AV", function(module, exports) {
$parcel$export(module.exports, "getTransitionKeywords", () => $69891a65ef885154$export$258538e0d3d46460);
const $69891a65ef885154$export$258538e0d3d46460 = (transition)=>{
    if (transition.name !== transition.to.name) return `${transition.name} ${transition.to.name}`;
    return transition.name;
};

});


parcelRegister("aKmI9", function(module, exports) {
$parcel$export(module.exports, "CreateStatusButton", () => $7f2792bccbea3643$export$d2e0b4f33d77a2b8);
/* CreateStatusButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $jOPSA = parcelRequire("jOPSA");

var $lRq8t = parcelRequire("lRq8t");

var $fiJwW = parcelRequire("fiJwW");

var $dxcgx = parcelRequire("dxcgx");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $lppZM = parcelRequire("lppZM");
var $bE8VR = parcelRequire("bE8VR");


var $cHtIB = parcelRequire("cHtIB");

var $4cTDP = parcelRequire("4cTDP");

var $aaGSX = parcelRequire("aaGSX");

var $asoyU = parcelRequire("asoyU");

var $8yyDM = parcelRequire("8yyDM");

var $62tn0 = parcelRequire("62tn0");

var $eCUrP = parcelRequire("eCUrP");
const $7f2792bccbea3643$export$d2e0b4f33d77a2b8 = ({ projectId: projectId, projectKey: projectKey, projectType: projectType, issueTypeId: issueTypeId, statusNames: statusNames = [], onClick: onClick, onClose: onClose, onStatusCreated: onStatusCreated, buttonRef: buttonRef = null, source: source, shouldTriggerModal: shouldTriggerModal = true })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const trigger = (0, $bE8VR.useTriggerContext)((0, $eCUrP.ConfigureStatusPanel));
    const handleClick = (0, $eJOHy.useCallback)((_e, analyticsEvent)=>{
        onClick();
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'createStatusButton'); // Because we are triggering the click manually for keyboard users
        // this handler becomes the source-of-truth handler for both keyboard users and mouse users
        // However, we need to stopPropagation from here to prevent double modal for mouse users
        // When mouse user clicks the button, if we don't stop propagation here, handleChange
        // will be called which will trigger click manually again and cause double modal rendering
        _e.stopPropagation();
    }, [
        onClick
    ]);
    const onModalClose = (0, $eJOHy.useCallback)(()=>{
        onClose();
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'inlineCreateStatusModal'
        }));
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            projectKey: projectKey
        }), [
        cloudId,
        projectKey
    ]);
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            statusNames: statusNames,
            projectId: projectId,
            projectKey: projectKey,
            projectType: projectType,
            onClose: onModalClose,
            isNewControllerEnabled: true,
            workflowAssociatedIssueTypeId: issueTypeId,
            createStatusExperience: $8yyDM.createStatusExperience,
            source: source || (0, $a63b79662d6e9902$export$cafb161c2b21b455),
            onStatusCreated: onStatusCreated,
            isWrappedInModal: shouldTriggerModal
        }), [
        statusNames,
        projectId,
        projectKey,
        projectType,
        onModalClose,
        issueTypeId,
        source,
        onStatusCreated,
        shouldTriggerModal
    ]);
    const getClickElement = (0, $eJOHy.useCallback)((ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
            xcss: $7f2792bccbea3643$var$flexContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7f2792bccbea3643$var$StyledButton, {
            appearance: "subtle",
            shouldFitContainer: true,
            interactionName: "issue.fields.status.create-status.popup.open",
            onClick: handleClick,
            ref: ref
        }, formatMessage((0, $62tn0.messages).createStatus))), [
        formatMessage,
        handleClick
    ]);
    const modalTrigger = (0, $4cTDP.fg)('inline_config_migrate_deprecated_modal_entrypoints') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $asoyU.ModalTrigger), {
        entryPoint: (0, $jOPSA.asyncInlineCreateStatusModal),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        modalProps: (0, $fiJwW.defaultModalProps),
        forwardedRef: buttonRef,
        Fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                numFormFields: 2
            })
    }, ({ ref: ref })=>getClickElement(ref)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxcgx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $jOPSA.asyncInlineCreateStatusModal),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        interactionName: "create-status-modal",
        modalProps: (0, $fiJwW.defaultModalProps),
        useInternalModal: true,
        forwardedRef: buttonRef,
        Fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                numFormFields: 2
            })
    }, ({ ref: ref })=>getClickElement(ref));
    return shouldTriggerModal ? modalTrigger : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lppZM.Trigger), {
        trigger: trigger,
        entryPoint: (0, $jOPSA.asyncInlineCreateStatusModal),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
            numFormFields: 2
        })
    }, ({ ref: ref })=>getClickElement(ref));
};
// Move all styled/xcss/css components to the bottom
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $7f2792bccbea3643$var$StyledButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _y3gn1e5h _syaz1fxt _ca0qpxbi _u5f3utpp _n3tdpxbi _19bvutpp _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $7f2792bccbea3643$var$flexContainerStyles = (0, $1DXK0.xcss)({
    flexGrow: 1,
    height: "var(--ds-space-500, 40px)"
});

});
parcelRegister("jOPSA", function(module, exports) {
$parcel$export(module.exports, "asyncInlineCreateStatusModal", () => $84cb6d9719e04136$export$64a761d25b20910a);

var $e6LaQ = parcelRequire("e6LaQ");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $84cb6d9719e04136$export$64a761d25b20910a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("6F7Y9")), {
        moduleId: "4ce02bb0",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey })=>({
            queries: {
                inlineCreateStatusModal: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $e6LaQ.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        })
});

});
parcelRegister("e6LaQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e7c266e7a20f6f1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a1c9f0ca0f32a1a7d832e77365f43e75>>
 * @relayHash 0df4748cd7c393765978be5843c7a913
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6f93e860194a5c2419c4911409b28d0ab9e3c6da5d722ecc79fae56d217265b
const $0e7c266e7a20f6f1$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a6f93e860194a5c2419c4911409b28d0ab9e3c6da5d722ecc79fae56d217265b",
        "metadata": {},
        "name": "srcAsyncInlineCreateStatusQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0e7c266e7a20f6f1$export$2e2bcd8739ae039 = $0e7c266e7a20f6f1$var$node;

});

parcelRegister("6F7Y9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1hxuP").then(()=>parcelRequire('4BRVO'));

});


parcelRegister("fiJwW", function(module, exports) {
$parcel$export(module.exports, "defaultModalProps", () => $1c2c3e9e62ce7fa5$export$14c11acc66fd51b3);
const $1c2c3e9e62ce7fa5$export$14c11acc66fd51b3 = {
    width: '395px'
};

});

parcelRegister("dxcgx", function(module, exports) {
$parcel$export(module.exports, "ModalEntryPointPressableTrigger", () => $6e1a9fb892f137c0$export$defad645fcc21c0a);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2bMVP = parcelRequire("2bMVP");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $78OnL = parcelRequire("78OnL");

var $dllpM = parcelRequire("dllpM");

var $lJKII = parcelRequire("lJKII");

var $4B7rn = parcelRequire("4B7rn");

var $5GSFM = parcelRequire("5GSFM");

var $bzbsd = parcelRequire("bzbsd");

var $7lK6t = parcelRequire("7lK6t");

var $5HFSX = parcelRequire("5HFSX");

var $4cTDP = parcelRequire("4cTDP");

var $8yPs2 = parcelRequire("8yPs2");
const $6e1a9fb892f137c0$var$emptyObject = {};
const $6e1a9fb892f137c0$export$defad645fcc21c0a = ({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, interactionName: interactionName, title: title, modalProps: modalProps, useInternalModal: useInternalModal, forwardedRef: forwardedRef, hasCloseButton: hasCloseButton })=>{
    const { openModal: openModal } = (0, $eJOHy.useContext)((0, $7lK6t.ModalContext));
    const environmentProvider = (0, $5HFSX.useJiraRelayEnvironmentProvider)();
    const metricName = (0, $eJOHy.useMemo)(()=>{
        if (interactionName) return interactionName;
        // @ts-expect-error Need to fix the types on this
        return entryPoint?.root?.getModuleName() ?? 'unknown';
    }, [
        entryPoint,
        interactionName
    ]);
    // eslint-disable-next-line jira/ufo/valid-labels
    const pressTracing = (0, $dllpM.default)(metricName);
    const load = (0, $eJOHy.useCallback)(()=>(0, $j4oe4.loadEntryPoint)(environmentProvider, entryPoint, // @ts-expect-error TS cannot infer that emptyObject is the correct params
        // type for TEntryPoint even when performing an explicit undefined check
        entryPointParams ?? $6e1a9fb892f137c0$var$emptyObject), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onBeforeLoad = (0, $eJOHy.useCallback)(()=>{
        if (interactionName) pressTracing();
    }, [
        interactionName,
        pressTracing
    ]);
    const onLoad = (0, $eJOHy.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = ()=>{
                entryPointProps?.onClose?.();
                closeModal();
                dispose();
            };
            const defaultFallbackInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
                hasCloseButton: (0, $4cTDP.fg)('platform_relay_use_hasclosebutton') && hasCloseButton
            }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), null, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
                grow: "fill"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null));
            const defaultFallback = useInternalModal ? defaultFallbackInner : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
                messageId: "modal-entry-point-pressable-trigger.modal.fallback",
                messageType: "transactional",
                onClose: closeModal,
                width: modalProps?.width,
                height: modalProps?.height
            }, defaultFallbackInner);
            const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5GSFM.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorAttributes: errorAttributes,
                errorFallback: "flag",
                fallback: Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                // @ts-expect-error Some type mismatch, should fix it one day
                runtimeProps: {
                    ...entryPointProps ?? $6e1a9fb892f137c0$var$emptyObject,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return useInternalModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
                ...modalProps,
                messageId: "modal-entry-point-pressable-trigger.modal",
                messageType: "transactional",
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress
            }, container)) : container;
        });
    }, [
        openModal,
        title,
        useInternalModal,
        modalProps,
        errorAttributes,
        Fallback,
        metricName,
        entryPointProps,
        hasCloseButton
    ]);
    const triggerRef = (0, $8yPs2.usePressablePreloadRef)({
        load: load,
        onBeforeLoad: onBeforeLoad,
        onLoad: onLoad
    });
    if (forwardedRef != null) {
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const ref = (0, $bzbsd.default)(triggerRef, forwardedRef);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return children({
            ref: ref
        });
    }
    return children({
        ref: triggerRef
    });
};

});
parcelRegister("8yPs2", function(module, exports) {
$parcel$export(module.exports, "usePressablePreloadRef", () => $29a42d023a266ffa$export$1ff47f24e06a5d2d);

var $eJOHy = parcelRequire("eJOHy");
const $29a42d023a266ffa$var$PRELOAD_MAX_AGE = 2000;
const $29a42d023a266ffa$var$TIME_TO_INTENT = 200;
function $29a42d023a266ffa$export$1ff47f24e06a5d2d({ load: load, onBeforeLoad: onBeforeLoad, onLoad: onLoad }) {
    const ref = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const clickListener = ()=>{
            clearPreloadTimeouts();
            onBeforeLoad();
            onLoad(loadReference());
        };
        const mouseDownListener = ()=>{
            clearPreloadTimeouts();
            loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $29a42d023a266ffa$var$PRELOAD_MAX_AGE);
            }, $29a42d023a266ffa$var$TIME_TO_INTENT);
        };
        el.addEventListener('click', clickListener);
        el.addEventListener('mousedown', mouseDownListener);
        el.addEventListener('mouseenter', preloadReference);
        el.addEventListener('mouseleave', cancelPreload);
        return ()=>{
            cancelPreload();
            el.removeEventListener('click', clickListener);
            el.removeEventListener('mousedown', mouseDownListener);
            el.removeEventListener('mouseenter', preloadReference);
            el.removeEventListener('mouseleave', cancelPreload);
        };
    }, [
        load,
        onBeforeLoad,
        onLoad
    ]);
    return ref;
}

});


parcelRegister("bE8VR", function(module, exports) {
$parcel$export(module.exports, "useTriggerContext", () => $ce0c3b0e8f7e0532$export$454c1d7c35958f5e);

var $eJOHy = parcelRequire("eJOHy");
function $ce0c3b0e8f7e0532$export$454c1d7c35958f5e(panel) {
    const { setPanel: setPanel } = (0, $eJOHy.useContext)(panel.Context);
    return (0, $eJOHy.useMemo)(()=>({
            setPanel: setPanel
        }), [
        setPanel
    ]);
}

});

const $a63b79662d6e9902$export$c766acff4513a976 = 'summaryView';
const $a63b79662d6e9902$export$4edb790587638895 = 'listView';
const $a63b79662d6e9902$export$7e2d75b13279a710 = 'listViewNoResults';
const $a63b79662d6e9902$export$5e4b47163db377f = 'listViewGroupByStatus';
const $a63b79662d6e9902$export$cafb161c2b21b455 = 'issueView';
const $a63b79662d6e9902$export$66397ed56abea4ca = 'gicView';
const $a63b79662d6e9902$export$46d07e67f98555aa = 'editStatusButton';
const $a63b79662d6e9902$export$415149578ef78676 = 'deleteStatusButton';

parcelRegister("aaGSX", function(module, exports) {
$parcel$export(module.exports, "FormDialogSkeleton", () => $0b33aba420d5c901$export$3e5b4585c21ca29d);

var $eJOHy = parcelRequire("eJOHy");

var $lmgo6 = parcelRequire("lmgo6");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $jjS5D = parcelRequire("jjS5D");
const $0b33aba420d5c901$var$COMMON_SKELETON_PROPS = {
    borderRadius: "var(--ds-radius-large, 8px)",
    isShimmering: true
};
const $0b33aba420d5c901$export$3e5b4585c21ca29d = ({ numFormFields: numFormFields })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        direction: "column",
        xcss: $0b33aba420d5c901$var$modalSkeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        direction: "column",
        xcss: $0b33aba420d5c901$var$headerSkeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "40%",
        height: 24,
        ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.header-title"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "35%",
        height: 16,
        ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.header-subtitle"
    }))), Array.from({
        length: numFormFields
    }).map((_, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
            space: "space.050",
            key: idx,
            xcss: $0b33aba420d5c901$var$formFieldSkeletonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
            width: "30%",
            height: 16,
            ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
            testId: `form-field-label-${idx}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
            width: "100%",
            height: 40,
            ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
            testId: `form-field-input-${idx}`
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        justifyContent: "end",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: 72,
        height: 32,
        ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.cancel-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: 72,
        height: 32,
        ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.submit-button"
    }))));
const $0b33aba420d5c901$var$modalSkeletonStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'radius.xlarge',
    width: '394px',
    padding: 'space.300'
});
const $0b33aba420d5c901$var$headerSkeletonStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.100'
});
const $0b33aba420d5c901$var$formFieldSkeletonStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});

});

parcelRegister("8yyDM", function(module, exports) {
$parcel$export(module.exports, "createStatusExperience", () => $6417766cf755877a$export$750cfa63c61c5008);
$parcel$export(module.exports, "editStatusExperience", () => $6417766cf755877a$export$1c3aa89ea6d8c93d);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");
const $6417766cf755877a$export$750cfa63c61c5008 = new (0, $f39LL.UFOExperience)('issue-view.create-status', {
    type: (0, $2lxLk.ExperienceTypes).Operation,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom
});
const $6417766cf755877a$export$1c3aa89ea6d8c93d = new (0, $f39LL.UFOExperience)('issue-view.edit-status', {
    type: (0, $2lxLk.ExperienceTypes).Operation,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom
});

});

parcelRegister("62tn0", function(module, exports) {
$parcel$export(module.exports, "messages", () => $18af944bcfc95931$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $18af944bcfc95931$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    statusNameButtonLabel: {
        "id": "issue-field-status.status-view.transition.configure-status.status-name-button-label",
        "defaultMessage": "Edit {statusName} status"
    },
    editStatusTooltip: {
        "id": "issue-field-status.status-view.transition.configure-status.edit-status-tooltip",
        "defaultMessage": "Edit status"
    },
    createStatus: {
        "id": "issue-field-status.status-view.configure-status.create-status",
        "defaultMessage": "Create status"
    },
    editStatus: {
        "id": "issue-field-status.status-view.configure-status.edit-status",
        "defaultMessage": "Edit status"
    }
});

});

parcelRegister("eCUrP", function(module, exports) {
$parcel$export(module.exports, "ConfigureStatusPanel", () => $364d049240095d21$export$3f3f3d137a7524e6);

var $5j8hU = parcelRequire("5j8hU");
const $364d049240095d21$export$3f3f3d137a7524e6 = (0, $5j8hU.createPanel)();

});
parcelRegister("5j8hU", function(module, exports) {
$parcel$export(module.exports, "createPanel", () => $10eff731f4fb221b$export$71ce2d4d67b6d9e4);

var $eJOHy = parcelRequire("eJOHy");
function $10eff731f4fb221b$export$71ce2d4d67b6d9e4() {
    const Context = /*#__PURE__*/ (0, $eJOHy.createContext)({
        setPanel: ()=>{}
    });
    return {
        Context: Context
    };
}

});



parcelRegister("aY0vM", function(module, exports) {
$parcel$export(module.exports, "default", () => $99e1b73ebbb9da2d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $99e1b73ebbb9da2d$var$messages = (0, $7qGN1.defineMessages)({
    noPermission: {
        "id": "issue-field-status.status-view.no-permission",
        "defaultMessage": "You don't have permission to transition this issue"
    },
    cannotLoadTransitions: {
        "id": "issue-field-status.status-view.cannot-load-transitions",
        "defaultMessage": "We couldn't load the statuses and transitions"
    },
    changeStatus: {
        "id": "issue-field-status.status-view.change-status",
        "defaultMessage": "Change status"
    },
    selectStatus: {
        "id": "issue-field-status.status-view.select-status",
        "defaultMessage": "Select status"
    },
    transitionTo: {
        "id": "issue-field-status.status-view.transition-to",
        "defaultMessage": "Transition to {statusName}"
    },
    noPermissionIssueTermRefresh: {
        "id": "issue-field-status.status-view.no-permission-issue-term-refresh",
        "defaultMessage": "You don't have permission to transition this work item"
    },
    status: {
        "id": "issue-field-status.status-view.status",
        "defaultMessage": "Status"
    },
    createStatus: {
        "id": "issue-field-status.status-view.create-status",
        "defaultMessage": "Create status"
    },
    editStatus: {
        "id": "issue-field-status.status-view.edit-status",
        "defaultMessage": "Edit status"
    },
    manageWorkflow: {
        "id": "issue-field-status.status-view.manage-workflow",
        "defaultMessage": "Manage workflow"
    }
});
var $99e1b73ebbb9da2d$export$2e2bcd8739ae039 = $99e1b73ebbb9da2d$var$messages;

});

parcelRegister("ke54d", function(module, exports) {
$parcel$export(module.exports, "LoadingSpinner", () => $90c5aa8926802ca9$export$b08b517936747730);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7ep4S = parcelRequire("7ep4S");
const $90c5aa8926802ca9$export$b08b517936747730 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($90c5aa8926802ca9$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        interactionName: "issue.fields.status.options.loading"
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $90c5aa8926802ca9$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2gPiL", function(module, exports) {
$parcel$export(module.exports, "StatusButton", () => $d92569ee3c144684$export$517b7ecb2da8e76d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1OQKp = parcelRequire("1OQKp");

var $goZPP = parcelRequire("goZPP");

var $k71qx = parcelRequire("k71qx");

var $f2JN3 = parcelRequire("f2JN3");

var $6XJko = parcelRequire("6XJko");

var $9RE4U = parcelRequire("9RE4U");

var $lhTT7 = parcelRequire("lhTT7");

var $g1vYr = parcelRequire("g1vYr");
const $d92569ee3c144684$var$getButton = (categoryId)=>{
    switch(categoryId){
        case 2:
            return $d92569ee3c144684$var$ToDoButton;
        case 3:
            return 0, $g1vYr.DoneButton;
        case 4:
            return $d92569ee3c144684$var$InProgressButton;
        default:
            return $d92569ee3c144684$var$DefaultButton;
    }
};
const $d92569ee3c144684$var$buttonStyle = null;
const $d92569ee3c144684$var$buttonStyleRefresh = null;
const $d92569ee3c144684$export$517b7ecb2da8e76d = (props)=>{
    const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, status: status, targetRef: targetRef, statusButtonRef: statusButtonRef, shouldFitContainer: shouldFitContainer = true, triggerProps: triggerProps = {}, helperTextId: helperTextId } = props;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const Button = $d92569ee3c144684$var$getButton(status.statusCategory.id);
    const isPageHydrating = (0, $9RE4U.useIsHydrateRenderMode)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: targetRef,
        ...triggerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "top",
        content: status.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lhTT7.default), {
        status: status
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Button, {
        id: "issue.fields.status-view.status-button",
        ref: statusButtonRef,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
            label: "",
            size: "small"
        }),
        testId: "issue-field-status.ui.status-view.status-button.status-button",
        shouldFitContainer: shouldFitContainer,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // When the popup is open we don't want to track the click on this button as it solely closes
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        // eslint-disable-next-line jira/ufo/valid-labels
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined,
        "data-ssr-placeholder": false && !isPageHydrating ? 'status-button' : undefined,
        "data-ssr-placeholder-replace": !false && !isPageHydrating ? 'status-button' : undefined,
        "aria-describedby": helperTextId,
        className: (0, $hcewu.default)([
            "_12r21pd9",
            (0, $6XJko.isVisualRefreshEnabled)() && "_19bv12x7 _1n8wglyw _12r21wq8"
        ])
    }, status.name))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $d92569ee3c144684$var$InProgressComponentVisualRefresh = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !__cmplp.isSelected && "_193glmqn _11a4lmqn _dntb16l4 _cp4g16l4 _5xmdlmqn _11sm16l4",
            __cmplp.className
        ])
    });
});
const $d92569ee3c144684$var$InProgressComponentCurrent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !__cmplp.isSelected && "_193g1mk5 _11a41mk5 _dntb1gfe _cp4g1gfe _5xmd4vzc _11sm1gfe",
            __cmplp.className
        ])
    });
});
const $d92569ee3c144684$var$InProgressButton = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $d92569ee3c144684$var$InProgressComponentVisualRefresh, $d92569ee3c144684$var$InProgressComponentCurrent);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $d92569ee3c144684$var$ToDoButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !__cmplp.isSelected && "_193g1d94 _11a41d94 _dntb16l4 _cp4g16l4 _5xmd1hek _11sm16l4",
            __cmplp.className
        ])
    });
});
const $d92569ee3c144684$var$DefaultButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !__cmplp.isSelected && "_193g1d94 _11a41d94 _dntb16l4 _cp4g16l4 _5xmd1hek _11sm16l4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lhTT7", function(module, exports) {
$parcel$export(module.exports, "default", () => $b410745bf354b3d3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $cdbP5 = parcelRequire("cdbP5");
// TODO consolidate status id's
const $b410745bf354b3d3$var$DONE_ID = 3;
class $b410745bf354b3d3$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    componentDidUpdate(prevProps) {
        if (prevProps.status.statusCategory.id !== this.props.status.statusCategory.id) this.setState({
            shouldShow: this.props.status.statusCategory.id === $b410745bf354b3d3$var$DONE_ID
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b410745bf354b3d3$var$PulseContainer, {
            shouldShow: this.state.shouldShow
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.state = {
            shouldShow: false
        };
    }
}
const $b410745bf354b3d3$var$PulseAnimation = /*#__PURE__*/ (0, $cdbP5.keyframes)({
    to: {
        boxShadow: '0 0 0 10px rgba(0, 0, 0, 0)'
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $b410745bf354b3d3$var$PulseContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldShow: shouldShow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1qbqnkm": (0, $awdRS.default)($b410745bf354b3d3$var$PulseAnimation)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _1e0c116y _1bsb1osq _16qs1pcf",
            __cmplp.shouldShow ? "_y44v1upg" : "_y44vglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("g1vYr", function(module, exports) {
$parcel$export(module.exports, "DoneButton", () => $c2938a2595a34a4b$export$e6559310cd173125);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $f2JN3 = parcelRequire("f2JN3");

var $6XJko = parcelRequire("6XJko");
const $c2938a2595a34a4b$export$b7c3a2f69225ecf = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !__cmplp.isSelected && "_193g1d94 _11a41d94 _dntb16l4 _cp4g16l4 _5xmd1hek _11sm16l4",
            __cmplp.className
        ])
    });
});
const $c2938a2595a34a4b$export$97f73b7c6e2328e5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !__cmplp.isSelected && "_193g1d94 _11a41d94 _dntb16l4 _cp4g16l4 _5xmd1hek _11sm16l4",
            __cmplp.className
        ])
    });
});
const $c2938a2595a34a4b$var$InProgressComponentVisualRefresh = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !__cmplp.isSelected && "_193glmqn _11a4lmqn _dntb16l4 _cp4g16l4 _5xmdlmqn _11sm16l4",
            __cmplp.className
        ])
    });
});
const $c2938a2595a34a4b$var$InProgressComponentCurrent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !__cmplp.isSelected && "_193g1mk5 _11a41mk5 _dntb1gfe _cp4g1gfe _5xmd4vzc _11sm1gfe",
            __cmplp.className
        ])
    });
});
const $c2938a2595a34a4b$export$8c94aeefd701630d = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $c2938a2595a34a4b$var$InProgressComponentVisualRefresh, $c2938a2595a34a4b$var$InProgressComponentCurrent);
const $c2938a2595a34a4b$export$5392037c0e6ad119 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !__cmplp.isSelected && "_193g1jjx _11a41jjx _dntb16l4 _cp4g16l4 _5xmd1jjx _11sm16l4",
            __cmplp.className
        ])
    });
});
const $c2938a2595a34a4b$export$5445f55445c67248 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !__cmplp.isSelected && "_193g1rwo _11a41rwo _dntb1gfe _cp4g1gfe _5xmd14kv _11sm1gfe",
            __cmplp.className
        ])
    });
});
const $c2938a2595a34a4b$export$e6559310cd173125 = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $c2938a2595a34a4b$export$5392037c0e6ad119, $c2938a2595a34a4b$export$5445f55445c67248);

});


parcelRegister("dYFa5", function(module, exports) {
$parcel$export(module.exports, "Transition", () => $df43a9db530a58a1$export$be58926105124dd4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k71qx = parcelRequire("k71qx");

var $2R0ne = parcelRequire("2R0ne");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $3J5Vz = parcelRequire("3J5Vz");

var $89H4a = parcelRequire("89H4a");
const $df43a9db530a58a1$export$be58926105124dd4 = ({ hasLabel: hasLabel, transition: transition, addTransitionArrowSpacing: addTransitionArrowSpacing, contentAfter: contentAfter, testId: testId })=>{
    if (transition.isDisabled === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df43a9db530a58a1$var$DisabledTransition, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $89H4a.TransitionWithoutLabel), {
        transition: transition,
        isDisabled: true
    }), transition.unavailableReasonText != null && transition.unavailableReasonText !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: transition.unavailableReasonText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df43a9db530a58a1$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
        label: "",
        color: "var(--ds-text-disabled, #091E424F)",
        spacing: "spacious",
        testId: "issue-field-status.ui.status-view.transition.information-icon"
    }))));
    const transitionComponent = hasLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3J5Vz.TransitionWithLabel), {
        transition: transition,
        addTransitionArrowSpacing: addTransitionArrowSpacing
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $89H4a.TransitionWithoutLabel), {
        transition: transition
    });
    return contentAfter ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _wjvokb7n"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $df43a9db530a58a1$var$transitionComponentStyles
    }, transitionComponent), contentAfter) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": testId
    }, transitionComponent);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df43a9db530a58a1$var$DisabledTransition = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx2vrvc _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $df43a9db530a58a1$var$IconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reoewfl _18m9ewfl _4t3io7ao _19pkr5cr",
            __cmplp.className
        ])
    });
});
const $df43a9db530a58a1$var$transitionWrapperStyles = null;
const $df43a9db530a58a1$var$transitionComponentStyles = (0, $1DXK0.xcss)({
    alignItems: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("3J5Vz", function(module, exports) {
$parcel$export(module.exports, "TransitionWithLabel", () => $9223b88f79eab721$export$20d2722b94f01359);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ePxSL = parcelRequire("ePxSL");

var $2sLVw = parcelRequire("2sLVw");

var $dTocu = parcelRequire("dTocu");

var $6XJko = parcelRequire("6XJko");

var $6UBwj = parcelRequire("6UBwj");

var $5q0Ec = parcelRequire("5q0Ec");
const $9223b88f79eab721$var$getLabel = (transition, intl)=>{
    if (transition.isGlobal) {
        if (transition.name !== transition.to.name) return transition.name;
        return intl.formatMessage((0, $5q0Ec.default).globalTransition);
    }
    return transition.name;
};
const $9223b88f79eab721$export$20d2722b94f01359 = (props)=>{
    const intl = (0, $dTocu.useIntlV2)();
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9223b88f79eab721$export$147422f7450ccfac, null, $9223b88f79eab721$var$getLabel(props.transition, intl)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9223b88f79eab721$export$da4545fe0ca096cf, {
        visualRefresh: (0, $6XJko.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9223b88f79eab721$var$VerticalCenter, {
        addTransitionArrowSpacing: props.addTransitionArrowSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ePxSL))), {
        label: "",
        testId: "issue-field-status.ui.status-view.transition.with-label.arrow-right"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UBwj.StatusLozenge), {
        status: props.transition.to,
        isDisabled: props.isDisabled
    })));
    if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        gap: "space.100"
    }, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9223b88f79eab721$var$Wrapper, null, content);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9223b88f79eab721$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9223b88f79eab721$export$147422f7450ccfac = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $9223b88f79eab721$export$da4545fe0ca096cf = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1o9zidpf _1e0c1txw",
            __cmplp.visualRefresh && "_zulpu2gc _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $9223b88f79eab721$var$VerticalCenter = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { addTransitionArrowSpacing: addTransitionArrowSpacing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _4cvr1h6o",
            __cmplp.addTransitionArrowSpacing ? "_18s8s8vo" : "_19pk1kw7 _2hwx1kw7 _otyr1kw7 _18u01kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ePxSL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::702c7642ca2bbc12ec1dc2b75efbc1ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acc01c6bd1fc51c7$var$_react = $acc01c6bd1fc51c7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $acc01c6bd1fc51c7$var$_baseNew = $acc01c6bd1fc51c7$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $acc01c6bd1fc51c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $acc01c6bd1fc51c7$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $acc01c6bd1fc51c7$var$_react.default.createElement($acc01c6bd1fc51c7$var$_baseNew.default, Object.assign({
        name: "ArrowRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$acc01c6bd1fc51c7$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $acc01c6bd1fc51c7$var$_default = module.exports.default = $acc01c6bd1fc51c7$var$ArrowRightIcon;

});

parcelRegister("dTocu", function(module, exports) {
$parcel$export(module.exports, "useIntlV2", () => $3e10afa6ddf4542a$export$d82607073b68786);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");
const $3e10afa6ddf4542a$export$d82607073b68786 = ()=>{
    const { messages: messages, locale: locale, formats: formats, formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber, formatPlural: formatPlural, formatTime: formatTime } = (0, $lRq8t.default)();
    // Only recreate intl object if reference to originral intl changes.
    const memoisedIntl = (0, $eJOHy.useMemo)(()=>{
        const modifiedIntl = {
            messages: // @ts-expect-error - TS2322 - Type 'Record<string, string> | Record<string, MessageFormatElement[]>' is not assignable to type '{ [id: string]: string; }'.
            messages,
            locale: locale,
            formats: formats,
            formatDate: formatDate,
            formatMessage: formatMessage,
            formatNumber: formatNumber,
            formatPlural: formatPlural,
            formatTime: formatTime
        };
        return modifiedIntl;
    }, [
        formatDate,
        formatMessage,
        formatPlural,
        formatTime,
        formatNumber,
        formats,
        locale,
        messages
    ]);
    return memoisedIntl;
};

});

parcelRegister("5q0Ec", function(module, exports) {
$parcel$export(module.exports, "default", () => $fca60fa9cc35a5eb$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $fca60fa9cc35a5eb$var$messages = (0, $7qGN1.defineMessages)({
    globalTransition: {
        "id": "issue-field-status.status-view.transition.with-label.global-transition",
        "defaultMessage": "Transition to"
    }
});
var $fca60fa9cc35a5eb$export$2e2bcd8739ae039 = $fca60fa9cc35a5eb$var$messages;

});


parcelRegister("89H4a", function(module, exports) {
$parcel$export(module.exports, "TransitionWithoutLabel", () => $27d57fa62e13b907$export$4cf2c7e5a408120e);

var $eJOHy = parcelRequire("eJOHy");

var $6UBwj = parcelRequire("6UBwj");
const $27d57fa62e13b907$export$4cf2c7e5a408120e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UBwj.StatusLozenge), {
        status: props.transition.to,
        isDisabled: props.isDisabled
    });

});


parcelRegister("dSpUw", function(module, exports) {
$parcel$export(module.exports, "OptionComponent", () => $9eb50420c12428cc$export$3e92eb7b7644ac65);
$parcel$export(module.exports, "useSelectOptions", () => $9eb50420c12428cc$export$338e37f345f318fa);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $ipnsI = parcelRequire("ipnsI");

var $cfGlq = parcelRequire("cfGlq");

var $lXDnY = parcelRequire("lXDnY");


var $aY0vM = parcelRequire("aY0vM");
const $9eb50420c12428cc$export$3e92eb7b7644ac65 = ({ children: children, ...optionProps })=>{
    if ([
        (0, $559e2d0f325c757f$export$bbd08ee543ba8cc3),
        (0, $559e2d0f325c757f$export$bc1622166baa0162),
        (0, $559e2d0f325c757f$export$4f9299d0cd8b6a8b)
    ].includes(optionProps.data.type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ipnsI.OptionWithButtonStyle), optionProps, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lXDnY.OptionWithAutoKeyboardScroll), optionProps, children);
};
const $9eb50420c12428cc$export$338e37f345f318fa = (targetOptions, hasFooter)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const footerOptions = (0, $eJOHy.useMemo)(()=>{
        return [
            {
                label: formatMessage((0, $aY0vM.default).createStatus),
                type: (0, $559e2d0f325c757f$export$bbd08ee543ba8cc3),
                value: (0, $559e2d0f325c757f$export$bbd08ee543ba8cc3)
            },
            {
                label: formatMessage((0, $aY0vM.default).editStatus),
                type: (0, $559e2d0f325c757f$export$bc1622166baa0162),
                value: (0, $559e2d0f325c757f$export$bc1622166baa0162)
            },
            {
                label: formatMessage((0, $aY0vM.default).manageWorkflow),
                type: (0, $559e2d0f325c757f$export$4f9299d0cd8b6a8b),
                value: (0, $559e2d0f325c757f$export$4f9299d0cd8b6a8b)
            }
        ];
    }, [
        formatMessage
    ]);
    const optionsWithFooter = (0, $cfGlq.appendStickyFooterOptions)(targetOptions, footerOptions);
    if (hasFooter) return optionsWithFooter;
    return targetOptions;
};

});
parcelRegister("ipnsI", function(module, exports) {
$parcel$export(module.exports, "OptionWithButtonStyle", () => $84e1dd1785575259$export$b3382093e45b6db9);

var $eJOHy = parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");

var $8IeH1 = parcelRequire("8IeH1");
const $84e1dd1785575259$export$b3382093e45b6db9 = ({ children: children, onHover: onHover, testId: testId, ...optionProps })=>{
    const customisedGetStyles = (propertyName, props)=>{
        return {
            ...optionProps.getStyles(propertyName, props),
            boxShadow: 'none',
            cursor: 'pointer',
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        onMouseOver: onHover,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Option, {
        ...optionProps,
        getStyles: customisedGetStyles
    }, children));
};

});

parcelRegister("cfGlq", function(module, exports) {
$parcel$export(module.exports, "appendStickyFooterOptions", () => $a6c5dd9f83b8973c$export$870da2f71d38aa94);
$parcel$export(module.exports, "useAppendStickyFooterOptions", () => $a6c5dd9f83b8973c$export$9ef0653bfb9844e7);
$parcel$export(module.exports, "scrollIntoView", () => $a6c5dd9f83b8973c$export$53a0910f038337bd);

var $eJOHy = parcelRequire("eJOHy");

const $a6c5dd9f83b8973c$export$870da2f71d38aa94 = (options, footerOptions)=>{
    return [
        ...options,
        {
            options: footerOptions.map((footerOption)=>{
                return {
                    ...footerOption,
                    groupType: (0, $2a68cf016118f389$export$e13d614fc55c6ce9)
                };
            })
        }
    ];
};
const $a6c5dd9f83b8973c$export$9ef0653bfb9844e7 = (options, footerOptions)=>{
    return (0, $eJOHy.useMemo)(()=>$a6c5dd9f83b8973c$export$870da2f71d38aa94(options, footerOptions), [
        footerOptions,
        options
    ]);
};
function $a6c5dd9f83b8973c$export$53a0910f038337bd(menuEl, focusedEl, bottomOffset = 0) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom - bottomOffset) // eslint-disable-next-line no-param-reassign
    menuEl.scrollTop = Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + bottomOffset + overScroll, menuEl.scrollHeight - bottomOffset);
    else if (focusedRect.top - overScroll < menuRect.top) // eslint-disable-next-line no-param-reassign
    menuEl.scrollTop = Math.max(focusedEl.offsetTop - overScroll, 0);
}

});

parcelRegister("lXDnY", function(module, exports) {
$parcel$export(module.exports, "OptionWithAutoKeyboardScroll", () => $9fea550d435eb0a8$export$39118cd824d8af0b);

var $eJOHy = parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");

var $4cTDP = parcelRequire("4cTDP");

var $bzbsd = parcelRequire("bzbsd");

var $cfGlq = parcelRequire("cfGlq");


var $eF3Xz = parcelRequire("eF3Xz");
const $9fea550d435eb0a8$export$39118cd824d8af0b = ({ children: children, containerRef: containerRef, ...optionProps })=>{
    const focusedOptionRef = (0, $eJOHy.useRef)();
    let containerRefFromContext;
    if ((0, $4cTDP.fg)('depreciate-select-with-footer-options-containerref')) // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    containerRefFromContext = (0, $eF3Xz.useMenuListRef)();
    (0, $eJOHy.useEffect)(()=>{
        if (optionProps.isFocused) {
            // We only auto scroll for focus with keyboard only, not for focus with mouse hover
            // because mouse users will manual scroll when browsing options
            if (!focusedOptionRef.current?.parentElement || focusedOptionRef.current?.matches(':hover')) return;
            // We need to add bottom offset when scrolling which is the current height of sticky footer options group
            const stickFooterBottomOffset = globalThis?.document.querySelector(`.${(0, $2a68cf016118f389$export$1ae91d219a8713ac)}`)?.clientHeight ?? 0;
            if ((0, $4cTDP.fg)('depreciate-select-with-footer-options-containerref')) (0, $cfGlq.scrollIntoView)(containerRefFromContext?.current ?? containerRef?.current ?? focusedOptionRef.current.parentElement, focusedOptionRef.current, stickFooterBottomOffset);
            else (0, $cfGlq.scrollIntoView)(containerRef?.current ?? focusedOptionRef.current.parentElement, focusedOptionRef.current, stickFooterBottomOffset);
        }
    }, [
        containerRefFromContext,
        containerRef,
        optionProps.isFocused
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Option, {
        ...optionProps,
        innerRef: (0, $bzbsd.mergeRefs)(optionProps.innerRef, focusedOptionRef)
    }, children);
};

});
parcelRegister("eF3Xz", function(module, exports) {
$parcel$export(module.exports, "MenuListWithAutoKeyboardScroll", () => $af8ce9936827719f$export$aa67fa7cdf057994);
$parcel$export(module.exports, "useMenuListRef", () => $af8ce9936827719f$export$bd98f7ccab264507);

var $eJOHy = parcelRequire("eJOHy");

var $kmlzw = parcelRequire("kmlzw");

var $6XEne = parcelRequire("6XEne");
const $af8ce9936827719f$var$context = /*#__PURE__*/ (0, $eJOHy.createContext)({
    current: null
});
const $af8ce9936827719f$export$aa67fa7cdf057994 = (props)=>{
    const containerRef = (0, $eJOHy.useRef)(null);
    const innerRef = typeof props.innerRef === 'string' ? props.innerRef : (0, $kmlzw.mergeRefs)([
        containerRef,
        props.innerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($af8ce9936827719f$var$context.Provider, {
        value: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).MenuList, {
        ...props,
        innerRef: innerRef
    }));
};
const $af8ce9936827719f$export$bd98f7ccab264507 = ()=>(0, $eJOHy.useContext)($af8ce9936827719f$var$context);

});



parcelRegister("kTIpG", function(module, exports) {
$parcel$export(module.exports, "CreateStatusOption", () => $569a891a9eea5bfd$export$be2add8d223902cf);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $jOPSA = parcelRequire("jOPSA");

var $lRq8t = parcelRequire("lRq8t");

var $fiJwW = parcelRequire("fiJwW");

var $dxcgx = parcelRequire("dxcgx");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $lppZM = parcelRequire("lppZM");
var $bE8VR = parcelRequire("bE8VR");


var $cHtIB = parcelRequire("cHtIB");

var $4cTDP = parcelRequire("4cTDP");

var $aaGSX = parcelRequire("aaGSX");

var $asoyU = parcelRequire("asoyU");

var $8yyDM = parcelRequire("8yyDM");

var $eCUrP = parcelRequire("eCUrP");

var $62tn0 = parcelRequire("62tn0");
const $569a891a9eea5bfd$export$be2add8d223902cf = ({ projectId: projectId, projectKey: projectKey, projectType: projectType, issueTypeId: issueTypeId, statusNames: statusNames = [], onClick: onClick, onClose: onClose, onStatusCreated: onStatusCreated, buttonRef: buttonRef, source: source, shouldTriggerModal: shouldTriggerModal = true })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const cloudId = (0, $cHtIB.useCloudId)();
    const trigger = (0, $bE8VR.useTriggerContext)((0, $eCUrP.ConfigureStatusPanel));
    const handleClick = (0, $eJOHy.useCallback)((_e)=>{
        onClick();
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createStatusButton');
        // Because we are triggering the click manually for keyboard users
        // this handler becomes the source-of-truth handler for both keyboard users and mouse users
        // However, we need to stopPropagation from here to prevent double modal for mouse users
        // When mouse user clicks the button, if we don't stop propagation here, handleChange
        // will be called which will trigger click manually again and cause double modal rendering
        _e.stopPropagation();
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const onModalClose = (0, $eJOHy.useCallback)(()=>{
        onClose();
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'inlineCreateStatusModal'
        }));
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const onMouseDown = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'createStatusButton');
    }, [
        createAnalyticsEvent
    ]);
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            projectKey: projectKey
        }), [
        cloudId,
        projectKey
    ]);
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            statusNames: statusNames,
            projectId: projectId,
            projectKey: projectKey,
            projectType: projectType,
            onClose: onModalClose,
            isNewControllerEnabled: true,
            workflowAssociatedIssueTypeId: issueTypeId,
            createStatusExperience: $8yyDM.createStatusExperience,
            source: source || (0, $a63b79662d6e9902$export$cafb161c2b21b455),
            onStatusCreated: onStatusCreated,
            isWrappedInModal: shouldTriggerModal
        }), [
        statusNames,
        projectId,
        projectKey,
        projectType,
        onModalClose,
        issueTypeId,
        source,
        onStatusCreated,
        shouldTriggerModal
    ]);
    const getClickElement = (0, $eJOHy.useCallback)((ref)=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            role: "button",
            xcss: $569a891a9eea5bfd$var$optionStyles,
            onClick: handleClick,
            "data-show-on-hover": true,
            ref: ref,
            onMouseDown: (event)=>{
                if (event.button === 0) // Left mouse button was clicked
                onMouseDown();
            }
        }, formatMessage((0, $62tn0.messages).createStatus)), [
        formatMessage,
        handleClick,
        onMouseDown
    ]);
    const modalTrigger = (0, $4cTDP.fg)('inline_config_migrate_deprecated_modal_entrypoints') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $asoyU.ModalTrigger), {
        entryPoint: (0, $jOPSA.asyncInlineCreateStatusModal),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        modalProps: (0, $fiJwW.defaultModalProps),
        forwardedRef: buttonRef,
        Fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                numFormFields: 2
            })
    }, ({ ref: ref })=>getClickElement(ref)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxcgx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $jOPSA.asyncInlineCreateStatusModal),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        interactionName: "create-status-modal",
        modalProps: (0, $fiJwW.defaultModalProps),
        useInternalModal: true,
        forwardedRef: buttonRef,
        Fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                numFormFields: 2
            })
    }, ({ ref: ref })=>getClickElement(ref));
    return shouldTriggerModal ? modalTrigger : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lppZM.Trigger), {
        trigger: trigger,
        entryPoint: (0, $jOPSA.asyncInlineCreateStatusModal),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
            numFormFields: 2
        })
    }, ({ ref: ref })=>getClickElement(ref));
};
const $569a891a9eea5bfd$var$optionStyles = (0, $1DXK0.xcss)({
    height: '100%',
    width: '100%',
    backgroundColor: 'color.background.neutral.subtle',
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: 'font.weight.medium'
});

});

parcelRegister("7Pc1n", function(module, exports) {
$parcel$export(module.exports, "EditStatusOption", () => $2099be11c3b3c83c$export$9550e3e17c5a4a3a);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $l1viU = parcelRequire("l1viU");

var $lRq8t = parcelRequire("lRq8t");

var $fiJwW = parcelRequire("fiJwW");

var $dxcgx = parcelRequire("dxcgx");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $lppZM = parcelRequire("lppZM");
var $bE8VR = parcelRequire("bE8VR");


var $4cTDP = parcelRequire("4cTDP");

var $aaGSX = parcelRequire("aaGSX");

var $asoyU = parcelRequire("asoyU");

var $8yyDM = parcelRequire("8yyDM");

var $eCUrP = parcelRequire("eCUrP");

var $62tn0 = parcelRequire("62tn0");
const $2099be11c3b3c83c$export$9550e3e17c5a4a3a = ({ projectId: projectId, projectKey: projectKey, issueTypeId: issueTypeId, statusNames: statusNames = [], status: status, statuses: statuses, onClick: onClick, onClose: onClose, onStatusUpdated: onStatusUpdated = Promise.resolve, buttonRef: buttonRef, source: source, shouldTriggerModal: shouldTriggerModal = true })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const trigger = (0, $bE8VR.useTriggerContext)((0, $eCUrP.ConfigureStatusPanel));
    const handleClick = (0, $eJOHy.useCallback)((_e)=>{
        onClick();
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'editStatusButton');
        // Because we are triggering the click manually for keyboard users
        // this handler becomes the source-of-truth handler for both keyboard users and mouse users
        // However, we need to stopPropagation from here to prevent double modal for mouse users
        // When mouse user clicks the button, if we don't stop propagation here, handleChange
        // will be called which will trigger click manually again and cause double modal rendering
        _e.stopPropagation();
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const onModalClose = (0, $eJOHy.useCallback)(()=>{
        onClose();
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'inlineEditStatusModal'
        }));
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const onMouseDown = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'editStatusButton');
    }, [
        createAnalyticsEvent
    ]);
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            status: status,
            statuses: statuses,
            statusNames: statusNames,
            projectId: projectId,
            projectKey: projectKey,
            onClose: onModalClose,
            isNewControllerEnabled: true,
            issueTypeId: issueTypeId,
            editStatusExperience: $8yyDM.editStatusExperience,
            source: source || (0, $a63b79662d6e9902$export$cafb161c2b21b455),
            onStatusUpdated: onStatusUpdated,
            shouldShowStatusSelect: true,
            isWrappedInModal: shouldTriggerModal
        }), [
        statusNames,
        projectId,
        projectKey,
        issueTypeId,
        source,
        status,
        statuses,
        onStatusUpdated,
        onModalClose,
        shouldTriggerModal
    ]);
    const getClickElement = (0, $eJOHy.useCallback)((ref)=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            role: "button",
            xcss: $2099be11c3b3c83c$var$optionStyles,
            onClick: handleClick,
            "data-show-on-hover": true,
            ref: ref,
            onMouseDown: (event)=>{
                if (event.button === 0) // Left mouse button was clicked
                onMouseDown();
            }
        }, formatMessage((0, $62tn0.messages).editStatus)), [
        handleClick,
        formatMessage,
        onMouseDown
    ]);
    const modalTrigger = (0, $4cTDP.fg)('inline_config_migrate_deprecated_modal_entrypoints') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $asoyU.ModalTrigger), {
        entryPoint: (0, $l1viU.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        modalProps: (0, $fiJwW.defaultModalProps),
        forwardedRef: buttonRef,
        Fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                numFormFields: 3
            })
    }, ({ ref: ref })=>getClickElement(ref)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxcgx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $l1viU.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        interactionName: "edit-status-modal",
        modalProps: (0, $fiJwW.defaultModalProps),
        useInternalModal: true,
        forwardedRef: buttonRef,
        Fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                numFormFields: 3
            })
    }, ({ ref: ref })=>getClickElement(ref));
    return shouldTriggerModal ? modalTrigger : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lppZM.Trigger), {
        trigger: trigger,
        entryPoint: (0, $l1viU.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
            numFormFields: 3
        })
    }, ({ ref: ref })=>getClickElement(ref));
};
const $2099be11c3b3c83c$var$optionStyles = (0, $1DXK0.xcss)({
    height: '100%',
    width: '100%',
    backgroundColor: 'color.background.neutral.subtle',
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: 'font.weight.medium'
});

});
parcelRegister("l1viU", function(module, exports) {
$parcel$export(module.exports, "asyncInlineEditStatusModal", () => $b27a6b36d5d6ed96$export$c3f451c40832a786);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $b27a6b36d5d6ed96$export$c3f451c40832a786 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("jW9RG")).then((module)=>module.AsyncInlineEditStatusModal), {
        moduleId: "177d76fa",
        moduleName: "AsyncInlineEditStatusModal",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jW9RG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("i6I9Z").then(()=>parcelRequire('j06kL'));

});



parcelRegister("8X6rE", function(module, exports) {
$parcel$export(module.exports, "EditStatusButton", () => $2ea55c5659695c38$export$bc1c056aa3d67f87);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $l1viU = parcelRequire("l1viU");

var $lRq8t = parcelRequire("lRq8t");

var $fiJwW = parcelRequire("fiJwW");


var $dxcgx = parcelRequire("dxcgx");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $lppZM = parcelRequire("lppZM");
var $bE8VR = parcelRequire("bE8VR");

var $4cTDP = parcelRequire("4cTDP");

var $aaGSX = parcelRequire("aaGSX");

var $asoyU = parcelRequire("asoyU");

var $8yyDM = parcelRequire("8yyDM");

var $62tn0 = parcelRequire("62tn0");

var $eCUrP = parcelRequire("eCUrP");
const $2ea55c5659695c38$export$bc1c056aa3d67f87 = ({ projectId: projectId, projectKey: projectKey, issueTypeId: issueTypeId, statusNames: statusNames = [], status: status, statuses: statuses, onClick: onClick, onClose: onClose, onStatusUpdated: onStatusUpdated = Promise.resolve, buttonRef: buttonRef, source: source, shouldTriggerModal: shouldTriggerModal = true })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const trigger = (0, $bE8VR.useTriggerContext)((0, $eCUrP.ConfigureStatusPanel));
    const handleClick = (0, $eJOHy.useCallback)((_e)=>{
        onClick();
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'editStatusButton');
        // Because we are triggering the click manually for keyboard users
        // this handler becomes the source-of-truth handler for both keyboard users and mouse users
        // However, we need to stopPropagation from here to prevent double modal for mouse users
        // When mouse user clicks the button, if we don't stop propagation here, handleChange
        // will be called which will trigger click manually again and cause double modal rendering
        _e.stopPropagation();
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const onModalClose = (0, $eJOHy.useCallback)(()=>{
        onClose();
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'inlineEditStatusModal'
        }));
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            status: status,
            statuses: statuses,
            statusNames: statusNames,
            projectId: projectId,
            projectKey: projectKey,
            onClose: onModalClose,
            isNewControllerEnabled: true,
            issueTypeId: issueTypeId,
            editStatusExperience: $8yyDM.editStatusExperience,
            source: source || (0, $a63b79662d6e9902$export$cafb161c2b21b455),
            onStatusUpdated: onStatusUpdated,
            shouldShowStatusSelect: true,
            isWrappedInModal: shouldTriggerModal
        }), [
        statusNames,
        projectId,
        projectKey,
        issueTypeId,
        source,
        status,
        statuses,
        onStatusUpdated,
        onModalClose,
        shouldTriggerModal
    ]);
    const getClickElement = (0, $eJOHy.useCallback)((ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
            xcss: $2ea55c5659695c38$var$flexContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
            testId: "issue-field-status.ui.status-view.configure-status.edit-status-button",
            xcss: $2ea55c5659695c38$var$pressableStyles,
            onClick: handleClick,
            "data-show-on-hover": true,
            // ref returned from entrypoint is of Type 'RefObject<HTMLElement>' is not assignable to type 'Ref<HTMLButtonElement>
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $2ea55c5659695c38$var$textWrapperStyle
        }, formatMessage((0, $62tn0.messages).editStatus)))), [
        handleClick,
        formatMessage
    ]);
    const modalTrigger = (0, $4cTDP.fg)('inline_config_migrate_deprecated_modal_entrypoints') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $asoyU.ModalTrigger), {
        entryPoint: (0, $l1viU.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        modalProps: (0, $fiJwW.defaultModalProps),
        forwardedRef: buttonRef,
        Fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                numFormFields: 3
            })
    }, ({ ref: ref })=>getClickElement(ref)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxcgx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $l1viU.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        interactionName: "edit-status-modal",
        modalProps: (0, $fiJwW.defaultModalProps),
        useInternalModal: true,
        forwardedRef: buttonRef,
        Fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                numFormFields: 3
            })
    }, ({ ref: ref })=>getClickElement(ref));
    return shouldTriggerModal ? modalTrigger : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lppZM.Trigger), {
        trigger: trigger,
        entryPoint: (0, $l1viU.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
            numFormFields: 3
        })
    }, ({ ref: ref })=>getClickElement(ref));
};
const $2ea55c5659695c38$var$flexContainerStyles = (0, $1DXK0.xcss)({
    flexGrow: 1,
    height: "var(--ds-space-500, 40px)"
});
const $2ea55c5659695c38$var$pressableStyles = (0, $1DXK0.xcss)({
    height: '100%',
    width: '100%',
    color: 'color.text',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    backgroundColor: 'color.background.neutral.subtle',
    alignItems: 'center',
    textAlign: 'left',
    paddingInline: 'space.150',
    fontWeight: 'font.weight.medium',
    ':hover': {
        backgroundColor: 'color.background.neutral'
    },
    ':focus-visible': {
        borderRadius: 'radius.small'
    }
});
const $2ea55c5659695c38$var$textWrapperStyle = (0, $1DXK0.xcss)({
    marginInline: 'space.025'
});

});

parcelRegister("fkCrf", function(module, exports) {
$parcel$export(module.exports, "ConfigureStatusPopup", () => $fc218b74133b5a34$export$35b5c681217bd086);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $8nMzv = parcelRequire("8nMzv");
const $fc218b74133b5a34$export$35b5c681217bd086 = ({ renderTarget: renderTarget, isTargetEditable: isTargetEditable, placement: placement, onClose: onClose, renderPopupContent: renderPopupContent })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $fc218b74133b5a34$var$popupContentStyles,
                role: "dialog",
                "aria-modal": "false",
                "aria-labelledby": "configure-status-form-popup-header"
            }, renderPopupContent()),
        isOpen: true,
        onClose: onClose,
        placement: placement,
        messageId: "issue-field-status.ui.status-view.configure-status.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>renderTarget({
                isEditable: isTargetEditable,
                isSaving: false,
                targetRef: undefined,
                triggerProps: triggerProps
            }),
        shouldRenderToParent: true
    });
};
const $fc218b74133b5a34$var$popupContentStyles = (0, $1DXK0.xcss)({
    width: '395px'
});

});

parcelRegister("buB1R", function(module, exports) {
$parcel$export(module.exports, "ExplainWorkflowButton", () => $ced1cf7c33c0c9ee$export$fb52d92db5df3500);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $gDKBr = parcelRequire("gDKBr");

var $goZPP = parcelRequire("goZPP");

var $leNtV = parcelRequire("leNtV");

var $gxC9D = parcelRequire("gxC9D");

var $lRq8t = parcelRequire("lRq8t");

var $bmoS1 = parcelRequire("bmoS1");

var $7IbDg = parcelRequire("7IbDg");
const $ced1cf7c33c0c9ee$export$fb52d92db5df3500 = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const issueKey = (0, $bmoS1.useIssueKey)();
    const publish = (0, $leNtV.usePublish)('ai-mate');
    const { isSidebarOpen: isSidebarOpen } = (0, $gxC9D.useConversationAssistantSidebarApi)({});
    const isRovoChatOpen = isSidebarOpen();
    const onClickHandler = (0, $eJOHy.useCallback)(()=>{
        publish({
            type: 'chat-new',
            product: 'jira',
            openChat: !isRovoChatOpen,
            source: 'jira-work-item-status-field',
            data: {
                dialogues: [],
                prompt: `Explain the workflow for ${issueKey}`
            }
        });
        onClick();
    }, [
        isRovoChatOpen,
        issueKey,
        onClick,
        publish
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: $ced1cf7c33c0c9ee$var$flexContainerStyles,
        alignItems: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ced1cf7c33c0c9ee$var$StyledButton, {
        appearance: "subtle",
        shouldFitContainer: true,
        onClick: onClickHandler,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDKBr))), {
            label: ""
        })
    }, formatMessage((0, $7IbDg.default).explainWorkflow)));
};
// Move all styled/xcss/css components to the bottom
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $ced1cf7c33c0c9ee$var$StyledButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _y3gn1e5h _syaz1fxt _ca0qpxbi _u5f3utpp _n3tdpxbi _19bvutpp _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $ced1cf7c33c0c9ee$var$flexContainerStyles = (0, $1DXK0.xcss)({
    flexGrow: 1,
    height: "var(--ds-space-500, 40px)"
});

});
parcelRegister("gxC9D", function(module, exports) {
$parcel$export(module.exports, "useConversationAssistantSidebarApi", () => $192a91fdede5ea98$export$b7bc690143f733fd);

var $eJOHy = parcelRequire("eJOHy");

var $dfP3D = parcelRequire("dfP3D");

const $192a91fdede5ea98$export$b7bc690143f733fd = ({ width: width = (0, $0b41093501185867$export$64aee74ba59709e5), isMinimised: isMinimised, toTop: toTop })=>{
    const { openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const { panelId: panelId, isCollapsed: isCollapsed } = (0, $dfP3D.useActiveRightSidebarState)() || {};
    const isActive = panelId === (0, $0b41093501185867$export$dffb4ed44e20ea9a) && !isCollapsed;
    const isOtherPanelActive = panelId !== (0, $0b41093501185867$export$dffb4ed44e20ea9a) && !isCollapsed;
    const openSidebar = (0, $eJOHy.useCallback)((newWidth)=>{
        isOtherPanelActive && closeCurrentRightSidebar();
        openRightSidebar((0, $0b41093501185867$export$dffb4ed44e20ea9a), newWidth ?? width, isMinimised, toTop);
    }, [
        closeCurrentRightSidebar,
        isOtherPanelActive,
        openRightSidebar,
        width,
        isMinimised,
        toTop
    ]);
    const closeSidebar = (0, $eJOHy.useCallback)(()=>{
        closeRightSidebar((0, $0b41093501185867$export$dffb4ed44e20ea9a));
    }, [
        closeRightSidebar
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            isSidebarOpen: ()=>isActive,
            openSidebar: openSidebar,
            closeSidebar: closeSidebar
        }), [
        isActive,
        openSidebar,
        closeSidebar
    ]);
};

});
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $0b41093501185867$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $0b41093501185867$export$64aee74ba59709e5 = 439; // px
const $0b41093501185867$export$1c07393c5bb1bc27 = 439; // px
const $0b41093501185867$export$aa3478deee7adbeb = 350; // px
const $0b41093501185867$export$21e515a86cd1733b = 'Chat';
const $0b41093501185867$export$e942bf04e23ff966 = 'Rovo';


parcelRegister("7IbDg", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fe9218ffbc27370$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4fe9218ffbc27370$var$messages = (0, $7qGN1.defineMessages)({
    explainWorkflow: {
        "id": "issue-field-status.status-view.explain-workflow-button.explain-workflow",
        "defaultMessage": "Explain workflow"
    }
});
var $4fe9218ffbc27370$export$2e2bcd8739ae039 = $4fe9218ffbc27370$var$messages;

});



parcelRegister("dYkoV", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2ef9ab31aca7974$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $4cTDP = parcelRequire("4cTDP");

var $et3hH = parcelRequire("et3hH");

var $5YGsJ = parcelRequire("5YGsJ");

var $5Mavp = parcelRequire("5Mavp");
class $f2ef9ab31aca7974$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    render() {
        const { issueKey: issueKey, workflowServiceApi: workflowServiceApi, onCloseModal: onCloseModal } = this.props;
        const { isWorkflowServiceRefetching: isWorkflowServiceRefetching } = this.state;
        const { data: data, loading: loading, error: error, fetch: fetch } = workflowServiceApi;
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $et3hH.default), {
            onRetry: (e)=>{
                this.onWorkflowServiceRefetch(e, fetch);
            }
        });
        if (!data) return null;
        const { isSimplified: isSimplified, projectId: projectId, issueTypeId: issueTypeId, hasPermission: hasPermission } = data;
        if (!isSimplified && (0, $4cTDP.fg)('legacy_readonly_workflow_modal_optin')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5YGsJ.default), {
            issueKey: issueKey,
            hasPermission: hasPermission,
            isServiceLoading: loading,
            isServiceRefetching: isWorkflowServiceRefetching
        });
        if (!projectId) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-field-status.view-workflow.no-project-id', 'WorkflowServiceApi finished loading but there was no projectId');
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Mavp.ViewWorkflowModalDropDownTrigger), {
            issueKey: issueKey,
            projectId: projectId,
            issueTypeId: issueTypeId,
            isSimplifiedProject: isSimplified,
            hasPermission: hasPermission,
            isServiceLoading: loading,
            isServiceRefetching: isWorkflowServiceRefetching,
            onClose: onCloseModal
        });
    }
    constructor(...args){
        super(...args), this.state = {
            isWorkflowServiceRefetching: false
        }, this.onWorkflowServiceRefetch = async (e, retry)=>{
            e.stopPropagation();
            this.setState({
                isWorkflowServiceRefetching: true
            });
            await retry();
            this.setState({
                isWorkflowServiceRefetching: false
            });
        };
    }
}

});
parcelRegister("et3hH", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c25024b1629ad09$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $abjs4 = parcelRequire("abjs4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");
var $kRgKj = parcelRequire("kRgKj");

var $45djs = parcelRequire("45djs");
const $2c25024b1629ad09$export$edf27be85e5f6da0 = ({ onRetry: onRetry })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onRetryClick = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'retryViewWorkflowButton'); // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
        onRetry(e);
    }, [
        onRetry
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "viewWorkflowError",
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2c25024b1629ad09$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $2c25024b1629ad09$var$errorMessageWrapperStyles
    }, formatMessage((0, $45djs.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2c25024b1629ad09$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $abjs4.default), {
        appearance: "link",
        spacing: "none",
        onClick: onRetryClick,
        theme: (currentTheme, theme)=>{
            const buttonTheme = currentTheme(theme);
            return {
                ...buttonTheme,
                buttonStyles: {
                    ...buttonTheme.buttonStyles,
                    alignItems: 'center'
                }
            };
        },
        interactionName: "auto-generated.jira-issue-field-status.common.ui.view-workflow.error.button"
    }, formatMessage((0, $45djs.default).tryAgain))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null)));
};
var $2c25024b1629ad09$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $2c25024b1629ad09$export$edf27be85e5f6da0;
const $2c25024b1629ad09$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3do187z _4t3ickbl _1e0c1txw _4cvr1h6o _ca0qidpf _u5f3utpp _n3tdidpf _19bvutpp _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2c25024b1629ad09$var$ButtonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _16jlkb7n _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $2c25024b1629ad09$var$errorMessageWrapperStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.100'
});

});
// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("45djs", function(module, exports) {
$parcel$export(module.exports, "default", () => $7962cde15920026e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7962cde15920026e$var$messages = (0, $7qGN1.defineMessages)({
    errorMessage: {
        "id": "issue-field-status.common.view-workflow.error.error-message",
        "defaultMessage": "Couldn\u2019t find the workflow."
    },
    tryAgain: {
        "id": "issue-field-status.common.view-workflow.error.try-again",
        "defaultMessage": "Try again"
    }
});
var $7962cde15920026e$export$2e2bcd8739ae039 = $7962cde15920026e$var$messages;

});


parcelRegister("5YGsJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $db9ba9819cc978d7$export$2e2bcd8739ae039);
// eslint-disable-next-line react-hooks/react-compiler
/* eslint-disable react-hooks/exhaustive-deps, jira/wrm/no-load-bridge */ 
var $eJOHy = parcelRequire("eJOHy");

var $gjeS9 = parcelRequire("gjeS9");

var $47YxQ = parcelRequire("47YxQ");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $a8PVz = parcelRequire("a8PVz");

var $8dJ7y = parcelRequire("8dJ7y");

var $et3hH = parcelRequire("et3hH");

var $10mjH = parcelRequire("10mjH");

var $eO2mJ = parcelRequire("eO2mJ");

var $bozoA = parcelRequire("bozoA");
const $db9ba9819cc978d7$export$b5e9eef0cad95164 = ({ isServiceLoading: isServiceLoading, isServiceRefetching: isServiceRefetching, issueKey: issueKey, hasPermission: hasPermission, ClassicViewWorkflowService: ClassicViewWorkflowService = (0, $eO2mJ.ClassicViewWorkflowServiceWithAnalytics) })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isModalMounted, setIsModalMounted] = (0, $eJOHy.useState)(false);
    const [isLoadingModal, setIsLoadingModal] = (0, $eJOHy.useState)(false);
    const [isRefetching, setIsRefetching] = (0, $eJOHy.useState)(false);
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const isModalMounting = isLoadingModal && !isModalMounted;
    const isDisabled = !hasPermission || isModalMounting;
    // we do not use || isClassicServiceLoading for isLoading because we do not want to show spinner while ClassicViewWorkflowService data loads
    const isLoading = isModalMounting || isServiceRefetching || isRefetching;
    let modalApi;
    (0, $eJOHy.useEffect)(()=>{
        const modalModuleName = 'workflow-designer/view-classic-project-workflow';
        // @ts-expect-error - TS2322 - Type 'Promise<unknown>' is not assignable to type 'Promise<ClassicProjectWorkflowModalApi>'.
        modalApi = (0, $gjeS9.loadBridge)({
            // checking if module was loaded on page load
            name: modalModuleName,
            tentatives: 0,
            shouldLogError: false
        }).catch(()=>{
            (0, $a8PVz.asyncWrmRequire)([
                // eslint-disable-next-line jira/wrm/no-wr-prefix
                'wr!com.atlassian.jira.plugins.jira-workflow-designer:view-issue-page-workflow-designer'
            ]); // wrmRequire() does not fire catch() event
            return (0, $gjeS9.loadBridge)({
                name: modalModuleName
            });
        });
    }, []);
    const onClick = (0, $eJOHy.useCallback)((analyticsEvent, pShowFlag, workflowName, currentStepId)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'viewWorkflowTrigger', {
            isSimplifiedProject: false
        });
        if (!modalApi || !workflowName || !currentStepId) return;
        // modal code is being loaded only once, therefore there is no need to reset this to false
        setIsLoadingModal(true);
        setIsRefetching(false);
        modalApi.then((api)=>{
            api.showDialog(workflowName, currentStepId);
            // since there is no way to close Ak dropdown programmatically, this is the only option
            // to avoid dropdown wrong position on View workflow modal opening in Bento modal (BENTO-4660)
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.dispatchEvent((0, $47YxQ.default)('resize'));
            // @ts-expect-error - TS2345 - Argument of type '{ isModalMounted: boolean; }' is not assignable to parameter of type 'SetStateAction<boolean>'.
            setIsModalMounted({
                isModalMounted: true
            });
        }).catch(()=>{
            pShowFlag && pShowFlag((0, $bozoA.errors).loadModalError());
            setIsLoadingModal(false);
        });
    }, // @ts-expect-error - TS2454 - Variable 'modalApi' is used before being assigned.
    [
        modalApi,
        setIsModalMounted,
        setIsRefetching,
        setIsLoadingModal
    ]);
    const onRetry = (0, $eJOHy.useCallback)((event, retry)=>{
        event.stopPropagation();
        setIsRefetching(true);
        return retry().then(()=>setIsRefetching(false));
    }, [
        setIsRefetching
    ]);
    const onMount = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
    (analyticsEvent)=>{
        (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'viewWorkflowTrigger mounted', {
            hasViewWorkflowPermission: hasPermission,
            isSimplifiedProject: false
        });
    }, [
        hasPermission
    ]);
    const getTooltipMessage = (0, $eJOHy.useCallback)((isClassicServiceLoading)=>{
        if (isServiceRefetching || isClassicServiceLoading) return formatMessage((0, $10mjH.default).loading);
        if (!hasPermission) return formatMessage((0, $10mjH.default).noPermission);
        return '';
    }, [
        formatMessage,
        hasPermission,
        isServiceRefetching
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ClassicViewWorkflowService, {
        issueKey: issueKey,
        shouldLoadOnMount: hasPermission
    }, ({ data: data, error: error, loading: isClassicServiceLoading, retry: retry })=>{
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $et3hH.default), {
            onRetry: (event)=>{
                onRetry(event, retry);
            }
        });
        const workflowName = data ? data.workflowName : null;
        const currentStepId = data ? data.currentStepId : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8dJ7y.default), {
            onMount: onMount,
            tooltipContent: getTooltipMessage(isServiceLoading || isClassicServiceLoading),
            isDisabled: isDisabled || isClassicServiceLoading,
            isLoading: isLoading,
            isInitialLoading: isServiceLoading || isClassicServiceLoading,
            onClick: (_, analyticsEvent)=>onClick(analyticsEvent, showFlag, workflowName, currentStepId)
        });
    });
};
var $db9ba9819cc978d7$export$2e2bcd8739ae039 = $db9ba9819cc978d7$export$b5e9eef0cad95164;

});
parcelRegister("47YxQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc3c6261cc07a59e$export$2e2bcd8739ae039);
const $bc3c6261cc07a59e$var$createEvent = (eventType, eventConstructor = 'Event', bubbles = true, cancelable = true)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const event = document.createEvent(eventConstructor);
    event.initEvent(eventType, bubbles, cancelable);
    return event;
};
var $bc3c6261cc07a59e$export$2e2bcd8739ae039 = $bc3c6261cc07a59e$var$createEvent;

});

parcelRegister("8dJ7y", function(module, exports) {
$parcel$export(module.exports, "ButtonWrapper", () => $19b4d25c370c35f3$export$d53c836cccbb0d90);
$parcel$export(module.exports, "default", () => $19b4d25c370c35f3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $abjs4 = parcelRequire("abjs4");

var $k71qx = parcelRequire("k71qx");

var $dTocu = parcelRequire("dTocu");

var $dFqXL = parcelRequire("dFqXL");

var $hRILf = parcelRequire("hRILf");
const $19b4d25c370c35f3$var$WithTooltip = ({ content: content, children: children })=>{
    if (content) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        tag: "span",
        content: content
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $19b4d25c370c35f3$var$ViewWorkflowButton = ({ forwardRef: forwardRef, isDisabled: isDisabled, isLoading: isLoading, isInitialLoading: isInitialLoading, onClick: onClick, onMount: onMount, tooltipContent: tooltipContent })=>{
    const intl = (0, $dTocu.useIntlV2)();
    const isDisabledColor = isDisabled === true && !isInitialLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($19b4d25c370c35f3$var$WrapperWithoutBorder, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dFqXL.MountEvent), {
        onMount: onMount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($19b4d25c370c35f3$var$WithTooltip, {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($19b4d25c370c35f3$export$d53c836cccbb0d90, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $abjs4.default), {
        testId: "issue-field-status.common.ui.view-workflow.button.view-workflow",
        shouldFitContainer: true,
        appearance: "subtle",
        spacing: "none",
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        theme: (currentTheme, theme)=>{
            const buttonTheme = currentTheme(theme);
            return {
                ...buttonTheme,
                buttonStyles: {
                    ...buttonTheme.buttonStyles,
                    alignItems: 'center',
                    textAlign: 'left',
                    color: isDisabledColor ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text, #172B4D)",
                    padding: `0 ${"var(--ds-space-150, 12px)"}`
                }
            };
        },
        interactionName: "auto-generated.issue-field-status.common.ui.view-workflow.button.view-workflow.button",
        ref: forwardRef
    }, intl.formatMessage((0, $hRILf.default).viewWorkflow)))));
};
var $19b4d25c370c35f3$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
 = $19b4d25c370c35f3$var$ViewWorkflowButton;
const $19b4d25c370c35f3$var$WrapperWithoutBorder = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1jfw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $19b4d25c370c35f3$export$d53c836cccbb0d90 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _16jlkb7n _4t3i1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hRILf", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8305ecde77e270b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $c8305ecde77e270b$var$messages = (0, $7qGN1.defineMessages)({
    viewWorkflow: {
        "id": "issue-field-status.common.view-workflow.button.view-workflow",
        "defaultMessage": "View workflow"
    }
});
var $c8305ecde77e270b$export$2e2bcd8739ae039 = $c8305ecde77e270b$var$messages;

});


parcelRegister("10mjH", function(module, exports) {
$parcel$export(module.exports, "default", () => $69e88eff724bce84$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $69e88eff724bce84$var$messages = (0, $7qGN1.defineMessages)({
    noPermission: {
        "id": "issue-field-status.common.view-workflow.no-permission",
        "defaultMessage": "You don't have permission to view this workflow."
    },
    loading: {
        "id": "issue-field-status.common.view-workflow.loading",
        "defaultMessage": "Looks like your connection is slow. We\u2019re still finding this workflow."
    }
});
var $69e88eff724bce84$export$2e2bcd8739ae039 = $69e88eff724bce84$var$messages;

});

parcelRegister("eO2mJ", function(module, exports) {
$parcel$export(module.exports, "ClassicViewWorkflowServiceWithAnalytics", () => $bdea71f0fee4b7d5$export$1a80ddaaeea6341b);

var $eJOHy = parcelRequire("eJOHy");

var $4J0ad = parcelRequire("4J0ad");

var $eSnSE = parcelRequire("eSnSE");

var $kRgKj = parcelRequire("kRgKj");

var $ittDg = parcelRequire("ittDg");
// eslint-disable-next-line jira/react/no-class-components
class $bdea71f0fee4b7d5$var$ClassicViewWorkflowService extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            shouldLoadOnMount: true
        };
    }
    componentDidMount() {
        if (this.props.shouldLoadOnMount === true) this.load();
    }
    onLoading() {
        this.setState({
            data: undefined,
            error: undefined,
            loading: true
        });
    }
    onLoadSucceeded(data) {
        this.setState({
            data: data,
            error: undefined,
            loading: false
        });
    }
    onLoadFailed(error) {
        this.setState({
            data: undefined,
            error: error,
            loading: false
        });
    }
    fireAnalytics() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'requested'
        });
        (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, 'classicViewWorkflowData requested');
    }
    render() {
        return this.props.children({
            ...this.state,
            retry: this.load
        });
    }
    constructor(...args){
        super(...args), this.state = {
            data: undefined,
            error: undefined,
            loading: false
        }, this.load = async ()=>{
            this.onLoading();
            const { issueKey: issueKey } = this.props;
            try {
                this.fireAnalytics();
                const data = await (0, $ittDg.getViewWorkflowData)(issueKey);
                this.onLoadSucceeded(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-field.status.classic-view-workflow-service.fetch', 'Failed to fetch classic view workflow data.', {
                    errorReason: error.message && error.message === 'TransformError' ? 'transform' : 'fetch'
                });
                this.onLoadFailed(error);
            }
        };
    }
}
const $bdea71f0fee4b7d5$export$1a80ddaaeea6341b = (0, $4J0ad.default)()(// @ts-expect-error - TS2345 - Argument of type 'typeof ClassicViewWorkflowService' is not assignable to parameter of type '(((props: WithAnalyticsEventsProps) => ReactElement<any, string | ((props: any) => ReactElement<any, any> | null) | (new (props: any) => Component<any, any, any>)> | null) & typeof ClassicViewWorkflowService) | ((new (props: WithAnalyticsEventsProps) => Component<...>) & typeof ClassicViewWorkflowService)'.
$bdea71f0fee4b7d5$var$ClassicViewWorkflowService);

});
parcelRegister("ittDg", function(module, exports) {
$parcel$export(module.exports, "getViewWorkflowData", () => $f4d40665ec85b249$export$fa1a6ac9833b0597);

var $keOPi = parcelRequire("keOPi");
const $f4d40665ec85b249$var$query = `
query classicViewWorkflowQuery($issueKey: String!) {
    viewIssue(issueKey: $issueKey) {
        workflow {
            name
            step {
                id
            }
        }
    }
}
`;
const $f4d40665ec85b249$export$3361e9be8093ddcc = (response)=>{
    if (response.data && response.data.viewIssue && response.data.viewIssue.workflow) return {
        workflowName: response.data.viewIssue.workflow.name,
        currentStepId: response.data.viewIssue.workflow.step.id
    };
    throw new Error('TransformError');
};
const $f4d40665ec85b249$export$fa1a6ac9833b0597 = (issueKey)=>(0, $keOPi.performIssuePostRequest)('/rest/gira/1/', {
        body: JSON.stringify({
            query: $f4d40665ec85b249$var$query,
            variables: {
                issueKey: issueKey
            }
        })
    }, 'fields/status/src/services/classic-view-workflow-service/utils').then($f4d40665ec85b249$export$3361e9be8093ddcc);

});


parcelRegister("bozoA", function(module, exports) {
$parcel$export(module.exports, "errors", () => $c748e6b67cb75f31$export$30f3b02011db23c0);

var $jI4Lx = parcelRequire("jI4Lx");
const $c748e6b67cb75f31$export$30f3b02011db23c0 = {
    loadModalError: $jI4Lx.loadModalError
};

});
parcelRegister("jI4Lx", function(module, exports) {
$parcel$export(module.exports, "loadModalError", () => $ce72785ba03e57b2$export$51c6a1172e47844f);

var $7qGN1 = parcelRequire("7qGN1");
const $ce72785ba03e57b2$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "issue-field-status.view-workflow.classic.flags.errors.load-modal-error.title",
        "defaultMessage": "We couldn't load the workflow"
    },
    description: {
        "id": "issue-field-status.view-workflow.classic.flags.errors.load-modal-error.description",
        "defaultMessage": "Check your connection, then try reloading the page."
    }
});
const $ce72785ba03e57b2$export$51c6a1172e47844f = ()=>({
        type: 'error',
        title: $ce72785ba03e57b2$var$messages.title,
        description: $ce72785ba03e57b2$var$messages.description,
        messageId: 'issue-field-status.ui.view-workflow.classic.flags.errors.load-modal-error.flag.error',
        messageType: 'transactional'
    });

});



parcelRegister("5Mavp", function(module, exports) {
$parcel$export(module.exports, "ViewWorkflowModalDropDownTrigger", () => $bafc0fda0d6a02e0$export$1c337688ee874e1d);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $dxcgx = parcelRequire("dxcgx");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $1OBnZ = parcelRequire("1OBnZ");

var $8dJ7y = parcelRequire("8dJ7y");

var $10mjH = parcelRequire("10mjH");
const $bafc0fda0d6a02e0$export$1c337688ee874e1d = ({ hasPermission: hasPermission, isServiceLoading: isServiceLoading, isServiceRefetching: isServiceRefetching, ...selfProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isSimplifiedProject = selfProps.isSimplifiedProject;
    const onMount = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireOperationalAnalytics)(createAnalyticsEvent({}), 'viewWorkflowTrigger mounted', {
            hasViewWorkflowPermission: hasPermission,
            isSimplifiedProject: isSimplifiedProject
        });
    }, [
        createAnalyticsEvent,
        hasPermission,
        isSimplifiedProject
    ]);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'viewWorkflowTrigger',
            action: 'clicked'
        }), {
            isSimplifiedProject: isSimplifiedProject
        });
    }, [
        createAnalyticsEvent,
        isSimplifiedProject
    ]);
    const { tooltip: tooltip, isDisabled: isDisabled, isLoading: isLoading } = (0, $eJOHy.useMemo)(()=>{
        if (isServiceLoading || isServiceRefetching) return {
            tooltip: formatMessage((0, $10mjH.default).loading),
            isDisabled: true,
            isLoading: isServiceRefetching
        };
        if (hasPermission !== true) return {
            tooltip: formatMessage((0, $10mjH.default).noPermission),
            isDisabled: true,
            isLoading: false
        };
        // Empty tooltip means no tooltip
        return {
            tooltip: '',
            isDisabled: false
        };
    }, [
        isServiceLoading,
        isServiceRefetching,
        hasPermission,
        formatMessage
    ]);
    const modalProps = (0, $eJOHy.useMemo)(()=>{
        return {
            autoFocus: false,
            width: '100%',
            testId: 'issue-field-status.ui.view-workflow.read-view-modal'
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxcgx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $1OBnZ.entryPoint),
        entryPointProps: selfProps,
        interactionName: "open-read-view-workflow-modal",
        modalProps: modalProps,
        useInternalModal: true
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8dJ7y.default), {
            forwardRef: ref,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isInitialLoading: !!isServiceLoading,
            onMount: onMount,
            onClick: onClick,
            tooltipContent: tooltip
        }));
};

});
parcelRegister("1OBnZ", function(module, exports) {
$parcel$export(module.exports, "entryPoint", () => $dcf076341dbdd90a$export$6333901e831d7af0);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $dcf076341dbdd90a$export$6333901e831d7af0 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("loCXj")), {
        moduleId: "16c65716",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("loCXj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1vipW").then(()=>parcelRequire('dZbks'));

});






//# sourceMappingURL=async-status-field.f852b8f6.js.map
